var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 562 448",
    width: 562,
    height: 448,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 72.5,
    y1: 385.7,
    x2: 155.1,
    y2: 230.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 261.8,
    y1: 438.8,
    x2: 214.6,
    y2: 327.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 404.9,
    y1: 402.3,
    x2: 298.7,
    y2: 315.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 451.9,
    y1: 473.6,
    x2: 289.9,
    y2: 356.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 53.9,
    y1: 262.7,
    x2: 201.2,
    y2: 262.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 149.6,
    y1: 318.2,
    x2: 212.1,
    y2: 256.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 485.1,
    y1: 224.2,
    x2: 433.8,
    y2: 280.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 497.7,
    y1: 346,
    x2: 346.3,
    y2: 306.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 201.1,
    y1: 453.6,
    x2: 158,
    y2: 238,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 141.6,
    y1: 278.5,
    x2: 229.1,
    y2: 278.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 355.5,
    y1: 336.8,
    x2: 308.3,
    y2: 302.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 86,
    y1: 252.3,
    x2: 187.3,
    y2: 252.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 470.5,
    y1: 98.3,
    x2: 433.2,
    y2: 183.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 36.6,
    y1: 270.6,
    x2: 215.2,
    y2: 270.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 471,
    y1: 269.4,
    x2: 392.9,
    y2: 277.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 495.8,
    y1: 155.3,
    x2: 401.4,
    y2: 224.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 382.1,
    y1: 17.4,
    x2: 418.6,
    y2: 129.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 10.6,
    y1: 170.2,
    x2: 173.3,
    y2: 170.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 66.7,
    y1: 178.6,
    x2: 159.4,
    y2: 178.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 160.3,
    y1: 46.4,
    x2: 275.1,
    y2: 46.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 54.5,
    y1: 124.3,
    x2: 185.9,
    y2: 124.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 501.3,
    y1: 370.2,
    x2: 355,
    y2: 297.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 112.3,
    y1: 97.4,
    x2: 236.5,
    y2: 97.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 543.6,
    y1: 163.9,
    x2: 411.4,
    y2: 242.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g25",
    cx: 278.5,
    cy: 149.4,
    r: 150.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f19ab",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 152.5,
    y1: 148.2,
    x2: 404.3,
    y2: 148.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ebdef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 341.7,
    y1: 225.2,
    x2: 257.3,
    y2: 467.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 158.3,
    y1: 136.3,
    x2: 398.4,
    y2: 136.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1bb0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1bb0d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 152.3,
    y1: 127.9,
    x2: 404.1,
    y2: 127.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ebdef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 395.9,
    y1: 70.5,
    x2: 231.4,
    y2: 495.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 475.6,
    y1: -148.8,
    x2: 319.3,
    y2: 254.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 384.4,
    y1: 59.6,
    x2: 256.9,
    y2: 388.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g33",
    cx: 278.2,
    cy: 229.9,
    r: 92.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 404.4,
    y1: 213.1,
    x2: 421,
    y2: 239.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g35",
    cx: 396.7,
    cy: 235,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 390.4,
    y1: 221.2,
    x2: 407,
    y2: 247.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g37",
    cx: 382.8,
    cy: 243.1,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 376.5,
    y1: 229.3,
    x2: 393,
    y2: 256,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g39",
    cx: 368.8,
    cy: 251.2,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 362.5,
    y1: 237.3,
    x2: 379,
    y2: 264,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g41",
    cx: 354.8,
    cy: 259.2,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 348.5,
    y1: 245.4,
    x2: 365,
    y2: 272.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g43",
    cx: 340.8,
    cy: 267.3,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 334.5,
    y1: 253.5,
    x2: 351,
    y2: 280.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g45",
    cx: 326.8,
    cy: 275.4,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 320.4,
    y1: 261.6,
    x2: 337,
    y2: 288.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g47",
    cx: 312.8,
    cy: 283.5,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x1: 306.5,
    y1: 269.7,
    x2: 323,
    y2: 296.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g49",
    cx: 298.8,
    cy: 291.6,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g50",
    x1: 152.4,
    y1: 213.1,
    x2: 135.9,
    y2: 239.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g51",
    cx: 160.1,
    cy: 235,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g52",
    x1: 166.4,
    y1: 221.2,
    x2: 149.9,
    y2: 247.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g53",
    cx: 174.1,
    cy: 243.1,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x1: 180.4,
    y1: 229.3,
    x2: 163.9,
    y2: 255.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g55",
    cx: 188.1,
    cy: 251.2,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x1: 194.4,
    y1: 237.3,
    x2: 177.9,
    y2: 264,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g57",
    cx: 202,
    cy: 259.2,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 208.4,
    y1: 245.4,
    x2: 191.8,
    y2: 272.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g59",
    cx: 216,
    cy: 267.3,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x1: 222.3,
    y1: 253.5,
    x2: 205.8,
    y2: 280.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g61",
    cx: 230,
    cy: 275.4,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x1: 236.2,
    y1: 261.6,
    x2: 219.7,
    y2: 288.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g63",
    cx: 243.9,
    cy: 283.5,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 250.2,
    y1: 269.6,
    x2: 233.7,
    y2: 296.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e8e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g65",
    cx: 257.9,
    cy: 291.5,
    r: 9.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g66",
    x1: 123.7,
    y1: 263.5,
    x2: 123.7,
    y2: 28.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1bb0d4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x1: 341.4,
    y1: 357.4,
    x2: 402.3,
    y2: 357.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g68",
    x1: 340.1,
    y1: 355.8,
    x2: 398.7,
    y2: 355.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g69",
    x1: 340.8,
    y1: 356.4,
    x2: 398,
    y2: 356.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g70",
    cx: 359.2,
    cy: 363.3,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g71",
    x1: 358.8,
    y1: 379.2,
    x2: 366,
    y2: 359.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g72",
    x1: 371.6,
    y1: 349.5,
    x2: 391.6,
    y2: 380.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g73",
    x1: 315.5,
    y1: 347.4,
    x2: 377.7,
    y2: 401.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g74",
    x1: 363,
    y1: 393,
    x2: 332.8,
    y2: 351.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2a0c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4299a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g75",
    x1: 389.3,
    y1: 298.2,
    x2: 431.8,
    y2: 348.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g76",
    x1: 365.4,
    y1: 403.6,
    x2: 334.9,
    y2: 354.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g77",
    cx: 398.7,
    cy: 346.9,
    r: 5.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g78",
    cx: 399.1,
    cy: 346.1,
    r: 2.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g79",
    cx: 479.6,
    cy: 238.4,
    r: 23.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5f5c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g80",
    x1: 458.3,
    y1: 233.3,
    x2: 495.1,
    y2: 233.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g81",
    x1: 498.3,
    y1: 192.7,
    x2: 457.4,
    y2: 236.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g82",
    cx: 470.8,
    cy: 242.8,
    r: 13.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g83",
    x1: 459.5,
    y1: 227.5,
    x2: 493.9,
    y2: 227.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g84",
    x1: 459.5,
    y1: 226.7,
    x2: 493.9,
    y2: 226.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g85",
    x1: 458.3,
    y1: 223.1,
    x2: 495.1,
    y2: 223.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g86",
    x1: 498.3,
    y1: 182.4,
    x2: 457.4,
    y2: 226.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g87",
    cx: 470.8,
    cy: 232.5,
    r: 13.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g88",
    x1: 459.5,
    y1: 217.3,
    x2: 493.9,
    y2: 217.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g89",
    x1: 459.5,
    y1: 216.5,
    x2: 493.9,
    y2: 216.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g90",
    x1: 458.3,
    y1: 213.1,
    x2: 495.1,
    y2: 213.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g91",
    x1: 498.3,
    y1: 172.5,
    x2: 457.4,
    y2: 216.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g92",
    cx: 470.8,
    cy: 222.6,
    r: 13.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g93",
    x1: 459.5,
    y1: 207.3,
    x2: 493.9,
    y2: 207.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g94",
    x1: 459.5,
    y1: 206.5,
    x2: 493.9,
    y2: 206.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g95",
    x1: 458.3,
    y1: 203,
    x2: 495.1,
    y2: 203,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g96",
    x1: 498.3,
    y1: 162.4,
    x2: 457.4,
    y2: 206.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g97",
    cx: 470.8,
    cy: 212.5,
    r: 13.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g98",
    x1: 459.5,
    y1: 197.3,
    x2: 493.9,
    y2: 197.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g99",
    x1: 459.5,
    y1: 196.4,
    x2: 493.9,
    y2: 196.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g100",
    x1: 458.3,
    y1: 193,
    x2: 495.1,
    y2: 193,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g101",
    x1: 498.3,
    y1: 152.3,
    x2: 457.4,
    y2: 196.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g102",
    cx: 470.8,
    cy: 202.4,
    r: 13.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g103",
    cx: 478.2,
    cy: 192.3,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5f5c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g104",
    x1: 469.4,
    y1: 189.4,
    x2: 484.1,
    y2: 189.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g105",
    x1: 485.4,
    y1: 173.2,
    x2: 469,
    y2: 190.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g106",
    x1: 482.3,
    y1: 192.2,
    x2: 470.7,
    y2: 192.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g107",
    x1: 482.3,
    y1: 190.8,
    x2: 470.7,
    y2: 190.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g108",
    cx: 474.4,
    cy: 193.2,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g109",
    x1: 181,
    y1: 86.2,
    x2: 100,
    y2: 22,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g110",
    x1: 148.8,
    y1: 17,
    x2: 178.9,
    y2: -20,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g111",
    x1: 200.7,
    y1: 37,
    x2: 221.2,
    y2: 83,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g112",
    x1: 159.8,
    y1: -5.1,
    x2: 180.6,
    y2: 6.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g113",
    x1: 159.4,
    y1: 27.2,
    x2: 190.6,
    y2: 11.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g114",
    x1: 154.3,
    y1: 13.4,
    x2: 162.1,
    y2: 54.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g115",
    x1: 117.3,
    y1: 64.6,
    x2: 126.7,
    y2: -0.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g116",
    x1: 126.6,
    y1: 1.2,
    x2: 159.8,
    y2: -18,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g117",
    x1: 110.8,
    y1: 7.2,
    x2: 132.6,
    y2: -14.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g118",
    x1: 115.2,
    y1: 24.8,
    x2: 137.6,
    y2: 19.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g119",
    x1: 153.3,
    y1: 33.7,
    x2: 143.6,
    y2: 45.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g120",
    x1: 115.2,
    y1: 24.8,
    x2: 137.6,
    y2: 19.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g121",
    x1: 130.3,
    y1: 7.6,
    x2: 150.5,
    y2: 11.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g122",
    x1: 121.8,
    y1: 30.8,
    x2: 144.2,
    y2: 25.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g123",
    x1: 143.4,
    y1: 19.2,
    x2: 154.6,
    y2: 33.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g124",
    x1: 132.6,
    y1: 34.7,
    x2: 155,
    y2: 29.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g125",
    x1: 173.7,
    y1: 33.9,
    x2: 162.4,
    y2: 56.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g126",
    x1: 125.7,
    y1: 24.6,
    x2: 143.4,
    y2: 20.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g127",
    x1: 132.6,
    y1: 34.7,
    x2: 155,
    y2: 29.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g128",
    x1: 128.4,
    y1: 25.2,
    x2: 137.6,
    y2: 22.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g129",
    x1: 125.7,
    y1: 24.6,
    x2: 143.4,
    y2: 20.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g130",
    x1: 121.8,
    y1: 30.8,
    x2: 144.2,
    y2: 25.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g131",
    x1: 150.9,
    y1: 31.4,
    x2: 167.4,
    y2: 26.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g132",
    x1: 155.2,
    y1: 27.3,
    x2: 164.7,
    y2: 24.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g133",
    x1: 155.2,
    y1: 27.3,
    x2: 164.7,
    y2: 24.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g134",
    x1: 140.2,
    y1: 55.4,
    x2: 136.3,
    y2: 10.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g135",
    x1: 164.5,
    y1: 55.3,
    x2: 173,
    y2: 74.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g136",
    x1: 146.4,
    y1: 26.5,
    x2: 153.3,
    y2: 57.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g137",
    x1: 174.2,
    y1: 29,
    x2: 159,
    y2: 57.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g138",
    x1: 161.2,
    y1: 41.7,
    x2: 155.8,
    y2: 45,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g139",
    x1: 143.7,
    y1: 44.4,
    x2: 122.8,
    y2: 27.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g140",
    x1: 160,
    y1: 40.6,
    x2: 159.7,
    y2: 55.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g141",
    x1: 457.4,
    y1: -30.2,
    x2: 480.6,
    y2: 9.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g142",
    cx: 414.9,
    cy: 25.3,
    r: 24.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af8afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g143",
    x1: 325.7,
    y1: 11.3,
    x2: 393.3,
    y2: -24.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g144",
    x1: 389.9,
    y1: 12.9,
    x2: 414.3,
    y2: 12.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g145",
    x1: 452.9,
    y1: -16.3,
    x2: 484.6,
    y2: 44.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g146",
    x1: 69.7,
    y1: 277.9,
    x2: 34.1,
    y2: 277.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g147",
    x1: 68.3,
    y1: 281.5,
    x2: 46.9,
    y2: 269.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g148",
    x1: 61.2,
    y1: 289.7,
    x2: 52.4,
    y2: 274.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g149",
    x1: 145.1,
    y1: 256.3,
    x2: 55.5,
    y2: 334.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g150",
    x1: 76.9,
    y1: 323.2,
    x2: 118.2,
    y2: 259.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2a0c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4299a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g151",
    x1: 72.9,
    y1: 337.3,
    x2: 116.9,
    y2: 267.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g152",
    cx: 25.4,
    cy: 256,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g153",
    cx: 161.5,
    cy: 414.2,
    r: 18,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f5c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g154",
    x1: 168.9,
    y1: 410.7,
    x2: 145,
    y2: 410.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g155",
    x1: 170.8,
    y1: 384.5,
    x2: 144.2,
    y2: 413,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g156",
    x1: 167.9,
    y1: 394.7,
    x2: 146,
    y2: 394.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g157",
    cx: 156.9,
    cy: 395,
    r: 9.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g158",
    x1: 169.6,
    y1: 370.5,
    x2: 145.3,
    y2: 396.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g159",
    cx: 163.8,
    cy: 404.7,
    r: 6.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dc3daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g160",
    x1: 133.2,
    y1: 349.8,
    x2: 128.4,
    y2: 357.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g161",
    x1: 135,
    y1: 349.1,
    x2: 128.5,
    y2: 359.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g162",
    x1: 221.3,
    y1: 386,
    x2: 200.7,
    y2: 334,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g163",
    x1: 157.7,
    y1: 337,
    x2: 127.5,
    y2: 325,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g164",
    x1: 105.3,
    y1: 375.5,
    x2: 106.9,
    y2: 396.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g165",
    cx: 163.3,
    cy: 353.6,
    r: 12.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g166",
    x1: 156.8,
    y1: 387.1,
    x2: 139.7,
    y2: 382,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g167",
    x1: 175,
    y1: 390.1,
    x2: 147.3,
    y2: 383.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g168",
    x1: 142.8,
    y1: 370.5,
    x2: 156.9,
    y2: 397.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g169",
    x1: 162.1,
    y1: 363.9,
    x2: 223.5,
    y2: 345.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g170",
    x1: 176.8,
    y1: 352.6,
    x2: 193.2,
    y2: 380.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g171",
    cx: 177.8,
    cy: 372.2,
    r: 11.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g172",
    x1: 205,
    y1: 389.4,
    x2: 198.3,
    y2: 372.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g173",
    x1: 188.6,
    y1: 375.8,
    x2: 176,
    y2: 370.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g174",
    cx: 190.1,
    cy: 378,
    r: 3.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g175",
    x1: 186.7,
    y1: 397.9,
    x2: 187.4,
    y2: 397.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g176",
    x1: 188.4,
    y1: 394.8,
    x2: 185.6,
    y2: 394.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g177",
    x1: 189.6,
    y1: 388.6,
    x2: 184.5,
    y2: 388.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g178",
    x1: 184.1,
    y1: 383,
    x2: 189.7,
    y2: 389,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g179",
    x1: 185.3,
    y1: 389.6,
    x2: 188.9,
    y2: 389.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g180",
    x1: 187.6,
    y1: 389.6,
    x2: 187.6,
    y2: 387.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g181",
    x1: 182.4,
    y1: 389.6,
    x2: 188.6,
    y2: 387.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g182",
    x1: 150.2,
    y1: 352.9,
    x2: 112.7,
    y2: 341.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g183",
    x1: 173.5,
    y1: 360.5,
    x2: 141,
    y2: 353.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g184",
    x1: 119.4,
    y1: 316.2,
    x2: 143.9,
    y2: 362.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g185",
    x1: 160,
    y1: 362,
    x2: 141.2,
    y2: 356.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g186",
    x1: 177.3,
    y1: 365.5,
    x2: 151.1,
    y2: 359.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g187",
    x1: 143.2,
    y1: 341,
    x2: 157.1,
    y2: 367.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g188",
    x1: 166.4,
    y1: 365.4,
    x2: 162.6,
    y2: 361.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65318a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g189",
    x1: 172.2,
    y1: 358.5,
    x2: 155,
    y2: 387.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g190",
    x1: 163.2,
    y1: 387.9,
    x2: 193.2,
    y2: 381.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g191",
    x1: 193.8,
    y1: 380.2,
    x2: 175.7,
    y2: 376.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g192",
    x1: 185.4,
    y1: 385.8,
    x2: 188.3,
    y2: 381.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g193",
    x1: 180.7,
    y1: 383.2,
    x2: 185.2,
    y2: 386,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g194",
    cx: 182.9,
    cy: 380.8,
    r: 2.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g195",
    cx: 178.5,
    cy: 376.9,
    r: 7.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dc3daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g196",
    x1: 212.5,
    y1: 390.8,
    x2: 191.9,
    y2: 338.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g197",
    x1: 148.9,
    y1: 341.8,
    x2: 118.7,
    y2: 329.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g198",
    cx: 152.1,
    cy: 363.1,
    r: 12.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g199",
    x1: 144.4,
    y1: 359.5,
    x2: 147.9,
    y2: 365.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g200",
    x1: 135.5,
    y1: 362.9,
    x2: 148.2,
    y2: 360.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g201",
    cx: 143.2,
    cy: 363.3,
    r: 1.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g202",
    x1: 154.1,
    y1: 391.8,
    x2: 157.6,
    y2: 397.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g203",
    x1: 145.2,
    y1: 395.2,
    x2: 157.9,
    y2: 392.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g204",
    cx: 152.9,
    cy: 395.6,
    r: 1.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g205",
    x1: 179.7,
    y1: 381.4,
    x2: 185.9,
    y2: 379.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g206",
    x1: 199.3,
    y1: 392.6,
    x2: 192.7,
    y2: 375.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g207",
    x1: 183,
    y1: 378.9,
    x2: 170.4,
    y2: 374,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g208",
    cx: 184.5,
    cy: 381.2,
    r: 3.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g209",
    x1: 155.2,
    y1: 367.9,
    x2: 216.7,
    y2: 349.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g210",
    x1: 169.9,
    y1: 356.6,
    x2: 186.3,
    y2: 384.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g211",
    cx: 170.9,
    cy: 376.2,
    r: 11.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g212",
    x1: 180.5,
    y1: 381.2,
    x2: 182.4,
    y2: 384.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g213",
    x1: 175.5,
    y1: 383.2,
    x2: 182.6,
    y2: 381.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g214",
    cx: 179.8,
    cy: 383.4,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g215",
    x1: 184,
    y1: 389.7,
    x2: 186,
    y2: 392.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g216",
    x1: 179,
    y1: 391.6,
    x2: 186.2,
    y2: 390,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g217",
    cx: 183.3,
    cy: 391.8,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g218",
    x1: 155.9,
    y1: 366.8,
    x2: 157.8,
    y2: 370.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g219",
    x1: 150.9,
    y1: 368.8,
    x2: 158,
    y2: 367.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g220",
    cx: 155.2,
    cy: 369,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g221",
    cx: 430.2,
    cy: 314,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g222",
    cx: 422.2,
    cy: 309.3,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g223",
    cx: 415,
    cy: 305,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g224",
    cx: 409.1,
    cy: 301.6,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g225",
    cx: 404,
    cy: 298.6,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g226",
    cx: 325.6,
    cy: 324.1,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g227",
    cx: 317.6,
    cy: 319.4,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g228",
    cx: 310.4,
    cy: 315.1,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g229",
    cx: 304.5,
    cy: 311.7,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g230",
    cx: 299.4,
    cy: 308.7,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g231",
    cx: 121.3,
    cy: 169.8,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g232",
    cx: 129.3,
    cy: 174.5,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g233",
    cx: 136.4,
    cy: 178.8,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g234",
    cx: 142.3,
    cy: 182.3,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g235",
    cx: 147.3,
    cy: 185.3,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g236",
    cx: 222.6,
    cy: 378.2,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g237",
    cx: 230.7,
    cy: 373.6,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g238",
    cx: 238,
    cy: 369.5,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g239",
    cx: 243.9,
    cy: 366.2,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g240",
    cx: 249,
    cy: 363.3,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g241",
    cx: 145,
    cy: 303.2,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g242",
    cx: 153.1,
    cy: 298.6,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g243",
    cx: 160.4,
    cy: 294.5,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g244",
    cx: 166.3,
    cy: 291.2,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g245",
    cx: 171.4,
    cy: 288.3,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g246",
    cx: 176.7,
    cy: 66.4,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g247",
    cx: 184.7,
    cy: 71.1,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g248",
    cx: 191.9,
    cy: 75.4,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g249",
    cx: 197.7,
    cy: 78.9,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g250",
    cx: 202.8,
    cy: 81.9,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g251",
    cx: 486.5,
    cy: 147.4,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g252",
    cx: 478.5,
    cy: 152.2,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g253",
    cx: 471.4,
    cy: 156.4,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g254",
    cx: 465.5,
    cy: 159.9,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g255",
    cx: 460.5,
    cy: 162.9,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g256",
    cx: 394.2,
    cy: 141.5,
    r: 10.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g257",
    cx: 386.3,
    cy: 146.3,
    r: 9.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g258",
    cx: 379.1,
    cy: 150.5,
    r: 8.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g259",
    cx: 373.2,
    cy: 154,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g260",
    cx: 368.2,
    cy: 157,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7c1dc9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g261",
    x1: 193.3,
    y1: 65.6,
    x2: 217.3,
    y2: 65.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#38d2f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g262",
    x1: 194.4,
    y1: 67.3,
    x2: 215.8,
    y2: 67.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#45aeed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g263",
    x1: 195.6,
    y1: 69,
    x2: 214.2,
    y2: 69,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#538ae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g264",
    x1: 196.7,
    y1: 70.6,
    x2: 212.7,
    y2: 70.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6165db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g265",
    x1: 197.9,
    y1: 72.2,
    x2: 211.1,
    y2: 72.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g266",
    x1: 199,
    y1: 73.6,
    x2: 209.6,
    y2: 73.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g267",
    x1: 221.1,
    y1: 59,
    x2: 272.5,
    y2: 59,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g268",
    x1: 223.2,
    y1: 60,
    x2: 270,
    y2: 60,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g269",
    x1: 225.2,
    y1: 61.1,
    x2: 267.5,
    y2: 61.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g270",
    x1: 227.3,
    y1: 62.1,
    x2: 265,
    y2: 62.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g271",
    x1: 229.3,
    y1: 63.1,
    x2: 262.5,
    y2: 63.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g272",
    x1: 231.3,
    y1: 64.1,
    x2: 260.1,
    y2: 64.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g273",
    x1: 303,
    y1: 28,
    x2: 326.5,
    y2: 28,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g274",
    x1: 303.8,
    y1: 28.7,
    x2: 325.1,
    y2: 28.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g275",
    x1: 304.5,
    y1: 29.1,
    x2: 323.9,
    y2: 29.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g276",
    x1: 305.2,
    y1: 29.5,
    x2: 322.7,
    y2: 29.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g277",
    x1: 305.8,
    y1: 29.9,
    x2: 321.6,
    y2: 29.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g278",
    x1: 306.3,
    y1: 30.4,
    x2: 320.6,
    y2: 30.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g279",
    x1: 240.4,
    y1: 64.4,
    x2: 292.5,
    y2: 64.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#45c6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3dece9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g280",
    x1: 244.7,
    y1: 68,
    x2: 288.9,
    y2: 68,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#47a4cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37eff0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g281",
    x1: 249.1,
    y1: 71.6,
    x2: 285.3,
    y2: 71.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4983c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30f3f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g282",
    x1: 253.4,
    y1: 75.2,
    x2: 281.7,
    y2: 75.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g283",
    x1: 245.2,
    y1: 124,
    x2: 287.4,
    y2: 124,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g284",
    x1: 247,
    y1: 126.3,
    x2: 285.3,
    y2: 126.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g285",
    x1: 248.8,
    y1: 128.4,
    x2: 283.1,
    y2: 128.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g286",
    x1: 250.7,
    y1: 130.1,
    x2: 281,
    y2: 130.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g287",
    x1: 252.5,
    y1: 131.5,
    x2: 278.9,
    y2: 131.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g288",
    x1: 254.2,
    y1: 132.7,
    x2: 276.7,
    y2: 132.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g289",
    x1: 287.5,
    y1: 102.3,
    x2: 329,
    y2: 102.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g290",
    x1: 289.7,
    y1: 103.8,
    x2: 328,
    y2: 103.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g291",
    x1: 291.9,
    y1: 105.3,
    x2: 327.1,
    y2: 105.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g292",
    x1: 294,
    y1: 106.8,
    x2: 326.3,
    y2: 106.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g293",
    x1: 296.1,
    y1: 108.2,
    x2: 325.6,
    y2: 108.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g294",
    x1: 298.2,
    y1: 109.7,
    x2: 325.1,
    y2: 109.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g295",
    x1: 264.5,
    y1: 35.2,
    x2: 311.4,
    y2: 35.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g296",
    x1: 266.9,
    y1: 36.4,
    x2: 310,
    y2: 36.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g297",
    x1: 269.3,
    y1: 37.7,
    x2: 308.5,
    y2: 37.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g298",
    x1: 271.7,
    y1: 38.9,
    x2: 307.2,
    y2: 38.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g299",
    x1: 274,
    y1: 40.1,
    x2: 305.8,
    y2: 40.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g300",
    x1: 276.4,
    y1: 41.3,
    x2: 304.4,
    y2: 41.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g301",
    x1: 214.2,
    y1: 100.9,
    x2: 257.7,
    y2: 100.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g302",
    x1: 215.6,
    y1: 102.5,
    x2: 254.5,
    y2: 102.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g303",
    x1: 217,
    y1: 104,
    x2: 251.3,
    y2: 104,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g304",
    x1: 218.4,
    y1: 105.4,
    x2: 248.1,
    y2: 105.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g305",
    x1: 219.8,
    y1: 106.7,
    x2: 245.4,
    y2: 106.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g306",
    x1: 221.2,
    y1: 108,
    x2: 243.3,
    y2: 108,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g307",
    x1: 278.2,
    y1: 46.6,
    x2: 344.8,
    y2: 46.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#30ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g308",
    x1: 282.5,
    y1: 52.6,
    x2: 341,
    y2: 52.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#35c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g309",
    x1: 286.9,
    y1: 58.6,
    x2: 337.2,
    y2: 58.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3bacdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g310",
    x1: 291.2,
    y1: 64.5,
    x2: 333.5,
    y2: 64.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4093d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g311",
    x1: 295.6,
    y1: 70.4,
    x2: 329.7,
    y2: 70.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#457ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g312",
    x1: 299.5,
    y1: 75.5,
    x2: 326,
    y2: 75.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g313",
    cx: 300.5,
    cy: 109.1,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g314",
    cx: 275.5,
    cy: 85.6,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g315",
    cx: 275.3,
    cy: 106.5,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g316",
    cx: 220.2,
    cy: 55.3,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g317",
    cx: 251.1,
    cy: 39,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g318",
    cx: 265.4,
    cy: 65.3,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g319",
    cx: 246.5,
    cy: 102.6,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g320",
    cx: 241.7,
    cy: 71.9,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g321",
    cx: 296.1,
    cy: 44.9,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g322",
    cx: 334.6,
    cy: 59.7,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g323",
    cx: 321.1,
    cy: 35.5,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g324",
    cx: 317.3,
    cy: 87.3,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g325",
    cx: 293.3,
    cy: 67.1,
    r: 7.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g326",
    x1: 481.8,
    y1: -1.7,
    x2: 519.1,
    y2: -12.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g327",
    x1: 444.4,
    y1: -105.4,
    x2: 483.3,
    y2: -114.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g328",
    x1: 519.3,
    y1: 48.2,
    x2: 511.6,
    y2: 62.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g329",
    x1: 538.3,
    y1: 103.9,
    x2: 543.8,
    y2: 102.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g330",
    x1: 522.2,
    y1: 105.2,
    x2: 548.4,
    y2: 99.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g331",
    x1: 547,
    y1: 90.4,
    x2: 538.4,
    y2: 106.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g332",
    x1: 508.4,
    y1: 103.2,
    x2: 528,
    y2: 97.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g333",
    x1: 501,
    y1: 106.9,
    x2: 510.4,
    y2: 104.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g334",
    x1: 523.2,
    y1: 88.2,
    x2: 512.5,
    y2: 108.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g335",
    x1: 509.3,
    y1: 103.7,
    x2: 527,
    y2: 98.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g336",
    x1: 502.9,
    y1: 108,
    x2: 509.9,
    y2: 106.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g337",
    x1: 523.2,
    y1: 88,
    x2: 512.5,
    y2: 108.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g338",
    x1: 533.8,
    y1: 121.1,
    x2: 548.2,
    y2: 116.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g339",
    x1: 480.8,
    y1: 120.2,
    x2: 559.9,
    y2: 102.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g340",
    x1: 560.3,
    y1: 66,
    x2: 529.6,
    y2: 124.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g341",
    x1: 511.1,
    y1: 61.7,
    x2: 517.6,
    y2: 59.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g342",
    x1: 504.5,
    y1: 67.9,
    x2: 519.5,
    y2: 64.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g343",
    x1: 518.8,
    y1: 63.7,
    x2: 514.9,
    y2: 71.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g344",
    x1: 534.9,
    y1: 118.5,
    x2: 554.5,
    y2: 112.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g345",
    x1: 527.4,
    y1: 122.2,
    x2: 536.9,
    y2: 120.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g346",
    x1: 549.6,
    y1: 103.5,
    x2: 539,
    y2: 123.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g347",
    x1: 535.8,
    y1: 118.9,
    x2: 553.5,
    y2: 113.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g348",
    x1: 529.4,
    y1: 123.2,
    x2: 536.4,
    y2: 121.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g349",
    x1: 549.6,
    y1: 103.2,
    x2: 539,
    y2: 123.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g350",
    x1: 513.9,
    y1: 104.5,
    x2: 512.7,
    y2: 104.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g351",
    x1: 523.5,
    y1: 91.2,
    x2: 522.6,
    y2: 91.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g352",
    x1: 524.2,
    y1: 89.8,
    x2: 521.9,
    y2: 89.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g353",
    x1: 510.9,
    y1: 67.2,
    x2: 522.4,
    y2: 63.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g354",
    x1: 504.8,
    y1: 66,
    x2: 514.6,
    y2: 63.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g355",
    x1: 519.6,
    y1: 63.1,
    x2: 514.7,
    y2: 72.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g356",
    x1: 537.3,
    y1: 76.4,
    x2: 545.2,
    y2: 74,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g357",
    x1: 471.3,
    y1: 72.9,
    x2: 572.9,
    y2: 50.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g358",
    x1: 563.2,
    y1: 15.7,
    x2: 530.3,
    y2: 78.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g359",
    x1: 522.6,
    y1: 73.8,
    x2: 499.8,
    y2: 67,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g360",
    x1: 526.8,
    y1: 79.6,
    x2: 524.3,
    y2: 79,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g361",
    x1: 505.9,
    y1: 56.6,
    x2: 518,
    y2: 79.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g362",
    x1: 522.6,
    y1: 77.2,
    x2: 499.8,
    y2: 70.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g363",
    x1: 526.8,
    y1: 83,
    x2: 524.3,
    y2: 82.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g364",
    x1: 505.9,
    y1: 60,
    x2: 518,
    y2: 83.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g365",
    x1: 520.1,
    y1: 109.5,
    x2: 576.3,
    y2: 92.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g366",
    x1: 566,
    y1: 54.4,
    x2: 529.5,
    y2: 124.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g367",
    x1: 515.8,
    y1: 106.1,
    x2: 571.8,
    y2: 89.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g368",
    x1: 507.4,
    y1: 120.8,
    x2: 510.1,
    y2: 120.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g369",
    x1: 556.4,
    y1: 64.9,
    x2: 527.2,
    y2: 120.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g370",
    x1: 518.2,
    y1: 107.6,
    x2: 574.3,
    y2: 90.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g371",
    x1: 509.9,
    y1: 122.3,
    x2: 512.6,
    y2: 121.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g372",
    x1: 558.9,
    y1: 66.3,
    x2: 529.6,
    y2: 122.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g373",
    x1: 527,
    y1: 113.7,
    x2: 560.5,
    y2: 103.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g374",
    x1: 485.2,
    y1: 119.2,
    x2: 543.7,
    y2: 106.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g375",
    x1: 563,
    y1: 56.8,
    x2: 528.7,
    y2: 122.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g376",
    x1: 527,
    y1: 112.8,
    x2: 560.5,
    y2: 102.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g377",
    x1: 485.2,
    y1: 118.4,
    x2: 543.7,
    y2: 105.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g378",
    x1: 563,
    y1: 55.9,
    x2: 528.7,
    y2: 121.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g379",
    cx: 518.8,
    cy: 120.9,
    r: 11.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g380",
    x1: 526.3,
    y1: 77.5,
    x2: 537.4,
    y2: 74.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g381",
    x1: 509.1,
    y1: 79.7,
    x2: 536.7,
    y2: 73.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g382",
    x1: 538.7,
    y1: 60.9,
    x2: 527.8,
    y2: 81.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g383",
    x1: 511.3,
    y1: 120,
    x2: 516.8,
    y2: 118.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g384",
    x1: 495.2,
    y1: 121.3,
    x2: 521.4,
    y2: 115.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g385",
    x1: 519.9,
    y1: 106.5,
    x2: 511.3,
    y2: 122.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g386",
    x1: 512.5,
    y1: 121.1,
    x2: 516.3,
    y2: 120,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g387",
    x1: 496.8,
    y1: 120.8,
    x2: 520.8,
    y2: 115.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g388",
    x1: 519.9,
    y1: 105.7,
    x2: 511.3,
    y2: 122.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g389",
    x1: 539.5,
    y1: 104.8,
    x2: 543.3,
    y2: 103.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g390",
    x1: 523.8,
    y1: 104.4,
    x2: 547.8,
    y2: 99.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g391",
    x1: 547,
    y1: 89.3,
    x2: 538.4,
    y2: 105.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g392",
    x1: 537.9,
    y1: 82.3,
    x2: 513.2,
    y2: 74.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g393",
    x1: 542.4,
    y1: 88.6,
    x2: 539.8,
    y2: 88.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g394",
    x1: 519.8,
    y1: 63.6,
    x2: 532.9,
    y2: 88.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g395",
    x1: 537.9,
    y1: 85.7,
    x2: 513.2,
    y2: 78.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g396",
    x1: 542.4,
    y1: 92.1,
    x2: 539.8,
    y2: 91.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g397",
    x1: 519.8,
    y1: 67,
    x2: 532.9,
    y2: 92.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g398",
    x1: 523,
    y1: 83.1,
    x2: 530.8,
    y2: 80.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g399",
    x1: 513.5,
    y1: 84.5,
    x2: 528.1,
    y2: 81.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g400",
    x1: 530.8,
    y1: 72.6,
    x2: 524,
    y2: 85.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g401",
    x1: 523.6,
    y1: 83.6,
    x2: 530.3,
    y2: 81.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g402",
    x1: 514.6,
    y1: 84.6,
    x2: 527.7,
    y2: 81.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g403",
    x1: 530.8,
    y1: 72.4,
    x2: 524,
    y2: 85.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g404",
    x1: 511.5,
    y1: 15.3,
    x2: 548.7,
    y2: 4.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g405",
    x1: 474,
    y1: -88.4,
    x2: 512.9,
    y2: -97.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g406",
    x1: 549,
    y1: 65.2,
    x2: 541.3,
    y2: 79.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g407",
    x1: 507.6,
    y1: 121.3,
    x2: 508.5,
    y2: 121.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g408",
    x1: 509.8,
    y1: 122.5,
    x2: 510.6,
    y2: 122.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g409",
    x1: 542.2,
    y1: 79.3,
    x2: 541.3,
    y2: 79.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g410",
    x1: 540.4,
    y1: 80.3,
    x2: 539.5,
    y2: 80.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g411",
    x1: 542.2,
    y1: 81.4,
    x2: 541.3,
    y2: 81.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g412",
    x1: 540.4,
    y1: 82.5,
    x2: 539.5,
    y2: 82.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g413",
    x1: 542.2,
    y1: 121.3,
    x2: 541.3,
    y2: 121.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g414",
    x1: 540.4,
    y1: 122.3,
    x2: 539.5,
    y2: 122.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g415",
    x1: 542.2,
    y1: 123.4,
    x2: 541.3,
    y2: 123.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g416",
    x1: 540.4,
    y1: 124.5,
    x2: 539.5,
    y2: 124.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g417",
    cx: 538.3,
    cy: 77.8,
    r: 6.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g418",
    cx: 523.6,
    cy: 78.4,
    r: 1.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g419",
    cx: 521.6,
    cy: 85.7,
    r: 2.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g420",
    cx: 509.6,
    cy: 122.6,
    r: 4.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g421",
    cx: 508.7,
    cy: 61,
    r: 4.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g422",
    x1: 519.6,
    y1: 395.5,
    x2: 529,
    y2: 382.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#190628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g423",
    x1: 522.7,
    y1: 379,
    x2: 514.3,
    y2: 379,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g424",
    cx: 517.6,
    cy: 384.3,
    r: 4.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g425",
    x1: 515.1,
    y1: 380.4,
    x2: 521.6,
    y2: 380.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g426",
    x1: 515.3,
    y1: 380.4,
    x2: 521.8,
    y2: 380.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g427",
    x1: 554.9,
    y1: 375.7,
    x2: 564.3,
    y2: 363.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#190628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g428",
    x1: 558,
    y1: 359.2,
    x2: 549.6,
    y2: 359.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g429",
    cx: 552.9,
    cy: 364.5,
    r: 4.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g430",
    x1: 550.4,
    y1: 360.5,
    x2: 556.9,
    y2: 360.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g431",
    x1: 550.6,
    y1: 360.6,
    x2: 557.1,
    y2: 360.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g432",
    cx: 505.2,
    cy: 354.3,
    r: 3.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g433",
    cx: 519.5,
    cy: 348.8,
    r: 44.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g434",
    cx: 533.2,
    cy: 368,
    r: 23.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g435",
    x1: 544.5,
    y1: 325.8,
    x2: 537.9,
    y2: 367.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g436",
    x1: 539.2,
    y1: 373.7,
    x2: 499.3,
    y2: 322.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g437",
    x1: 546.6,
    y1: 346.1,
    x2: 513.5,
    y2: 354.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9de9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g438",
    cx: 495.4,
    cy: 378.8,
    r: 5.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g439",
    x1: 504.5,
    y1: 380.6,
    x2: 505,
    y2: 385.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g440",
    x1: 507.3,
    y1: 384.2,
    x2: 507.4,
    y2: 378.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g441",
    x1: 489.5,
    y1: 371.3,
    x2: 486.8,
    y2: 371.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g442",
    x1: 477.6,
    y1: 372.2,
    x2: 479,
    y2: 378.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g443",
    cx: 559.6,
    cy: 347.4,
    r: 2.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#feeca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa98c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g444",
    x1: 506.9,
    y1: 382.2,
    x2: 503.9,
    y2: 382.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g445",
    x1: 503.6,
    y1: 382.7,
    x2: 504.9,
    y2: 382.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g446",
    x1: 508.8,
    y1: 382.2,
    x2: 505.8,
    y2: 382.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g447",
    x1: 505.5,
    y1: 382.6,
    x2: 506.8,
    y2: 382.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g448",
    cx: 508.6,
    cy: 382.2,
    r: 1.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cc4100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g449",
    cx: 507.6,
    cy: 382.4,
    r: 0.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cc4100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g450",
    x1: 489.2,
    y1: 373.6,
    x2: 487.7,
    y2: 373.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g451",
    x1: 487.5,
    y1: 373.8,
    x2: 488.7,
    y2: 373.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g452",
    x1: 488.5,
    y1: 372.6,
    x2: 487.3,
    y2: 372.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g453",
    x1: 487.1,
    y1: 372.5,
    x2: 488.1,
    y2: 372.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g454",
    x1: 519.1,
    y1: 356.7,
    x2: 540.3,
    y2: 392.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g455",
    x1: 566.5,
    y1: 361.9,
    x2: 562.5,
    y2: 353.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g456",
    x1: 509.4,
    y1: 391.7,
    x2: 507,
    y2: 386.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g457",
    x1: 557.3,
    y1: 385,
    x2: 537.7,
    y2: 351,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g458",
    cx: 498.7,
    cy: 378.6,
    r: 10.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g459",
    cx: 491.7,
    cy: 384.8,
    r: 10.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g460",
    x1: 501.6,
    y1: 394.9,
    x2: 503.4,
    y2: 383.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g461",
    x1: 510.5,
    y1: 391.4,
    x2: 507.9,
    y2: 386.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g462",
    x1: 494.6,
    y1: 334.3,
    x2: 516.8,
    y2: 365.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g463",
    x1: 479.2,
    y1: 387,
    x2: 518.4,
    y2: 378.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0c95e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g464",
    cx: 507.3,
    cy: 381.9,
    r: 2.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g465",
    x1: 516.2,
    y1: 373.2,
    x2: 559.5,
    y2: 329.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g466",
    x1: 507.6,
    y1: 363.2,
    x2: 547.7,
    y2: 411.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g467",
    x1: 523.7,
    y1: 371.3,
    x2: 531,
    y2: 373.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g468",
    cx: 527.5,
    cy: 366.7,
    r: 3.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g469",
    x1: 526.9,
    y1: 366.1,
    x2: 526.6,
    y2: 369.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g470",
    x1: 531,
    y1: 337.2,
    x2: 546.8,
    y2: 359.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g471",
    cx: 400.5,
    cy: 67.7,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g472",
    cx: 514.4,
    cy: 118.2,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g473",
    cx: 463.8,
    cy: 242.7,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g474",
    cx: 493.3,
    cy: 384.2,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g475",
    cx: 357.9,
    cy: 378,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g476",
    cx: 60.7,
    cy: 291.8,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g477",
    cx: 164.8,
    cy: 416.2,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g478",
    cx: 163.7,
    cy: 48.4,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g479",
    cx: 62.5,
    cy: 123,
    r: 27.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g480",
    x1: 85.3,
    y1: 92,
    x2: 90.9,
    y2: 92,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g481",
    x1: 91.4,
    y1: 85.9,
    x2: 85.2,
    y2: 92.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g482",
    cx: 87.2,
    cy: 93.5,
    r: 2.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g483",
    x1: 39.1,
    y1: 92,
    x2: 33.5,
    y2: 92,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g484",
    x1: 33,
    y1: 85.9,
    x2: 39.2,
    y2: 92.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g485",
    cx: 37.2,
    cy: 93.5,
    r: 2.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g486",
    x1: 85.3,
    y1: 121.3,
    x2: 90.9,
    y2: 121.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g487",
    x1: 91.4,
    y1: 115.1,
    x2: 85.2,
    y2: 121.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g488",
    cx: 87.2,
    cy: 122.7,
    r: 2.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g489",
    x1: 72.4,
    y1: 98.7,
    x2: 63.4,
    y2: 96,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g490",
    x1: 115.4,
    y1: 97.3,
    x2: 49.7,
    y2: 82.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g491",
    x1: 52.8,
    y1: 56.9,
    x2: 75.9,
    y2: 101,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g492",
    x1: 52.1,
    y1: 98.7,
    x2: 61.1,
    y2: 96,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g493",
    x1: 9.1,
    y1: 97.3,
    x2: 74.8,
    y2: 82.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g494",
    x1: 71.7,
    y1: 56.9,
    x2: 48.6,
    y2: 101,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g495",
    x1: 50.5,
    y1: 108.4,
    x2: 73.7,
    y2: 108.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g496",
    x1: 48.9,
    y1: 103.8,
    x2: 75.3,
    y2: 103.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g497",
    x1: 77.5,
    y1: 74.7,
    x2: 48.3,
    y2: 106.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g498",
    cx: 57.9,
    cy: 110.6,
    r: 9.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g499",
    cx: 63.2,
    cy: 103.3,
    r: 6.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5f5c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g500",
    x1: 56.9,
    y1: 101.3,
    x2: 67.4,
    y2: 101.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g501",
    x1: 68.3,
    y1: 89.6,
    x2: 56.6,
    y2: 102.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g502",
    x1: 64.9,
    y1: 96.2,
    x2: 59.7,
    y2: 101.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g503",
    cx: 60.5,
    cy: 104,
    r: 4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g504",
    x1: 88.5,
    y1: 119.7,
    x2: 96.8,
    y2: 117.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g505",
    x1: 44.1,
    y1: 117.8,
    x2: 111.4,
    y2: 102.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g506",
    x1: 108.4,
    y1: 76.1,
    x2: 84.5,
    y2: 121.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g507",
    x1: 85.6,
    y1: 115.6,
    x2: 90.6,
    y2: 115.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g508",
    x1: 91,
    y1: 110.1,
    x2: 85.5,
    y2: 116.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g509",
    cx: 87.3,
    cy: 116.9,
    r: 1.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g510",
    x1: 86.8,
    y1: 113.5,
    x2: 89.5,
    y2: 113.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g511",
    x1: 89.7,
    y1: 110.6,
    x2: 86.7,
    y2: 113.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g512",
    cx: 87.7,
    cy: 114.2,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g513",
    x1: 39.1,
    y1: 121.3,
    x2: 33.5,
    y2: 121.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g514",
    x1: 33,
    y1: 115.1,
    x2: 39.2,
    y2: 121.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g515",
    cx: 37.2,
    cy: 122.7,
    r: 2.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g516",
    x1: 36,
    y1: 119.7,
    x2: 27.6,
    y2: 117.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g517",
    x1: 80.3,
    y1: 117.8,
    x2: 13,
    y2: 102.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g518",
    x1: 16.1,
    y1: 76.1,
    x2: 40,
    y2: 121.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g519",
    x1: 38.8,
    y1: 115.6,
    x2: 33.8,
    y2: 115.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g520",
    x1: 33.4,
    y1: 110.1,
    x2: 38.9,
    y2: 116.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g521",
    cx: 37.1,
    cy: 116.9,
    r: 1.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g522",
    x1: 37.6,
    y1: 113.5,
    x2: 35,
    y2: 113.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g523",
    x1: 34.7,
    y1: 110.6,
    x2: 37.7,
    y2: 113.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g524",
    cx: 36.7,
    cy: 114.2,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g525",
    x1: 85.6,
    y1: 86.4,
    x2: 90.6,
    y2: 86.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g526",
    x1: 91,
    y1: 80.9,
    x2: 85.5,
    y2: 86.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g527",
    cx: 87.3,
    cy: 87.7,
    r: 1.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g528",
    x1: 86.8,
    y1: 84.3,
    x2: 89.5,
    y2: 84.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g529",
    x1: 89.7,
    y1: 81.3,
    x2: 86.7,
    y2: 84.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g530",
    cx: 87.7,
    cy: 85,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g531",
    x1: 38.8,
    y1: 86.4,
    x2: 33.8,
    y2: 86.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g532",
    x1: 33.4,
    y1: 80.9,
    x2: 38.9,
    y2: 86.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g533",
    cx: 37.1,
    cy: 87.7,
    r: 1.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g534",
    x1: 37.6,
    y1: 84.3,
    x2: 35,
    y2: 84.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b086cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g535",
    x1: 34.7,
    y1: 81.3,
    x2: 37.7,
    y2: 84.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g536",
    cx: 36.7,
    cy: 85,
    r: 1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g537",
    cx: 246.9,
    cy: 322.3,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g538",
    cx: 310.2,
    cy: 391.1,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g539",
    cx: 378.6,
    cy: 293,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g540",
    cx: 442.2,
    cy: 261,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g541",
    cx: 119.5,
    cy: 326.1,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g542",
    cx: 147.9,
    cy: 261.7,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g543",
    cx: 114.1,
    cy: 207.2,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g544",
    cx: 435.3,
    cy: 168.6,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g545",
    cx: 149.4,
    cy: 119.5,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g546",
    cx: 458.8,
    cy: 364.5,
    r: 9.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fee2a6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1b2b69",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#g1)}.b{fill:url(#g2)}.c{fill:url(#g3)}.d{fill:url(#g4)}.e{fill:#45108a}.f{fill:url(#g5)}.g{fill:url(#g6)}.h{fill:url(#g7)}.i{fill:url(#g8)}.j{fill:url(#g9)}.k{fill:url(#g10)}.l{fill:url(#g11)}.m{fill:url(#g12)}.n{fill:url(#g13)}.o{fill:url(#g14)}.p{fill:url(#g15)}.q{fill:url(#g16)}.r{fill:url(#g17)}.s{fill:url(#g18)}.t{fill:url(#g19)}.u{fill:url(#g20)}.v{fill:url(#g21)}.w{fill:url(#g22)}.x{fill:url(#g23)}.y{fill:url(#g24)}.z{mix-blend-mode:color-dodge;fill:url(#g25)}.A{opacity:.1;fill:#43e8e1}.B{opacity:.2;fill:#43e8e1}.C{opacity:.3;fill:#43e8e1}.D{opacity:.4;fill:#43e8e1}.E{opacity:.5;fill:#43e8e1}.F{opacity:.6;fill:#43e8e1}.G{opacity:.7;fill:#43e8e1}.H{opacity:.8;fill:#43e8e1}.I{opacity:.9;fill:#43e8e1}.J{fill:#43e8e1}.K{fill:url(#g26)}.L{fill:url(#g27)}.M{fill:url(#g28)}.N{fill:url(#g29)}.O{fill:url(#g30)}.P{fill:url(#g31)}.Q{fill:url(#g32)}.R{mix-blend-mode:color-dodge;fill:url(#g33)}.S{opacity:.2;fill:#2af6ff}.T{opacity:.5;fill:#2af6ff}.U{fill:#2af6ff}.V{opacity:.5;fill:#ff63ce}.W{fill:#ff63ce}.X{opacity:0;fill:#2af6ff}.Y{opacity:.2;fill:#ff63ce}.Z{fill:url(#g34)}.a0{mix-blend-mode:color-dodge;fill:url(#g35)}.a1{fill:url(#g36)}.a2{mix-blend-mode:color-dodge;fill:url(#g37)}.a3{fill:url(#g38)}.a4{mix-blend-mode:color-dodge;fill:url(#g39)}.a5{fill:url(#g40)}.a6{mix-blend-mode:color-dodge;fill:url(#g41)}.a7{fill:url(#g42)}.a8{mix-blend-mode:color-dodge;fill:url(#g43)}.a9{fill:url(#g44)}.aa{mix-blend-mode:color-dodge;fill:url(#g45)}.ab{fill:url(#g46)}.ac{mix-blend-mode:color-dodge;fill:url(#g47)}.ad{fill:url(#g48)}.ae{mix-blend-mode:color-dodge;fill:url(#g49)}.af{fill:url(#g50)}.ag{mix-blend-mode:color-dodge;fill:url(#g51)}.ah{fill:url(#g52)}.ai{mix-blend-mode:color-dodge;fill:url(#g53)}.aj{fill:url(#g54)}.ak{mix-blend-mode:color-dodge;fill:url(#g55)}.al{fill:url(#g56)}.am{mix-blend-mode:color-dodge;fill:url(#g57)}.an{fill:url(#g58)}.ao{mix-blend-mode:color-dodge;fill:url(#g59)}.ap{fill:url(#g60)}.aq{mix-blend-mode:color-dodge;fill:url(#g61)}.ar{fill:url(#g62)}.as{mix-blend-mode:color-dodge;fill:url(#g63)}.at{fill:url(#g64)}.au{mix-blend-mode:color-dodge;fill:url(#g65)}.av{mix-blend-mode:screen;fill:url(#g66)}.aw{opacity:0}.ax{opacity:.1}.ay{opacity:.2}.az{opacity:.3}.aA{opacity:.4}.aB{opacity:.5}.aC{opacity:.6}.aD{opacity:.7}.aE{opacity:.8}.aF{opacity:.9}.aG{fill:url(#g67)}.aH{fill:url(#g68)}.aI{fill:url(#g69)}.aJ{fill:#fff}.aK{mix-blend-mode:color-dodge;fill:url(#g70)}.aL{fill:url(#g71)}.aM{opacity:.3;mix-blend-mode:screen;fill:url(#g72)}.aN{fill:url(#g73)}.aO{fill:url(#g74)}.aP{fill:url(#g75)}.aQ{fill:url(#g76)}.aR{mix-blend-mode:screen;fill:url(#g77)}.aS{mix-blend-mode:color-dodge;fill:url(#g78)}.aT{mix-blend-mode:multiply;fill:url(#g79)}.aU{fill:url(#g80)}.aV{fill:url(#g81)}.aW{mix-blend-mode:color-dodge;fill:url(#g82)}.aX{fill:url(#g83)}.aY{fill:url(#g84)}.aZ{fill:url(#g85)}.b0{fill:url(#g86)}.b1{mix-blend-mode:color-dodge;fill:url(#g87)}.b2{fill:url(#g88)}.b3{fill:url(#g89)}.b4{fill:url(#g90)}.b5{fill:url(#g91)}.b6{mix-blend-mode:color-dodge;fill:url(#g92)}.b7{fill:url(#g93)}.b8{fill:url(#g94)}.b9{fill:url(#g95)}.ba{fill:url(#g96)}.bb{mix-blend-mode:color-dodge;fill:url(#g97)}.bc{fill:url(#g98)}.bd{fill:url(#g99)}.be{fill:url(#g100)}.bf{fill:url(#g101)}.bg{mix-blend-mode:color-dodge;fill:url(#g102)}.bh{mix-blend-mode:multiply;fill:url(#g103)}.bi{fill:url(#g104)}.bj{fill:url(#g105)}.bk{fill:url(#g106)}.bl{fill:url(#g107)}.bm{mix-blend-mode:color-dodge;fill:url(#g108)}.bn{mix-blend-mode:multiply;fill:url(#g109)}.bo{fill:url(#g110)}.bp{fill:url(#g111)}.bq{fill:url(#g112)}.br{fill:#d1b4e3}.bs{fill:url(#g113)}.bt{mix-blend-mode:multiply;fill:#e6e7e8}.bu{fill:url(#g114)}.bv{fill:url(#g115)}.bw{fill:#f1e8f6}.bx{fill:url(#g116)}.by{fill:url(#g117)}.bz{fill:url(#g118)}.bA{opacity:.5;fill:url(#g119)}.bB{opacity:.5;fill:url(#g120)}.bC{fill:url(#g121)}.bD{fill:url(#g122)}.bE{fill:url(#g123)}.bF{fill:url(#g124)}.bG{opacity:.5;fill:url(#g125)}.bH{fill:url(#g126)}.bI{opacity:.5;fill:url(#g127)}.bJ{fill:url(#g128)}.bK{opacity:.5;fill:url(#g129)}.bL{opacity:.5;fill:url(#g130)}.bM{fill:url(#g131)}.bN{fill:url(#g132)}.bO{opacity:.5;fill:url(#g133)}.bP{fill:url(#g134)}.bQ{fill:url(#g135)}.bR{fill:url(#g136)}.bS{fill:url(#g137)}.bT{fill:url(#g138)}.bU{mix-blend-mode:multiply;fill:url(#g139)}.bV{fill:url(#g140)}.bW{fill:url(#g141)}.bX{opacity:.6;mix-blend-mode:screen;fill:url(#g142)}.bY{fill:url(#g143)}.bZ{fill:url(#g144)}.c0{fill:url(#g145)}.c1{mix-blend-mode:multiply;fill:#bcbec0}.c2{mix-blend-mode:multiply;fill:#8969c3}.c3{fill:url(#g146)}.c4{fill:url(#g147)}.c5{opacity:.8;mix-blend-mode:multiply;fill:url(#g148)}.c6{fill:url(#g149)}.c7{fill:url(#g150)}.c8{fill:url(#g151)}.c9{mix-blend-mode:screen;fill:url(#g152)}.ca{mix-blend-mode:multiply;fill:url(#g153)}.cb{fill:url(#g154)}.cc{fill:url(#g155)}.cd{fill:url(#g156)}.ce{mix-blend-mode:color-dodge;fill:url(#g157)}.cf{fill:url(#g158)}.cg{mix-blend-mode:color-dodge;fill:url(#g159)}.ch{fill:url(#g160)}.ci{fill:url(#g161)}.cj{fill:url(#g162)}.ck{fill:url(#g163)}.cl{mix-blend-mode:multiply;fill:url(#g164)}.cm{mix-blend-mode:color-dodge;fill:url(#g165)}.cn{fill:url(#g166)}.co{fill:url(#g167)}.cp{fill:url(#g168)}.cq{fill:url(#g169)}.cr{fill:url(#g170)}.cs{mix-blend-mode:color-dodge;fill:url(#g171)}.ct{fill:url(#g172)}.cu{fill:url(#g173)}.cv{mix-blend-mode:color-dodge;fill:url(#g174)}.cw{fill:url(#g175)}.cx{fill:url(#g176)}.cy{fill:url(#g177)}.cz{fill:url(#g178)}.cA{fill:url(#g179)}.cB{mix-blend-mode:multiply;fill:url(#g180)}.cC{fill:url(#g181)}.cD{mix-blend-mode:screen;fill:#e6e7e8}.cE{fill:url(#g182)}.cF{fill:url(#g183)}.cG{fill:url(#g184)}.cH{fill:url(#g185)}.cI{fill:url(#g186)}.cJ{fill:url(#g187)}.cK{fill:url(#g188)}.cL{fill:url(#g189)}.cM{mix-blend-mode:multiply;fill:url(#g190)}.cN{fill:url(#g191)}.cO{fill:url(#g192)}.cP{mix-blend-mode:multiply;fill:url(#g193)}.cQ{mix-blend-mode:color-dodge;fill:url(#g194)}.cR{mix-blend-mode:color-dodge;fill:url(#g195)}.cS{fill:url(#g196)}.cT{fill:url(#g197)}.cU{mix-blend-mode:color-dodge;fill:url(#g198)}.cV{mix-blend-mode:multiply;fill:#b086cc}.cW{fill:url(#g199)}.cX{fill:url(#g200)}.cY{mix-blend-mode:color-dodge;fill:url(#g201)}.cZ{fill:url(#g202)}.d0{fill:url(#g203)}.d1{mix-blend-mode:color-dodge;fill:url(#g204)}.d2{fill:url(#g205)}.d3{fill:url(#g206)}.d4{fill:url(#g207)}.d5{mix-blend-mode:color-dodge;fill:url(#g208)}.d6{fill:url(#g209)}.d7{fill:url(#g210)}.d8{mix-blend-mode:color-dodge;fill:url(#g211)}.d9{fill:url(#g212)}.da{fill:url(#g213)}.db{mix-blend-mode:color-dodge;fill:url(#g214)}.dc{fill:url(#g215)}.dd{fill:url(#g216)}.de{mix-blend-mode:color-dodge;fill:url(#g217)}.df{fill:url(#g218)}.dg{fill:url(#g219)}.dh{mix-blend-mode:color-dodge;fill:url(#g220)}.di{mix-blend-mode:screen;fill:url(#g221)}.dj{opacity:.8;mix-blend-mode:screen;fill:url(#g222)}.dk{opacity:.7;mix-blend-mode:screen;fill:url(#g223)}.dl{opacity:.5;mix-blend-mode:screen;fill:url(#g224)}.dm{opacity:.3;mix-blend-mode:screen;fill:url(#g225)}.dn{mix-blend-mode:screen;fill:url(#g226)}.do{opacity:.8;mix-blend-mode:screen;fill:url(#g227)}.dp{opacity:.7;mix-blend-mode:screen;fill:url(#g228)}.dq{opacity:.5;mix-blend-mode:screen;fill:url(#g229)}.dr{opacity:.3;mix-blend-mode:screen;fill:url(#g230)}.ds{mix-blend-mode:screen;fill:url(#g231)}.dt{opacity:.8;mix-blend-mode:screen;fill:url(#g232)}.du{opacity:.7;mix-blend-mode:screen;fill:url(#g233)}.dv{opacity:.5;mix-blend-mode:screen;fill:url(#g234)}.dw{opacity:.3;mix-blend-mode:screen;fill:url(#g235)}.dx{mix-blend-mode:screen;fill:url(#g236)}.dy{opacity:.8;mix-blend-mode:screen;fill:url(#g237)}.dz{opacity:.7;mix-blend-mode:screen;fill:url(#g238)}.dA{opacity:.5;mix-blend-mode:screen;fill:url(#g239)}.dB{opacity:.3;mix-blend-mode:screen;fill:url(#g240)}.dC{mix-blend-mode:screen;fill:url(#g241)}.dD{opacity:.8;mix-blend-mode:screen;fill:url(#g242)}.dE{opacity:.7;mix-blend-mode:screen;fill:url(#g243)}.dF{opacity:.5;mix-blend-mode:screen;fill:url(#g244)}.dG{opacity:.3;mix-blend-mode:screen;fill:url(#g245)}.dH{mix-blend-mode:screen;fill:url(#g246)}.dI{opacity:.8;mix-blend-mode:screen;fill:url(#g247)}.dJ{opacity:.7;mix-blend-mode:screen;fill:url(#g248)}.dK{opacity:.5;mix-blend-mode:screen;fill:url(#g249)}.dL{opacity:.3;mix-blend-mode:screen;fill:url(#g250)}.dM{mix-blend-mode:screen;fill:url(#g251)}.dN{opacity:.8;mix-blend-mode:screen;fill:url(#g252)}.dO{opacity:.7;mix-blend-mode:screen;fill:url(#g253)}.dP{opacity:.5;mix-blend-mode:screen;fill:url(#g254)}.dQ{opacity:.3;mix-blend-mode:screen;fill:url(#g255)}.dR{mix-blend-mode:screen;fill:url(#g256)}.dS{opacity:.8;mix-blend-mode:screen;fill:url(#g257)}.dT{opacity:.7;mix-blend-mode:screen;fill:url(#g258)}.dU{opacity:.5;mix-blend-mode:screen;fill:url(#g259)}.dV{opacity:.3;mix-blend-mode:screen;fill:url(#g260)}.dW{opacity:.4;mix-blend-mode:multiply;fill:#a56ef4}.dX{opacity:.7;mix-blend-mode:multiply;fill:#138bbd}.dY{opacity:0;fill:#43e8e1}.dZ{opacity:.1;fill:#54dcdf}.e0{opacity:.1;fill:#65d0de}.e1{opacity:.1;fill:#76c4dc}.e2{opacity:.2;fill:#87b8da}.e3{opacity:.2;fill:#98acd8}.e4{opacity:.3;fill:#aa9fd7}.e5{opacity:.3;fill:#bb93d5}.e6{opacity:.4;fill:#cc87d3}.e7{opacity:.4;fill:#dd7bd1}.e8{opacity:.5;fill:#ee6fd0}.e9{opacity:.2;fill:#76c4dc}.ea{opacity:.3;fill:#98acd8}.eb{opacity:.1;fill:#ff63ce}.ec{opacity:.3;fill:#ff63ce}.ed{opacity:.4;fill:#ff63ce}.ee{fill:url(#g261)}.ef{fill:url(#g262)}.eg{fill:url(#g263)}.eh{fill:url(#g264)}.ei{fill:url(#g265)}.ej{fill:url(#g266)}.ek{opacity:.1;fill:#87b8da}.el{opacity:.2;fill:#aa9fd7}.em{opacity:.2;fill:#bb93d5}.en{opacity:.2;fill:#cc87d3}.eo{opacity:.3;fill:#dd7bd1}.ep{opacity:.3;fill:#ee6fd0}.eq{fill:url(#g267)}.er{fill:url(#g268)}.es{fill:url(#g269)}.et{fill:url(#g270)}.eu{fill:url(#g271)}.ev{fill:url(#g272)}.ew{fill:url(#g273)}.ex{fill:url(#g274)}.ey{fill:url(#g275)}.ez{fill:url(#g276)}.eA{fill:url(#g277)}.eB{fill:url(#g278)}.eC{fill:url(#g279)}.eD{fill:url(#g280)}.eE{fill:url(#g281)}.eF{fill:url(#g282)}.eG{fill:url(#g283)}.eH{fill:url(#g284)}.eI{fill:url(#g285)}.eJ{fill:url(#g286)}.eK{fill:url(#g287)}.eL{fill:url(#g288)}.eM{fill:url(#g289)}.eN{fill:url(#g290)}.eO{fill:url(#g291)}.eP{fill:url(#g292)}.eQ{fill:url(#g293)}.eR{fill:url(#g294)}.eS{fill:url(#g295)}.eT{fill:url(#g296)}.eU{fill:url(#g297)}.eV{fill:url(#g298)}.eW{fill:url(#g299)}.eX{fill:url(#g300)}.eY{fill:url(#g301)}.eZ{fill:url(#g302)}.f0{fill:url(#g303)}.f1{fill:url(#g304)}.f2{fill:url(#g305)}.f3{fill:url(#g306)}.f4{fill:url(#g307)}.f5{fill:url(#g308)}.f6{fill:url(#g309)}.f7{fill:url(#g310)}.f8{fill:url(#g311)}.f9{fill:url(#g312)}.fa{mix-blend-mode:color-dodge;fill:url(#g313)}.fb{mix-blend-mode:color-dodge;fill:url(#g314)}.fc{mix-blend-mode:color-dodge;fill:url(#g315)}.fd{mix-blend-mode:color-dodge;fill:url(#g316)}.fe{mix-blend-mode:color-dodge;fill:url(#g317)}.ff{mix-blend-mode:color-dodge;fill:url(#g318)}.fg{mix-blend-mode:color-dodge;fill:url(#g319)}.fh{mix-blend-mode:color-dodge;fill:url(#g320)}.fi{mix-blend-mode:color-dodge;fill:url(#g321)}.fj{mix-blend-mode:color-dodge;fill:url(#g322)}.fk{mix-blend-mode:color-dodge;fill:url(#g323)}.fl{mix-blend-mode:color-dodge;fill:url(#g324)}.fm{mix-blend-mode:color-dodge;fill:url(#g325)}.fn{fill:url(#g326)}.fo{fill:url(#g327)}.fp{fill:url(#g328)}.fq{opacity:.5;mix-blend-mode:multiply;fill:#b086cc}.fr{fill:url(#g329)}.fs{fill:url(#g330)}.ft{fill:url(#g331)}.fu{fill:url(#g332)}.fv{fill:url(#g333)}.fw{fill:url(#g334)}.fx{fill:url(#g335)}.fy{fill:url(#g336)}.fz{fill:url(#g337)}.fA{fill:url(#g338)}.fB{fill:url(#g339)}.fC{fill:url(#g340)}.fD{fill:url(#g341)}.fE{fill:url(#g342)}.fF{fill:url(#g343)}.fG{fill:url(#g344)}.fH{fill:url(#g345)}.fI{fill:url(#g346)}.fJ{fill:url(#g347)}.fK{fill:url(#g348)}.fL{fill:url(#g349)}.fM{fill:url(#g350)}.fN{fill:url(#g351)}.fO{fill:url(#g352)}.fP{fill:url(#g353)}.fQ{fill:url(#g354)}.fR{fill:url(#g355)}.fS{fill:url(#g356)}.fT{fill:url(#g357)}.fU{fill:url(#g358)}.fV{fill:url(#g359)}.fW{fill:url(#g360)}.fX{fill:url(#g361)}.fY{fill:url(#g362)}.fZ{fill:url(#g363)}.g0{fill:url(#g364)}.g1{fill:url(#g365)}.g2{fill:url(#g366)}.g3{fill:url(#g367)}.g4{fill:url(#g368)}.g5{fill:url(#g369)}.g6{fill:url(#g370)}.g7{fill:url(#g371)}.g8{fill:url(#g372)}.g9{fill:url(#g373)}.ga{fill:url(#g374)}.gb{fill:url(#g375)}.gc{fill:url(#g376)}.gd{fill:url(#g377)}.ge{fill:url(#g378)}.gf{mix-blend-mode:color-dodge;fill:url(#g379)}.gg{fill:url(#g380)}.gh{fill:url(#g381)}.gi{fill:url(#g382)}.gj{fill:url(#g383)}.gk{fill:url(#g384)}.gl{fill:url(#g385)}.gm{fill:url(#g386)}.gn{fill:url(#g387)}.go{fill:url(#g388)}.gp{fill:url(#g389)}.gq{fill:url(#g390)}.gr{fill:url(#g391)}.gs{fill:url(#g392)}.gt{fill:url(#g393)}.gu{fill:url(#g394)}.gv{fill:url(#g395)}.gw{fill:url(#g396)}.gx{fill:url(#g397)}.gy{fill:url(#g398)}.gz{fill:url(#g399)}.gA{fill:url(#g400)}.gB{fill:url(#g401)}.gC{fill:url(#g402)}.gD{fill:url(#g403)}.gE{fill:url(#g404)}.gF{fill:url(#g405)}.gG{fill:url(#g406)}.gH{fill:url(#g407)}.gI{fill:url(#g408)}.gJ{fill:url(#g409)}.gK{fill:url(#g410)}.gL{fill:url(#g411)}.gM{fill:url(#g412)}.gN{fill:url(#g413)}.gO{fill:url(#g414)}.gP{fill:url(#g415)}.gQ{fill:url(#g416)}.gR{mix-blend-mode:color-dodge;fill:url(#g417)}.gS{mix-blend-mode:color-dodge;fill:url(#g418)}.gT{mix-blend-mode:color-dodge;fill:url(#g419)}.gU{mix-blend-mode:color-dodge;fill:url(#g420)}.gV{mix-blend-mode:color-dodge;fill:url(#g421)}.gW{opacity:.2;fill:#16032e}.gX{fill:#1b2b69}.gY{fill:url(#g422)}.gZ{fill:url(#g423)}.h0{mix-blend-mode:multiply;fill:url(#g424)}.h1{fill:url(#g425)}.h2{fill:url(#g426)}.h3{fill:url(#g427)}.h4{fill:url(#g428)}.h5{mix-blend-mode:multiply;fill:url(#g429)}.h6{fill:url(#g430)}.h7{fill:url(#g431)}.h8{fill:url(#g432)}.h9{fill:url(#g433)}.ha{mix-blend-mode:screen;fill:url(#g434)}.hb{fill:url(#g435)}.hc{fill:#271273}.hd{fill:url(#g436)}.he{fill:url(#g437)}.hf{mix-blend-mode:screen;fill:url(#g438)}.hg{fill:url(#g439)}.hh{mix-blend-mode:multiply;fill:url(#g440)}.hi{fill:url(#g441)}.hj{mix-blend-mode:multiply;fill:url(#g442)}.hk{fill:url(#g443)}.hl{fill:url(#g444)}.hm{fill:url(#g445)}.hn{fill:url(#g446)}.ho{fill:url(#g447)}.hp{fill:url(#g448)}.hq{fill:url(#g449)}.hr{fill:url(#g450)}.hs{fill:url(#g451)}.ht{fill:url(#g452)}.hu{fill:url(#g453)}.hv{mix-blend-mode:screen;fill:url(#g454)}.hw{fill:url(#g455)}.hx{fill:url(#g456)}.hy{fill:url(#g457)}.hz{fill:url(#g458)}.hA{mix-blend-mode:color-dodge;fill:url(#g459)}.hB{mix-blend-mode:multiply;fill:url(#g460)}.hC{mix-blend-mode:multiply;fill:url(#g461)}.hD{mix-blend-mode:screen;fill:url(#g462)}.hE{fill:#16032e}.hF{mix-blend-mode:screen;fill:url(#g463)}.hG{mix-blend-mode:screen;fill:url(#g464)}.hH{mix-blend-mode:screen;fill:url(#g465)}.hI{mix-blend-mode:screen;fill:url(#g466)}.hJ{mix-blend-mode:multiply;fill:url(#g467)}.hK{fill:url(#g468)}.hL{mix-blend-mode:screen;fill:url(#g469)}.hM{mix-blend-mode:screen;fill:url(#g470)}.hN{mix-blend-mode:color-dodge;fill:url(#g471)}.hO{mix-blend-mode:color-dodge;fill:url(#g472)}.hP{mix-blend-mode:color-dodge;fill:url(#g473)}.hQ{mix-blend-mode:color-dodge;fill:url(#g474)}.hR{mix-blend-mode:color-dodge;fill:url(#g475)}.hS{mix-blend-mode:color-dodge;fill:url(#g476)}.hT{mix-blend-mode:color-dodge;fill:url(#g477)}.hU{mix-blend-mode:color-dodge;fill:url(#g478)}.hV{mix-blend-mode:color-dodge;fill:url(#g479)}.hW{fill:url(#g480)}.hX{fill:url(#g481)}.hY{mix-blend-mode:color-dodge;fill:url(#g482)}.hZ{fill:url(#g483)}.i0{fill:url(#g484)}.i1{mix-blend-mode:color-dodge;fill:url(#g485)}.i2{fill:url(#g486)}.i3{fill:url(#g487)}.i4{mix-blend-mode:color-dodge;fill:url(#g488)}.i5{fill:url(#g489)}.i6{fill:url(#g490)}.i7{fill:url(#g491)}.i8{fill:url(#g492)}.i9{fill:url(#g493)}.ia{fill:url(#g494)}.ib{fill:url(#g495)}.ic{fill:url(#g496)}.id{fill:url(#g497)}.ie{mix-blend-mode:color-dodge;fill:url(#g498)}.if{mix-blend-mode:multiply;fill:url(#g499)}.ig{fill:url(#g500)}.ih{fill:url(#g501)}.ii{fill:url(#g502)}.ij{mix-blend-mode:color-dodge;fill:url(#g503)}.ik{fill:url(#g504)}.il{fill:url(#g505)}.im{fill:url(#g506)}.in{fill:url(#g507)}.io{fill:url(#g508)}.ip{mix-blend-mode:color-dodge;fill:url(#g509)}.iq{fill:url(#g510)}.ir{fill:url(#g511)}.is{mix-blend-mode:color-dodge;fill:url(#g512)}.it{mix-blend-mode:screen;fill:#a56ef4}.iu{opacity:.5;mix-blend-mode:screen;fill:#a56ef4}.iv{fill:url(#g513)}.iw{fill:url(#g514)}.ix{mix-blend-mode:color-dodge;fill:url(#g515)}.iy{fill:url(#g516)}.iz{fill:url(#g517)}.iA{fill:url(#g518)}.iB{fill:url(#g519)}.iC{fill:url(#g520)}.iD{mix-blend-mode:color-dodge;fill:url(#g521)}.iE{fill:url(#g522)}.iF{fill:url(#g523)}.iG{mix-blend-mode:color-dodge;fill:url(#g524)}.iH{fill:url(#g525)}.iI{fill:url(#g526)}.iJ{mix-blend-mode:color-dodge;fill:url(#g527)}.iK{fill:url(#g528)}.iL{fill:url(#g529)}.iM{mix-blend-mode:color-dodge;fill:url(#g530)}.iN{fill:url(#g531)}.iO{fill:url(#g532)}.iP{mix-blend-mode:color-dodge;fill:url(#g533)}.iQ{fill:url(#g534)}.iR{fill:url(#g535)}.iS{mix-blend-mode:color-dodge;fill:url(#g536)}.iT{mix-blend-mode:color-dodge;fill:url(#g537)}.iU{mix-blend-mode:color-dodge;fill:url(#g538)}.iV{mix-blend-mode:color-dodge;fill:url(#g539)}.iW{mix-blend-mode:color-dodge;fill:url(#g540)}.iX{mix-blend-mode:color-dodge;fill:url(#g541)}.iY{mix-blend-mode:color-dodge;fill:url(#g542)}.iZ{mix-blend-mode:color-dodge;fill:url(#g543)}.j0{mix-blend-mode:color-dodge;fill:url(#g544)}.j1{mix-blend-mode:color-dodge;fill:url(#g545)}.j2{mix-blend-mode:color-dodge;fill:url(#g546)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m209 377.3l61.1 36.6-59.4 33.4-39.5-22.9 0.1-0.1c-1.2 0.5-2.7 0.7-4.2 0.7-2 0-4-0.5-5.4-1.3-1.7-1-2.7-2.4-2.7-3.9 0-1.6 1-3 2.7-4 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.4 1.7 1 2.6 2.4 2.6 3.9 0 1.1-0.5 2.2-1.5 3.1l37 21.3 53.9-30.3-61.2-36.6 69.7-38.4-46.2-27.2 15.4-8.7c-1.1-0.9-1.7-2.1-1.7-3.3 0-1.5 1-3 2.7-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.4 2.7 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.5 1.4-5.5 1.4-1.3 0-2.5-0.2-3.6-0.5l-12.9 7.3 46.3 27.2zm34.4-77.7c0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.1 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.7 0-0.5-0.5-1.1-1.3-1.5-1-0.6-2.5-1-4.1-1-1.5 0-3.1 0.4-4.1 1-0.9 0.5-1.4 1.1-1.4 1.6zm-72.2 121.7c0.9-0.5 1.4-1.1 1.4-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6 0 0.6 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m355.4 326.1l-48.6 27.5 20.1 13.6-27.6 15.6 25.7 15.5 23.5-13.1c-1-0.9-1.5-2-1.5-3.1 0-1.6 0.9-3 2.6-4 1.5-0.8 3.5-1.3 5.5-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.6-0.9 3-2.7 3.9-1.4 0.9-3.4 1.4-5.4 1.4-1.4 0-2.7-0.3-3.9-0.7l-26.3 14.7-31.1-18.7 27.8-15.7-20.1-13.6 48.2-27.3-38.1-21.8c-1.1 0.4-2.4 0.6-3.7 0.6-2 0-4-0.5-5.5-1.4-1.7-0.9-2.7-2.4-2.7-3.9 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.4-1.3 2.1 0 4.1 0.5 5.6 1.4 1.7 0.9 2.6 2.4 2.6 3.9 0 1.2-0.5 2.3-1.6 3.2zm-43.2-24.9c0.8-0.5 1.3-1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6 0 0.5 0.5 1.1 1.4 1.6 2.1 1.2 6.1 1.2 8.2 0zm37.6 80.9c0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.1 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.4-1.6-1-0.6-2.5-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m424 359.9c-1.5 0.8-3.5 1.3-5.5 1.3-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4 0-1.6 0.9-3 2.7-3.9 1.4-0.9 3.4-1.4 5.4-1.4 1.4 0 2.8 0.3 3.9 0.7l13.9-8.5-95.8-54.6c-1.3 0.6-2.8 0.9-4.5 0.9-2 0-4-0.5-5.5-1.4-1.7-0.9-2.7-2.4-2.7-3.9 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.4 1.7 0.9 2.7 2.4 2.7 3.9 0 1-0.4 2-1.2 2.8l98.6 56.1-16.4 10.1c1 0.9 1.5 2 1.5 3.1 0 1.6-0.9 3-2.6 4zm-84-74.5c0.9-0.5 1.3-1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0zm83.9 70.5c0-0.5-0.5-1.1-1.3-1.6l-0.4 0.2-0.3-0.5c-1-0.4-2.2-0.6-3.5-0.6-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6 0 0.5 0.5 1.1 1.4 1.6 2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1 1.3-1.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m501.6 387.6c0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.4-5.4 1.4-1.7 0-3.3-0.4-4.7-1l-29.2 16.8-38.7-22.6 56.4-34.9-122.8-70.9c-1.3 0.6-2.9 0.9-4.6 0.9-2.1 0-4-0.5-5.5-1.4-1.7-0.9-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.7-4 1.4-0.8 3.4-1.3 5.4-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1-0.3 1.9-1 2.6l125.6 72.6-56.4 34.9 33.4 19.6 26.7-15.4c-0.7-0.8-1.1-1.7-1.1-2.7 0-1.5 1-2.9 2.7-3.9 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4zm-147.6-110.1c0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.4 1.6 2.1 1.2 6.1 1.2 8.2 0zm144.8 110.1c0-0.5-0.4-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.4-1.3 1-1.3 1.5 0 0.6 0.5 1.2 1.3 1.7 1.1 0.6 2.6 0.9 4.2 0.9 1.5 0 3-0.3 4-0.9 0.9-0.5 1.3-1.1 1.3-1.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m557.5 194.8c0 1.6-0.9 3-2.6 4-1.5 0.8-3.4 1.3-5.5 1.3-2 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4q0-1.1 0.6-2l-52.6-29.2 18-10.3q-0.7-1.1-0.8-2.3c0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.4-5.5 1.4-1.9 0-3.8-0.5-5.2-1.3l-14.7 8.5 49.2 27.2c1.4-0.8 3.4-1.3 5.4-1.3 2.1 0 4 0.5 5.5 1.4 1.8 1 2.7 2.4 2.7 3.9zm-48.3-43.8c0 0.6 0.5 1.2 1.3 1.6 2.1 1.3 6.1 1.3 8.2 0.1 0.9-0.5 1.3-1.1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.4-1.3 1-1.3 1.5zm45.6 43.8c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-2.9 0.3-3.9 0.9l-0.7 1.2-0.5-0.3q-0.3 0.4-0.3 0.7c0 0.5 0.5 1.1 1.4 1.6 1 0.6 2.5 1 4.1 1 1.6 0 3.1-0.4 4.1-1 0.8-0.5 1.3-1 1.3-1.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m193 273.3c-1.8 0-3.5-0.4-4.9-1.1v0.1l-52.4 29.6-28.9-15.1-29.4 18.4-10.5-6.4 0.4-0.7c-1.4 0.8-3.3 1.2-5.2 1.2-2.1 0-4-0.4-5.5-1.3-1.8-1-2.7-2.4-2.7-4 0-1.5 0.9-2.9 2.6-3.9 1.5-0.9 3.4-1.3 5.5-1.3 2 0 4 0.4 5.5 1.3 1.7 1 2.7 2.4 2.7 4 0 1-0.4 2-1.2 2.8l8.4 5.1 29.3-18.4 28.9 15.2 50.2-28.3c-0.6-0.8-0.9-1.6-0.9-2.5 0-1.5 1-3 2.7-4 1.5-0.8 3.5-1.3 5.5-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.6 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.4 1.4-5.5 1.4zm-125.5 20.8c0-0.6-0.5-1.1-1.4-1.6-1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.8 0.4-1.3 1-1.3 1.5 0 0.6 0.5 1.2 1.3 1.6 2.2 1.3 6.1 1.3 8.3 0.1 0.8-0.5 1.3-1.1 1.3-1.6zm121.4-24.5c2.1 1.2 6.1 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.5-1.1-1.3-1.6-1-0.6-2.5-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.4 1.1-1.4 1.6 0 0.5 0.5 1.1 1.3 1.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m234.9 297c-1.5 0-2.9-0.3-4.2-0.7l0.3 0.5-27.3 15.5 43.2 24.9-23.3 13.6-19.8-11.8c-1.3 0.5-2.8 0.8-4.4 0.8-2 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.4 1.7 0.9 2.7 2.4 2.7 3.9 0 1.1-0.5 2-1.3 2.8l17.3 10.3 17.9-10.4-43.3-25 30.3-17.2c-1.1-0.9-1.7-2-1.7-3.3 0-1.5 1-3 2.7-3.9 1.5-0.9 3.4-1.4 5.5-1.4 2 0 4 0.5 5.4 1.3 1.8 1 2.7 2.4 2.7 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.4 1.4-5.5 1.4zm-31.4 39.1c0.9-0.5 1.3-1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.1-0.9-1.6 0-3.1 0.3-4.1 0.9-0.9 0.5-1.3 1.1-1.3 1.6 0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0zm27.3-42.8c2.1 1.2 6.1 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6 0 0.6 0.5 1.1 1.3 1.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m410.5 240l23.9-15.1-25.8-14.9 26-15.7c-0.7-0.9-1.1-1.8-1.1-2.8 0-1.6 0.9-3 2.6-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 3.9 0 1.6-0.9 3-2.6 4-1.5 0.8-3.5 1.3-5.5 1.3-1.6 0-3.2-0.3-4.6-0.9l-23.1 14.1 25.7 14.8-26.8 16.9c0.6 0.8 1 1.7 1 2.6 0 1.6-1 3-2.7 4-1.5 0.8-3.4 1.3-5.5 1.3-2 0-4-0.5-5.5-1.4-1.7-1-2.7-2.4-2.7-3.9 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 1.7 0 3.4 0.4 4.8 1zm25.7-48.5c0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6zm-25.1 52.8c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1-1.3 1.6 0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1.1 1.3-1.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "i",
    d: "m372 268q0 1.1-0.7 2.1l90.8 52.1 30-18.7c-0.6-0.8-1-1.7-1-2.5 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.6-1 3-2.7 3.9-1.5 0.9-3.4 1.4-5.5 1.4-1.8 0-3.5-0.4-4.9-1.1l-32.2 20.2-0.7-0.4-92.3-53c-1.5 0.8-3.4 1.3-5.3 1.3-2.1 0-4.1-0.5-5.5-1.4-1.8-0.9-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.6-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4zm121.9 33c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1.1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1-1.3 1.6zm-125.9-31.4c0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.4-1.6-1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.1 1.2 8.3 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m290 369.3l-12 7.2c0.6 0.8 0.9 1.6 0.9 2.5 0 1.6-0.9 3-2.6 4-1.5 0.8-3.5 1.3-5.5 1.3-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4 0-1.6 0.9-3 2.7-4 1.4-0.8 3.4-1.3 5.4-1.3 2 0 3.9 0.5 5.4 1.3l-0.2-0.4 12-7.2q-0.6-1-0.7-2.1c0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.6-1 3-2.7 4-1.5 0.8-3.4 1.3-5.5 1.3-2 0-3.9-0.5-5.4-1.3zm0-4c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1-1.3 1.6zm-13.8 13.7c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1.1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1 1.3-1.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m321.1 423.3c0 1.6-1 3-2.7 3.9-1.5 0.9-3.4 1.4-5.5 1.4-2 0-4-0.5-5.5-1.4-1.7-1-2.7-2.4-2.7-3.9 0-1 0.4-1.9 1-2.6l-71.4-41.1 76.7-43.5-28.3-16.9c-1.4 0.6-3.1 1-4.8 1-2.1 0-4-0.5-5.5-1.4-1.7-1-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.7-4 1.4-0.8 3.4-1.3 5.4-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 0.9-0.3 1.8-0.9 2.5l31.4 18.7-76.7 43.5 68.4 39.3c1.4-0.6 3-0.9 4.7-0.9 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4zm-39.1-106.8c0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.4 1.6 2.1 1.2 6.1 1.2 8.2 0zm36.3 106.8c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1-1.3 1.6 0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1.1 1.3-1.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m183.2 354.2l-41.6-23.8 72.9-43.3c-1.1-1-1.7-2.1-1.7-3.3 0-1.5 1-3 2.7-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.6 4 0 1.5-0.9 3-2.6 3.9-1.5 0.9-3.5 1.4-5.6 1.4-1.8 0-3.5-0.4-4.9-1.1l0.6 1-69.6 41.4 38.4 21.9c1.4-0.8 3.3-1.3 5.2-1.3 2.1 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 4 0 1.5-0.9 2.9-2.6 3.9-1.5 0.9-3.5 1.3-5.5 1.3-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.4-2.7-4q0-1.1 0.7-2.1zm32.4-70.4c0 0.6 0.4 1.1 1.2 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.5-1.1-1.3-1.6-1-0.6-2.5-1-4.1-1-1.5 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1.1-1.3 1.6zm-29.1 70.9c-0.8 0.5-1.3 1.1-1.3 1.6 0 0.6 0.5 1.1 1.4 1.6 2.1 1.3 6.1 1.3 8.2 0 0.8-0.4 1.3-1 1.3-1.5 0-0.6-0.5-1.2-1.3-1.6-1.1-0.7-2.6-1-4.2-1-1.5 0-3 0.3-4.1 0.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "l",
    d: "m367.3 313.5c0 1.6-0.9 3-2.6 4-1.5 0.8-3.5 1.3-5.5 1.3-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4q0-1.2 0.8-2.3l-25.2-15.1c-1.4 0.6-2.9 0.9-4.6 0.9-2.1 0-4-0.5-5.5-1.4-1.7-0.9-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.6-4 1.5-0.8 3.5-1.3 5.5-1.3 2.1 0 4 0.5 5.5 1.4 1.7 0.9 2.7 2.4 2.7 3.9 0 1-0.4 1.9-1 2.7l24.9 15c1.4-0.7 3.2-1.2 5.1-1.2 2.1 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 3.9zm-41.2-20.2c0.8-0.5 1.3-1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0zm38.5 20.2c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1 1.3-1.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "m",
    d: "m102.3 257.6c0 0.9-0.3 1.8-1 2.6l39.2 21.7 32.2-18.5c-1.1-0.9-1.8-2-1.8-3.3 0-1.5 1-3 2.7-4 1.5-0.8 3.5-1.3 5.6-1.3 2 0 3.9 0.5 5.4 1.3 1.7 1 2.7 2.4 2.7 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.5 1.4-5.5 1.4-1.4 0-2.6-0.2-3.8-0.6l0.1 0.2-34.8 20-41.7-23.1c-1.4 0.6-3 1-4.7 1-2 0-4-0.5-5.5-1.4-1.7-1-2.7-2.4-2.7-4 0-1.5 1-2.9 2.7-3.9 1.5-0.8 3.4-1.3 5.4-1.3 2.1 0 4.1 0.5 5.6 1.3 1.7 1 2.6 2.5 2.6 4zm71.4 2.5c0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1.1 1.3-1.6 0-0.6-0.4-1.1-1.3-1.6-1-0.6-2.5-1-4-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6zm-75.4-0.9q0.3-0.2 0.5-0.3v-0.1h0.1c0.4-0.4 0.7-0.8 0.7-1.2 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4 1-0.9 0.4-1.3 1-1.3 1.5 0 0.6 0.4 1.2 1.3 1.7 2.1 1.2 6.1 1.2 8.2 0z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m257 79.6l-49.1-27.1 44.7-27 0.7 0.4 92.3 51-38.6 24q0.4 0.8 0.4 1.7c0 1.6-0.9 3-2.7 4-1.4 0.8-3.4 1.3-5.4 1.3-2.1 0-4-0.5-5.5-1.4-1.7-1-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.6-4 1.5-0.8 3.4-1.3 5.5-1.3 2.1 0 4 0.5 5.5 1.3q0.2 0.1 0.4 0.3l35.1-21.9-87.5-48.3-39.3 23.7 45.7 25.2c1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 4 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.3-5.5 1.3-2 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4q0-1.1 0.6-2zm47.7 23c0-0.5-0.5-1.1-1.4-1.6-1-0.6-2.5-1-4.1-1-1.6 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 1.1 0.6 2.6 0.9 4.2 0.9 1.5 0 3-0.3 4.1-0.9 0.8-0.5 1.3-1.1 1.3-1.6zm-40.1-23.5c-1.6 0-3.1 0.3-4.1 0.9q-0.3 0.2-0.5 0.3l-0.4 0.7-0.2-0.1q-0.2 0.4-0.2 0.7c0 0.5 0.5 1.1 1.3 1.6 2.1 1.3 6.1 1.3 8.2 0 0.9-0.4 1.3-1 1.3-1.5 0-0.6-0.5-1.2-1.3-1.6-1.1-0.7-2.6-1-4.1-1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "n",
    d: "m390.6 70.6c0-1.6 0.9-3 2.7-3.9 1.4-0.9 3.4-1.4 5.4-1.4 2.1 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 3.9 0 1.6-0.9 3-2.6 4-1.5 0.8-3.5 1.3-5.5 1.3-1.4 0-2.8-0.2-4-0.7v0.1l-51.8 32.1 47.6 26.2-51.5 29.9-1.4-2.3 47.3-27.6-47.4-26 54.5-33.8c-1-0.9-1.5-2-1.5-3.2zm2.7 0c0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.3 8.3 0 0.8-0.5 1.3-1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m15 327.9q-0.2 0.2-0.5 0.4c-1.5 0.9-3.4 1.3-5.5 1.3-2 0-4-0.4-5.5-1.3-1.7-1-2.7-2.4-2.7-4 0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.4-1.3 5.4-1.3 2.1 0 4 0.4 5.5 1.3 1.8 1 2.7 2.4 2.7 4q0 0.7-0.3 1.4l29.2 16.9 51.2-31.2c-0.6-0.8-0.9-1.6-0.9-2.5 0-1.5 0.9-2.9 2.6-3.9 1.5-0.9 3.5-1.3 5.5-1.3 2.1 0 4 0.4 5.5 1.3 1.7 1 2.7 2.4 2.7 4 0 1.5-0.9 2.9-2.7 3.9-1.4 0.9-3.4 1.3-5.4 1.3-1.8 0-3.6-0.4-5-1l-53.4 32.6zm84.5-17.9l0.1-0.1 0.3 0.4q0.2 0.1 0.4 0.3c2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.3 0.2 0.6 0.6 1zm-86.5 15.9c0.9-0.5 1.3-1.1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.9 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "o",
    d: "m52.5 366.5q0.4 0.8 0.4 1.7c0 1.6-0.9 3-2.6 4-1.5 0.8-3.4 1.3-5.5 1.3-2 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.4-1.3 2.1 0 4.1 0.5 5.6 1.4q0.1 0.1 0.3 0.2l149.5-85.7c-0.8-0.8-1.2-1.8-1.2-2.9 0-1.5 0.9-3 2.7-4 1.4-0.8 3.4-1.3 5.5-1.3 2 0 3.9 0.5 5.4 1.3 1.7 1 2.7 2.4 2.7 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.5 1.4-5.5 1.4-1.8 0-3.5-0.4-4.9-1.1l0.3 0.6zm149.1-90.6c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1.1 1.3-1.7 0-0.5-0.4-1.1-1.2-1.5-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6zm-151.4 92.3c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.4 1.6 2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1.1 1.3-1.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "p",
    d: "m397 256.7l0.4-0.7q-0.1 0.1-0.2 0.2c-1.4 0.8-3.4 1.3-5.4 1.3-2.1 0-4-0.5-5.5-1.4-1.7-1-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.6-4 1.5-0.8 3.5-1.3 5.5-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 0.9-0.3 1.7-0.9 2.5l25.7 15.5 32-19.1c-0.9-0.8-1.4-1.9-1.4-3 0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.4-1.3 5.4-1.3 2.1 0 4.1 0.4 5.5 1.3 1.8 1 2.7 2.4 2.7 4 0 1.5-0.9 2.9-2.6 3.9-1.5 0.9-3.4 1.3-5.5 1.3-1.5 0-2.9-0.2-4.1-0.7l-34.7 20.7zm61-8.6c0 0.6 0.5 1.2 1.3 1.6 2.2 1.3 6.1 1.3 8.3 0.1 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.5-1.1-1.4-1.6-1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.8 0.4-1.3 1-1.3 1.5zm-60.9 4.1c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.2 1.1-1.2 1.6 0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1 1.3-1.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m417.8 116.1l42.7-25.8q-0.5-0.9-0.5-1.8c0-1.6 0.9-3 2.6-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.6-1 3-2.7 3.9-1.5 0.9-3.4 1.4-5.4 1.4-2.1 0-4.1-0.5-5.6-1.4q0 0-0.1-0.1l-44.7 27-24.4-14.4c-1.3 0.5-2.9 0.9-4.6 0.9-2.1 0-4-0.5-5.5-1.4-1.8-0.9-2.7-2.4-2.7-3.9 0-1.6 0.9-3 2.6-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1-0.4 1.9-1 2.6zm-25-14q0.1 0 0.1-0.1l0.3-0.4 0.2 0.1c0.4-0.4 0.7-0.8 0.7-1.2 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.4 1.6 2.1 1.2 6.1 1.2 8.2 0zm69.8-13.6c0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "q",
    d: "m419.7 160.4l-51.5 30-1.3-2.4 47.3-27.5-16.9-9.3 51.9-31.5c-0.9-0.9-1.5-2-1.5-3.1 0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.4-1.4 5.5-1.4 2 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 4 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.3-5.5 1.3-1.4 0-2.8-0.2-4-0.7l-49.2 29.9zm30.8-43.8c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.3-1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.1-0.9-1.6 0-3.1 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "r",
    d: "m286.9 176.9l47.3-27.5-79.3-43.2 45.7-28.5-31.7-16.9q-0.1 0-0.2 0.1c-1.5 0.8-3.4 1.3-5.4 1.3-2.1 0-4.1-0.5-5.6-1.3-1.7-1-2.6-2.5-2.6-4 0-1.5 0.9-2.9 2.6-3.9 1.5-0.9 3.4-1.4 5.5-1.4 2 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 4q0 0.9-0.5 1.8l35.1 18.7-45.7 28.5 79.5 43.3-51.5 30zm-19.6-118.4c0.9-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4 1-0.9 0.5-1.3 1-1.3 1.6 0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s",
    d: "m10.6 175.5c0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.4 2.7 4 0 1-0.4 1.9-1.2 2.7l73.4 43-16.7 9.9 57.5 34.1 18.1-10.3c-0.7-0.8-1.1-1.7-1.1-2.7 0-1.5 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.6 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.4 1.4-5.5 1.4-1.6 0-3.2-0.3-4.5-0.9l-20.6 11.7-62.9-37.2 16.7-9.9-70.5-41.3c-1.3 0.6-2.9 0.9-4.5 0.9-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.4-2.7-4zm149.1 76.7c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6zm-146.3-76.7c0 0.6 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0q0.3-0.1 0.5-0.3c0.5-0.4 0.8-0.9 0.8-1.3 0-0.5-0.4-1.1-1.3-1.6-1-0.6-2.5-0.9-4.1-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "t",
    d: "m66.7 183.9c0-1.5 0.9-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.4 1.3 1.7 1 2.7 2.4 2.7 4q0 1.1-0.7 2.1l62.3 38.2-24.3 14.5 18.6 10.8 4.9-2.9q-0.8-1.1-0.8-2.3c0-1.5 1-3 2.7-4 1.5-0.8 3.5-1.3 5.5-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.7 4 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.5 1.4-5.6 1.4-1.8 0-3.6-0.4-5.1-1.2l-7.1 4.3-24-14 24.5-14.6-59.3-36.2c-1.4 0.8-3.3 1.3-5.3 1.3-2.1 0-4-0.5-5.5-1.4-1.7-0.9-2.6-2.3-2.6-3.9zm79.1 60.4c0 0.5 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.4-1.1-1.3-1.6-1-0.6-2.5-1-4.1-1-1.5 0-3 0.4-4.1 1-0.9 0.5-1.3 1.1-1.3 1.6zm-76.4-60.4c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.4-1.1 1.4-1.6 0-0.6-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m160.3 51.7c0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.4 1.7 0.9 2.7 2.3 2.7 3.9 0 1.2-0.7 2.4-1.8 3.3l48.8 27.6-41.9 23.3 93.3 54.9-1.4 2.3-97.3-57.3 41.8-23.2-46.2-26.1c-1.1 0.3-2.3 0.5-3.5 0.5-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.4-2.7-4zm2.8 0c0 0.6 0.4 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1-0.6-2.5-0.9-4.1-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "v",
    d: "m54.5 129.6c0-1.5 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.4 1.3 1.8 1 2.7 2.4 2.7 4 0 1-0.5 2-1.3 2.9l44.3 26-15.3 8.7 87.4 51.2-1.4 2.3-91.4-53.5 15.3-8.7-41.5-24.4c-1.3 0.5-2.8 0.8-4.3 0.8-2.1 0-4-0.5-5.5-1.4-1.7-1-2.6-2.3-2.6-3.9zm2.7 0c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.2 0 0.9-0.5 1.4-1.1 1.4-1.6 0-0.6-0.5-1.2-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m112.3 74.4c0-1.5 1-3 2.7-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.6 4q0 1.1-0.6 2l22.7 13.3 16-8.9c-1-0.9-1.5-2-1.5-3.1 0-1.5 1-3 2.7-4 1.5-0.8 3.5-1.3 5.5-1.3 2.1 0 4 0.4 5.5 1.3 1.7 1 2.6 2.4 2.6 3.9 0 1.6-0.9 3-2.6 4-1.5 0.9-3.5 1.4-5.6 1.4-1.3 0-2.6-0.3-3.8-0.7l-18.1 10.2-0.7-1.2-0.7 1.2-24.1-14.1c-1.5 0.8-3.4 1.3-5.5 1.3-2 0-3.9-0.5-5.4-1.3-1.7-1-2.7-2.4-2.7-4zm55.6 3.3c0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.7 0-0.5-0.5-1.1-1.3-1.5-1-0.6-2.5-1-4.1-1-1.5 0-3.1 0.4-4.1 1-0.9 0.5-1.4 1.1-1.4 1.6zm-52.9-3.3c0 0.6 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1-0.6-2.5-0.9-4.1-0.9-1.5 0-3.1 0.3-4.1 0.9-0.9 0.5-1.4 1.1-1.4 1.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "w",
    d: "m500.6 272.7l46.5 26-53.6 32.8q0.7 1 0.7 2.2c0 1.5-1 2.9-2.7 3.9-1.5 0.8-3.4 1.3-5.5 1.3-2 0-4-0.5-5.5-1.3-1.7-1-2.7-2.5-2.7-4 0-1.6 1-3 2.7-3.9 1.5-0.9 3.4-1.4 5.5-1.4 2 0 3.9 0.5 5.4 1.3l50.3-30.8-41.1-22.9-47.9 27.7-70.1-38.3 0.7-1.3q0 0 0 0.1c-1.5 0.8-3.4 1.3-5.5 1.3-2 0-4-0.5-5.5-1.4-1.7-0.9-2.7-2.4-2.7-3.9 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.4-1.3 2.1 0 4.1 0.5 5.6 1.3 1.7 1 2.6 2.5 2.6 4 0 1.2-0.5 2.2-1.4 3.1l68.2 37.2zm-117.4-12.6c0-0.5-0.5-1.1-1.4-1.6-1-0.6-2.5-1-4.1-1-1.6 0-3.1 0.4-4.1 1-0.8 0.5-1.3 1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.2 8.3 0 0.8-0.5 1.3-1 1.3-1.6zm107.9 72.9l-0.3 0.2-0.6-1.1q-0.1 0-0.1-0.1c-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 1.1 0.6 2.6 1 4.2 1 1.5 0 3-0.4 4.1-1 0.8-0.4 1.3-1 1.3-1.5q0-0.4-0.3-0.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m220.2 399.8q0 1.1-0.7 2.1l12 7.3-0.2 0.3c1.5-0.8 3.4-1.2 5.4-1.2 2 0 4 0.4 5.5 1.3 1.7 1 2.6 2.4 2.6 3.9 0 1.6-1 3-2.7 4-1.5 0.9-3.4 1.3-5.5 1.3-2 0-4-0.4-5.4-1.3-1.8-1-2.7-2.4-2.7-3.9 0-0.9 0.3-1.8 0.9-2.5l-12-7.3c-1.5 0.9-3.4 1.3-5.4 1.3-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.4-2.7-3.9 0-1.6 1-3 2.7-4 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 3.9zm-4.1 1.6c0.9-0.5 1.3-1.1 1.3-1.6 0-0.5-0.4-1.1-1.3-1.6-1-0.6-2.5-0.9-4.1-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.7 0 0.5 0.4 1.1 1.3 1.5 1 0.6 2.5 1 4.1 1 1.5 0 3-0.4 4.1-1zm15.1 12.2c0 0.5 0.5 1.1 1.3 1.5 2.1 1.3 6.1 1.3 8.3 0 0.8-0.5 1.3-1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.1-0.9-1.6 0-3.1 0.3-4.2 1-0.8 0.4-1.3 1-1.3 1.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m111.2 136.6c0-1.5 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.6 4q0 1.1-0.6 2.1l12 7.2-0.2 0.4c1.4-0.8 3.3-1.3 5.3-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.4 2.7 4 0 1.5-1 3-2.7 3.9-1.5 0.9-3.5 1.4-5.5 1.4-2.1 0-4-0.5-5.5-1.3-1.7-1-2.7-2.4-2.7-4 0-0.9 0.4-1.7 1-2.5l-12.1-7.2c-1.5 0.8-3.4 1.3-5.4 1.3-2 0-4-0.5-5.4-1.4-1.8-0.9-2.7-2.3-2.7-3.9zm27.4 13.7c0 0.6 0.4 1.1 1.3 1.6 1 0.6 2.5 1 4.1 1 1.5 0 3-0.4 4.1-1 0.9-0.5 1.3-1.1 1.3-1.6 0-0.6-0.4-1.1-1.3-1.6-1-0.6-2.5-1-4.1-1-1.5 0-3 0.4-4.1 1-0.8 0.5-1.3 1.1-1.3 1.6zm-24.7-13.7c0 0.5 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.3 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.6-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m531.6 233.8l-61.2 35.1c0.6 0.7 1 1.6 1 2.5 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.3-5.5 1.3-2 0-4-0.4-5.5-1.3-1.7-1-2.7-2.4-2.7-4 0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.4-1.3 5.5-1.3 2 0 3.9 0.4 5.3 1.2l-0.2-0.3 61.2-35.1q-0.7-1-0.7-2.2c0-1.5 0.9-2.9 2.7-3.9 1.4-0.8 3.4-1.3 5.4-1.3 2.1 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.5-0.9 2.9-2.6 3.9-1.5 0.9-3.5 1.4-5.5 1.4-2 0-3.9-0.5-5.4-1.3zm-0.1-4.1c0 0.6 0.5 1.2 1.4 1.7 2.1 1.2 6.1 1.2 8.2 0 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.4-4.1 1-0.8 0.4-1.3 1-1.3 1.5zm-62.9 41.7c0-0.6-0.5-1.1-1.3-1.6-1.1-0.7-2.6-1-4.1-1-1.6 0-3.1 0.3-4.1 0.9-0.9 0.5-1.3 1.1-1.3 1.6 0 0.6 0.4 1.1 1.3 1.6 2.1 1.3 6.1 1.3 8.2 0.1 0.9-0.5 1.3-1.1 1.3-1.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m449.8 142.6l-12.1 7.3c0.6 0.7 0.9 1.6 0.9 2.5 0 1.5-0.9 2.9-2.6 3.9-1.5 0.9-3.5 1.3-5.5 1.3-2.1 0-4-0.4-5.5-1.3-1.7-1-2.7-2.4-2.7-4 0-1.5 0.9-2.9 2.7-3.9 1.4-0.9 3.4-1.3 5.4-1.3 2 0 3.9 0.4 5.4 1.3l-0.2-0.4 12-7.3q-0.6-1-0.7-2.1c0-1.5 1-2.9 2.7-3.9 1.5-0.9 3.4-1.3 5.5-1.3 2 0 4 0.4 5.5 1.3 1.7 1 2.7 2.4 2.7 4 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.3-5.4 1.3-2.1 0-4-0.4-5.4-1.3zm-0.1-4c0 0.6 0.5 1.1 1.3 1.6 2.1 1.3 6.1 1.3 8.2 0 0.9-0.4 1.3-1 1.3-1.5 0-0.6-0.4-1.2-1.3-1.6-1.1-0.7-2.6-1-4.1-1-1.6 0-3.1 0.3-4.1 0.9-0.9 0.5-1.3 1.1-1.3 1.6zm-13.8 13.8c0-0.6-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.2-1-1.5 0-3 0.3-4.1 1-0.8 0.4-1.3 1-1.3 1.5 0 0.6 0.5 1.2 1.4 1.6 2.1 1.3 6.1 1.3 8.2 0.1 0.8-0.5 1.3-1.1 1.3-1.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "x",
    d: "m157.2 158.3l27.2-16.8-59.1-34.5c-1.4 0.6-3.1 1-4.9 1-2 0-3.9-0.5-5.4-1.3-1.7-1-2.7-2.4-2.7-4 0-1.5 1-3 2.7-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.3 1.7 1 2.6 2.4 2.6 4 0 0.9-0.3 1.7-0.9 2.5l62 36.2-27.2 16.9 74 43.2-1.3 2.3zm-32.6-54c0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-1-4.1-1-1.6 0-3.1 0.4-4.2 1-0.8 0.5-1.3 1.1-1.3 1.6 0 0.6 0.5 1.1 1.3 1.6 2.1 1.2 6.1 1.2 8.3 0z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m136.4 340.4c0 1.6-0.9 3-2.7 4-1.4 0.8-3.4 1.3-5.4 1.3-2 0-3.8-0.4-5.3-1.2l-40.4 22.8 26.5 14.5c1.5-0.9 3.4-1.3 5.4-1.3 2 0 4 0.5 5.5 1.3 1.7 1 2.7 2.5 2.7 4 0 1.5-1 2.9-2.7 3.9-1.5 0.9-3.4 1.4-5.4 1.4-2.1 0-4.1-0.5-5.6-1.4-1.7-1-2.6-2.4-2.6-4q0-1 0.6-2l-30.1-16.4 43.9-24.7q-0.7-1-0.7-2.2c0-1.6 0.9-3 2.6-3.9 1.5-0.9 3.5-1.4 5.5-1.4 2.1 0 4 0.5 5.5 1.4 1.7 1 2.7 2.4 2.7 3.9zm-21.9 42.8c-1.6 0-3.1 0.4-4.1 1q-0.6 0.3-0.9 0.7l-0.1 0.1q-0.3 0.4-0.3 0.7c0 0.6 0.5 1.2 1.3 1.7 1.1 0.6 2.6 0.9 4.2 0.9 1.5 0 3-0.3 4.1-0.9 0.8-0.5 1.3-1.1 1.3-1.6 0-0.5-0.5-1.1-1.4-1.6-1-0.6-2.6-1-4.1-1zm19.2-42.8c0-0.5-0.5-1.1-1.3-1.6-1.1-0.6-2.6-0.9-4.2-0.9-1.5 0-3 0.3-4.1 0.9-0.8 0.5-1.3 1.1-1.3 1.6 0 0.5 0.5 1.1 1.3 1.6 2.2 1.2 6.2 1.3 8.3 0 0.8-0.4 1.3-1 1.3-1.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "y",
    d: "m504.9 125.8c-0.7-0.8-1.2-1.8-1.2-2.8 0-1.6 1-3 2.7-4 1.5-0.8 3.4-1.3 5.5-1.3 2 0 4 0.5 5.5 1.4 1.7 0.9 2.7 2.4 2.7 3.9 0 1.6-1 3-2.7 4-1.5 0.8-3.4 1.3-5.5 1.3-1.9 0-3.7-0.4-5.1-1.2l0.3 0.6-129.4 77.2-1.4-2.3zm1.6-2.8c0 0.6 0.4 1.1 1.3 1.6 2.1 1.3 6.1 1.3 8.2 0 0.9-0.4 1.3-1 1.3-1.5 0-0.6-0.5-1.2-1.3-1.6-1.1-0.7-2.6-1-4.2-1-1.5 0-3 0.3-4 0.9-0.9 0.5-1.3 1.1-1.3 1.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m428.6 149.4c0 104.7-67.2 189.6-150.1 189.6-82.9 0-150.1-84.9-150.1-189.6 0-104.7 67.2-189.6 150.1-189.6 82.9 0 150.1 84.9 150.1 189.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m274.6 329.3c6.3 0 12-1.4 16.5-4l109.1-63.1c6.1-3.5 9.5-9 9.5-15.1 0-6.7-4.2-12.9-11.4-17.1l-99-57.1c-5.7-3.3-12.8-5.1-20-5.1-6.3 0-12 1.4-16.5 4l-109.1 63.1c-6 3.5-9.4 9-9.4 15.1 0 6.6 4.1 12.9 11.3 17l99 57.2c5.7 3.3 12.8 5.1 20 5.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m263.7 172.2l-106.5 61.6c-5.4 3.2-9.4 8.8-9.6 14.3-0.3 6.4 3.3 12.6 10.5 16.8l97.6 56.3c5.5 3.2 12.4 5 19.4 4.9 4.3 0 8.3-0.7 11.8-1.9 1.4-0.6 3-1.3 4.2-2l106.3-61.5c5.5-3.2 9.4-8.8 9.7-14.3 0.2-6.4-3.3-12.6-10.5-16.7l-97.1-56.1c-2.1-1.2-4.8-2.4-7.2-3.2-3.9-1.2-8.1-2-12.4-2-6.1 0-11.8 1.3-16.2 3.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m264.6 172.6l-103.9 60.2c-4.9 2.8-9.4 8.6-9.8 13.5-0.6 6.2 2.4 12.3 9.6 16.4l96.2 55.6c5.4 3.1 12.1 4.7 18.9 4.7 4.2 0 8.1-0.8 11.5-2 1.2-0.5 3-1.3 4.1-2l103.4-59.8c4.9-2.9 9.4-8.6 9.8-13.6 0.6-6.1-2.4-12.2-9.6-16.3l-95.2-55c-1.8-1.1-4.9-2.5-7-3.2-3.8-1.2-7.9-2-12.1-2.1-6-0.1-11.6 1.2-15.9 3.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m265.5 173.1l-101.2 58.6c-4.4 2.5-9.6 8.4-10.2 12.8-0.8 6 1.7 11.9 8.8 16l94.8 54.8c5.2 3 11.9 4.6 18.4 4.5 4.1 0 7.8-0.8 11.1-2 1.1-0.4 3-1.4 4-1.9l100.6-58.2c4.4-2.5 9.4-8.4 10-12.8 0.8-5.9-1.6-11.9-8.7-16l-93.3-53.9c-1.7-0.9-5-2.5-6.9-3.2-3.7-1.2-7.7-2.1-11.8-2.2-5.9-0.1-11.4 1.1-15.6 3.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m266.4 173.5l-98.6 57.1c-3.9 2.2-10.4 8.2-10.4 12.1-2.1 5.5 0.8 11.6 7.9 15.7l93.4 53.9c5.1 2.9 11.6 4.5 17.9 4.4 4-0.1 7.6-0.8 10.8-2.1 1-0.3 3-1.4 3.8-1.9l97.8-56.5c3.8-2.2 10.2-8.1 10.2-12 2.1-5.5-0.8-11.6-7.9-15.7l-91.4-52.8c-1.4-0.8-5-2.6-6.7-3.1-3.6-1.3-7.5-2.2-11.5-2.3-5.7-0.2-11.2 0.9-15.3 3.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m267.3 174l-96 55.6c-3.3 1.9-10.6 8-10.6 11.3-2.6 5.2 0 11.2 7 15.3l92 53.1c5 2.9 11.3 4.4 17.4 4.2 3.9 0 7.4-0.8 10.4-2 0.9-0.4 3-1.5 3.8-1.9l94.9-54.9c3.2-1.9 10.3-7.9 10.3-11.3 2.7-5.1 0.1-11.2-6.9-15.2l-89.5-51.7c-1.3-0.7-5.1-2.7-6.6-3.2-3.5-1.3-7.3-2.2-11.2-2.4-5.6-0.3-11 0.8-15 3.1z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m268.2 174.4l-93.4 54.1c-2.7 1.6-10.8 7.8-10.8 10.6-3.2 4.9-0.9 10.9 6.1 14.9l90.6 52.3c4.8 2.8 11 4.2 16.9 4.1 3.7-0.1 7.2-0.9 10.1-2.1 0.7-0.3 3-1.5 3.6-1.9l92-53.2c2.8-1.6 10.6-7.7 10.6-10.5 3.2-4.9 0.9-10.9-6.1-14.9l-87.6-50.6c-1-0.6-5.2-2.8-6.3-3.2-3.4-1.3-7.2-2.3-11-2.5-5.5-0.3-10.8 0.7-14.7 2.9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m269.1 174.9l-90.8 52.5c-2.2 1.3-11 7.7-11 9.9-3.7 4.6-1.7 10.6 5.2 14.5l89.2 51.6c4.7 2.7 10.7 4 16.4 3.8 3.6-0.1 6.9-0.9 9.8-2.1 0.5-0.2 2.9-1.5 3.4-1.8l89.2-51.6c2.2-1.3 10.8-7.5 10.8-9.7 3.7-4.6 1.7-10.6-5.2-14.6l-85.7-49.5c-0.9-0.5-5.3-2.8-6.2-3.2-3.3-1.2-7-2.3-10.7-2.6-5.4-0.3-10.6 0.6-14.4 2.8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m270 175.3l-88.2 51.1c-1.6 0.9-11.2 7.4-11.2 9.1-4.2 4.2-2.6 10.2 4.3 14.2l87.8 50.7c4.6 2.6 10.4 3.9 15.9 3.7 3.5-0.1 6.7-1 9.4-2.2 0.4-0.1 3-1.5 3.4-1.8l86.3-49.9c1.6-1 10.9-7.3 10.9-9 4.3-4.2 2.6-10.2-4.2-14.2l-83.9-48.4c-0.6-0.3-5.3-2.9-6-3.2-3.2-1.2-6.8-2.4-10.4-2.7-5.2-0.4-10.4 0.5-14.1 2.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m270.9 175.8l-85.6 49.5c-1.1 0.6-11.4 7.3-11.4 8.4-4.8 3.9-3.4 9.9 3.4 13.8l86.5 49.9c4.3 2.5 10 3.8 15.3 3.5 3.4-0.1 6.5-1 9.1-2.1 0.3-0.2 2.9-1.7 3.2-1.8l83.5-48.3c1.1-0.7 11.1-7.1 11.1-8.2 4.8-4 3.4-9.9-3.4-13.8l-82-47.4c-0.4-0.2-5.3-3-5.8-3.1-3.1-1.3-6.5-2.5-10.1-2.9-5.1-0.4-10.2 0.4-13.8 2.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m271.8 176.2l-83 48c-0.5 0.4-11.6 7.1-11.6 7.6-5.3 3.7-4.3 9.6 2.5 13.5l85.1 49.1c4.2 2.5 9.7 3.6 14.8 3.4 3.3-0.2 6.2-1.1 8.7-2.2 0.2-0.1 3-1.7 3.1-1.7l80.7-46.7c0.5-0.3 11.3-6.9 11.3-7.4 5.3-3.7 4.2-9.6-2.5-13.5l-80.1-46.2c-0.2-0.2-5.4-3.1-5.7-3.2-3-1.3-6.3-2.6-9.8-2.9-5-0.5-10 0.2-13.5 2.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m288.5 292.4l92.3-53.4c5.8-3.3 5-9.2-1.7-13.1l-83.7-48.3c-6.7-3.9-16.9-4.3-22.7-0.9l-92.2 53.3c-5.9 3.4-5.1 9.3 1.6 13.2l83.7 48.3c6.7 3.8 16.9 4.3 22.7 0.9z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m404.3 213.5h-2.6c-1.2-1.6-3-3.1-5.2-4.4l-97.6-56.4c-11.6-6.7-31.8-5.8-45.1 1.9l-90.2 52.1c-3.6 2-6.3 4.4-8.1 6.8h-3v7.8h0.1c0.4 3.8 2.9 7.5 7.7 10.3l97.6 56.3c11.6 6.7 31.7 5.9 45.1-1.8l90.2-52.1c6.4-3.7 10-8.2 10.8-12.7h0.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m257.9 282l-97.6-56.3c-11.5-6.7-10.1-18.4 3.3-26.1l90.2-52.1c13.3-7.7 33.5-8.5 45.1-1.8l97.6 56.3c11.5 6.7 10.1 18.3-3.3 26l-90.2 52.1c-13.4 7.7-33.5 8.6-45.1 1.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m401.1 200.1h-2.4c-1.3-1.6-3-3.1-5.2-4.4l-95.3-55c-11.3-6.5-31-5.7-44 1.8l-88.2 50.9c-3.4 2-6 4.3-7.8 6.7h-2.9v13.6c0.4 3.7 2.9 7.3 7.6 10l95.3 55c11.3 6.6 31 5.7 44-1.8l88.1-50.9c6.2-3.5 9.7-8 10.6-12.3h0.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m404.1 193.2h-2.6c-1.2-1.6-3-3.1-5.2-4.5l-97.6-56.3c-11.6-6.7-31.8-5.8-45.1 1.9l-90.3 52.1c-3.5 2-6.2 4.4-8 6.8h-3v13.1h0.1c0.4 3.8 2.9 7.5 7.7 10.3l97.6 56.3c11.6 6.7 31.7 5.8 45.1-1.9l90.2-52.1c6.4-3.6 10-8.2 10.8-12.6h0.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m257.7 261.7l-97.6-56.3c-11.5-6.7-10.1-18.4 3.2-26.1l90.3-52.1c13.3-7.7 33.5-8.5 45.1-1.8l97.6 56.3c11.5 6.7 10.1 18.3-3.3 26l-90.2 52.1c-13.4 7.7-33.5 8.6-45.1 1.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m277.3 261.8c-6.9 0-13-1.4-17.4-3.9l-97.6-56.3c-2.6-1.5-5.6-4-5.6-7.5 0-3.7 3.3-7.8 8.8-11l90.3-52.1c6.4-3.7 14.8-5.8 23.3-5.8 6.8 0 13 1.4 17.4 3.9l97.6 56.4c2.5 1.5 5.6 4 5.6 7.5 0 3.7-3.3 7.7-8.9 10.9l-90.2 52.1c-6.4 3.7-14.9 5.8-23.3 5.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m262.3 246.3l-75.6-43.6c-8.9-5.2-7.8-14.2 2.5-20.2l69.9-40.3c10.4-6 26-6.6 34.9-1.5l75.6 43.7c9 5.1 7.9 14.2-2.5 20.1l-69.9 40.4c-10.3 5.9-25.9 6.6-34.9 1.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m393 205.7l-90.2 52.1c-13.4 7.7-33.5 8.6-45.1 1.9l-97.6-56.4c-4.6-2.6-7.1-6.1-7.6-9.8-0.8 4.8 1.7 9.5 7.6 12.9l97.6 56.3c11.6 6.7 31.7 5.8 45.1-1.9l90.2-52.1c8-4.6 11.7-10.6 10.9-16.1-0.7 4.6-4.3 9.3-10.9 13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m277.5 143.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m270.1 147.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m262.8 152.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m255.4 156.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m248.1 160.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m240.7 164.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m233.4 169.1l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m226 173.3l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m218.7 177.6l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m211.3 181.8l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m203.9 186.1l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m196.6 190.3l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m189.2 194.6l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m284.4 147.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m277.1 151.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m269.7 156.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m262.4 160.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m255 164.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m247.7 168.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m240.3 173.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m233 177.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m225.6 181.6l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m218.2 185.8l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m210.9 190.1l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m203.5 194.3l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m196.2 198.6l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m291.4 151.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m284 155.9l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m276.7 160.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m269.3 164.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m262 168.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m254.6 172.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m247.3 177.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m239.9 181.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m232.5 185.6l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m225.2 189.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m217.8 194.1l4-2.3-3.9-2.2-3.9 2.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m210.5 198.3l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m203.1 202.6l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m298.3 155.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m291 159.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m283.6 164.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m276.3 168.4l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m268.9 172.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m261.6 176.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m254.2 181.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m246.8 185.4l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m239.5 189.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m232.1 193.9l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m224.8 198.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m217.4 202.4l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m210.1 206.6l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m305.3 159.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m297.9 163.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m290.6 168.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m283.2 172.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m275.9 176.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m268.5 180.9l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m261.1 185.1l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m253.8 189.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m246.4 193.6l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m239.1 197.9l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m231.7 202.1l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m224.4 206.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m217 210.6l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m312.2 163.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m304.9 167.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m297.5 172.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m290.2 176.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m282.8 180.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m275.4 184.9l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m268.1 189.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m260.7 193.4l4-2.3-3.9-2.2-3.9 2.3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m253.4 197.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m246 201.9l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m238.7 206.1l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m231.3 210.4l4-2.3-3.9-2.2-4 2.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m224 214.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m319.2 167.7l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m311.8 171.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m304.5 176.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m297.1 180.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m289.7 184.7l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m282.4 188.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m275 193.2l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m267.7 197.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m260.3 201.7l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m253 205.9l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m245.6 210.1l4-2.2-3.9-2.3-4 2.3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m238.3 214.4l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m230.9 218.6l3.9-2.2-3.8-2.3-4 2.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m326.1 171.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m318.8 176l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m311.4 180.2l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m304 184.4l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m296.7 188.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m289.3 192.9l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m282 197.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m274.6 201.4l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m267.3 205.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m259.9 209.9l4-2.2-3.9-2.3-4 2.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m252.6 214.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m245.2 218.4l3.9-2.3-3.8-2.2-4 2.3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m237.9 222.6l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m333.1 175.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m325.7 180l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m318.3 184.2l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m311 188.5l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m303.6 192.7l4-2.3-3.9-2.2-3.9 2.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m296.3 196.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m288.9 201.2l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m281.6 205.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m274.2 209.7l4-2.3-3.9-2.2-4 2.2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m266.9 213.9l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m259.5 218.2l3.9-2.3-3.8-2.2-4 2.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m252.2 222.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m244.8 226.7l3.9-2.3-3.8-2.2-4 2.2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m340 179.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m332.6 184l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m325.3 188.2l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m317.9 192.5l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m310.6 196.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m303.2 201l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m295.9 205.2l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m288.5 209.5l4-2.3-3.9-2.3-4 2.3z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m281.2 213.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m273.8 217.9l3.9-2.2-3.8-2.3-4 2.3z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m266.5 222.2l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m259.1 226.4l3.9-2.2-3.8-2.3-4 2.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m251.8 230.7l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m346.9 183.8l4-2.3-3.9-2.3-3.9 2.3z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m339.6 188l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m332.2 192.2l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m324.9 196.5l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m317.5 200.7l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m310.2 205l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m302.8 209.2l4-2.2-3.9-2.3-4 2.3z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m295.5 213.5l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m288.1 217.7l3.9-2.3-3.8-2.2-4 2.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m280.8 222l3.9-2.3-3.9-2.3-3.9 2.3z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m273.4 226.2l3.9-2.3-3.8-2.2-4 2.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m266.1 230.4l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m258.7 234.7l3.9-2.3-3.8-2.2-4 2.2z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m353.9 187.8l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m346.5 192l4-2.3-3.9-2.2-3.9 2.3z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m339.2 196.3l3.9-2.3-3.9-2.3-3.9 2.3z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m331.8 200.5l4-2.3-3.9-2.2-3.9 2.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m324.5 204.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m317.1 209l4-2.3-3.9-2.2-4 2.2z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m309.8 213.2l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m302.4 217.5l3.9-2.3-3.8-2.2-4 2.2z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m295.1 221.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m287.7 226l3.9-2.3-3.8-2.2-4 2.2z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m280.4 230.2l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m273 234.5l3.9-2.3-3.8-2.3-4 2.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m265.7 238.7l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m360.8 191.8l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m353.5 196l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m346.1 200.3l4-2.3-3.9-2.2-3.9 2.2z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m338.8 204.5l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m331.4 208.8l4-2.3-3.9-2.3-4 2.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m324.1 213l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m316.7 217.2l3.9-2.2-3.8-2.3-4 2.3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m309.4 221.5l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m302 225.7l3.9-2.2-3.8-2.3-4 2.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m294.7 230l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m287.3 234.2l3.9-2.2-3.8-2.3-4 2.3z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m280 238.5l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m272.6 242.7l3.9-2.3-3.9-2.2-3.9 2.3z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m367.8 195.8l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m360.4 200l4-2.2-3.9-2.3-3.9 2.3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m353.1 204.3l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m345.7 208.5l4-2.2-3.9-2.3-4 2.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m338.4 212.8l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m331 217l3.9-2.3-3.8-2.2-4 2.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m323.7 221.3l3.9-2.3-3.9-2.3-3.9 2.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m316.3 225.5l3.9-2.3-3.8-2.2-4 2.3z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m309 229.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m301.6 234l3.9-2.3-3.8-2.2-4 2.2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m294.3 238.2l3.9-2.2-3.9-2.3-3.9 2.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m286.9 242.5l3.9-2.3-3.9-2.2-3.9 2.2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m279.6 246.7l3.9-2.2-3.9-2.3-3.9 2.3z"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "Z",
    d: "m387.4 226.2l7.3-4.3 11.7 7.1c0.9 0.6 1.3 1.6 1.1 2.5l-1.5 12.8-4.4-8.9c-0.8-1.1-1.9-2-3.1-2.7z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m402.2 234.6c-0.9-1.1-1.9-2-3.1-2.7l-10.8-6.2-0.9 0.5 11.1 6.5c1.2 0.7 2.3 1.6 3.1 2.7l4.4 8.9 0.1-0.2z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m373.4 234.3l7.3-4.3 11.7 7.1c0.9 0.5 1.3 1.5 1.1 2.5l-1.4 12.8-4.5-9c-0.8-1-1.9-1.9-3.1-2.6z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m388.2 242.7c-0.9-1.1-1.9-2-3.1-2.7l-10.8-6.2-0.9 0.5 11.1 6.5c1.2 0.7 2.3 1.6 3.1 2.6l4.5 9v-0.2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m359.4 242.4l7.3-4.3 11.7 7.1c0.9 0.5 1.3 1.5 1.1 2.5l-1.4 12.8-4.4-9c-0.9-1-2-1.9-3.2-2.6z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m374.2 250.8c-0.9-1.1-1.9-2-3.1-2.7l-10.7-6.2-1 0.5 11.1 6.5c1.2 0.7 2.3 1.6 3.2 2.6l4.4 9v-0.3z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "a5",
    d: "m345.4 250.5l7.3-4.3 11.7 7.1c0.9 0.5 1.3 1.5 1.1 2.5l-1.4 12.8-4.4-9c-0.9-1.1-2-2-3.1-2.7z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m360.2 258.9c-0.8-1.1-1.9-2-3.1-2.7l-10.7-6.3-1 0.6 11.2 6.4c1.1 0.7 2.2 1.6 3.1 2.7l4.4 9v-0.3z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m331.5 258.6l7.2-4.3 11.8 7.1c0.8 0.5 1.2 1.5 1 2.5l-1.4 12.7-4.4-8.9c-0.9-1.1-1.9-2-3.1-2.7z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m346.2 266.9c-0.8-1-1.9-1.9-3.1-2.6l-10.7-6.3-0.9 0.6 11.1 6.4c1.2 0.7 2.2 1.6 3.1 2.7l4.4 8.9 0.1-0.2z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m317.5 266.6l7.3-4.2 11.7 7c0.8 0.6 1.3 1.6 1 2.5l-1.4 12.8-4.4-8.9c-0.9-1.1-1.9-2-3.1-2.7z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m332.3 275c-0.9-1.1-2-2-3.1-2.6l-10.8-6.3-0.9 0.5 11.1 6.5c1.2 0.7 2.2 1.6 3.1 2.7l4.4 8.9 0.1-0.2z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m303.4 274.7l7.3-4.3 11.7 7.1c0.9 0.5 1.3 1.6 1.1 2.5l-1.4 12.8-4.5-8.9c-0.8-1.1-1.9-2-3.1-2.7z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m318.2 283.1c-0.9-1.1-1.9-2-3.1-2.7l-10.7-6.2-1 0.5 11.1 6.5c1.2 0.7 2.3 1.6 3.1 2.7l4.5 8.9v-0.2z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "m289.4 282.8l7.3-4.3 11.7 7.1c0.9 0.5 1.3 1.5 1.1 2.5l-1.4 12.8-4.4-9c-0.9-1-2-1.9-3.1-2.6z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "m304.2 291.2c-0.8-1.1-1.9-2-3.1-2.7l-10.7-6.2-1 0.5 11.2 6.5c1.1 0.7 2.2 1.6 3.1 2.6l4.4 9v-0.3z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "m169.5 226.2l-7.3-4.3-11.7 7.1c-0.9 0.6-1.3 1.6-1.1 2.5l1.4 12.8 4.4-8.9c0.9-1.1 2-2 3.1-2.7z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m154.7 234.6c0.8-1.1 1.9-2 3.1-2.7l10.7-6.2 1 0.5-11.2 6.5c-1.1 0.7-2.2 1.6-3.1 2.7l-4.4 8.9v-0.2z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m183.4 234.3l-7.2-4.3-11.8 7.1c-0.8 0.5-1.2 1.5-1 2.5l1.4 12.8 4.4-9c0.9-1 1.9-1.9 3.1-2.6z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "m168.6 242.7c0.9-1.1 2-2 3.2-2.7l10.7-6.2 0.9 0.5-11.1 6.5c-1.2 0.7-2.2 1.6-3.1 2.6l-4.4 9-0.1-0.3z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m197.4 242.4l-7.3-4.3-11.7 7.1c-0.8 0.5-1.3 1.5-1 2.5l1.4 12.8 4.4-9c0.9-1 1.9-2 3.1-2.6z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "m182.6 250.8c0.9-1.1 2-2 3.1-2.7l10.8-6.3 0.9 0.6-11.1 6.5c-1.2 0.6-2.2 1.6-3.1 2.6l-4.4 9-0.1-0.3z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "m211.4 250.5l-7.3-4.3-11.7 7.1c-0.9 0.5-1.3 1.5-1.1 2.5l1.5 12.8 4.4-9c0.8-1.1 1.9-2 3.1-2.7z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m196.6 258.8c0.9-1 1.9-1.9 3.1-2.6l10.8-6.3 0.9 0.6-11.1 6.4c-1.2 0.7-2.3 1.6-3.1 2.7l-4.4 9-0.1-0.3z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m225.4 258.5l-7.3-4.2-11.7 7c-0.9 0.6-1.3 1.6-1.1 2.6l1.4 12.7 4.5-8.9c0.8-1.1 1.9-2 3.1-2.7z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "m210.6 266.9c0.9-1 1.9-1.9 3.1-2.6l10.7-6.3 1 0.5-11.1 6.5c-1.2 0.7-2.3 1.6-3.1 2.7l-4.5 8.9v-0.2z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "m239.4 266.6l-7.3-4.3-11.7 7.1c-0.9 0.5-1.3 1.6-1.1 2.5l1.4 12.8 4.4-8.9c0.9-1.1 2-2 3.1-2.7z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "m224.6 275c0.8-1.1 1.9-2 3.1-2.7l10.7-6.2 1 0.5-11.2 6.5c-1.1 0.7-2.2 1.6-3.1 2.7l-4.4 8.9v-0.2z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m253.2 274.7l-7.2-4.3-11.8 7.1c-0.8 0.5-1.2 1.5-1 2.5l1.4 12.8 4.4-9c0.9-1 1.9-1.9 3.1-2.6z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "m238.4 283.1c0.9-1.1 2-2 3.2-2.7l10.7-6.2 0.9 0.5-11.1 6.5c-1.2 0.7-2.2 1.6-3.1 2.6l-4.4 9-0.1-0.3z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "m267.2 282.8l-7.3-4.3-11.7 7.1c-0.8 0.5-1.3 1.5-1 2.5l1.4 12.8 4.4-9c0.9-1.1 1.9-2 3.1-2.7z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "m252.4 291.2c0.9-1.1 2-2 3.1-2.7l10.8-6.3 0.9 0.6-11.1 6.4c-1.2 0.7-2.2 1.6-3.1 2.7l-4.4 9-0.1-0.3z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "m371.7 60.7l-92.3-53.8-93.6 52.6v133.2l93.2 54.3 92.7-53.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m376 393c-1.2 0-2.3-0.2-3.1-0.7l-32.8-19c-1.2-0.6-1.8-1.6-1.8-2.8 0-1.2 0.8-2.4 2.1-3.2l18.7-10.8c1-0.6 2.4-0.9 3.7-0.9 1.2 0 2.3 0.2 3.1 0.7l32.8 19c1.2 0.6 1.8 1.7 1.8 2.8 0 1.3-0.8 2.4-2.1 3.2l-18.7 10.8c-1 0.6-2.4 0.9-3.7 0.9z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m359.1 356.7c1.1-0.6 2.4-1 3.8-0.9q0.8 0 1.5 0.1c0.5 0.2 1.1 0.4 1.6 0.6l32.6 18.9c1.2 0.7 1.7 1.7 1.7 2.8q-0.1 0.5-0.2 0.9c-0.3 0.8-1.1 1.7-2 2.2l-18.4 10.6c-0.2 0.1-0.5 0.3-0.7 0.4-0.9 0.3-2 0.6-3 0.6-1.1 0-2.2-0.3-3-0.8l-32.8-18.9c-1.2-0.7-1.8-1.7-1.7-2.8q0.1-0.4 0.2-0.8c0.2-0.8 1.1-1.7 2-2.3z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m359.2 356.8c1.1-0.6 2.4-0.9 3.8-0.9q0.8 0.1 1.5 0.2c0.4 0.2 1.1 0.4 1.5 0.7l32.6 18.8c1.1 0.6 1.6 1.6 1.5 2.7q-0.1 0.5-0.3 0.9c-0.3 0.7-1.2 1.6-2 2.1l-18.1 10.4c-0.2 0.1-0.5 0.3-0.8 0.4-0.8 0.4-1.8 0.6-2.8 0.6-1.2 0-2.2-0.2-3.1-0.7l-32.8-18.9c-1.1-0.7-1.6-1.7-1.5-2.8q0.1-0.4 0.2-0.8c0.3-0.7 1.3-1.7 2.1-2.2z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m359.3 357c1.1-0.6 2.4-1 3.7-0.9q0.8 0 1.5 0.2c0.5 0.1 1.2 0.5 1.5 0.7l32.5 18.7c1.1 0.6 1.6 1.7 1.4 2.7-0.1 0.3-0.2 0.6-0.3 0.9-0.3 0.6-1.4 1.5-2.1 1.9l-17.8 10.3c-0.2 0.1-0.6 0.3-0.8 0.4-0.8 0.4-1.8 0.6-2.8 0.6-1.1 0-2.2-0.2-3-0.6l-32.8-19c-1.1-0.6-1.6-1.7-1.3-2.7q0.1-0.4 0.2-0.7c0.3-0.7 1.4-1.7 2.1-2.2z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "aA",
    d: "m359.4 357.1c1-0.6 2.4-0.9 3.7-0.8 0.5 0 1 0.1 1.5 0.2 0.4 0.1 1.2 0.5 1.5 0.7l32.3 18.6c1.1 0.7 1.5 1.7 1.2 2.7 0 0.3-0.2 0.5-0.3 0.8-0.3 0.6-1.4 1.6-2.1 1.9l-17.6 10.2c-0.1 0.1-0.5 0.3-0.7 0.3-0.8 0.4-1.8 0.6-2.8 0.7-1.1 0-2.1-0.2-2.9-0.7l-32.8-18.9c-1.1-0.7-1.5-1.7-1.2-2.7 0.1-0.3 0.2-0.5 0.3-0.7 0.2-0.6 1.5-1.7 2.1-2z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m359.5 357.3c1-0.7 2.4-0.9 3.7-0.9 0.5 0.1 1 0.2 1.5 0.3 0.3 0.1 1.2 0.6 1.4 0.7l32.2 18.6c1.1 0.6 1.5 1.6 1.1 2.6-0.1 0.3-0.2 0.5-0.4 0.8-0.2 0.4-1.5 1.5-2.1 1.8l-17.3 10c-0.1 0.1-0.5 0.3-0.7 0.4-0.8 0.3-1.8 0.6-2.7 0.6-1.1 0-2.1-0.2-2.9-0.6l-32.8-19c-1.1-0.6-1.5-1.6-1.1-2.6 0.1-0.3 0.2-0.5 0.3-0.7 0.3-0.5 1.7-1.6 2.2-1.9z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m359.5 357.4c1.1-0.6 2.5-0.9 3.7-0.8 0.6 0 1.1 0.2 1.5 0.3 0.3 0.1 1.2 0.6 1.5 0.7l32 18.5c1.1 0.7 1.4 1.7 1 2.6q-0.2 0.4-0.4 0.7c-0.2 0.4-1.7 1.5-2.2 1.8l-17 9.8c-0.1 0.1-0.6 0.3-0.7 0.4-0.8 0.4-1.7 0.6-2.7 0.6-1.1 0.1-2.1-0.1-2.8-0.6l-32.8-18.9c-1.1-0.7-1.4-1.7-1-2.7q0.2-0.3 0.4-0.6c0.1-0.4 1.8-1.5 2.2-1.8z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "aC",
    d: "m359.6 357.5c1.1-0.6 2.5-0.8 3.7-0.7 0.6 0 1 0.2 1.5 0.3 0.2 0.1 1.2 0.6 1.4 0.7l31.9 18.5c1.1 0.6 1.4 1.6 0.9 2.5q-0.2 0.4-0.5 0.7c-0.1 0.3-1.8 1.4-2.1 1.6l-16.8 9.7c-0.1 0.1-0.6 0.4-0.7 0.4-0.8 0.4-1.7 0.6-2.7 0.7-1 0-2-0.2-2.7-0.6l-32.8-19c-1.2-0.6-1.4-1.6-0.8-2.6q0.1-0.3 0.4-0.5c0.1-0.4 1.8-1.6 2.2-1.8z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "aD",
    d: "m359.7 357.7c1.1-0.6 2.4-0.9 3.7-0.8 0.5 0.1 1 0.3 1.4 0.4 0.2 0.1 1.3 0.7 1.4 0.7l31.9 18.4c1 0.6 1.3 1.6 0.7 2.5q-0.2 0.4-0.6 0.7c0 0.2-1.9 1.4-2.1 1.5l-16.5 9.6c-0.1 0-0.7 0.3-0.7 0.3-0.8 0.4-1.7 0.7-2.6 0.7-1 0-2-0.1-2.8-0.6l-32.8-18.9c-1.1-0.6-1.3-1.7-0.6-2.6q0.2-0.3 0.4-0.5c0.1-0.3 2-1.5 2.3-1.7z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "aE",
    d: "m359.8 357.8c1-0.6 2.4-0.8 3.7-0.7 0.5 0.1 1 0.3 1.4 0.4 0.1 0 1.3 0.7 1.4 0.7l31.7 18.4c1.1 0.6 1.2 1.6 0.6 2.5q-0.3 0.3-0.6 0.5c-0.1 0.2-2 1.4-2.2 1.5l-16.3 9.4c0 0-0.6 0.3-0.6 0.4-0.8 0.3-1.7 0.6-2.6 0.6-1 0.1-2-0.1-2.7-0.5l-32.8-18.9c-1.1-0.7-1.2-1.7-0.5-2.6q0.2-0.3 0.5-0.5c0.1-0.2 2.1-1.4 2.3-1.6z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "aF",
    d: "m359.9 358c1-0.6 2.4-0.9 3.6-0.7 0.6 0 1 0.2 1.5 0.4 0 0 1.3 0.7 1.3 0.8l31.6 18.2c1.1 0.6 1.2 1.6 0.4 2.5q-0.2 0.2-0.6 0.5c0 0.1-2.1 1.3-2.2 1.4l-16 9.2c0 0-0.6 0.4-0.6 0.4-0.8 0.3-1.7 0.6-2.5 0.7-1 0-2-0.1-2.7-0.5l-32.8-19c-1.1-0.6-1.2-1.6-0.4-2.5q0.3-0.2 0.6-0.5c0-0.1 2.2-1.4 2.3-1.4z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "m373.8 390.7l-32.8-18.9c-1.3-0.8-1.2-2.1 0.3-2.9l18.7-10.8c1.5-0.9 3.7-0.9 5-0.2l32.8 18.9c1.3 0.8 1.2 2.1-0.3 3l-18.7 10.7c-1.5 0.9-3.7 1-5 0.2z"
  }))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "aG",
    d: "m373.8 390.7l-32.8-19c-0.6-0.3-0.9-0.7-0.9-1.2 0 0 0-1.6 0-1.6 0-0.6 0.4 0.4 1.2-0.1l18.7-10.7c1.5-0.9 3.7-1 5-0.2l32.8 18.9c0.5 0.3 0.8-0.8 0.9-0.5 0 0.1 0 1.6 0 1.8 0 0.5-0.4 1.1-1.2 1.6l-18.7 10.8c-1.5 0.8-3.7 0.9-5 0.2z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "aH",
    d: "m373.8 389.1l-32.8-19c-1.3-0.7-1.2-2 0.3-2.9l18.7-10.7c1.5-0.9 3.7-1 5-0.2l32.8 18.9c1.3 0.8 1.2 2.1-0.3 2.9l-18.7 10.8c-1.5 0.8-3.7 0.9-5 0.2z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "aI",
    d: "m376 388.9c-0.8 0-1.4-0.1-1.9-0.4l-32.8-18.9c-0.2-0.1-0.5-0.4-0.5-0.7 0-0.4 0.3-0.8 0.9-1.1l18.6-10.7c0.7-0.4 1.6-0.7 2.5-0.7 0.8 0 1.4 0.2 1.9 0.4l32.8 19c0.2 0.1 0.5 0.3 0.5 0.7 0 0.3-0.3 0.7-0.9 1.1l-18.6 10.7c-0.7 0.4-1.6 0.6-2.5 0.6z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "aJ",
    d: "m397.5 377.9l-18.7 10.7c-1.5 0.9-3.7 1-5 0.2l-32.8-18.9c-0.6-0.3-0.8-0.7-0.9-1.2-0.1 0.6 0.2 1.1 0.9 1.4l32.8 19c1.3 0.7 3.5 0.6 5-0.2l18.7-10.8c0.8-0.5 1.2-1.1 1.2-1.7-0.1 0.5-0.5 1-1.2 1.5z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "aK",
    d: "m367 360.6c0.8 2.6-1.9 5.8-6.2 7.3-4.3 1.4-8.5 0.6-9.3-1.9-0.9-2.6 1.9-5.8 6.1-7.3 4.3-1.4 8.5-0.6 9.4 1.9z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m379.6 382.1l-26.6-15.4c-0.6-0.3-0.5-0.8 0.1-1.2l10-5.7c0.6-0.4 1.6-0.4 2.1-0.1l26.6 15.4c0.6 0.3 0.5 0.8-0.1 1.2l-10 5.7c-0.6 0.4-1.6 0.4-2.1 0.1z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aM",
    d: "m363.7 360.4c0.2-0.1 0.6-0.1 0.8 0l1.7 1c0.2 0.1 0.2 0.3 0 0.5-0.2 0.1-0.6 0.1-0.8 0l-1.7-1c-0.2-0.1-0.2-0.3 0-0.5zm2.9 1.7c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.2-0.5 0.2-0.8 0l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5zm2.1 1.2c0.2-0.1 0.5-0.1 0.7 0l0.8 0.5c0.3 0.1 0.3 0.3 0 0.4-0.2 0.1-0.5 0.1-0.7 0l-0.8-0.5c-0.3-0.1-0.3-0.3 0-0.4zm2 1.2c0.2-0.2 0.5-0.2 0.8 0l0.8 0.4c0.2 0.1 0.2 0.3 0 0.5-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4zm2 1.1c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.2-0.6 0.2-0.8 0l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5zm2 1.2c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.1-0.5 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4zm2.1 1.2c0.2-0.2 0.5-0.2 0.7 0l0.8 0.4c0.3 0.2 0.3 0.4 0 0.5-0.2 0.1-0.5 0.1-0.7 0l-0.8-0.5c-0.3-0.1-0.3-0.3 0-0.4zm2 1.1c0.2-0.1 0.5-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.2-0.6 0.2-0.8 0l-0.8-0.4c-0.2-0.1-0.2-0.3 0-0.5zm2 1.2c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4zm2 1.2c0.2-0.2 0.6-0.2 0.8 0l0.8 0.4c0.2 0.2 0.2 0.4 0 0.5-0.2 0.1-0.5 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4zm2 1.1c0.3-0.1 0.6-0.1 0.8 0l0.8 0.5c0.3 0.1 0.3 0.3 0 0.5-0.2 0.1-0.5 0.1-0.7 0l-0.8-0.5c-0.3-0.1-0.3-0.3-0.1-0.5zm2.1 1.2c0.2-0.1 0.5-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5zm2 1.2c0.3-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4-0.2 0.1-0.5 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4zm-27-13.5l0.7-0.4c0.2-0.2 0.6-0.2 0.9 0l0.7 0.4c0.2 0.1 0.2 0.4 0 0.5l-0.7 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.4 0-0.5zm2.7 2.1l-0.7-0.4c-0.2-0.2-0.2-0.4 0-0.6l0.7-0.4c0.3-0.1 0.6-0.1 0.9 0l0.7 0.5c0.2 0.1 0.2 0.3 0 0.5l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0zm1.3 0.2l0.7-0.4c0.3-0.1 0.7-0.1 0.9 0l0.7 0.4c0.3 0.2 0.3 0.4 0 0.5l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.3 0-0.5zm2.1 1.2l0.7-0.4c0.2-0.2 0.6-0.2 0.8 0l0.7 0.4c0.3 0.1 0.3 0.4 0 0.5l-0.6 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.4 0-0.5zm4.3 1.7l-0.7 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.2-0.3-0.4 0-0.5l0.7-0.4c0.2-0.2 0.6-0.2 0.9 0l0.7 0.4c0.2 0.1 0.2 0.3 0 0.5zm2 1.1l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.3 0-0.5l0.7-0.4c0.2-0.1 0.6-0.1 0.9 0l0.7 0.4c0.2 0.2 0.2 0.4 0 0.5zm2 1.2l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.4 0-0.5l0.7-0.4c0.3-0.2 0.7-0.2 0.9 0l0.7 0.4c0.3 0.1 0.3 0.4 0 0.5zm2 1.2l-0.6 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.2-0.3-0.4 0-0.5l0.7-0.4c0.2-0.2 0.6-0.2 0.8 0l0.7 0.4c0.3 0.1 0.3 0.3 0 0.5zm2.1 1.1l-0.7 0.5c-0.3 0.1-0.7 0.1-0.9-0.1l-0.7-0.4c-0.3-0.1-0.3-0.3 0-0.5l0.7-0.4c0.2-0.1 0.6-0.1 0.9 0l0.7 0.4c0.2 0.2 0.2 0.4 0 0.5zm2 1.2l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.4 0-0.5l0.7-0.4c0.2-0.1 0.6-0.1 0.9 0l0.7 0.4c0.2 0.1 0.2 0.4 0 0.5zm-0.3 0.7l0.7-0.4c0.3-0.2 0.7-0.2 0.9 0l0.7 0.4c0.3 0.1 0.3 0.3 0 0.5l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-0.7-0.4c-0.2-0.2-0.2-0.4 0-0.5zm4.3 1.7l-0.7 0.4c-0.2 0.1-0.6 0.1-0.8 0l-0.7-0.4c-0.3-0.2-0.3-0.4 0-0.6l0.6-0.4c0.3-0.1 0.7-0.1 0.9 0l0.7 0.4c0.3 0.2 0.3 0.4 0 0.6zm3 1.7l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-1.6-1c-0.2-0.1-0.2-0.3 0-0.5l0.7-0.4c0.3-0.1 0.7-0.1 0.9 0l1.6 1c0.3 0.1 0.3 0.3 0 0.5zm-29.4-14l0.7-0.4c0.3-0.2 0.7-0.2 0.9 0l1.6 0.9c0.2 0.1 0.2 0.4 0 0.5l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-1.6-0.9c-0.2-0.2-0.2-0.4 0-0.5zm2.9 1.6l0.7-0.4c0.3-0.1 0.7-0.1 0.9 0l0.7 0.5c0.3 0.1 0.3 0.3 0 0.5l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-0.7-0.4c-0.2-0.2-0.2-0.4 0-0.6zm2.1 1.7c-0.3-0.1-0.3-0.3 0-0.5l0.7-0.4c0.2-0.1 0.6-0.1 0.8 0l0.7 0.4c0.3 0.2 0.3 0.4 0 0.5l-0.6 0.4c-0.3 0.2-0.7 0.2-0.9 0zm2 1.2c-0.3-0.1-0.3-0.4 0-0.5l0.7-0.4c0.2-0.2 0.6-0.2 0.9 0l0.7 0.4c0.2 0.1 0.2 0.4 0 0.5l-0.7 0.4c-0.3 0.2-0.7 0.2-0.9 0zm3.6 0.3l0.7 0.4c0.2 0.1 0.2 0.3 0 0.5l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-0.7-0.4c-0.2-0.2-0.2-0.4 0-0.5l0.7-0.4c0.2-0.2 0.6-0.2 0.9 0zm2 1.1l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0zm3.1 8.9l-0.6 0.4c-0.3 0.1-0.7 0.1-0.9 0l-12.9-7.4c-0.2-0.2-0.2-0.4 0-0.5l0.7-0.4c0.2-0.2 0.7-0.2 0.9 0l12.8 7.4c0.3 0.1 0.3 0.4 0 0.5zm0.9-6.6l0.8 0.5c0.2 0.1 0.2 0.3 0 0.5l-0.8 0.4c-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0zm2 1.2l0.8 0.5c0.3 0.1 0.3 0.3 0 0.4l-0.7 0.5c-0.3 0.1-0.6 0.1-0.9 0l-0.7-0.5c-0.3-0.1-0.3-0.3 0-0.4l0.7-0.5c0.3-0.1 0.6-0.1 0.8 0zm2.1 1.2l0.8 0.4c0.2 0.2 0.2 0.4 0 0.5l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.5l0.8-0.4c0.2-0.1 0.5-0.1 0.8 0zm1.2 2.5l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5l0.8-0.4c0.2-0.2 0.6-0.2 0.8 0l0.8 0.4c0.2 0.1 0.2 0.3 0 0.5l-0.8 0.4c-0.2 0.2-0.6 0.1-0.8 0zm2 1.2l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0zm3.7 0.7l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4zm-29.5-13.9l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l2.5 1.5c0.2 0.1 0.2 0.3 0 0.5l-0.8 0.4c-0.2 0.1-0.5 0.1-0.8 0l-2.5-1.5c-0.2-0.1-0.2-0.3 0-0.4zm3.8 2.2l0.8-0.5c0.2-0.1 0.5-0.1 0.8 0l0.7 0.5c0.3 0.1 0.3 0.3 0 0.4l-0.7 0.5c-0.3 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.3-0.1-0.3-0.3 0-0.4zm2 1.1l0.8-0.4c0.2-0.2 0.6-0.2 0.8 0l0.8 0.4c0.2 0.2 0.2 0.4 0 0.5l-0.8 0.4c-0.2 0.2-0.6 0.2-0.8 0l-0.8-0.4c-0.2-0.1-0.2-0.3 0-0.5zm2 1.2l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.5l-0.8 0.4c-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5zm2.8 2.1l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4l-0.8 0.5c-0.2 0.1-0.5 0.1-0.8 0zm2.1 1.2l-0.8-0.5c-0.3-0.1-0.3-0.3 0-0.5l0.7-0.4c0.3-0.1 0.6-0.1 0.9 0l0.7 0.4c0.3 0.2 0.3 0.4 0 0.5l-0.7 0.5c-0.3 0.1-0.6 0.1-0.8 0zm2 1.1l-0.8-0.4c-0.2-0.2-0.2-0.4 0-0.5l0.8-0.4c0.2-0.2 0.6-0.2 0.8 0l0.8 0.4c0.2 0.1 0.2 0.3 0 0.5l-0.8 0.4c-0.2 0.2-0.6 0.2-0.8 0zm2 1.2l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0zm2 1.2l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.5l0.8-0.4c0.2-0.1 0.6-0.1 0.8 0l0.8 0.4c0.2 0.2 0.2 0.4 0 0.5l-0.8 0.5c-0.2 0.1-0.5 0.1-0.8 0zm2.1 1.1l-0.8-0.4c-0.3-0.2-0.3-0.4 0-0.5l0.7-0.4c0.3-0.2 0.6-0.2 0.9 0l0.7 0.4c0.3 0.1 0.3 0.3 0 0.5l-0.7 0.4c-0.3 0.2-0.6 0.2-0.8 0zm1.2 0.3l0.8-0.5c0.2-0.1 0.6-0.1 0.8 0l0.8 0.5c0.2 0.1 0.2 0.3 0 0.4l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0l-0.8-0.5c-0.2-0.1-0.2-0.3 0-0.4zm5.6 2.3l-0.8 0.5c-0.2 0.1-0.6 0.1-0.8 0l-2-1.2c-0.2-0.1-0.2-0.3 0-0.5l0.8-0.4c0.2-0.1 0.6-0.1 0.8 0l2 1.2c0.2 0.1 0.2 0.3 0 0.4zm-29.5-13.9l0.7-0.4c0.3-0.2 0.7-0.2 0.9 0l3.6 2c0.3 0.2 0.3 0.4 0 0.6l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-3.6-2.1c-0.2-0.2-0.2-0.4 0-0.5zm5 2.8l0.6-0.4c0.3-0.1 0.7-0.1 1 0l0.6 0.4c0.3 0.2 0.3 0.4 0 0.5l-0.6 0.4c-0.3 0.2-0.7 0.2-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.3 0-0.5zm2 1.2l0.7-0.4c0.2-0.2 0.6-0.2 0.9 0l0.7 0.4c0.2 0.1 0.2 0.4 0 0.5l-0.7 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.4 0-0.5zm2 1.1l0.7-0.3c0.2-0.2 0.7-0.2 0.9 0l0.7 0.4c0.2 0.1 0.2 0.3 0 0.5l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-0.7-0.4c-0.2-0.2-0.2-0.4 0-0.6zm2 1.2l0.7-0.4c0.3-0.1 0.7-0.1 0.9 0l0.7 0.4c0.3 0.2 0.3 0.4 0 0.5l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.3 0-0.5zm2.1 1.2l0.6-0.4c0.3-0.1 0.7-0.1 1 0l0.6 0.4c0.3 0.1 0.3 0.4 0 0.5l-0.6 0.4c-0.3 0.2-0.7 0.2-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.4 0-0.5zm2 1.2l0.7-0.4c0.2-0.2 0.6-0.2 0.9 0l0.7 0.4c0.2 0.1 0.2 0.3 0 0.5l-0.7 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.2-0.3-0.4 0-0.5zm2 1.1l0.7-0.4c0.2-0.1 0.7-0.1 0.9 0l0.7 0.4c0.2 0.2 0.2 0.4 0 0.6l-0.7 0.3c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.3 0-0.5zm2 1.2l0.7-0.4c0.3-0.1 0.7-0.1 0.9 0l0.7 0.4c0.3 0.1 0.3 0.4 0 0.5l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.4 0-0.5zm2.1 1.2l0.6-0.4c0.3-0.2 0.7-0.2 1 0l0.6 0.4c0.3 0.1 0.3 0.3 0 0.5l-0.6 0.4c-0.3 0.1-0.7 0.1-1 0l-0.6-0.4c-0.3-0.2-0.3-0.4 0-0.5zm2 1.1l0.7-0.4c0.2-0.1 0.6-0.1 0.9 0l0.7 0.4c0.2 0.2 0.2 0.4 0 0.6l-0.7 0.4c-0.3 0.1-0.7 0.1-0.9-0.1l-0.7-0.3c-0.3-0.2-0.3-0.4 0-0.6zm4.3 1.8l-0.6 0.3c-0.3 0.2-0.7 0.2-1 0l-0.6-0.4c-0.3-0.1-0.3-0.3 0-0.5l0.6-0.4c0.3-0.1 0.7-0.1 0.9 0l0.7 0.4c0.3 0.2 0.3 0.4 0 0.6zm-26.2-13l-0.7 0.4c-0.2 0.1-0.6 0.1-0.9 0l-1.5-0.9c-0.3-0.2-0.3-0.4-0.1-0.6l0.7-0.4c0.3-0.1 0.7-0.1 0.9 0l1.6 1c0.3 0.1 0.3 0.3 0 0.5zm2 1.2l-0.6 0.3c-0.3 0.2-0.7 0.2-0.9 0l-0.7-0.3c-0.3-0.2-0.3-0.4 0-0.6l0.6-0.4c0.3-0.1 0.7-0.1 1 0l0.6 0.4c0.3 0.2 0.3 0.4 0 0.6zm2.1 1.1l-0.7 0.4c-0.3 0.2-0.7 0.2-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.4 0-0.5l0.7-0.4c0.2-0.1 0.6-0.1 0.9 0l0.7 0.4c0.2 0.1 0.2 0.4 0 0.5zm13 0.5l0.8 0.4c0.2 0.2 0.2 0.4 0 0.5l-0.8 0.4c-0.2 0.2-0.6 0.2-0.8 0l-0.8-0.4c-0.2-0.1-0.2-0.3 0-0.5l0.8-0.4c0.2-0.2 0.6-0.2 0.8 0zm3.2 8.9l-0.7 0.4c-0.3 0.1-0.7 0.1-0.9 0l-0.7-0.4c-0.3-0.2-0.3-0.4 0-0.6l0.7-0.3c0.2-0.2 0.6-0.2 0.9 0l0.7 0.3c0.2 0.2 0.2 0.4 0 0.6zm2 1.1l-0.7 0.4c-0.2 0.2-0.6 0.2-0.9 0l-0.7-0.4c-0.2-0.1-0.2-0.3 0-0.5l0.7-0.4c0.2-0.1 0.7-0.1 0.9 0l0.7 0.4c0.2 0.2 0.2 0.4 0 0.5zm2.1 1.2l-0.7 0.4c-0.3 0.2-0.7 0.2-0.9 0l-0.7-0.4c-0.3-0.1-0.3-0.3 0-0.5l0.7-0.4c0.2-0.1 0.6-0.1 0.9 0l0.7 0.4c0.2 0.2 0.2 0.4 0 0.5z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m397.3 375l-31.6-18.3c-1.2-0.7-2.2-2.6-2.2-4.2v-24.8c0-1.7 1-2.4 2.2-1.7l31.6 18.3c1.2 0.7 2.2 2.6 2.2 4.2v24.8c0 1.6-1 2.4-2.2 1.7z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m397.6 373.7l-31.3-18.1c-1-0.6-1.6-1.9-1.6-3.1v-24.9c0-0.4 0.3-0.5 0.6-0.4q0.1 0 0.1 0.1l31.3 18c1.1 0.7 1.6 1.9 1.6 3.2v24.8c0 0.4-0.4 0.6-0.7 0.4q0 0 0 0z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aP",
    d: "m398.3 348.5v24.8c0 0.4-0.4 0.6-0.7 0.4q0 0 0 0l-31.3-18.1c-1-0.6-1.6-1.9-1.6-3.1v-24.9c0-0.4 0.3-0.5 0.6-0.4q0.1 0 0.1 0.1l31.3 18c1.1 0.7 1.6 1.9 1.6 3.2zm-0.3 0c0-1-0.2-2.2-1.4-2.9l-31.4-18.2q0 0-0.1 0c-0.1 0-0.1 0.1-0.1 0.2v24.9c0 1.2 0.5 2.3 1.4 2.9l31.4 18.1q0 0 0 0c0.1 0 0.2 0 0.2-0.2z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "aQ",
    d: "m397.9 343.9l-31.6-18.2q-0.7-0.4-1.3-0.2c0 0-0.6 0.3-0.7 0.3 0.4-0.1 0.9-0.1 1.4 0.2l31.6 18.3c1.2 0.7 2.2 2.6 2.2 4.2v24.8c0 1-0.4 1.7-1 1.9q0.1 0 0.2-0.1c0.1 0 0.7-0.4 0.8-0.4 0.4-0.3 0.6-0.9 0.6-1.7v-24.8c0-1.7-1-3.6-2.2-4.3z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "aR",
    d: "m397.4 344.2l-31.6-18.3c-0.5-0.2-1-0.3-1.3-0.1q0.4-0.1 1 0.2l31.6 18.3c1.3 0.7 2.3 2.6 2.3 4.2v24.8c0 1-0.4 1.6-0.9 1.9 0.7-0.1 1.1-0.9 1.1-2v-24.8c0-1.6-1-3.5-2.2-4.2z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "aS",
    d: "m400.1 348.3c-0.9 0.3-1.9-0.4-2.4-1.6-0.5-1.2-0.3-2.5 0.5-2.8 0.8-0.4 1.9 0.4 2.4 1.6 0.5 1.2 0.3 2.5-0.5 2.8z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "aT",
    d: "m502.7 238.4c0 6.5-10.4 11.8-23.1 11.8-12.8 0-23.2-5.3-23.2-11.8 0-6.5 10.4-11.8 23.2-11.8 12.7 0 23.1 5.3 23.1 11.8z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "aU",
    d: "m495.5 233.3h-37.4v5.6c0 0 0 0.1 0 0.2 0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "aV",
    d: "m458.1 233.4c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9 0-6-8.4-10.9-18.7-10.9-10.3 0-18.7 4.9-18.7 10.9z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "aW",
    d: "m476.8 244.3c-10.2 0-18.5-4.8-18.7-10.8q0 0.1 0 0.2c0 6.1 8.4 10.9 18.7 10.9 10.3 0 18.7-4.8 18.7-10.9q0-0.1 0-0.2c-0.2 6-8.5 10.8-18.7 10.8z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "aX",
    d: "m494.2 227.5h-34.8v4.8q0 0.1 0 0.1c0 5.6 7.8 10.2 17.4 10.2 9.6 0 17.4-4.6 17.4-10.2q0 0 0-0.1z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "aY",
    d: "m494.2 226.7h-34.8v4.8q0 0 0 0.1c0 5.6 7.8 10.2 17.4 10.2 9.6 0 17.4-4.6 17.4-10.2q0-0.1 0-0.1z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "aZ",
    d: "m495.5 223.1h-37.4v5.6c0 0 0 0.1 0 0.2 0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "b0",
    d: "m458.1 223.2c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9 0-6.1-8.4-11-18.7-11-10.3 0-18.7 4.9-18.7 11z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "b1",
    d: "m476.8 234c-10.2 0-18.5-4.8-18.7-10.7q0 0.1 0 0.2c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2c-0.2 5.9-8.5 10.7-18.7 10.7z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "b2",
    d: "m494.2 217.3h-34.8v4.8q0 0 0 0.1c0 5.6 7.8 10.1 17.4 10.1 9.6 0 17.4-4.5 17.4-10.1q0-0.1 0-0.1z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "b3",
    d: "m494.2 216.5h-34.8v4.7q0 0.1 0 0.2c0 5.6 7.8 10.1 17.4 10.1 9.6 0 17.4-4.5 17.4-10.1q0-0.1 0-0.2z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "b4",
    d: "m495.5 213.1h-37.4v5.6c0 0 0 0.1 0 0.2 0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "b5",
    d: "m458.1 213.2c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9 0-6-8.4-10.9-18.7-10.9-10.3 0-18.7 4.9-18.7 10.9z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "b6",
    d: "m476.8 224c-10.2 0-18.5-4.7-18.7-10.7q0 0.1 0 0.2c0 6.1 8.4 10.9 18.7 10.9 10.3 0 18.7-4.8 18.7-10.9q0-0.1 0-0.2c-0.2 6-8.5 10.7-18.7 10.7z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "b7",
    d: "m494.2 207.3h-34.8v4.8q0 0.1 0 0.1c0 5.6 7.8 10.2 17.4 10.2 9.6 0 17.4-4.6 17.4-10.2q0 0 0-0.1z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "b8",
    d: "m494.2 206.5h-34.8v4.8q0 0 0 0.1c0 5.6 7.8 10.2 17.4 10.2 9.6 0 17.4-4.6 17.4-10.2q0-0.1 0-0.1z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "b9",
    d: "m495.5 203h-37.4v5.7c0 0 0 0.1 0 0.1 0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.1z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "m458.1 203.1c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9 0-6-8.4-10.9-18.7-10.9-10.3 0-18.7 4.9-18.7 10.9z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "m476.8 214c-10.2 0-18.5-4.8-18.7-10.7q0 0.1 0 0.2c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2c-0.2 5.9-8.5 10.7-18.7 10.7z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "m494.2 197.3h-34.8v4.7q0 0.1 0 0.2c0 5.6 7.8 10.1 17.4 10.1 9.6 0 17.4-4.5 17.4-10.1q0-0.1 0-0.2z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "m494.2 196.4h-34.8v4.8q0 0.1 0 0.1c0 5.6 7.8 10.2 17.4 10.2 9.6 0 17.4-4.6 17.4-10.2q0 0 0-0.1z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "m495.5 193h-37.4v5.6c0 0 0 0.1 0 0.2 0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "m458.1 193.1c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9 0-6.1-8.4-10.9-18.7-10.9-10.3 0-18.7 4.8-18.7 10.9z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "m476.8 203.9c-10.2 0-18.5-4.8-18.7-10.7q0 0.1 0 0.2c0 6 8.4 10.9 18.7 10.9 10.3 0 18.7-4.9 18.7-10.9q0-0.1 0-0.2c-0.2 5.9-8.5 10.7-18.7 10.7z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "m487.7 192.3c0 2.6-4.2 4.8-9.5 4.8-5.2 0-9.4-2.2-9.4-4.8 0-2.7 4.2-4.9 9.4-4.9 5.3 0 9.5 2.2 9.5 4.9z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "m484.3 189.4h-15v2.9q0 0.1 0 0.1c0 2.4 3.4 4.4 7.5 4.4 4.1 0 7.5-2 7.5-4.4q0 0 0-0.1z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "m469.3 189.5c0 2.4 3.4 4.3 7.5 4.3 4.1 0 7.5-1.9 7.5-4.3 0-2.4-3.4-4.4-7.5-4.4-4.1 0-7.5 2-7.5 4.4z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "m472.1 189.5c0 1.5 2.1 2.7 4.7 2.7 2.6 0 4.7-1.2 4.7-2.7 0-1.5-2.1-2.8-4.7-2.8-2.6 0-4.7 1.3-4.7 2.8z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "m476.8 189.3c1.8 0 3.4 0.6 4.2 1.5q0.5-0.6 0.5-1.3c0-1.5-2.1-2.8-4.7-2.8-2.6 0-4.7 1.3-4.7 2.8q0 0.7 0.6 1.3c0.8-0.9 2.3-1.5 4.1-1.5z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "m476.8 193.8c-4.1 0-7.4-1.9-7.5-4.3q0 0.1 0 0.1c0 2.4 3.4 4.4 7.5 4.4 4.1 0 7.5-2 7.5-4.4q0 0 0-0.1c-0.1 2.4-3.4 4.3-7.5 4.3z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "m124 39.7l6.8 3.9v2.2l9 5.3 12.9 5.1 24.8-5.9-2.2-1 8.8-13.1-27-16.3z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "m139 8.2l26.2 15.2 15.1 2.2-26.2-14.9z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "m165.2 23.4v25.7l2.7-1.5v-0.6l9.6-5.7 0.6 0.3 2.2-1.3v-14.7z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "m165.2 23.4v25.7l-26.2-15.2v-25.7z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m167.3 34.4l11.4-6.9v13.7l-0.6 0.4-0.6-0.3-9.6 5.7v0.6l-0.6 0.4z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "m177.5 41.3v-12.3l-9.6 5.8v12.2z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 29.9v-0.9l-9.6 5.8v0.8z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 30.1v-0.5l-9.6 5.8v0.4z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 31.1v-0.5l-9.6 5.8v0.4z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 32.1v-0.5l-9.6 5.7v0.5z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 33v-0.5l-9.6 5.8v0.4z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 34v-0.5l-9.6 5.8v0.4z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 35v-0.5l-9.6 5.8v0.4z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 36v-0.5l-9.6 5.7v0.4z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 36.9v-0.5l-9.6 5.8v0.4z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 37.9v-0.5l-9.6 5.8v0.4z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 38.9v-0.5l-9.6 5.8v0.4z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 39.9v-0.6l-9.6 5.8v0.4z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m177.5 40.8v-0.5l-9.6 5.8v0.4z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "m150.8 38.7v16.3l-26.8-15.3v-16.4z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "m150.8 38.8l12.5-21.6-26.8-15.3-12.5 21.5z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m125.9 40.7v-14.3l5.7 3.4v14.3z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m131 30.1v12.9l-4.5-2.6v-12.9z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "m150.8 55v-16.2l12.5-21.8v31z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "m151.4 18.4l-11.6 6.8v25.9l1.9-1.2v-16.3z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "m127 40.1l4 2.3v-12.3l-4-2.3z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "bA",
    d: "m127 40.1l4-10-4-2.3z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bB",
    d: "m131 30.1v12.3l-4-2.3v-12.3zm-0.3 0.2l-3.3-1.9v11.5l3.3 1.9z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "bC",
    d: "m139.8 25.2v25.9l-9-5.3v-25.9z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m132.4 46.7v-14.3l5.8 3.3v14.3z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m137.5 36.1v12.9l-4.4-2.6v-12.9z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m143.3 50.6v-14.3l5.7 3.4v14.3z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m148.4 40v12.9l-4.5-2.6v-12.9z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m132.4 30.5v-7.8l5.8 3.4v7.7z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m137.5 26.5v6.2l-4.4-2.6v-6.3z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "bD",
    d: "m133.6 46.1l3.9 2.2v-12.2l-3.9-2.3z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "bE",
    d: "m133.6 46.1l3.9-10-3.9-2.3z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "bF",
    d: "m144.5 50l3.9 2.3v-12.3l-3.9-2.3z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "bG",
    d: "m144.5 50l3.9-10-3.9-2.3z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "bH",
    d: "m133.6 29.8l3.9 2.3v-5.6l-3.9-2.3z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bI",
    d: "m148.4 40v12.3l-3.9-2.3v-12.3zm-0.3 0.2l-3.3-1.9v11.5l3.3 1.9z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "bJ",
    d: "m133.6 29.8l3.9-3.3-3.9-2.3z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bK",
    d: "m137.5 26.5v5.6l-3.9-2.3v-5.6zm-0.3 0.1l-3.3-1.9v5l3.3 1.9z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bL",
    d: "m137.5 36.1v12.2l-3.9-2.2v-12.3zm-0.3 0.2l-3.3-2v11.6l3.3 1.9z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m154.1 37.1l1-0.6 5.8-3.3v-8.4z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m155.8 35.4l4.4-2.6v-5.5z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "m154.2 38.8l6.7-3.8v14.3l-6.7 3.8z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m154.8 39.2v12.8l5.4-3v-12.9z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "bM",
    d: "m159.7 48.7v-12.3l-4.9 2.8v12.2z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bt",
    d: "m159.7 36.4v12.3l-4.9 2.7v-12.2zm-0.3 0.5l-4.2 2.4v11.6l4.2-2.4z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "bN",
    d: "m159.7 28.2l-3.5 6.4 3.5-2.1z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bO",
    d: "m159.7 28.2v4.3l-3.5 2.1zm-0.3 1.2l-2.3 4.3 2.3-1.4z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "bP",
    d: "m139.8 25.2l11.6-6.8-9-5.2-11.6 6.7z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "bQ",
    d: "m152.7 55.4v0.8l12.5-7.1v-0.7z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "bR",
    d: "m152.7 55.4v0.8l-1.9-1.2v-0.7z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "bS",
    d: "m150.8 54.3l1.9 1.1 12.5-7-1.9-1.2z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "bT",
    d: "m156 44.2c0 0.2-0.2 0.4-0.3 0.5-0.2 0.1-0.4 0-0.4-0.2 0-0.2 0.2-0.4 0.4-0.5 0.1-0.1 0.3-0.1 0.3 0.2z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "bU",
    d: "m141.7 33.6l9.7-15.2-7 16.7z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "bV",
    d: "m150.8 54.3l14.4-5.9-1.9-1.2z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m177.5 29v12.3l0.6 0.3v-12.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m414 78c-1.4 0-2.6-0.3-3.6-0.9l-10.8-6.2-10.8-6.2c-1.3-0.8-2-2-2-3.3 0-1.5 0.9-2.8 2.5-3.7l2.6-1.6c1.3-0.7 2.8-1.1 4.4-1.1 1.3 0 2.6 0.3 3.6 0.8l10.8 6.3 10.8 6.2c1.3 0.8 2 2 2 3.3 0 1.4-0.9 2.8-2.5 3.7l-2.6 1.6c-1.3 0.7-2.8 1.1-4.4 1.1z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m389.3 57.8l0.6-0.3c0.1 0 2-1.2 2.1-1.2 1.2-0.7 2.8-1 4.3-1q0.3 0 0.6 0.1c1 0.1 2.1 0.4 2.9 0.8l10.6 6.2 10.6 6.1c0.9 0.5 1.7 1.5 1.9 2.4q0.1 0.3 0.2 0.7c0.1 1.4-0.8 2.8-2.4 3.7l-0.5 0.3c-0.1 0-2.1 1.2-2.1 1.2-1.2 0.7-2.8 1-4.3 1q-0.3 0-0.6-0.1c-1-0.1-2.1-0.4-2.9-0.8l-10.6-6.2-10.6-6.1c-0.9-0.5-1.7-1.5-2-2.4q-0.1-0.3-0.1-0.7c-0.1-1.4 0.8-2.8 2.3-3.7z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m389.4 58l0.6-0.3c0.1-0.1 1.9-1.1 2.1-1.1 1.2-0.7 2.7-1 4.2-0.9q0.3 0 0.5 0c1 0.1 2.2 0.6 2.9 1l10.4 6 10.4 6c0.8 0.5 1.7 1.4 2 2.2q0.1 0.4 0.1 0.8c0.2 1.3-0.6 2.6-2.1 3.5l-0.6 0.3c-0.1 0.1-2 1.2-2.1 1.2-1.2 0.6-2.7 0.9-4.2 0.8q-0.3 0-0.6 0c-0.9-0.1-2.1-0.5-2.8-0.9l-10.4-6-10.4-6c-0.8-0.5-1.7-1.5-2-2.3q-0.1-0.4-0.1-0.7c-0.2-1.4 0.6-2.7 2.1-3.6z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m389.5 58.2l0.6-0.3c0.1-0.1 1.8-1.1 2-1.1 1.3-0.6 2.7-0.9 4.2-0.8q0.2 0.1 0.5 0.1c0.8 0.1 2.2 0.6 2.8 1l10.2 5.9 10.2 5.9c0.7 0.4 1.8 1.4 2 2.1q0.1 0.3 0.2 0.7c0.2 1.3-0.5 2.6-2 3.5l-0.6 0.3c-0.1 0.1-1.9 1-2 1.1-1.3 0.6-2.8 0.8-4.2 0.7q-0.3 0-0.5 0c-0.8-0.1-2.2-0.6-2.8-1l-10.2-5.9-10.2-5.9c-0.7-0.4-1.8-1.4-2-2.1q-0.1-0.4-0.2-0.7c-0.2-1.3 0.5-2.6 2-3.5z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "aA",
    d: "m389.6 58.3l0.6-0.2c0.2-0.1 1.8-1 2-1.1 1.2-0.5 2.7-0.8 4.1-0.6q0.2 0 0.5 0.1c0.7 0.1 2.1 0.7 2.7 1l10 5.8 10 5.7c0.6 0.4 1.8 1.5 2 2.1 0.1 0.2 0.2 0.4 0.3 0.6 0.3 1.3-0.4 2.6-1.9 3.5l-0.6 0.2c-0.2 0.1-1.8 1-2 1.1-1.2 0.5-2.7 0.8-4.1 0.6q-0.2 0-0.5-0.1c-0.7-0.1-2.1-0.7-2.7-1l-10-5.8-10-5.7c-0.6-0.4-1.8-1.5-2-2.1-0.1-0.2-0.2-0.4-0.3-0.6-0.3-1.3 0.4-2.6 1.9-3.5z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m389.7 58.5l0.6-0.3c0.2-0.1 1.7-0.9 2-0.9 1.2-0.5 2.6-0.7 3.9-0.5q0.3 0 0.6 0.1c0.6 0.1 2.1 0.7 2.6 1l9.8 5.7 9.8 5.6c0.5 0.3 1.8 1.4 2.1 2 0 0.2 0.2 0.3 0.2 0.6 0.4 1.1-0.2 2.4-1.7 3.3l-0.6 0.3c-0.2 0.1-1.7 0.9-2 1-1.2 0.5-2.6 0.7-3.9 0.5q-0.3-0.1-0.6-0.1c-0.6-0.1-2.1-0.8-2.6-1l-9.8-5.7-9.8-5.7c-0.6-0.3-1.8-1.4-2.1-1.9-0.1-0.2-0.2-0.4-0.2-0.6-0.4-1.2 0.2-2.5 1.7-3.4z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m389.8 58.7l0.5-0.3c0.3-0.1 1.7-0.8 2-0.9 1.3-0.5 2.7-0.6 3.9-0.4q0.3 0.1 0.5 0.1c0.6 0.1 2.2 0.9 2.6 1.1l9.6 5.6 9.6 5.5c0.5 0.3 2 1.4 2.1 1.8q0.2 0.3 0.3 0.6c0.5 1.1-0.1 2.4-1.6 3.3l-0.6 0.2c-0.2 0.2-1.6 0.9-1.9 1-1.3 0.4-2.7 0.6-3.9 0.4q-0.3-0.1-0.6-0.2c-0.5-0.1-2.1-0.8-2.5-1l-9.6-5.6-9.6-5.5c-0.5-0.3-2-1.4-2.1-1.9q-0.2-0.2-0.3-0.5c-0.5-1.2 0.1-2.5 1.6-3.3z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "aC",
    d: "m389.9 58.8l0.5-0.2c0.4-0.2 1.6-0.8 2-0.9 1.2-0.4 2.6-0.5 3.8-0.2 0.2 0 0.4 0.1 0.5 0.1 0.4 0.1 2.2 0.9 2.5 1.1l9.4 5.5 9.4 5.4c0.4 0.2 2 1.3 2.1 1.7q0.2 0.2 0.4 0.5c0.5 1.1 0 2.4-1.5 3.3l-0.5 0.2c-0.4 0.2-1.6 0.8-2 0.9-1.2 0.4-2.6 0.5-3.8 0.2-0.2 0-0.4-0.1-0.5-0.1-0.4-0.1-2.2-0.9-2.5-1.1l-9.4-5.5-9.4-5.4c-0.4-0.2-2-1.3-2.1-1.7q-0.2-0.2-0.4-0.5c-0.5-1.1 0-2.4 1.5-3.3z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "aD",
    d: "m390 59l0.5-0.2c0.4-0.2 1.5-0.7 1.9-0.8 1.3-0.4 2.7-0.5 3.8-0.2 0.2 0.1 0.3 0.1 0.5 0.2 0.3 0 2.1 1 2.4 1.1l9.2 5.3 9.2 5.4c0.3 0.1 2.1 1.3 2.1 1.6q0.3 0.2 0.4 0.4c0.7 1.1 0.2 2.4-1.3 3.2l-0.5 0.2c-0.4 0.3-1.5 0.8-1.9 0.9-1.3 0.3-2.7 0.4-3.8 0.1-0.2 0-0.3-0.1-0.5-0.1-0.3-0.1-2.1-1-2.4-1.2l-9.2-5.3-9.2-5.3c-0.3-0.2-2.1-1.4-2.1-1.6q-0.3-0.3-0.4-0.5c-0.7-1.1-0.2-2.3 1.3-3.2z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "aE",
    d: "m390.1 59.2l0.5-0.2c0.5-0.3 1.4-0.7 1.9-0.8 1.2-0.3 2.6-0.4 3.7 0q0.3 0 0.5 0.2c0.2 0 2.1 1 2.3 1.1l9 5.2 9 5.2c0.2 0.1 2.1 1.3 2.2 1.5q0.2 0.2 0.4 0.5c0.7 1 0.3 2.2-1.2 3.1l-0.5 0.2c-0.5 0.2-1.4 0.7-1.9 0.8-1.2 0.3-2.6 0.3-3.7 0q-0.3-0.1-0.5-0.2c-0.2 0-2.1-1.1-2.3-1.1l-9-5.3-9-5.2c-0.2-0.1-2.1-1.3-2.2-1.5q-0.2-0.2-0.4-0.4c-0.7-1-0.3-2.3 1.2-3.1z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "aF",
    d: "m390.2 59.3l0.5-0.1c0.5-0.3 1.3-0.7 1.9-0.8 1.2-0.3 2.6-0.2 3.6 0.1q0.2 0.1 0.5 0.2c0.1 0 2.1 1.2 2.2 1.2l8.8 5.1 8.8 5.1c0.1 0.1 2.2 1.3 2.2 1.4q0.3 0.2 0.5 0.4c0.8 1 0.4 2.2-1.1 3.1l-0.5 0.1c-0.5 0.3-1.3 0.6-1.9 0.8-1.2 0.3-2.6 0.2-3.6-0.1q-0.2-0.1-0.5-0.2c-0.1 0-2.1-1.2-2.2-1.2l-8.8-5.1-8.8-5.1c-0.1-0.1-2.2-1.3-2.2-1.4q-0.3-0.2-0.5-0.4c-0.8-1-0.4-2.2 1.1-3.1z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m411.5 75.3l-10.8-6.2-10.8-6.2c-1.5-0.9-1.3-2.4 0.4-3.4l0.5-0.2c1.7-1 4.3-1.1 5.8-0.2l10.8 6.2 10.8 6.3c1.5 0.8 1.3 2.3-0.4 3.3l-0.5 0.2c-1.7 1-4.3 1.1-5.8 0.2z"
  }))), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "bW",
    d: "m413.7 74.7l-20-11.6c-1.8-1.1-3.3-3.9-3.3-6.3v-43.2c0-1.2-1-1.5-0.4-2 0 0 1.4-0.6 1.5-0.6 0.6-0.3 1.3-0.4 2.2 0.1l20 11.6c1.8 1.1 3.3 3.9 3.3 6.3v43.2c0 1.3-0.4 2.2-1.1 2.6-0.1 0.1-1.8 0.9-1.8 0.9-0.6 0.2 0.4-0.6-0.4-1z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "bX",
    d: "m412.4 75.3l-19.9-11.6c-1.9-1.1-3.4-3.9-3.4-6.4v-43.1c0-2.5 1.5-3.6 3.4-2.5l19.9 11.6c1.8 1 3.3 3.9 3.3 6.3v43.2c0 2.4-1.5 3.5-3.3 2.5z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "aJ",
    d: "m412.1 75.4l-19.9-11.6c-1.9-1-3.3-3.9-3.3-6.3v-43.2c0-2.4 1.4-3.5 3.3-2.5l19.9 11.6c1.8 1.1 3.3 3.9 3.3 6.4v43.1c0 2.5-1.5 3.6-3.3 2.5z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "bY",
    d: "m389.3 57.8v-43.2c0-2.2 1.3-3.2 2.9-2.2l19.9 11.5c1.6 0.9 2.9 3.4 2.9 5.6v43.2c0 2.1-1.3 3.1-2.9 2.2l-19.9-11.6c-1.6-0.9-2.9-3.4-2.9-5.5z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "bZ",
    d: "m389.9 53.6v-38.6c0-1.7 1.1-2.6 2.5-1.8l19.5 11.4c1.3 0.7 2.4 2.8 2.4 4.6v38.6c0 1.8-1.1 2.6-2.4 1.8l-19.5-11.3c-1.4-0.8-2.5-2.9-2.5-4.7z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "c0",
    d: "m392.6 13.7c-1.3-0.7-2.3-0.2-2.3 1.3v39.1c0 1.4 1 3.2 2.3 3.9l19.1 11.2c1.3 0.7 2.3 0.1 2.3-1.3v-39.1c0-1.5-1-3.2-2.3-4z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c1",
    d: "m414 28.8v39.1c0 1.4-1 2-2.3 1.3l-19.1-11.2c-1.3-0.7-2.3-2.5-2.3-3.9v-39.1c0-1.5 1-2 2.3-1.3l19.1 11.1c1.3 0.8 2.3 2.5 2.3 4zm-0.2 0c0-1.4-1-3.1-2.2-3.8l-19.1-11.1q-0.5-0.3-1-0.3c-0.6 0-1 0.5-1 1.4v39.1c0 1.4 1 3 2.2 3.7l19.1 11.2q0.5 0.3 0.9 0.3 0.5 0 0.8-0.4 0.3-0.4 0.3-1z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "c2",
    d: "m403.3 67.3c0 0.9-0.6 1.2-1.3 0.8-0.8-0.5-1.4-1.5-1.4-2.3 0-0.9 0.6-1.2 1.4-0.8 0.7 0.4 1.3 1.5 1.3 2.3z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aJ",
    d: "m402.1 64.7c0.9 0.5 1.5 1.6 1.5 2.6 0 0.7-0.4 1.2-1 1.2q-0.4 0-0.8-0.2c-0.8-0.5-1.4-1.6-1.4-2.5 0-0.8 0.4-1.3 1-1.3q0.3 0 0.7 0.2zm-1.5 1.1c0 0.8 0.6 1.8 1.4 2.3q0.3 0.2 0.6 0.2c0.4 0 0.7-0.4 0.7-1 0-0.8-0.6-1.9-1.3-2.3q-0.3-0.2-0.6-0.2c-0.5 0-0.8 0.4-0.8 1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m50 299.4c1 0 1.9-0.2 2.6-0.6l17.9-10.5c1-0.5 1.5-1.4 1.5-2.3 0-1.1-0.7-2-1.8-2.7l-15.7-6c-0.9-0.6-2-0.8-3.2-0.8-0.9 0-1.8 0.2-2.5 0.6l-12.1 7c-0.9 0.6-1.5 1.4-1.5 2.4 0 1 0.7 2 1.8 2.7l9.9 9.4c0.9 0.5 2 0.8 3.1 0.8z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m48.8 277.2l-11.9 7c0 0-0.1 0.1-0.1 0.1-1 0.5-1.4 1.4-1.3 2.3 0 1 0.7 2 1.8 2.6l9.6 9.3c1 0.5 2.1 0.8 3.3 0.7 0.9 0 1.9-0.3 2.5-0.7l17.7-10.3c1-0.5 1.5-1.3 1.5-2.2 0-1-0.7-1.9-1.8-2.6l-15.6-6c-0.3-0.2-0.7-0.4-1.1-0.5q-0.9-0.3-2-0.3c-1 0-1.9 0.2-2.6 0.6z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m48.9 277.3l-12 7c0 0-0.1 0.1-0.1 0.1-0.9 0.6-1.2 1.4-1.1 2.3 0.1 0.9 0.9 2 1.8 2.6l9.5 9c1 0.6 2.2 0.8 3.3 0.7 0.8 0 1.9-0.4 2.5-0.7l17.6-10.2c0.8-0.5 1.3-1.3 1.3-2.1 0-1-0.6-1.9-1.6-2.5l-15.6-5.9c-0.2-0.2-0.7-0.4-1.1-0.5-0.6-0.2-1.3-0.4-2-0.4-0.9 0-1.8 0.2-2.5 0.6z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m49 277.4l-12 7c0 0-0.1 0.1-0.1 0.1-1 0.6-1.3 1.5-1 2.4 0 0.7 1 1.9 1.8 2.4l9.4 8.9c1 0.6 2.3 0.8 3.4 0.7 0.7 0 1.9-0.5 2.4-0.8l17.4-10.1c0.8-0.5 1.3-1.2 1.3-2 0-0.9-0.6-1.8-1.6-2.3l-15.4-6c-0.3-0.1-0.8-0.3-1.1-0.4-0.6-0.3-1.3-0.4-2-0.4-1-0.1-1.9 0.1-2.5 0.5z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "aA",
    d: "m49 277.6l-11.9 7c-0.1 0-0.2 0-0.2 0-0.9 0.6-1.2 1.5-0.8 2.4 0 0.7 1.2 2 1.9 2.4l9.1 8.7c1.1 0.6 2.5 0.8 3.6 0.6 0.6 0 1.9-0.6 2.4-0.8l17.1-10c0.8-0.5 1.3-1.2 1.3-2-0.1-0.8-0.6-1.6-1.6-2.1l-15.3-5.9c-0.2-0.1-0.8-0.4-1.1-0.5-0.6-0.2-1.3-0.4-1.9-0.4-1 0-1.9 0.2-2.6 0.6z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m49.1 277.7l-12 7c0 0-0.1 0.1-0.1 0.1-0.9 0.6-1.2 1.5-0.6 2.3 0 0.6 1.2 2 1.8 2.3l9 8.6c1.1 0.6 2.5 0.8 3.6 0.5 0.6 0 2-0.7 2.4-0.9l17-9.8c0.7-0.5 1.1-1.1 1.1-1.9 0-0.7-0.5-1.5-1.4-2l-15.3-5.9c-0.2-0.1-0.9-0.3-1.1-0.4-0.6-0.2-1.2-0.4-1.9-0.4-0.9-0.1-1.8 0.1-2.5 0.5z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m49.2 277.8l-12 7c-0.1 0-0.1 0.1-0.2 0.1-0.9 0.6-1 1.5-0.4 2.3 0 0.5 1.4 2 1.9 2.3l8.8 8.4c1.1 0.6 2.6 0.8 3.7 0.4 0.4 0 2-0.7 2.3-0.9l16.8-9.8c0.7-0.4 1.1-1 1.1-1.7 0-0.7-0.5-1.4-1.4-1.9l-15.1-5.8c-0.2-0.1-1-0.4-1.1-0.5-0.6-0.2-1.3-0.4-1.9-0.4-1-0.1-1.9 0.1-2.5 0.5z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "aC",
    d: "m49.2 277.9l-12 7c0 0.1-0.1 0.1-0.1 0.1-0.9 0.6-1 1.6-0.3 2.4 0 0.4 1.5 1.9 1.9 2.1l8.6 8.3c1.2 0.6 2.8 0.8 3.9 0.4 0.3 0 2-0.9 2.2-1l16.6-9.7c0.7-0.4 1.1-1 1-1.6 0-0.6-0.4-1.3-1.3-1.8l-15-5.8c-0.1 0-1-0.3-1.1-0.4-0.6-0.2-1.2-0.4-1.9-0.5-0.9 0-1.8 0.1-2.5 0.5z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "aD",
    d: "m49.3 278l-12 7.1c0 0-0.1 0-0.2 0.1-0.9 0.6-0.9 1.5 0 2.3 0 0.3 1.6 1.9 1.9 2.1l8.4 8c1.2 0.7 2.8 0.8 3.9 0.4 0.3 0 2-0.9 2.2-1.1l16.5-9.5c0.6-0.4 0.9-0.9 0.9-1.5 0-0.6-0.5-1.2-1.2-1.6l-15-5.8c-0.1-0.1-1-0.4-1.1-0.4-0.5-0.3-1.2-0.5-1.8-0.5-1-0.1-1.8 0.1-2.5 0.4z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "aE",
    d: "m49.4 278.1l-12.1 7.1q0 0-0.1 0.1c-0.9 0.6-0.9 1.6 0.1 2.3 0 0.2 1.7 1.9 1.9 2l8.3 7.9c1.2 0.7 2.9 0.8 4 0.3 0.2 0 2-1 2.1-1.1l16.3-9.4c0.6-0.4 0.9-0.9 0.9-1.4-0.1-0.6-0.5-1.1-1.2-1.5l-14.9-5.7c0-0.1-1-0.4-1-0.5-0.6-0.2-1.2-0.4-1.9-0.5-0.9-0.1-1.8 0.1-2.4 0.4z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "aF",
    d: "m49.4 278.3l-12 7q-0.1 0.1-0.1 0.1c-1 0.6-0.8 1.6 0.2 2.3 0 0.1 1.9 1.9 2 2l8.1 7.7c1.2 0.7 3 0.8 4.1 0.2 0.1 0 2-1.1 2.1-1.1l16-9.3c0.6-0.4 0.9-0.8 0.8-1.3 0-0.5-0.4-1-1.1-1.4l-14.7-5.7c-0.1 0-1.1-0.4-1.1-0.4-0.6-0.2-1.2-0.5-1.8-0.5-0.9-0.1-1.8 0-2.5 0.4z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "m51.8 297.5l18-10.5c1-0.6 0.9-1.7-0.3-2.4l-15.8-6c-1.2-0.8-3.1-0.8-4.2-0.2l-12 7c-1.1 0.7-1 1.8 0.3 2.5l9.8 9.4c1.3 0.7 3.2 0.8 4.2 0.2z"
  }))), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "c3",
    d: "m51.8 297.4l18-10.4c0.4-0.3 0.7-0.6 0.7-1 0 0 0-1.4 0-1.4 0-0.4-0.4 0.4-1 0l-15.8-6.1c-1.2-0.7-3.1-0.8-4.2-0.1l-12 7c-0.4 0.2-0.7-0.7-0.8-0.4 0 0.1 0 1.4 0 1.5 0 0.4 0.4 0.9 1.1 1.3l9.8 9.5c1.3 0.7 3.2 0.8 4.2 0.1z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "c4",
    d: "m51.8 296.1l18-10.4c1-0.6 0.9-1.7-0.3-2.4l-15.8-6.1c-1.2-0.7-3.1-0.8-4.2-0.2l-12 7.1c-1.1 0.6-1 1.7 0.3 2.4l9.8 9.4c1.3 0.7 3.2 0.8 4.2 0.2z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "c5",
    d: "m37.5 284.1l12-7.1c1.1-0.6 3-0.5 4.2 0.2l8 3.1q-0.2 0-0.3 0.1l-17.9 10.4q-0.4 0.2-0.9 0.4l-4.8-4.7c-1.3-0.7-1.4-1.8-0.3-2.4z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "aJ",
    d: "m37.8 286.3l9.8 9.4c1.3 0.7 3.2 0.8 4.2 0.2l18-10.4q0.6-0.4 0.7-1c0 0.4-0.2 0.9-0.7 1.2l-18 10.4c-1 0.6-2.9 0.5-4.2-0.2l-9.8-9.4c-0.8-0.4-1.1-0.9-1.1-1.5 0.1 0.5 0.4 0.9 1.1 1.3z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "c6",
    d: "m28.4 296.2l44-25.5c2.3-1.3 4.1-4.8 4.1-7.8v-33.7c0-3-1.8-4.3-4.1-3l-44 25.4c-2.2 1.3-4.1 4.8-4.1 7.8v33.7c0 3 1.9 4.4 4.1 3.1z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m27.9 293.8l43.4-25.1c1.8-1.1 2.9-3.4 2.9-5.8v-33.9c0-0.5-0.6-0.9-1.1-0.6q0 0-0.1 0.1l-43.4 25.1c-2.2 1.2-3 3.4-3 5.8v33.8c0 0.6 0.7 1 1.2 0.7q0-0.1 0.1-0.1z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c1",
    d: "m29.6 253.6l43.4-25.1q0.1-0.1 0.1-0.1c0.5-0.3 1.1 0.1 1.1 0.6v33.9c0 2.4-1.1 4.7-2.9 5.8l-43.4 25.1q-0.1 0-0.1 0.1c-0.5 0.3-1.2-0.1-1.2-0.7v-33.8c0-2.4 0.8-4.6 3-5.8zm-2.5 39.6c0 0.2 0.1 0.3 0.3 0.3q0.1 0 0.2 0l43.5-25.2c1.6-1 2.7-3.1 2.7-5.4v-33.9c0-0.1-0.2-0.2-0.3-0.2q-0.1 0-0.1 0l-43.6 25.2c-2.3 1.3-2.7 3.6-2.7 5.4z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "c8",
    d: "m27.3 251l44-25.5c0.9-0.5 1.7-0.6 2.4-0.3 0.1 0 1.2 0.6 1.3 0.7-0.7-0.4-1.6-0.3-2.6 0.3l-44 25.4c-2.2 1.3-4.1 4.8-4.1 7.8v33.7c0 1.9 0.7 3.1 1.8 3.4q-0.1 0.1-0.3-0.1c-0.1 0-1.3-0.7-1.4-0.7-0.7-0.6-1.2-1.7-1.2-3.2v-33.7c0-3 1.8-6.5 4.1-7.8z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "c9",
    d: "m28.2 251.5l44-25.4c1-0.6 1.8-0.6 2.5-0.4q-0.9-0.1-2 0.5l-44 25.5c-2.3 1.3-4.1 4.7-4.1 7.7v33.7c0 1.8 0.7 3 1.6 3.4-1.2-0.2-2.1-1.5-2.1-3.5v-33.7c0-3 1.9-6.5 4.1-7.8z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "m179.5 414.2c0 5-8.1 9-18 9-10 0-18.1-4-18.1-9 0-5 8.1-9 18.1-9 9.9 0 18 4 18 9z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "m144.7 410.7h24.3v2.6q0 0 0 0.1c0 3.9-5.4 7-12.1 7-6.8 0-12.2-3.1-12.2-7q0-0.1 0-0.1z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "m144.7 411c0 3.9 5.4 7.1 12.2 7.1 6.7 0 12.1-3.2 12.1-7.1 0-3.9-5.4-7.1-12.1-7.1-6.8 0-12.2 3.2-12.2 7.1z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "m145.7 394.7h22.3v15.3q0 0.1 0 0.1c0 3.6-5 6.5-11.1 6.5-6.2 0-11.2-2.9-11.2-6.5q0 0 0-0.1z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "m145.7 395c0 3.6 5 6.5 11.2 6.5 6.1 0 11.1-2.9 11.1-6.5 0-3.6-5-6.5-11.1-6.5-6.2 0-11.2 2.9-11.2 6.5z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m145.7 394.7c0 3.6 5 6.5 11.2 6.5 6.1 0 11.1-2.9 11.1-6.5 0-3.6-5-6.5-11.1-6.5-6.2 0-11.2 2.9-11.2 6.5z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m163.8 398.5c-1 0-1.7 2.8-1.7 6.2 0.1 3.5 0.8 6.2 1.8 6.2 0.9 0 1.6-2.8 1.6-6.2 0-3.4-0.8-6.2-1.7-6.2z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "ch",
    d: "m131.9 355.5c0 0.6 0.2 0.9 0.4 1.1 0.1 0 2.6 1.5 2.6 1.5 0.3 0.2 0.1-0.2 0.5-0.5 1-0.5 1.7-1.9 1.7-2.9 0-0.6 0.5-0.6 0.2-0.7 0 0-2.5-1.5-2.5-1.5-0.3-0.2-0.8-0.2-1.2 0.1-1 0.5-1.7 1.9-1.7 2.9z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "m133.2 356.9c0 0.7 0.2 1.2 0.6 1.5 0 0 3.5 2 3.5 2 0.4 0.2 0.1-0.3 0.8-0.7 1.2-0.7 2.3-2.5 2.3-4 0-0.7 0.7-0.7 0.2-0.9 0 0-3.5-2.1-3.5-2.1-0.4-0.2-1-0.2-1.6 0.2-1.3 0.7-2.3 2.5-2.3 4z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m149.7 354.4l-0.1-0.2 0.7-0.3q0.2-0.2 0.5-0.3h0.1q0.3-0.1 0.7-0.1c2 0.1 4.4 2.5 5.3 5.3l9.1 31.2c0.7 2.2 0.3 4.1-1 4.7l-0.6 0.4-0.1-0.2q-0.1 0-0.3 0c-2-0.1-4.4-2.5-5.3-5.3l-9.1-31.2c-0.5-1.6-0.4-3.1 0.1-4z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "m163.2 395.3c2.1 0.1 2.9-2.1 2-4.9l-9.1-31.2c-0.9-2.8-3.2-5.2-5.2-5.3-2.1-0.1-2.9 2.1-2 4.9l9 31.2c1 2.8 3.3 5.2 5.3 5.3z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m163.2 395.3c2.1 0.1 2.9-2.1 2-4.9l-9.1-31.2c-0.9-2.8-3.2-5.2-5.2-5.3-2.1-0.1-2.9 2.1-2 4.9l9 31.2c1 2.8 3.3 5.2 5.3 5.3z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "m165.1 390.5l-9-31.1c-1-2.9-3.3-5.3-5.3-5.4q-0.8 0-1.3 0.4 0.5-0.6 1.5-0.6c2 0.2 4.4 2.5 5.3 5.4l9.1 31.1c0.6 2.1 0.3 3.9-0.7 4.6 0.8-0.8 1.1-2.5 0.4-4.4z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "m156.7 392.5v6.7l-6.6-3.8v-6.8z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "m156.7 392.5v6.7l6.5-3.8v-6.7z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "m163.2 388.7l-6.5 3.8-6.6-3.9 6.5-3.8z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m187.5 377.5l-25.9-15c-0.9-0.5-1.5 0-1.5 1.1v0.5c0 1.1 0.6 2.4 1.5 2.9l25.9 15c0.8 0.5 1.5 0 1.5-1.1v-0.5c0-1.1-0.7-2.4-1.5-2.9z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "m188.2 377.1l-25.9-15.1q-0.5-0.3-0.9-0.1l-0.8 0.5q0.4-0.2 1 0.1l25.9 15c0.8 0.5 1.5 1.8 1.5 2.9v0.5c0 0.5-0.2 0.9-0.5 1.1l0.5-0.3c0.4-0.2 0.7-0.5 0.7-1.3v-0.5c0-1.1-0.6-2.4-1.5-2.8z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "m187.5 377.4l-25.9-15c-0.4-0.2-0.7-0.2-1 0q0.4-0.2 0.9 0.1l25.9 15c0.8 0.5 1.5 1.8 1.5 2.9v0.5c0 0.6-0.2 1-0.5 1.2 0.4-0.1 0.6-0.6 0.6-1.3v-0.5c0-1.1-0.6-2.4-1.5-2.9z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "m185.1 378.4l-0.1-0.2 0.3-0.1c0.1-0.1 0.5-0.2 0.6-0.3h0.1q0.2 0 0.4 0c1 0 2.2 1.2 2.7 2.7l2.4 7.4c0.4 1.2 0.1 2.1-0.5 2.4l-0.7 0.3v-0.1q-0.1 0.1-0.2 0c-1 0-2.2-1.2-2.7-2.7l-2.4-7.4c-0.3-0.8-0.2-1.6 0.1-2z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cu",
    d: "m189.7 390.8c1.1 0 1.5-1.1 1-2.6l-2.4-7.4c-0.4-1.4-1.6-2.6-2.7-2.7-1-0.1-1.5 1.1-1 2.5l2.4 7.4c0.5 1.5 1.7 2.7 2.7 2.8z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "m190.7 388.3l-2.4-7.4c-0.5-1.5-1.7-2.7-2.7-2.7q-0.4-0.1-0.7 0.1 0.3-0.2 0.8-0.2c1 0 2.2 1.3 2.7 2.7l2.4 7.4c0.4 1.1 0.2 2-0.3 2.4 0.4-0.5 0.5-1.3 0.2-2.3z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "m187.4 397.9h-0.8v8.4c0 0.2 0.2 0.3 0.4 0.3 0.2 0 0.4-0.1 0.4-0.3z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "m185.6 394.8h2.8v4.3 0.1c0 0.4-0.6 0.8-1.4 0.8-0.8 0-1.4-0.4-1.4-0.8v-0.1z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "m184.5 388.6h5.1v5.8c0 0.8-1.2 1.5-2.6 1.5-1.4 0-2.5-0.7-2.5-1.5z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cz",
    d: "m189.6 388.6c0 0.8-1.2 1.5-2.6 1.5-1.4 0-2.5-0.7-2.5-1.5 0-0.8 1.1-1.5 2.5-1.5 1.4 0 2.6 0.7 2.6 1.5z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m188.9 388.6c0 0.5-0.9 1-1.9 1-1 0-1.8-0.5-1.8-1 0-0.6 0.8-1.1 1.8-1.1 1 0 1.9 0.5 1.9 1.1z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cB",
    d: "m188.9 388.6c0 0.5-0.9 1-1.9 1-1 0-1.8-0.5-1.8-1 0-0.6 0.8-1.1 1.8-1.1 1 0 1.9 0.5 1.9 1.1z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cC",
    d: "m185.2 392.2c0 0.8-0.6 1.1-1.3 0.7-0.7-0.4-1.2-1.4-1.2-2.2 0-0.8 0.5-1.1 1.2-0.7 0.7 0.4 1.3 1.4 1.3 2.2z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cD",
    d: "m184 390q-0.5-0.3-0.9-0.1 0.3-0.1 0.8 0.1c0.7 0.4 1.2 1.4 1.2 2.2 0 0.4-0.1 0.7-0.4 0.8 0.4-0.1 0.6-0.4 0.6-0.9 0-0.8-0.6-1.7-1.3-2.1z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cE",
    d: "m151.9 363.2v8.9l-15.8-9.2v-8.8z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cF",
    d: "m151.9 363.2v8.9l7.5-4.1v-9z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cG",
    d: "m159.4 359l-7.5 4.2-15.8-9.1 7.5-4.1z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cH",
    d: "m159.9 367.7v7.2l-7.3-4.2v-7.1z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m159.9 367.7v7.2l6-3.3v-7.2z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cJ",
    d: "m165.9 364.4l-6 3.3-7.3-4.1 6.1-3.3z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m160.3 371.3c0 1.7 1.2 2.4 2.7 1.6 1.5-0.9 2.7-2.9 2.7-4.6 0-1.7-1.2-2.4-2.7-1.6-1.5 0.9-2.7 3-2.7 4.6z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cL",
    d: "m160.8 371.1c0 0.7 0.3 1.2 0.7 1.4 0 0 21 12 21 12 0.4 0.2 0.1-0.3 0.7-0.6 1.3-0.7 2.3-2.5 2.3-3.9 0-0.7 0.6-0.7 0.2-1 0 0-21-12-21-12-0.4-0.2-1-0.2-1.6 0.2-1.2 0.7-2.3 2.5-2.3 3.9z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cM",
    d: "m160.8 371.1c0 0.7 0.3 1.2 0.7 1.4 0 0 21 12 21 12 0.4 0.2 0.1-0.3 0.7-0.6 1.3-0.7 2.3-2.5 2.3-3.9 0-0.7 0.6-0.7 0.2-1 0 0-21-12-21-12-0.4-0.2-1-0.2-1.6 0.2-1.2 0.7-2.3 2.5-2.3 3.9z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m181.9 383.1c0 1.4 1 2 2.3 1.3 1.2-0.7 2.2-2.5 2.2-3.9 0-1.4-1-2-2.3-1.3-1.2 0.7-2.2 2.5-2.2 3.9z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cO",
    d: "m182.6 382.7c0 0.9 0.7 1.3 1.5 0.8 0.9-0.4 1.6-1.6 1.6-2.6 0-1-0.7-1.4-1.6-0.9-0.8 0.5-1.5 1.7-1.5 2.7z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cP",
    d: "m182.6 382.7c0 0.9 0.7 1.3 1.5 0.8 0.9-0.4 1.6-1.6 1.6-2.6 0-1-0.7-1.4-1.6-0.9-0.8 0.5-1.5 1.7-1.5 2.7z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cQ",
    d: "m184 379.2c0.6-0.4 1.2-0.4 1.6-0.2q-0.6-0.2-1.4 0.2c-1.2 0.7-2.2 2.5-2.2 3.9 0 0.8 0.3 1.3 0.7 1.5-0.6-0.2-0.9-0.7-0.9-1.6 0-1.4 1-3.1 2.2-3.8z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cR",
    d: "m173.9 374.3c-0.3 0.5-3-0.6 1.4 1.9 4.4 2.6 8.1 4.2 8.4 3.7 0.3-0.5-3-2.9-7.4-5.5-4.3-2.5-2.1-0.6-2.4-0.1z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cS",
    d: "m140.9 359.2l-0.1-0.2 0.7-0.3q0.2-0.2 0.5-0.3h0.1q0.3-0.1 0.7-0.1c2 0.1 4.4 2.5 5.3 5.3l9.1 31.2c0.7 2.3 0.3 4.1-1 4.7l-0.6 0.4-0.1-0.2q-0.1 0-0.3 0c-2-0.1-4.4-2.5-5.3-5.3l-9.1-31.2c-0.5-1.6-0.4-3.1 0.1-4z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cT",
    d: "m154.4 400.1c2.1 0.1 2.9-2.1 2-4.9l-9-31.2c-1-2.8-3.3-5.2-5.3-5.3-2.1-0.1-2.9 2.1-2 4.9l9.1 31.2c0.9 2.8 3.2 5.2 5.2 5.3z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cU",
    d: "m156.3 395.3l-9-31.1c-1-2.9-3.3-5.3-5.3-5.4q-0.8 0-1.3 0.4 0.6-0.6 1.5-0.6c2 0.2 4.4 2.5 5.3 5.4l9.1 31.1c0.6 2.1 0.3 3.9-0.7 4.6 0.8-0.8 1.1-2.5 0.4-4.4z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m155 396.8c0 1.2-0.9 1.7-2 1.1-1-0.6-1.9-2.1-1.9-3.3 0-1.2 0.9-1.7 1.9-1.1 1.1 0.6 2 2.1 2 3.3z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m145.2 364.5c0 1.3-0.9 1.7-1.9 1.1-1.1-0.6-1.9-2.1-1.9-3.3 0-1.2 0.8-1.7 1.9-1.1 1 0.6 1.9 2.1 1.9 3.3z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m144.7 364.5c0 0.4-0.2 0.8-0.4 1 0 0-0.8 0.4-0.8 0.4-0.3 0.2-0.1-0.2-0.6-0.4-0.8-0.5-1.6-1.7-1.6-2.7 0-0.5-0.4-0.5-0.1-0.7 0 0 0.8-0.5 0.8-0.5 0.3-0.1 0.7-0.1 1.1 0.1 0.9 0.5 1.6 1.8 1.6 2.8z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cX",
    d: "m143.9 364.9c0 1-0.7 1.4-1.6 0.9-0.9-0.5-1.6-1.7-1.6-2.7 0-1 0.7-1.4 1.6-0.9 0.9 0.5 1.6 1.7 1.6 2.7z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cY",
    d: "m142.4 362.2c-0.5-0.3-0.8-0.3-1.1-0.2q0.4-0.1 0.9 0.2c0.9 0.5 1.6 1.8 1.6 2.8 0 0.5-0.2 0.8-0.5 1 0.4-0.1 0.6-0.5 0.6-1.1 0-1-0.7-2.2-1.5-2.7z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cZ",
    d: "m154.4 396.8c0 0.5-0.1 0.8-0.4 1 0 0-0.8 0.4-0.8 0.4-0.3 0.2-0.1-0.2-0.6-0.4-0.8-0.5-1.5-1.7-1.5-2.7 0-0.5-0.5-0.5-0.2-0.7 0 0 0.8-0.5 0.8-0.5 0.3-0.1 0.7-0.1 1.1 0.1 0.9 0.5 1.6 1.8 1.6 2.8z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "d0",
    d: "m153.6 397.2c0 1-0.7 1.4-1.6 0.9-0.9-0.5-1.6-1.7-1.6-2.7 0-1 0.7-1.4 1.6-0.9 0.9 0.5 1.6 1.7 1.6 2.7z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "d1",
    d: "m152.1 394.5c-0.4-0.3-0.8-0.3-1.1-0.1q0.4-0.2 0.9 0.1c0.9 0.5 1.6 1.8 1.6 2.8 0 0.5-0.2 0.8-0.5 1 0.4-0.1 0.7-0.5 0.7-1.1 0-1-0.7-2.2-1.6-2.7z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "d2",
    d: "m182.5 383.9c0 0.8-0.6 1.1-1.3 0.7-0.7-0.4-1.2-1.4-1.2-2.2 0-0.8 0.5-1.1 1.2-0.7 0.7 0.4 1.3 1.4 1.3 2.2z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cD",
    d: "m181.3 381.7q-0.5-0.3-0.9-0.1 0.4-0.1 0.8 0.1c0.7 0.4 1.3 1.4 1.3 2.2 0 0.4-0.2 0.7-0.4 0.8 0.3-0.1 0.5-0.4 0.5-0.8 0-0.8-0.6-1.8-1.3-2.2z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "d3",
    d: "m179.4 381.5v-0.1l0.3-0.2c0.1 0 0.5-0.2 0.6-0.2q0.2-0.1 0.4-0.1c1 0.1 2.3 1.3 2.7 2.8l2.4 7.4c0.4 1.1 0.2 2.1-0.5 2.4l-0.6 0.3v-0.1q-0.1 0-0.2 0c-1.1-0.1-2.3-1.3-2.7-2.7l-2.4-7.4c-0.3-0.9-0.3-1.6 0-2.1z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "d4",
    d: "m184.1 393.9c1 0.1 1.5-1.1 1-2.5l-2.4-7.4c-0.5-1.5-1.7-2.7-2.7-2.7-1-0.1-1.5 1-1 2.5l2.4 7.4c0.4 1.4 1.7 2.7 2.7 2.7z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "d5",
    d: "m185.1 391.4l-2.4-7.3c-0.5-1.5-1.7-2.7-2.8-2.8q-0.3 0-0.6 0.2 0.3-0.3 0.8-0.3c1 0.1 2.2 1.3 2.7 2.8l2.4 7.4c0.3 1 0.2 1.9-0.4 2.3 0.5-0.4 0.6-1.3 0.3-2.3z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "d6",
    d: "m180.6 381.5l-25.9-15.1c-0.9-0.4-1.5 0.1-1.5 1.2v0.5c0 1.1 0.6 2.4 1.5 2.9l25.9 15c0.8 0.5 1.5 0 1.5-1.1v-0.5c0-1.2-0.7-2.4-1.5-2.9z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "d7",
    d: "m181.3 381l-25.8-15q-0.6-0.3-1-0.1l-0.8 0.5q0.4-0.3 1 0l25.9 15.1c0.8 0.5 1.5 1.7 1.5 2.9v0.5c0 0.5-0.2 0.9-0.4 1.1l0.4-0.3c0.4-0.2 0.8-0.6 0.8-1.3v-0.5c0-1.1-0.7-2.4-1.6-2.9z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "d8",
    d: "m180.7 381.4l-25.9-15c-0.5-0.3-0.8-0.3-1.1-0.1q0.4-0.1 0.9 0.2l25.9 15c0.8 0.5 1.5 1.8 1.5 2.9v0.5c0 0.6-0.2 1-0.5 1.2 0.4-0.2 0.7-0.6 0.7-1.3v-0.5c0-1.1-0.7-2.4-1.5-2.9z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m181 384.1c0 0.7-0.5 0.9-1.1 0.6-0.5-0.3-1-1.2-1-1.8 0-0.7 0.5-1 1-0.7 0.6 0.4 1.1 1.2 1.1 1.9z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m186.3 389.5h1.4c0-2 1.4-3.2 2.7-4.3 1.4-1.2 3.2-2.7 1.6-5q-0.8-1.3-2-1.5c-1.3-0.1-2.4 0.9-3.4 1.8-0.3 0.3-1.2 1.1-1.4 1-1.4-0.5-1.7-0.8-1.7-0.8l-1 1.1c0.2 0.2 1 0.6 2.2 1.1 1 0.3 2-0.5 2.9-1.4 0.7-0.6 1.6-1.4 2.2-1.3q0.5 0 1 0.8c0.8 1.1 0.3 1.7-1.3 3.1-1.4 1.2-3.2 2.7-3.2 5.4z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "d9",
    d: "m180.7 384q-0.1 0.4-0.3 0.6c0 0-0.4 0.3-0.4 0.3-0.2 0-0.1-0.2-0.3-0.3-0.5-0.3-0.9-1-0.9-1.5 0-0.3-0.3-0.3-0.1-0.4l0.5-0.3q0.2-0.1 0.6 0.1c0.5 0.3 0.9 1 0.9 1.5z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "da",
    d: "m180.2 384.3c0 0.6-0.4 0.8-0.9 0.5-0.5-0.3-0.9-1-0.9-1.5 0-0.6 0.4-0.8 0.9-0.5 0.5 0.2 0.9 0.9 0.9 1.5z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "db",
    d: "m179.3 382.7q-0.3-0.2-0.6 0 0.3-0.1 0.6 0.1c0.5 0.3 0.9 0.9 0.9 1.5q-0.1 0.5-0.3 0.6c0.2-0.1 0.3-0.3 0.3-0.6 0-0.6-0.4-1.3-0.9-1.6z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m184.5 392.5c0 0.7-0.4 1-1 0.6-0.6-0.3-1.1-1.1-1.1-1.8 0-0.7 0.5-0.9 1.1-0.6 0.6 0.3 1 1.2 1 1.8z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "dc",
    d: "m184.2 392.5q0 0.4-0.3 0.5l-0.4 0.3c-0.2 0.1-0.1-0.1-0.3-0.2-0.5-0.3-0.9-1-0.9-1.6 0-0.3-0.3-0.3-0.1-0.4 0 0 0.5-0.2 0.5-0.2q0.2-0.2 0.6 0c0.5 0.3 0.9 1 0.9 1.6z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "dd",
    d: "m183.7 392.8c0 0.5-0.4 0.7-0.9 0.5-0.5-0.3-0.9-1-0.9-1.6 0-0.5 0.4-0.8 0.9-0.5 0.5 0.3 0.9 1 0.9 1.6z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "m182.9 391.2q-0.4-0.2-0.6-0.1 0.2 0 0.5 0.1c0.5 0.3 0.9 1 0.9 1.6q0 0.4-0.3 0.5c0.2 0 0.4-0.2 0.4-0.6 0-0.5-0.4-1.2-0.9-1.5z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m156.4 369.7c0 0.6-0.5 0.9-1.1 0.6-0.6-0.4-1-1.2-1-1.9 0-0.6 0.4-0.9 1-0.6 0.6 0.4 1.1 1.2 1.1 1.9z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "df",
    d: "m156 369.6q0 0.4-0.2 0.6c0 0-0.4 0.2-0.4 0.2-0.2 0.1-0.1-0.1-0.4-0.2-0.4-0.3-0.8-1-0.8-1.6 0-0.2-0.3-0.2-0.1-0.3 0 0 0.4-0.3 0.4-0.3q0.3-0.1 0.7 0.1c0.4 0.3 0.8 0.9 0.8 1.5z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "dg",
    d: "m155.6 369.9c0 0.5-0.4 0.8-0.9 0.5-0.5-0.3-0.9-1-0.9-1.5 0-0.6 0.4-0.8 0.9-0.6 0.5 0.3 0.9 1 0.9 1.6z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "m154.7 368.3q-0.3-0.2-0.6 0 0.2-0.1 0.6 0.1c0.4 0.2 0.8 0.9 0.8 1.5q0 0.4-0.2 0.6c0.2-0.1 0.3-0.3 0.3-0.6 0-0.6-0.4-1.3-0.9-1.6z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "m435.7 304.6c-5.2-3.1-11.9-1.4-15 3.8-3 5.2-1.3 11.9 3.9 15 5.2 3 11.9 1.3 15-3.9 3-5.2 1.3-11.9-3.9-14.9z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "dj",
    d: "m427 301c-4.6-2.6-10.4-1.1-13.1 3.4-2.7 4.6-1.1 10.4 3.4 13.1 4.6 2.7 10.4 1.1 13.1-3.4 2.7-4.5 1.1-10.4-3.4-13.1z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "dk",
    d: "m419.1 298c-3.9-2.3-8.9-1-11.2 2.9-2.3 3.9-1 8.9 2.9 11.2 3.9 2.3 8.9 1 11.2-2.9 2.3-3.9 1-8.9-2.9-11.2z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "dl",
    d: "m412.5 295.7c-3.2-1.9-7.4-0.8-9.3 2.4-1.9 3.3-0.8 7.5 2.4 9.4 3.3 1.9 7.5 0.8 9.4-2.5 1.9-3.2 0.8-7.4-2.5-9.3z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "dm",
    d: "m406.8 293.9c-2.6-1.5-6-0.7-7.5 1.9-1.5 2.6-0.6 6 2 7.5 2.6 1.5 5.9 0.7 7.4-1.9 1.5-2.6 0.7-6-1.9-7.5z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "dn",
    d: "m331.1 314.6c-5.2-3-11.9-1.3-14.9 3.9-3.1 5.2-1.4 11.9 3.8 15 5.2 3 11.9 1.3 15-3.9 3-5.2 1.3-11.9-3.9-15z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "do",
    d: "m322.4 311.1c-4.5-2.6-10.4-1.1-13.1 3.4-2.6 4.6-1.1 10.4 3.4 13.1 4.6 2.7 10.4 1.1 13.1-3.4 2.7-4.6 1.1-10.4-3.4-13.1z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "dp",
    d: "m314.5 308.1c-3.9-2.3-8.9-1-11.2 2.9-2.3 3.9-1 8.9 2.9 11.2 3.9 2.3 8.9 1 11.2-2.9 2.3-3.9 1-8.9-2.9-11.2z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "dq",
    d: "m307.9 305.8c-3.2-1.9-7.4-0.8-9.3 2.4-1.9 3.3-0.8 7.5 2.4 9.4 3.3 1.9 7.5 0.8 9.4-2.5 1.9-3.2 0.8-7.4-2.5-9.3z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "dr",
    d: "m302.2 304c-2.6-1.5-6-0.7-7.5 1.9-1.5 2.6-0.6 6 2 7.5 2.6 1.5 5.9 0.7 7.4-1.9 1.6-2.6 0.7-6-1.9-7.5z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "ds",
    d: "m126.9 160.4c5.2 3.1 6.9 9.8 3.8 15-3.1 5.2-9.8 6.8-15 3.7-5.2-3.1-6.9-9.8-3.8-14.9 3.1-5.2 9.8-6.9 15-3.8z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "dt",
    d: "m134.2 166.3c4.5 2.8 6 8.6 3.2 13.1-2.7 4.6-8.5 6-13.1 3.3-4.5-2.7-5.9-8.5-3.2-13.1 2.7-4.5 8.5-6 13.1-3.3z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "du",
    d: "m140.6 171.8c3.9 2.3 5.2 7.4 2.8 11.2-2.3 3.9-7.3 5.2-11.2 2.9-3.9-2.4-5.1-7.4-2.8-11.3 2.3-3.9 7.3-5.1 11.2-2.8z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "dv",
    d: "m145.8 176.5c3.2 1.9 4.2 6.1 2.3 9.3-1.9 3.3-6.1 4.3-9.3 2.4-3.3-2-4.3-6.1-2.4-9.4 1.9-3.2 6.1-4.3 9.4-2.3z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "dw",
    d: "m150.1 180.7c2.6 1.5 3.4 4.9 1.9 7.5-1.6 2.5-4.9 3.4-7.5 1.8-2.6-1.5-3.4-4.9-1.9-7.5 1.6-2.5 4.9-3.4 7.5-1.8z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "dx",
    d: "m217.2 368.7c5.3-3 11.9-1.1 14.9 4.1 3 5.3 1.1 11.9-4.1 14.9-5.3 3-11.9 1.1-14.9-4.1-3-5.3-1.1-11.9 4.1-14.9z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "m226 365.3c4.6-2.6 10.4-0.9 13 3.6 2.6 4.6 1 10.5-3.6 13.1-4.6 2.5-10.4 0.9-13-3.7-2.6-4.6-1-10.4 3.6-13z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "dz",
    d: "m233.9 362.4c4-2.2 9-0.8 11.2 3.1 2.2 3.9 0.8 8.9-3.1 11.2-4 2.2-9 0.8-11.2-3.1-2.2-4-0.8-9 3.1-11.2z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "dA",
    d: "m240.5 360.2c3.3-1.8 7.5-0.6 9.3 2.6 1.9 3.3 0.7 7.5-2.6 9.3-3.2 1.9-7.4 0.7-9.3-2.6-1.8-3.2-0.7-7.4 2.6-9.3z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "dB",
    d: "m246.3 358.5c2.6-1.4 6-0.5 7.4 2.1 1.5 2.6 0.6 6-2 7.4-2.6 1.5-6 0.6-7.5-2-1.4-2.6-0.5-6 2.1-7.5z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "dC",
    d: "m139.7 293.7c5.2-3 11.9-1.1 14.8 4.1 3 5.3 1.2 11.9-4.1 14.9-5.2 3-11.9 1.1-14.9-4.1-2.9-5.3-1.1-11.9 4.2-14.9z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "dD",
    d: "m148.4 290.3c4.6-2.6 10.4-1 13 3.6 2.6 4.6 1 10.5-3.6 13-4.6 2.6-10.4 1-13-3.6-2.6-4.6-1-10.4 3.6-13z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "dE",
    d: "m156.4 287.4c3.9-2.2 8.9-0.8 11.1 3.1 2.2 3.9 0.9 8.9-3.1 11.2-3.9 2.2-8.9 0.8-11.1-3.1-2.3-4-0.9-9 3.1-11.2z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "dF",
    d: "m163 285.2c3.3-1.8 7.4-0.7 9.3 2.6 1.8 3.3 0.7 7.5-2.6 9.3-3.3 1.9-7.5 0.7-9.3-2.6-1.9-3.2-0.7-7.4 2.6-9.3z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "dG",
    d: "m168.8 283.5c2.6-1.4 5.9-0.5 7.4 2.1 1.5 2.6 0.5 6-2.1 7.4-2.6 1.5-5.9 0.6-7.4-2-1.5-2.7-0.6-6 2.1-7.5z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "dH",
    d: "m182.3 57c5.2 3.1 6.9 9.8 3.8 15-3.1 5.2-9.8 6.8-15 3.8-5.2-3.1-6.9-9.8-3.8-15 3.1-5.2 9.8-6.9 15-3.8z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "dI",
    d: "m189.6 62.9c4.5 2.7 6 8.6 3.3 13.1-2.7 4.6-8.6 6-13.1 3.3-4.5-2.7-6-8.5-3.3-13 2.7-4.6 8.5-6.1 13.1-3.4z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "dJ",
    d: "m196 68.4c3.9 2.3 5.2 7.3 2.9 11.2-2.3 3.9-7.3 5.2-11.2 2.8-3.9-2.3-5.2-7.3-2.9-11.2 2.3-3.9 7.4-5.1 11.2-2.8z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "dK",
    d: "m201.2 73c3.2 2 4.3 6.1 2.4 9.4-2 3.2-6.1 4.3-9.4 2.4-3.2-2-4.3-6.2-2.4-9.4 2-3.2 6.2-4.3 9.4-2.4z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "dL",
    d: "m205.5 77.2c2.6 1.6 3.5 4.9 1.9 7.5-1.5 2.6-4.8 3.4-7.4 1.9-2.6-1.6-3.5-4.9-1.9-7.5 1.5-2.6 4.9-3.4 7.4-1.9z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "dM",
    d: "m480.9 138c-5.2 3.1-6.9 9.8-3.8 15 3.1 5.2 9.8 6.9 15 3.8 5.2-3.1 6.9-9.8 3.8-15-3.1-5.2-9.8-6.9-15-3.8z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "dN",
    d: "m473.7 143.9c-4.6 2.7-6.1 8.6-3.4 13.1 2.7 4.6 8.6 6.1 13.1 3.4 4.6-2.7 6-8.6 3.3-13.1-2.7-4.6-8.5-6-13-3.4z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "dO",
    d: "m467.2 149.4c-3.9 2.3-5.2 7.3-2.9 11.2 2.3 3.9 7.4 5.2 11.2 2.9 3.9-2.4 5.2-7.4 2.9-11.3-2.3-3.8-7.3-5.1-11.2-2.8z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "dP",
    d: "m462 154c-3.2 2-4.3 6.2-2.3 9.4 1.9 3.2 6.1 4.3 9.3 2.4 3.2-2 4.3-6.1 2.4-9.4-2-3.2-6.1-4.3-9.4-2.4z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "dQ",
    d: "m457.7 158.2c-2.6 1.6-3.5 4.9-1.9 7.5 1.5 2.6 4.9 3.4 7.5 1.9 2.5-1.5 3.4-4.9 1.9-7.5-1.6-2.6-4.9-3.4-7.5-1.9z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "dR",
    d: "m388.6 132.1c-5.1 3.1-6.8 9.8-3.7 15 3 5.2 9.7 6.9 14.9 3.8 5.2-3.1 6.9-9.8 3.8-15-3.1-5.1-9.8-6.8-15-3.8z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "dS",
    d: "m381.4 138.1c-4.6 2.7-6 8.5-3.3 13.1 2.7 4.5 8.5 6 13 3.3 4.6-2.7 6.1-8.6 3.4-13.1-2.7-4.6-8.6-6-13.1-3.3z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "dT",
    d: "m374.9 143.5c-3.9 2.3-5.2 7.3-2.9 11.2 2.4 3.9 7.4 5.2 11.3 2.9 3.9-2.3 5.1-7.4 2.8-11.2-2.3-3.9-7.3-5.2-11.2-2.9z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "dU",
    d: "m369.7 148.2c-3.2 1.9-4.3 6.1-2.3 9.3 1.9 3.2 6.1 4.3 9.3 2.4 3.3-1.9 4.3-6.1 2.4-9.4-1.9-3.2-6.1-4.3-9.4-2.3z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "dV",
    d: "m365.4 152.3c-2.6 1.6-3.4 4.9-1.9 7.5 1.5 2.6 4.9 3.5 7.5 1.9 2.6-1.5 3.4-4.9 1.9-7.5-1.6-2.6-4.9-3.4-7.5-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m210.2 128.8c-0.9 0-1.5-0.4-2.6-1.1q-0.7-0.5-1.8-1.1c-0.7-0.4-1.4-0.8-2.2-1.1-4.3-2.1-10.2-4.8-9.9-13.2 0.1-4.9-0.8-8.4-1.7-12.1-0.9-3.6-1.8-7.2-1.9-12.1-0.1-9.1 4.6-15.4 7.5-19.1q0.8-1.1 1.4-1.9c0.6-0.9 1.4-3 2.4-5.3 2.4-6.1 6-15.3 11.3-18.5 2.7-1.7 6-3.4 9.1-5 4.9-2.4 9.4-4.7 10.5-6.5 2.1-3.1 21.7-13.4 32.3-16.2 10.8-2.8 47.6-3.8 54.5 3.2 3 3 5.9 3.6 8.5 4.1 3.2 0.6 6 1.2 7.1 6.3l-1 0.3c-1-4.6-3.2-5-6.3-5.7-2.6-0.5-5.8-1.1-9-4.3-6.6-6.6-43.2-5.6-53.5-2.9-10.9 2.9-30 13-31.7 15.8-1.3 2-5.7 4.2-10.9 6.8-3.2 1.6-6.4 3.2-9.1 4.9-5 3.1-8.5 12.1-10.9 18-1 2.6-1.8 4.6-2.5 5.6q-0.5 0.8-1.4 1.9c-2.8 3.6-7.4 9.7-7.3 18.5 0.1 4.8 1 8.4 1.8 11.8 1 3.8 1.9 7.4 1.8 12.4-0.3 7.8 5.3 10.4 9.3 12.2 0.8 0.4 1.6 0.8 2.3 1.2 0.8 0.4 1.4 0.8 1.8 1.2 1.9 1.2 2.1 1.3 5.6-0.3l0.4 0.9c-1.9 0.9-3.1 1.3-3.9 1.3z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m214.2 44.6c2.6-1.6 5.6-3.1 8.5-4.6 4.4-2.2 8.5-4.4 9.9-6 0.9-1 2.7-2.3 4.8-3.9 5.8-4.7 16.8-9.8 24.5-11.8 3.3-0.8 8-1.5 12.8-2.4 6-1.1 14-1.6 21.7-1.3q0.4 0 0.8 0c8.5 0.5 15.7 1.9 18.8 4.5q0.3 0.3 0.5 0.5c3 2.9 6 3.3 8.7 3.7 3.3 0.4 6.1 0.8 7.2 5.7l-0.8 0.2c-1-4.3-3.3-4.7-6.5-5.1-2.8-0.4-6.1-0.8-9.3-4-5.9-6-34.4-5.8-47-2.7-1.7 0.3-3.1 0.7-4.4 1.1-2.9 0.9-6.4 2-10 3.4-9.3 3.6-18.9 8.5-20.3 11.6-0.9 2.1-5.3 4.3-10.3 6.9q-1.5 0.7-3 1.5c-2 1-4 2.1-5.8 3.2q-0.8 0.5-1.5 1.1c-4.3 3.5-7.8 10.2-10.1 15.5-1 2.2-1.8 4.1-2.4 5.3q-0.5 1-1.2 2.2c-0.8 1.2-1.8 2.8-2.9 4.8-1.9 3.4-3.7 7.7-3.8 13.2q0 2.6 0.3 4.9c0.2 2.5 0.7 4.6 1 6.5 0.2 1.4 0.4 2.6 0.6 3.9 0.3 2.4 0.5 4.8 0.4 8.1q0 0.6 0 1.1c0.1 3.9 1.9 6.4 4.3 8.2 1.5 1.1 3.1 1.9 4.6 2.6 0.8 0.3 1.5 0.7 2.2 1q1.1 0.6 1.9 1c1.4 0.7 2 0.9 3.5 0.4 0.1-0.1 0.2 0 0.2 0q0.4-0.2 0.9-0.6c-0.1 0 0.2 0.7 0.1 0.7-1.7 0.7-2.9 0.9-3.8 0.8-0.9 0-1.5-0.4-2.5-1q-0.8-0.4-1.8-1c-0.6-0.4-1.4-0.8-2.1-1.2-2.9-1.5-6.2-3.5-7.5-7.3-0.6-1.6-0.9-3.5-0.8-5.6 0.1-1.6 0.1-3 0-4.4-0.1-2.4-0.5-4.6-1-7.1-0.2-1.3-0.5-2.7-0.8-4.3-0.3-2.1-0.5-4.5-0.5-7.1 0.2-5.3 1.9-9.6 3.7-12.9 1.1-2.1 2.3-3.9 3.1-5.2q0.7-1.1 1.2-1.9c0.5-1.1 1.3-3 2.2-5.2 2.5-6 6.5-13.8 11.7-17z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m215.7 46c2.4-1.5 5.2-3 8-4.4 3.8-1.9 7.5-3.9 9.1-5.5 1.2-1.1 3-2.2 4.3-3.7 4.7-5.3 14.4-9.6 22.1-11.4 3.8-0.9 8.5-1.7 12.7-3.1 5.5-1.7 13.6-2.7 21.8-2.5q0.4 0 0.8 0c8.6 0.3 15.9 1.9 18.9 4.6q0.3 0.2 0.6 0.5c2.9 2.7 6.1 3 8.9 3.2 3.3 0.3 6.2 0.5 7.2 5.1l-0.6 0.2c-0.9-4.2-3.4-4.4-6.7-4.7-2.9-0.2-6.4-0.5-9.6-3.6-6-6.1-33.7-5.8-45.1-1.7-1.5 0.5-2.8 0.9-4.1 1.4-2.9 0.9-6.3 1.9-9.8 3.1-8.7 2.9-17.6 6.8-19.2 11.2-0.7 2-4.9 4.3-9.8 6.8q-1.3 0.7-2.8 1.5c-1.9 1-3.9 2-5.6 3.1q-0.8 0.4-1.5 1c-4.4 3.3-8.4 8.9-10.8 14.1-1 2-1.7 3.8-2.3 5.2q-0.4 1-1 2.3c-0.5 1.2-1.4 2.8-2.4 4.8-1.7 3.3-3.4 7.6-3.6 12.7q-0.2 2.5 0 4.8c0.2 2.5 0.5 4.5 0.7 6.3 0.1 1.4 0.1 2.6 0.2 3.8 0.1 2.2 0.1 4.4 0 7.8q0 0.5 0 1.1c0 3.5 1.7 6.1 4.1 7.9 1.4 1.1 2.9 1.9 4.4 2.5 0.7 0.3 1.5 0.6 2.2 0.9q1 0.4 1.8 0.8c1.4 0.5 2.2 0.6 3.5 0.2 0 0 0.1 0.1 0.2 0.1q0 0 0-0.3c-0.1 0-0.1 0.5-0.2 0.5-1.5 0.4-2.7 0.5-3.7 0.3-0.8-0.1-1.5-0.4-2.4-0.9q-0.8-0.5-1.8-1c-0.6-0.4-1.3-0.8-2-1.2-2.7-1.7-5.4-3.9-6.2-7.4-0.4-1.8-0.5-3.5-0.4-5.4 0.1-1.5 0.2-2.8 0.2-4 0-2.2-0.2-4.2-0.5-6.7-0.1-1.3-0.3-2.6-0.5-4.1-0.2-2.1-0.3-4.3-0.2-6.7 0.3-4.9 1.9-8.9 3.5-12.1 1-2.1 2-3.7 2.6-5q0.5-1.1 0.9-2c0.5-1.2 1.1-3 2-4.9 2.5-5.9 7-12.4 12.1-15.5z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m217.2 47.3c2.2-1.3 4.8-2.7 7.4-4 3.3-1.8 6.6-3.5 8.5-5 1.5-1.2 3.1-2.3 3.8-3.6 3.3-6.1 11.9-9.2 19.6-11 4.3-1 9.1-2 12.7-3.7 4.8-2.4 13-3.9 21.8-3.8q0.4 0 0.8 0c8.8 0.1 16.1 1.8 19 4.6q0.3 0.2 0.6 0.5c2.9 2.6 6.2 2.7 9.1 2.8 3.4 0.1 6.3 0.2 7.4 4.5l-0.5 0.1c-0.9-3.9-3.5-4-6.9-4.1-3.1-0.1-6.7-0.2-9.9-3.4-6.1-6.1-33.1-5.8-43.2-0.6-1.3 0.6-2.6 1.2-3.9 1.6-2.8 1-6.1 1.9-9.4 2.9-8.3 2.3-16.7 5.1-18.1 10.8-0.5 2-4.6 4.3-9.3 6.8q-1.3 0.7-2.7 1.4c-1.8 1-3.7 2-5.5 3q-0.7 0.4-1.4 0.9c-4.5 3.1-8.9 7.6-11.6 12.7-0.9 1.7-1.6 3.5-2.1 5q-0.4 1.2-0.8 2.5c-0.3 1.3-1.1 2.8-1.9 4.8-1.4 3.2-3.1 7.4-3.5 12.3q-0.2 2.3-0.1 4.6c0.1 2.6 0.2 4.5 0.2 6.1 0 1.4 0 2.5-0.1 3.7-0.1 2-0.2 4.1-0.4 7.5q0 0.5 0 1c0 3.3 1.4 5.8 3.8 7.8 1.3 1 2.8 1.7 4.3 2.3q1.1 0.5 2.1 0.8 1 0.3 1.9 0.6c1.3 0.3 2.3 0.4 3.4 0.1 0 0 0.1 0.2 0.1 0.2q-0.4 0-0.8-0.1c-0.2 0-0.3 0.2-0.5 0.2-1.3 0.2-2.5 0.1-3.7-0.1-0.7-0.2-1.4-0.5-2.3-0.9q-0.8-0.4-1.7-0.9-0.9-0.5-1.8-1.2c-2.7-1.9-4.6-4.3-5-7.6-0.2-1.9-0.2-3.5 0-5 0.1-1.5 0.2-2.6 0.3-3.8 0.1-1.9 0.2-3.7 0.1-6.3-0.1-1.1-0.2-2.3-0.3-3.8q-0.2-3.1 0.2-6.3c0.5-4.5 2-8.3 3.3-11.3 0.9-2 1.7-3.6 2-4.9q0.3-1 0.6-1.9c0.5-1.5 1.1-3.1 1.9-4.8 2.7-5.7 7.5-10.9 12.5-14z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m210.9 117.7c-2.8 0-7-1-10-3.5-2.5-2-3.8-4.7-3.7-7.7 0.1-4.2 0.5-6.3 0.8-8.3 0.4-2.2 0.7-4.3 0.7-9.4-0.1-6.7 2-12.3 3.6-16.3 0.7-2 1.3-3.6 1.5-4.8 1.2-9.4 8.2-14.9 15-19 2-1.3 4.4-2.5 6.7-3.8 5.2-2.8 10.7-5.7 11.1-7.9 1.3-7.1 9.4-8.9 17.2-10.7 4.7-1 9.6-2.1 12.7-4.3 4.1-3 12.5-5 21.8-5.1q0.4 0 0.8 0c9 0 16.3 1.8 19.2 4.7 3 3 6.7 3 9.9 2.9 3.4 0 6.4-0.1 7.4 3.9l-0.3 0.1c-0.9-3.8-3.7-3.7-7.1-3.7-3.3 0.1-7 0.2-10.2-3-6.2-6.2-32.5-6-41.3 0.4-3.2 2.3-8.1 3.4-12.8 4.4-7.7 1.7-15.7 3.5-17 10.4-0.4 2.4-5.7 5.2-11.3 8.2-2.3 1.2-4.7 2.5-6.7 3.7-6.7 4.1-13.7 9.6-14.8 18.8-0.2 1.3-0.8 2.8-1.6 4.9-1.5 4-3.6 9.5-3.5 16.2 0 5.1-0.3 7.2-0.7 9.5-0.3 2-0.7 4-0.8 8.2-0.1 2.9 1.1 5.5 3.6 7.5 3.6 2.9 9 3.8 11.3 3.2l0.1 0.3q-0.7 0.2-1.6 0.2z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "dW",
    d: "m210 125.7c-4.8-3.4-6.6-13.6-3.7-17.8 2.9-4.1 6.2-12.4 6.2-12.4 0 0-5.8 1.3-6.2-1.6-0.4-2.9 1.7-10.4 1.7-10.4 0 0 1.6 6.6 4.1 4.6 2.5-2.1 6.2 6.2 6.6 2.5 0.4-3.8 3.3-14.5 6.2-17.4 2.9-2.9 6.6-9.9 6.6-9.9 0 0 2.5-2.5 7.1-2.5 4.5 0 11.1-4.2 11.5-8.7 0.4-4.5 2.5-10.8 5-12 2.5-1.2 7.9-7 6.6-9.9-1.2-2.9-1.2-5.8-1.2-5.8 0 0 7 2.9 5.3 6.6-1.6 3.7-2.4 8.3-2.4 8.3 0 0 1.2 1.6 7-0.4 5.8-2.1 10.7-8.7 10.7-8.7 0 0 6.2-0.4 10-1.3 3.7-0.8 4.5-6.6 12-5.7 7.4 0.8 9.9 0.2 17.3 0.6 7.5 0.4 17.8 2.9 17 17.8-0.8 14.8-29 49.4-66.2 66.7-37.2 17.4-54.1 22.4-61.2 17.4z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "dX",
    d: "m214.6 127.2c-11.3-4.1-6.6-19-3.9-22.3 2.8-3.3 6.9-8 6.9-8 0 0-1.9-1.7-2.8-3-0.8-1.4-3.5-2.8-3.5-2.8l6.3 3.6c0 0 2.2 1.1 3.3-1.7 1.1-2.7 3.7-23.2 14.6-27.9 6.4-2.8 17.4-7.3 18.5-9 1.1-1.7 1.9-6.6 2.5-9.1 0.5-2.5 4.9-9.7 4.9-9.7l-1.9 9.7c0 0 7.7-1.4 16-7.2 8.3-5.8 13.2-8.2 18.2-9.6 5-1.4 13.4-3.9 21.4-5 10.4-1.4 61 14.1-0.2 52.1-61.2 38.1-82.4 56.5-100.3 49.9z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m239.4 52.2c0 0-8-3.8-6.9-7.7 1.1-3.8 1.4-7.2 1.4-7.2 0 0 8.5-4.6 10.4-2.7 2 1.9 6.4-4.1 6.4-4.1 0 0-4.7 0-8.6 0-2.1 0-6.2 0.8-9.3 1.6q0 0 0 0c-0.8 1.2-3 2.6-5.9 4.2 1.4 1.7 4.8 6.6 1.5 10.7-3.6 4.4 11 5.2 11 5.2z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m232.8 49.6c-1.7-0.4-3-0.9-3.3-1.3q0-0.1 0.1-0.3 0.8-0.9 1.2-1.9c0.3 1.3 1 2.5 2 3.5zm-1.4-7.5q-0.3-2.5-2-5.3c2.2-1.3 3.5-2.3 4.4-3.3 3.9-0.9 6.8-1.4 8.3-1.4h4.9c-0.6 0.6-1.3 1.1-1.6 1.2q-1-0.8-2.5-0.8c-3.5 0-9.2 3-9.8 3.4l-0.8 0.4-0.1 0.9c0 0-0.2 2.2-0.8 4.9z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m207.7 63.3c-1.9 0.2-4.5-1.4-5.6-2.1-1.1 2.8-2 5.1-2.7 6.2-0.5 0.7-1.1 1.5-1.9 2.5l11.3-1.7c0 0 0.5 2 0.8 5 0.3 3 6.3 5.5 6.3 5.5 0 0-1.9-3.9-1.9-6.1 0-2.2 0.8-8.5 0-11.5-0.8-3.1-2.1-9.6-2.1-9.6 0 0-1.7 11.5-4.2 11.8z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m212.7 74.9c-0.8-0.6-1.4-1.3-1.4-1.9-0.3-3.1-0.9-5.1-0.9-5.2l-0.4-1.4c0 0-8.6 1.9-7.8-1.9 1.3 0.7 3.7 0.4 5.1 0.4q0.3 0 0.6 0c1.2-0.1 1.3-1 2.9-3.1 0.1 0.1 0.9-2.3 0.9-2.3 0.5 2 1 7.8 0.8 10.4-0.1 1.1-0.1 2.1-0.1 2.7 0 0.7 0.1 1.5 0.3 2.3z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m276.3 18.9c-1.2 0.3-1.6 7.1-1.6 7.1 0 0 1.1-4.4 6.6-5.2 5.5-0.8 9.9-5 9.9-5 0 0-8 1.1-14.9 3.1z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m275.9 22.5c0.2-1.4 2.4-2.5 2.6-2.8 4.1-1.1 6.7-2 9.6-2.5-1.7 1.1-4.2 2.4-6.9 2.8-2.5 0.4-4.2 1.4-5.3 2.5z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m212.5 113.2c0 0-7.4 1-10.6-2.2-3.1-3.2-0.7-12.3-0.7-12.3 0 0-1.1 3.7-5 2.2-2.1-0.8-3.6-2.9-5-6.1 1.1 5.9 3.2 10.3 3 17.5-0.3 9.7 8 11.6 11.8 13.8 3.9 2.2 3.5 2.7 8.3 0.6 1.7-0.8-1.8-13.5-1.8-13.5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "dY",
    d: "m202.2 73.8c-3.4-0.7-8.7 2.9-10.5 9-1.8 6 0.1 13.1 3.2 13.2 3 0.1 6 0.4 7.7 3.3 1.6 2.9 3-3.3 1.2-8.5-1.8-5.3-6-7.1-3.2-9 2.9-1.9 6.7-6.9 1.6-8z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m202 74.3c2.9 0.7 2.5 2.8 1.2 4.7-0.8 1.1-1.9 2.2-2.9 2.9q-0.4 0.3-0.6 0.5c-1.2 1.5 1.2 3.1 2.8 6.3q0.5 0.8 0.8 1.8c0.6 1.7 0.9 3.4 0.9 5 0 2.9-0.9 4.9-1.9 3.2-1.6-2.7-4.6-3-7.5-3.1-2.8-0.2-4.6-6.9-2.9-12.7 1.5-5.2 5.8-8.6 8.9-8.7q0.3 0 0.5 0 0.3 0 0.7 0.1z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m201.7 74.7c2.6 0.7 2.3 2.7 0.9 4.5-0.8 1.1-1.8 2.1-2.7 2.8q-0.4 0.3-0.6 0.5c-1.1 1.5 1.1 3 2.7 6.1q0.4 0.7 0.8 1.6c0.6 1.6 0.9 3.2 0.9 4.7 0.1 2.8-0.7 4.6-1.6 3.2-1.7-2.6-4.5-2.8-7.3-2.9-2.6-0.2-4.4-6.6-2.7-12.2 1.5-5 5.6-8.2 8.6-8.4q0.2 0 0.4 0 0.4 0.1 0.6 0.1z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "e1",
    d: "m201.5 75.2c2.3 0.7 1.9 2.6 0.6 4.3-0.8 1-1.8 1.9-2.6 2.6q-0.3 0.3-0.5 0.5c-1 1.5 1 3 2.5 5.8q0.4 0.7 0.8 1.5c0.5 1.5 0.8 3.1 0.9 4.5 0.1 2.5-0.6 4.3-1.4 3.1-1.6-2.4-4.4-2.6-7-2.7-2.4-0.3-4.1-6.3-2.5-11.7 1.4-4.8 5.4-7.9 8.2-8q0.2 0 0.4 0 0.4 0 0.6 0.1z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m201.3 75.7c2 0.6 1.5 2.4 0.2 4-0.7 0.9-1.7 1.9-2.4 2.5q-0.3 0.3-0.5 0.5c-0.9 1.5 1 2.9 2.4 5.5q0.4 0.7 0.7 1.4c0.6 1.4 0.9 2.9 1 4.2 0.2 2.4-0.4 4-1.1 3.1-1.7-2.2-4.3-2.4-6.8-2.6-2.2-0.2-3.8-5.9-2.3-11.1 1.4-4.6 5.2-7.5 7.8-7.6q0.2-0.1 0.4 0 0.4 0 0.6 0.1z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "m201.1 76.1c1.7 0.6 1.2 2.4-0.1 3.8-0.8 0.9-1.6 1.8-2.3 2.5q-0.3 0.2-0.4 0.4c-0.8 1.5 0.9 2.8 2.2 5.2q0.4 0.6 0.7 1.4c0.6 1.2 0.9 2.6 1 3.9 0.2 2.1-0.3 3.7-0.9 3-1.6-2.1-4.2-2.3-6.5-2.4-2-0.3-3.6-5.6-2.1-10.5 1.3-4.5 5-7.3 7.5-7.4q0.2 0 0.4 0 0.3 0.1 0.5 0.1z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m200.9 76.6c1.4 0.6 0.8 2.2-0.5 3.6-0.7 0.8-1.5 1.6-2.1 2.3q-0.2 0.2-0.4 0.4c-0.7 1.4 0.9 2.8 2.1 4.9q0.4 0.6 0.7 1.3c0.5 1.1 0.9 2.4 1 3.6 0.3 2-0.1 3.4-0.6 3-1.7-1.9-4.2-2.1-6.4-2.2-1.7-0.3-3.2-5.3-1.8-10 1.3-4.3 4.8-6.9 7.1-7q0.2 0 0.4 0 0.3 0 0.5 0.1z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m200.7 77.1c1 0.5 0.4 2.1-0.8 3.3-0.7 0.7-1.5 1.5-2 2.2q-0.2 0.2-0.3 0.4c-0.6 1.4 0.8 2.7 1.9 4.6q0.4 0.6 0.7 1.2c0.5 1.1 0.9 2.2 1.1 3.4 0.2 1.7-0.1 3.1-0.5 2.9-1.6-1.7-4-1.9-6.1-2-1.5-0.3-2.9-5-1.6-9.5 1.2-4.1 4.6-6.6 6.7-6.7q0.2 0 0.4 0.1 0.3 0 0.5 0.1z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m200.5 77.5c0.7 0.6 0 2-1.2 3.2-0.7 0.6-1.3 1.3-1.8 2q-0.1 0.2-0.2 0.4c-0.6 1.4 0.7 2.6 1.7 4.3q0.4 0.5 0.7 1.1c0.5 1 0.9 2 1.1 3.1 0.2 1.6 0 2.8-0.2 2.9-1.7-1.6-4-1.7-5.9-1.8-1.3-0.4-2.7-4.7-1.4-9 1.2-3.9 4.4-6.3 6.4-6.3q0.1 0 0.3 0 0.3 0.1 0.5 0.1z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m200.3 78c0.4 0.5-0.3 1.9-1.5 2.9-0.7 0.6-1.3 1.2-1.7 1.9q-0.1 0.2-0.2 0.4c-0.4 1.4 0.7 2.5 1.6 4.1q0.3 0.4 0.6 0.9c0.5 0.9 1 1.8 1.2 2.9 0.3 1.3 0.2 2.5 0 2.8-1.6-1.4-3.8-1.6-5.6-1.6-1.1-0.4-2.4-4.4-1.2-8.5 1.1-3.7 4.2-5.9 6-5.9q0.2-0.1 0.3 0 0.3 0 0.5 0.1z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m200 78.4c0.2 0.6-0.6 1.9-1.7 2.7q-1.1 0.8-1.6 1.8-0.1 0.2-0.1 0.4c-0.4 1.4 0.6 2.5 1.4 3.8q0.3 0.4 0.6 0.9c0.5 0.7 0.9 1.6 1.2 2.5 0.3 1.2 0.3 2.2 0.3 2.8-1.7-1.3-3.8-1.4-5.4-1.5-0.9-0.4-2.1-4-1-7.8 1.1-3.6 4-5.7 5.6-5.7q0.2 0 0.3 0 0.3 0.1 0.4 0.1z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m199.8 92.7c-1.7-1.1-3.7-1.2-5.2-1.3-0.6-0.4-1.7-3.7-0.7-7.3 1-3.4 3.8-5.3 5.3-5.3q0.1 0 0.2 0 0.3 0.1 0.4 0.1c-0.1 0.5-1 1.7-2.1 2.5q-1.3 0.8-1.5 2c-0.2 1.4 0.5 2.4 1.3 3.5 0.7 0.8 1.4 1.8 1.8 3.1 0.3 0.9 0.5 1.9 0.5 2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m217.5 78.3c2.4 1.4 7.2-15.3 12.8-15.9 5.6-0.5 11.1-3.5 11.8-5 0.3-0.8-3.5-1.5-7.6-2.4-4-0.9-8.2-2.1-8.6-4.1-0.7-4.1 1-11.9-2.9-11.2-3.8 0.7-9.6 12.6-8.2 18.4 1.4 5.7-1.8 17.4 2.7 20.2z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m222.8 41.1c3.5-0.6 2.1 6.6 2.8 10.3 0.3 1.7 3.5 2.8 6.8 3.6q0.6 0.1 1.1 0.3c3.7 0.8 7.3 1.4 7 2.1-0.5 1.1-3.4 2.8-6.9 3.9-1.3 0.4-2.6 0.7-4 0.8-1.1 0.1-2.1 0.9-3.1 1.9-3.8 4.2-7 13.7-8.8 12.7-2.2-1.4-2.4-5.1-2.3-9.1 0.1-3.5 0.5-7.1-0.1-9.5-1.3-5.3 4-16.3 7.5-17z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m222.5 42.5c3.2-0.5 2 6.1 2.7 9.5 0.4 1.5 3.3 2.5 6.3 3.3q0.5 0.1 1 0.2c3.4 0.8 6.6 1.3 6.4 2-0.5 1-3.1 2.6-6.3 3.5-1.2 0.4-2.4 0.7-3.7 0.8-1 0.1-1.9 0.8-2.8 1.8-3.5 3.8-6.5 12.4-8.1 11.6-2-1.3-2.2-4.8-2.1-8.4 0.1-3.2 0.4-6.4-0.1-8.7-1.2-4.9 3.6-14.9 6.7-15.6z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m222.2 43.9c3-0.3 1.9 5.6 2.7 8.6 0.3 1.4 2.9 2.3 5.7 3q0.5 0.1 0.9 0.3c3.1 0.7 6 1.2 5.9 1.8-0.5 0.9-2.9 2.3-5.8 3.2-1.1 0.3-2.2 0.6-3.4 0.7-0.9 0.1-1.7 0.7-2.6 1.6-3.2 3.5-5.9 11.2-7.4 10.6-1.8-1.3-1.9-4.4-1.8-7.7 0.1-2.9 0.3-5.8-0.2-7.9-1-4.5 3.3-13.5 6-14.2z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m222 45.3c2.6-0.2 1.8 5 2.5 7.8 0.4 1.2 2.7 2 5.2 2.7q0.4 0.1 0.8 0.2c2.7 0.7 5.4 1.1 5.3 1.7-0.5 0.7-2.7 2-5.3 2.8-0.9 0.3-2 0.5-3 0.7-0.8 0.1-1.6 0.6-2.3 1.4-2.9 3.1-5.4 10-6.8 9.5-1.5-1.1-1.6-3.9-1.5-6.9 0-2.6 0.2-5.2-0.2-7.1-0.8-4.1 2.9-12 5.3-12.8z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m221.7 46.7c2.3-0.1 1.7 4.5 2.5 6.9 0.3 1.1 2.4 1.9 4.6 2.4q0.4 0.1 0.7 0.2c2.4 0.6 4.7 1 4.7 1.5-0.5 0.7-2.4 1.8-4.7 2.5q-1.3 0.4-2.7 0.7c-0.7 0.1-1.4 0.6-2 1.3-2.7 2.7-4.9 8.7-6.2 8.4-1.3-1.1-1.4-3.6-1.3-6.2 0.1-2.3 0.3-4.6-0.1-6.3-0.7-3.6 2.4-10.6 4.5-11.4z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m221.4 48.1c2 0 1.6 4 2.4 6.1 0.4 0.9 2.2 1.6 4.1 2.1q0.3 0.1 0.6 0.2c2.1 0.5 4.1 0.9 4.2 1.3-0.5 0.6-2.2 1.5-4.2 2.2q-1.2 0.3-2.4 0.5c-0.6 0.2-1.2 0.6-1.8 1.2-2.3 2.4-4.2 7.4-5.4 7.4-1.1-1-1.2-3.2-1.1-5.5 0-2 0.2-4-0.1-5.5-0.6-3.2 2-9.2 3.7-10z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m221.1 49.5c1.7 0.2 1.6 3.4 2.3 5.2 0.4 0.8 1.9 1.4 3.6 1.9q0.2 0.1 0.5 0.1c1.7 0.5 3.4 0.8 3.6 1.2-0.5 0.5-1.9 1.3-3.6 1.8q-1 0.3-2 0.5c-0.6 0.1-1.1 0.5-1.6 1-2 2-3.7 6.2-4.8 6.3-0.9-0.9-0.9-2.7-0.8-4.7 0-1.7 0.1-3.4-0.1-4.7-0.5-2.8 1.6-7.8 2.9-8.6z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m220.9 50.9c1.4 0.3 1.4 2.9 2.2 4.4 0.4 0.6 1.6 1.1 3 1.5q0.2 0.1 0.4 0.2c1.4 0.4 2.8 0.6 3 1-0.5 0.4-1.7 1-3 1.4q-0.9 0.3-1.7 0.5c-0.5 0.1-0.9 0.4-1.4 0.8-1.7 1.7-3.1 5-4.1 5.3-0.6-0.8-0.6-2.4-0.6-3.9 0.1-1.5 0.2-2.9 0-4-0.4-2.4 1.2-6.4 2.2-7.2z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m220.6 52.3c1.1 0.4 1.3 2.4 2.1 3.5 0.4 0.6 1.4 1 2.4 1.3q0.2 0.1 0.4 0.1c1.1 0.3 2.2 0.6 2.5 0.9-0.5 0.2-1.5 0.7-2.6 1.1q-0.6 0.2-1.3 0.4c-0.4 0.1-0.7 0.4-1.1 0.7-1.4 1.3-2.6 3.7-3.4 4.2-0.4-0.8-0.4-2-0.4-3.2 0-1.2 0.1-2.3 0-3.2-0.2-2 0.8-5 1.4-5.8z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m220.3 53.6c0.8 0.7 1.3 1.9 2.1 2.8 0.4 0.4 1.1 0.7 1.8 1q0.2 0 0.3 0.1c0.8 0.2 1.5 0.4 1.9 0.6-0.5 0.2-1.2 0.5-2 0.8q-0.5 0.2-1 0.4-0.4 0.2-0.8 0.5c-1.1 0.9-2.1 2.5-2.8 3.1-0.2-0.6-0.2-1.5-0.1-2.4 0-0.9 0-1.7 0-2.4-0.1-1.5 0.4-3.5 0.6-4.5z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m220 61.4q0.1-0.9 0.1-1.7 0.1-0.9 0.1-1.7 0-1.6-0.2-3 0.8 1.1 2 1.9 0.6 0.4 1.3 0.7 0.7 0.3 1.5 0.6-0.7 0.1-1.4 0.4-0.7 0.3-1.3 0.7-1.2 0.9-2.1 2.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "eb",
    d: "m246.4 50.2c-2.6 0.6-6.5-9.1-4.5-10.9 1.9-1.7 7.1-0.9 9.1-3.8 1.9-2.9 3.8-10.8 6.6-9.2 2.7 1.5-2.5 7.5-4.6 13.6-2 6.1-1.9 9.4-6.6 10.3z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "eb",
    d: "m246.5 49.8c-2.4 0.4-6-8.5-4.3-10.2 1.8-1.6 6.6-0.9 8.3-3.5 1.8-2.7 3.7-9.8 6.2-8.4 2.5 1.3-2.2 6.9-4.1 12.4-2 5.7-1.9 8.8-6.1 9.7z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "eb",
    d: "m246.5 49.4c-2.2 0.2-5.5-7.9-4-9.5 1.7-1.5 6-0.9 7.6-3.2 1.7-2.4 3.4-8.9 5.8-7.6 2.2 1.2-2.1 6.2-3.8 11.2-1.8 5.3-1.7 8.2-5.6 9.1z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m246.5 48.9c-2 0.1-4.9-7.2-3.6-8.8 1.5-1.3 5.3-0.7 6.8-2.8 1.6-2.2 3.1-7.9 5.3-6.8 2 1.1-1.8 5.5-3.3 10-1.7 4.9-1.7 7.6-5.2 8.4z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m246.6 48.5c-1.8 0-4.5-6.6-3.4-8.1 1.4-1.2 4.8-0.7 6.1-2.5 1.4-1.9 2.9-6.9 4.8-6 1.8 1-1.6 4.9-2.9 8.8-1.5 4.5-1.5 7-4.6 7.8z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "m246.6 48c-1.6-0.1-4-5.9-3-7.4 1.2-1 4.1-0.6 5.3-2.1 1.3-1.7 2.6-6 4.4-5.2 1.5 0.9-1.4 4.2-2.5 7.6-1.4 4.1-1.5 6.4-4.2 7.1z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "m246.7 47.6c-1.5-0.3-3.5-5.3-2.8-6.7 1.1-0.8 3.6-0.5 4.6-1.8 1.1-1.4 2.4-5 3.9-4.4 1.3 0.7-1.2 3.6-2.1 6.4-1.3 3.7-1.3 5.8-3.6 6.5z"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "m246.7 47.1c-1.2-0.4-3-4.6-2.4-5.9 0.8-0.7 2.9-0.5 3.8-1.5 1-1.2 2.1-4.1 3.5-3.6 0.9 0.6-1 2.9-1.8 5.2-1.1 3.3-1.2 5.2-3.1 5.8z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "ed",
    d: "m246.8 46.7c-1.1-0.5-2.5-4.1-2.2-5.3 0.7-0.5 2.3-0.4 3.1-1.1 0.8-1 1.8-3.1 3-2.8 0.7 0.5-0.7 2.2-1.3 4-1 2.9-1.2 4.6-2.6 5.2z"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "ed",
    d: "m246.8 46.3c-0.9-0.7-2-3.5-1.8-4.6 0.5-0.4 1.7-0.3 2.3-0.8 0.7-0.7 1.6-2.2 2.6-2 0.4 0.4-0.6 1.6-1 2.8-0.8 2.6-1 4-2.1 4.6z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m246.8 45.8c-0.6-0.8-1.4-2.8-1.5-3.8 0.4-0.3 1.1-0.3 1.6-0.6 0.6-0.4 1.3-1.1 2.1-1.1 0.2 0.2-0.3 0.9-0.5 1.6-0.7 2.2-1 3.3-1.7 3.9z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m246.9 45.4c-0.5-1-1-2.2-1.3-3.2q0.5-0.1 0.9-0.2 0.7-0.1 1.6-0.3 0 0.2-0.1 0.4c-0.5 1.8-0.8 2.7-1.1 3.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m281.3 28.3c1.3 1.2 4.2-0.4 7.5-2.2 3.2-1.8 6.8-3.9 9.3-3.9 5.1 0 18.6 0.7 14.2-2.9-4.4-3.6-13.4-5.5-18.7-2.1-2.7 1.7-7 3.4-10.1 5.1-3 1.8-4.7 3.7-2.2 6z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m294.2 17.3c5-3.1 13.2-1.3 17.3 1.9 2.2 1.8-0.2 2.4-3.6 2.7-1.8 0.1-3.9 0.1-5.8 0.1-1.4 0-2.7-0.1-3.6-0.1-1.2 0-2.5 0.4-3.9 1-1.5 0.7-3.1 1.6-4.6 2.4q-0.2 0.1-0.4 0.2c-3 1.6-5.8 3.1-7.1 2-0.7-0.6-1-1.2-1-1.8-0.1-1.3 1.2-2.5 3.2-3.7 0.9-0.5 1.9-1 2.9-1.5 2.3-1 4.8-2.1 6.6-3.2z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m294.8 17.4c4.6-2.7 12.1-1.2 15.9 1.8 2.1 1.6 0 2.2-2.9 2.4-1.7 0.1-3.7 0.1-5.5 0.1-1.3 0-2.5 0-3.5 0-1 0-2.3 0.3-3.6 0.9-1.5 0.6-3 1.4-4.4 2.1q-0.2 0.1-0.4 0.2c-2.8 1.5-5.4 2.8-6.7 1.8-0.6-0.5-0.8-1.1-0.9-1.6 0-1.2 1.3-2.3 3-3.4 0.9-0.4 1.8-0.9 2.8-1.4 2.2-0.9 4.5-1.9 6.2-2.9z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m295.5 17.5c4.2-2.4 10.9-1 14.4 1.6 1.9 1.5 0.2 2-2.3 2.3-1.6 0.1-3.5 0.1-5.2 0-1.2 0-2.3 0-3.2 0-1 0-2.2 0.3-3.4 0.8-1.4 0.6-2.9 1.2-4.2 1.9q-0.2 0.1-0.3 0.2c-2.7 1.3-5.1 2.5-6.4 1.7q-0.7-0.8-0.7-1.5c0-1.1 1.2-2.1 2.8-3.1 0.8-0.4 1.7-0.8 2.6-1.2 2-1 4.2-1.8 5.9-2.7z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m296.1 17.6c3.8-2 9.8-0.9 13 1.4 1.8 1.3 0.4 1.8-1.7 2.1-1.5 0.1-3.2 0.1-4.8 0.1-1.1 0-2.2 0-3 0-1-0.1-2.1 0.2-3.3 0.7-1.3 0.4-2.6 1-3.9 1.6q-0.2 0.1-0.3 0.1c-2.5 1.2-4.7 2.3-6 1.6q-0.6-0.7-0.5-1.3c0-1 1.1-1.9 2.6-2.8 0.7-0.4 1.5-0.8 2.4-1.1 1.9-0.9 3.9-1.6 5.5-2.4z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m296.7 17.7c3.5-1.7 8.7-0.7 11.6 1.3 1.7 1.1 0.6 1.6-1 1.8-1.4 0.1-3 0.1-4.5 0.1-1.1 0-2.1 0-2.9 0-0.9 0-1.9 0.2-3 0.6-1.2 0.4-2.5 0.9-3.7 1.4q-0.1 0.1-0.3 0.1c-2.2 1-4.3 2-5.5 1.5q-0.5-0.6-0.5-1.2c0.1-0.9 1.1-1.7 2.4-2.5q1.1-0.5 2.3-1c1.7-0.8 3.7-1.4 5.1-2.1z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m297.4 17.8c3-1.4 7.5-0.5 10.1 1.1 1.5 1 0.8 1.4-0.4 1.7-1.3 0.1-2.7 0.1-4.2 0.1-0.9-0.1-1.8-0.1-2.6-0.1-0.9 0-1.8 0.2-2.8 0.5-1.2 0.4-2.4 0.8-3.5 1.2q-0.1 0-0.2 0.1c-2.1 0.8-4 1.7-5.2 1.3q-0.4-0.5-0.3-1c0.1-0.8 1-1.5 2.2-2.1q0.9-0.6 2.1-1c1.6-0.7 3.4-1.2 4.8-1.8z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m298 17.9c2.6-1 6.4-0.4 8.7 0.9 1.4 0.9 1 1.2 0.2 1.5-1.1 0.1-2.5 0.1-3.8 0.1-0.9 0-1.7 0-2.4 0-0.8 0-1.7 0.1-2.6 0.4-1.1 0.2-2.3 0.6-3.3 0.9q-0.1 0-0.2 0.1c-1.9 0.6-3.6 1.4-4.8 1.2q-0.3-0.5-0.1-0.9c0.1-0.7 0.9-1.3 1.9-1.8q0.9-0.5 2-0.9c1.4-0.6 3.1-1 4.4-1.5z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m298.6 18c2.2-0.7 5.3-0.3 7.2 0.8 1.4 0.7 1.4 1 1 1.3-1.1 0-2.3 0-3.6 0-0.7 0-1.5 0-2.2 0-0.7 0-1.5 0.1-2.3 0.3-1.1 0.2-2.1 0.5-3 0.7q-0.2 0-0.3 0.1c-1.6 0.4-3.2 1.1-4.4 1q-0.1-0.4 0-0.7c0.2-0.6 0.9-1.1 1.8-1.5q0.8-0.4 1.8-0.8c1.3-0.5 2.8-0.8 4-1.2z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m299.3 18.1c1.8-0.5 4.1-0.1 5.7 0.6 1.2 0.5 1.6 0.8 1.6 1.1-0.9 0.1-2 0.1-3.2 0.1q-1.1 0-2 0c-0.7 0-1.4 0-2.2 0.1-1 0.2-1.9 0.3-2.7 0.5q-0.1 0-0.2 0c-1.5 0.4-2.9 0.9-4.1 1q0-0.3 0.2-0.6c0.2-0.5 0.8-0.9 1.5-1.2q0.8-0.4 1.6-0.7c1.2-0.4 2.6-0.6 3.8-0.9z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m299.9 18.2c1.4-0.2 3 0 4.3 0.4 1.1 0.4 1.8 0.7 2.2 1q-1.2 0-2.8 0-1 0-1.8 0-1 0-2 0.1c-0.9 0-1.8 0.1-2.5 0.2q-0.1 0-0.2 0c-1.3 0.2-2.5 0.6-3.7 0.8q0.1-0.2 0.3-0.4c0.3-0.4 0.8-0.7 1.4-0.9q0.7-0.3 1.4-0.6c1.1-0.3 2.2-0.4 3.4-0.6z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m295.1 19.7q0.5-0.4 1.1-0.6 0.6-0.3 1.3-0.4 1.4-0.4 3-0.4 1.5 0 2.9 0.3 1.5 0.2 2.9 0.7-1.1 0-2.6 0c-1.1 0-2.3 0-3.3 0q-1.3 0-2.3 0c-1.1 0-2.3 0.2-3.5 0.7q0.3-0.2 0.5-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m260.9 20.8c-0.4-2.9 6-2.3 8.4-2.2 2.3 0.1 3.2 8.7 5.5 8.5 2.3-0.1 4.7 5.4-1 7.6-2.8 1.1-4.1-0.4-5-2.5-0.8-2.1-1.2-4.8-2.3-6.2-2-2.6-5.2-1.9-5.6-5.2z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m261.3 20.9c-0.1-1 0.6-1.6 1.7-1.9 1.9-0.5 4.8-0.2 6.2-0.1 1 0.1 1.7 1.9 2.4 3.7 0.8 2.2 1.6 4.5 2.8 4.5 0.6 0 1.2 0.4 1.6 1 1.2 1.4 1.5 4.1-1.1 5.7q-0.4 0.3-1 0.6-1.2 0.5-2.1 0.4-0.4 0-0.7-0.1c-0.9-0.5-1.6-1.6-2.1-2.8-0.8-2.1-1.2-4.7-2.2-6q-0.3-0.3-0.6-0.6c-1.9-1.9-4.5-1.6-4.9-4.4z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m261.6 20.9c0-0.9 0.7-1.4 1.7-1.6 1.8-0.5 4.5-0.3 5.8-0.2 1 0.2 1.6 1.9 2.3 3.6 0.8 2.1 1.5 4.3 2.6 4.4 0.6 0.1 1.1 0.4 1.6 0.9 1 1.5 1.4 4-0.8 5.4q-0.3 0.3-0.9 0.6-1 0.5-2 0.5-0.4 0-0.7-0.1c-0.9-0.4-1.5-1.6-2-2.8-0.8-2-1.2-4.5-2.2-5.8q-0.2-0.3-0.5-0.6c-1.9-1.8-4.4-1.7-4.9-4.3z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m262 21c0-0.8 0.6-1.3 1.6-1.5 1.7-0.4 4.2-0.2 5.4-0.1 0.9 0.2 1.6 1.8 2.2 3.5 0.7 1.9 1.4 4 2.4 4.2 0.5 0.1 1.1 0.4 1.5 0.9 1 1.4 1.5 3.8-0.3 5.1q-0.3 0.2-0.8 0.5-1 0.6-2 0.6-0.4 0.1-0.7 0c-0.8-0.5-1.5-1.7-1.9-2.9-0.8-2-1.2-4.3-2.2-5.6q-0.2-0.3-0.4-0.6c-1.9-1.8-4.2-1.8-4.8-4.1z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m262.4 21c0-0.7 0.6-1.1 1.5-1.3 1.6-0.3 3.8-0.1 5-0.1 0.8 0.3 1.5 1.9 2 3.4 0.7 1.8 1.4 3.8 2.4 4.1 0.4 0.1 0.9 0.4 1.3 0.9 1 1.4 1.5 3.5 0.1 4.7q-0.2 0.3-0.6 0.6-0.9 0.5-2 0.7-0.4 0-0.7-0.1c-0.8-0.4-1.4-1.8-1.9-2.9-0.7-1.9-1.1-4.2-2-5.4q-0.2-0.3-0.5-0.6c-1.7-1.8-4-1.9-4.6-4z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m262.7 21.1c0.1-0.6 0.7-1 1.5-1.1 1.5-0.3 3.5-0.2 4.6-0.1 0.8 0.3 1.4 1.8 1.9 3.2 0.6 1.7 1.2 3.6 2.2 3.9 0.4 0.2 0.8 0.5 1.2 1 1 1.3 1.6 3.3 0.6 4.3q-0.2 0.3-0.6 0.6-0.8 0.6-1.9 0.8-0.5 0-0.7 0c-0.7-0.4-1.4-1.9-1.8-3-0.6-1.8-1.1-4-2-5.3q-0.2-0.3-0.4-0.5c-1.7-1.8-3.9-1.9-4.6-3.8z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m263.1 21.1c0.1-0.5 0.7-0.8 1.4-0.9 1.3-0.3 3.2-0.1 4.2 0 0.7 0.3 1.3 1.8 1.8 3.1 0.6 1.6 1.1 3.3 2 3.7 0.4 0.2 0.8 0.5 1.1 1 0.9 1.3 1.6 3.1 1 3.9-0.1 0.2-0.2 0.4-0.4 0.6-0.5 0.4-1.1 0.7-1.9 0.9q-0.5 0.1-0.7 0c-0.7-0.4-1.3-1.9-1.7-3-0.6-1.8-1-3.8-2-5.1q-0.2-0.3-0.4-0.5c-1.6-1.7-3.6-2-4.4-3.7z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m263.5 21.2c0.1-0.4 0.6-0.7 1.3-0.8 1.2-0.2 2.9 0 3.9 0 0.6 0.4 1.1 1.8 1.5 3 0.6 1.5 1.1 3.1 1.9 3.6 0.3 0.2 0.7 0.6 1 1 0.9 1.2 1.6 2.8 1.5 3.5-0.1 0.2-0.2 0.4-0.4 0.6-0.4 0.5-1 0.8-1.8 1-0.3 0.1-0.5 0.1-0.7 0.1-0.6-0.4-1.2-2-1.6-3.1-0.6-1.7-1-3.7-1.9-4.9q-0.2-0.3-0.4-0.5c-1.6-1.7-3.5-2.1-4.3-3.5z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m263.8 21.2c0.2-0.3 0.7-0.5 1.3-0.5 1.1-0.2 2.6-0.1 3.5 0 0.5 0.4 1 1.8 1.4 2.8 0.5 1.4 1 2.8 1.7 3.5 0.3 0.2 0.6 0.6 0.9 1 0.9 1.2 1.7 2.6 1.9 3.2 0 0.1-0.1 0.4-0.2 0.6-0.3 0.4-1 0.8-1.8 1.1-0.3 0.1-0.6 0.1-0.7 0-0.6-0.4-1.2-2.1-1.5-3.1-0.6-1.7-1-3.5-1.9-4.7q-0.2-0.3-0.4-0.5c-1.4-1.7-3.2-2.2-4.2-3.4z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m264.2 21.3c0.2-0.2 0.7-0.4 1.2-0.4 1-0.1 2.2 0 3.1 0 0.4 0.5 0.9 1.8 1.3 2.8 0.4 1.2 0.9 2.5 1.5 3.3q0.4 0.4 0.8 0.9c0.9 1.2 1.7 2.5 2.4 2.9 0 0.2-0.1 0.4-0.2 0.6-0.2 0.5-0.8 0.9-1.7 1.2-0.4 0.1-0.6 0.1-0.7 0.1-0.5-0.4-1.1-2.2-1.5-3.3-0.5-1.5-0.9-3.2-1.7-4.5q-0.2-0.2-0.4-0.4c-1.4-1.7-3.1-2.2-4.1-3.2z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m264.6 21.3q0.4-0.1 1.1-0.2c0.9 0 1.9 0 2.7 0.1 0.4 0.6 0.8 1.7 1.1 2.6 0.5 1.1 0.9 2.3 1.4 3.1q0.4 0.5 0.7 1c0.8 1.2 1.8 2.2 2.8 2.5 0 0.2 0.1 0.4 0 0.6-0.2 0.5-0.8 1-1.7 1.3-0.4 0.1-0.6 0.2-0.7 0.2-0.5-0.5-1.1-2.3-1.4-3.4-0.5-1.5-0.9-3.1-1.7-4.3q-0.2-0.2-0.4-0.4c-1.3-1.7-2.9-2.3-3.9-3.1z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m272.1 32.2c-0.5-0.4-1-2.3-1.3-3.4-0.5-1.6-1-3.3-2-4.5-1.2-1.6-2.7-2.4-3.8-2.9q0.4 0 1 0c0.8 0 1.6 0 2.3 0 0.3 0.7 0.7 1.8 1 2.5 0.5 1.4 1.1 2.9 1.8 4 0.8 1.2 1.8 2 3.3 2.1 0 0.2 0.1 0.4 0 0.7-0.1 0.5-0.7 1-1.6 1.3-0.4 0.2-0.6 0.2-0.7 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m216.3 114.9q-0.9 0-1.8-1.5c-3-5.3-8.5-6-14.7-6.3-1.5-0.1-3-1-4.2-2.7-3-4.3-4.8-13.8-2.1-23 3.2-10.9 12.2-17.6 18.6-17.6q0.9 0 1.8 0.2 4.3 1 4.9 3.9c0.8 4-4.2 9.4-7.8 11.8q-1.6 1.1-1.8 2.2c-0.2 1.5 1 3.1 2.6 5.4 1.8 2.4 4 5.4 5.4 9.5 2.5 7.3 1.8 15.2 0.2 17.4q-0.5 0.7-1.1 0.7zm-4.2-50.7c-6.3 0-15.1 6.6-18.3 17.3-2.7 9.1-0.9 18.5 2.1 22.7 1.1 1.6 2.5 2.5 3.9 2.6 6.3 0.3 11.9 1 15 6.4 0.5 0.9 1 1.4 1.5 1.4q0.4 0 0.8-0.6c1.6-2.2 2.3-9.9-0.2-17.1-1.4-4.1-3.6-7.1-5.3-9.5-1.7-2.3-3-4-2.7-5.5q0.2-1.3 1.9-2.5c3.6-2.3 8.4-7.6 7.7-11.4q-0.5-2.8-4.7-3.7-0.8-0.1-1.7-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ee",
    d: "m217.3 68.9q0 0.1 0 0.2 0 0.1 0 0.1c0.2 2.7-2.2 6-4.8 8.5-1 0.8-1.9 1.5-2.7 2.1q-1.4 1-1.6 2.1-0.1 0.7 0.1 1.4c0.3 1.1 1.1 2.2 2 3.6 1.2 1.7 2.6 3.6 3.8 6q0.7 1.4 1.3 2.9c0.9 2.5 1.4 5.1 1.7 7.5 0.3 3.6-0.1 6.7-0.8 8.3-0.1 0.1-0.1 0.3-0.2 0.4-0.2 0.2-0.3 0.3-0.5 0.4q-0.3 0.1-0.6 0.1-0.8 0-1.5-1.3c-1.1-1.8-2.4-3-3.9-3.9-2.7-1.5-5.8-2-9.4-2.1q-0.1 0-0.2 0c-1.3-0.2-2.5-1-3.6-2.5-2.7-3.8-4.4-12.1-1.9-20.6 3-9.9 10.8-16.2 16.6-16.5q0.8 0 1.6 0.1 1.9 0.3 3 1.1 0.5 0.3 0.9 0.7 0.5 0.6 0.7 1.4zm-0.4 0.1q-0.1-0.6-0.4-1-0.3-0.4-0.7-0.7-1.1-1-3.2-1.3-0.7-0.1-1.5-0.1c-5.7 0.3-13.4 6.5-16.3 16.3-2.4 8.4-0.8 16.6 1.9 20.3 1.1 1.5 2.3 2.3 3.5 2.4 3.9 0.1 7.3 0.6 10 2.4 1.4 0.9 2.5 2.1 3.5 3.7q0.7 1.1 1.3 1.2 0.4 0 0.8-0.5c0.7-1.2 1.2-4.2 1-7.7-0.2-2.6-0.8-5.4-1.8-8.1q-0.4-1.3-1-2.4c-1.2-2.6-2.7-4.6-4-6.4-0.9-1.4-1.7-2.6-2-3.7q-0.3-0.8-0.1-1.5 0.2-1.3 1.7-2.3c0.9-0.7 1.9-1.5 2.9-2.4 2.6-2.5 4.8-5.7 4.4-8.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ef",
    d: "m215.7 69.9c0 0 0 0.1 0.1 0.1 0 0.1-0.1 0.2 0 0.2 0 2.3-2.2 5.5-4.8 7.7-0.8 0.7-1.7 1.4-2.4 2q-1.3 1-1.5 2-0.1 0.6 0 1.3c0.3 1 0.9 2.1 1.7 3.4 1 1.6 2.3 3.4 3.5 5.6q0.7 1.2 1.3 2.6c0.9 2.3 1.5 4.6 1.8 6.9 0.4 3.3 0.1 6.2-0.5 7.7 0 0.1-0.1 0.3-0.1 0.4-0.1 0.1-0.3 0.2-0.5 0.3q-0.2 0.1-0.5 0-0.7-0.1-1.4-1.2c-1-1.5-2.2-2.6-3.5-3.4-2.4-1.5-5.1-2.1-8.3-2.2-0.1 0-0.1-0.1-0.2-0.1-1.1-0.2-2.2-0.9-3.1-2.2-2.5-3.3-4-10.5-1.7-18.2 2.6-9 9.3-14.8 14.4-15.4q0.7-0.1 1.4 0 1.7 0.1 2.8 0.7 0.4 0.3 0.8 0.7 0.5 0.5 0.7 1.1zm-0.3 0.1q-0.2-0.5-0.5-0.8-0.3-0.4-0.6-0.6-1.1-0.7-2.9-0.9-0.7-0.1-1.4 0c-4.9 0.6-11.5 6.4-14.1 15.1-2.3 7.7-0.8 14.8 1.7 18 0.9 1.3 2 2 3 2.1 3.5 0.2 6.4 0.8 8.9 2.5 1.1 0.8 2.2 1.9 3.1 3.3q0.6 0.9 1.2 1 0.3 0.1 0.7-0.3c0.6-1.2 0.9-3.9 0.6-7.1-0.3-2.5-0.9-5-1.9-7.4q-0.5-1.2-1-2.2c-1.2-2.3-2.6-4.2-3.7-5.9-0.8-1.4-1.4-2.5-1.7-3.6q-0.1-0.7 0-1.4 0.2-1.1 1.6-2.1c0.8-0.6 1.7-1.4 2.6-2.3 2.5-2.2 4.6-5.2 4.4-7.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eg",
    d: "m214.1 70.9c0 0 0.1 0.1 0.1 0.1 0 0 0 0.1 0 0.2 0 2-2.1 4.9-4.6 6.9-0.8 0.7-1.6 1.4-2.2 1.9q-1.1 0.9-1.4 1.9-0.1 0.6 0 1.2c0.2 1 0.6 2 1.3 3.2 0.9 1.6 2.1 3.2 3.2 5.2q0.6 1.1 1.2 2.4c0.9 2 1.6 4.1 1.9 6.2 0.5 3 0.4 5.6 0 7.1-0.1 0.1-0.1 0.3-0.1 0.4-0.1 0.1-0.3 0.1-0.4 0.1q-0.2 0.1-0.5 0-0.6-0.1-1.3-1c-0.9-1.4-2-2.3-3.1-3.1-2.1-1.4-4.4-2.1-7.2-2.3 0 0-0.1 0-0.1 0-1-0.2-1.9-0.9-2.8-2-2.1-2.8-3.6-8.8-1.5-15.9 2.4-8 8-13.3 12.3-14.2q0.7-0.2 1.3-0.2 1.5 0 2.5 0.5 0.4 0.2 0.7 0.5 0.5 0.4 0.7 0.9zm-0.3 0.1q-0.2-0.3-0.5-0.6-0.2-0.3-0.6-0.5-1-0.5-2.6-0.5-0.5 0-1.1 0.1c-4.3 0.9-9.8 6.2-12.1 14-2 7-0.6 12.9 1.5 15.6 0.8 1.1 1.8 1.7 2.7 1.9 3 0.2 5.5 0.9 7.6 2.5 1 0.7 1.9 1.7 2.8 2.9q0.5 0.8 1 0.9 0.3 0.1 0.6-0.1c0.5-1.3 0.7-3.8 0.3-6.6-0.4-2.3-1.1-4.6-2.1-6.8q-0.4-1-1-1.9c-1.1-2.1-2.4-3.9-3.3-5.5-0.7-1.2-1.2-2.3-1.3-3.3q-0.1-0.7 0-1.3 0.3-1.1 1.4-2c0.8-0.6 1.6-1.3 2.5-2.1 2.3-2 4.3-4.8 4.2-6.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eh",
    d: "m212.6 71.9c0 0 0 0.1 0.1 0.1 0 0-0.1 0.1-0.1 0.1-0.1 1.7-2 4.4-4.4 6.3q-1.2 0.9-2 1.7-1 0.8-1.2 1.8-0.2 0.5-0.1 1.1c0 1 0.4 1.9 0.9 3 0.7 1.5 1.8 3 2.9 4.7q0.6 1 1.2 2.2c0.9 1.7 1.6 3.6 2 5.6 0.6 2.7 0.6 5.1 0.3 6.5 0 0.1 0 0.3-0.1 0.4 0 0-0.2 0-0.3 0q-0.2 0-0.4 0-0.6-0.3-1.1-1c-0.9-1.1-1.8-1.9-2.8-2.7-1.8-1.4-3.6-2.2-6.1-2.3 0 0-0.1 0-0.1 0-0.7-0.3-1.6-0.8-2.3-1.7-1.9-2.4-3.3-7.2-1.4-13.6 2.1-7.1 6.6-12 10.3-13.2q0.5-0.1 1-0.2 1.3-0.2 2.2 0.2 0.4 0.1 0.7 0.3 0.5 0.3 0.8 0.7zm-0.3 0.2q-0.2-0.3-0.6-0.6-0.2-0.1-0.5-0.3-1-0.3-2.3-0.1-0.5 0-1 0.2c-3.5 1.2-7.9 6-10 12.9-1.8 6.2-0.5 11 1.3 13.2 0.8 0.9 1.6 1.5 2.3 1.7 2.6 0.1 4.6 1 6.4 2.5 0.9 0.7 1.7 1.5 2.4 2.5q0.5 0.6 1 0.8 0.2 0.1 0.5 0c0.3-1.3 0.3-3.5-0.2-6-0.4-2.2-1.2-4.2-2.1-6.1q-0.5-0.9-1-1.7c-1.1-1.9-2.2-3.5-3-5-0.6-1.1-0.9-2.1-1-3.1q0-0.6 0.1-1.2 0.3-1 1.3-1.9c0.6-0.6 1.4-1.2 2.2-1.9 2.3-1.8 4.1-4.3 4.2-5.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ei",
    d: "m211 72.9c0 0 0.1 0 0.1 0 0 0.1 0 0.2 0 0.2-0.2 1.4-2 3.8-4.3 5.5q-1.1 0.8-1.9 1.6-0.7 0.8-1 1.6-0.2 0.5-0.2 1.1c0 0.9 0.2 1.8 0.6 2.8 0.6 1.4 1.6 2.8 2.6 4.3q0.6 0.9 1.2 1.9c0.8 1.5 1.6 3.2 2.1 5 0.7 2.4 0.8 4.6 0.7 5.9-0.1 0-0.1 0.3-0.1 0.4 0 0-0.2-0.1-0.3-0.1q-0.1 0-0.3-0.1-0.5-0.3-1-0.8-1.2-1.3-2.3-2.3c-1.6-1.4-3-2.3-5.1-2.4 0 0-0.1-0.1-0.1-0.1-0.5-0.2-1.2-0.7-1.9-1.4-1.5-1.9-2.8-5.6-1.1-11.2 1.8-6.1 5.2-10.6 8.1-12.1q0.5-0.2 0.9-0.3 1-0.3 1.9-0.2 0.4 0.1 0.6 0.2 0.5 0.2 0.8 0.5zm-0.3 0.2q-0.2-0.2-0.5-0.4-0.3-0.1-0.6-0.1-0.8-0.2-1.9 0.2-0.4 0.1-0.8 0.3c-2.9 1.5-6.2 5.9-7.9 11.8-1.7 5.5-0.4 9.1 1.1 10.9 0.6 0.7 1.3 1.1 1.8 1.3 2.2 0.2 3.7 1.2 5.3 2.6q1 0.9 2 2.1 0.4 0.4 0.8 0.7 0.3 0.1 0.5 0.1c0.1-1.3 0-3.3-0.6-5.5-0.5-1.9-1.3-3.7-2.3-5.3q-0.5-0.8-0.9-1.5c-1.1-1.6-2.1-3.1-2.7-4.6-0.4-0.9-0.7-1.9-0.6-2.9q0-0.5 0.2-1 0.3-0.9 1.1-1.8 0.8-0.8 1.9-1.7c2.2-1.6 3.9-3.9 4.1-5.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ej",
    d: "m209.5 101l-0.2-0.2c-1.3-0.9-2.3-1.9-3.1-2.8-1.3-1.3-2.2-2.4-3.9-2.5h-0.1c-1.4-0.9-4.6-3.1-2.5-10 2.1-7 5.5-11.9 8.4-11.9q0.3 0 0.5 0 0.5 0.1 0.8 0.3h0.2l-0.1 0.2c-0.3 1-1.9 3.3-4.1 4.8q-2.4 1.5-2.8 3.8c-0.5 2.5 1 4.5 2.5 6.6 1.2 1.6 2.6 3.5 3.4 6 0.7 2.1 0.9 4 1 5.3zm-7.2-5.7c1.8 0.1 2.9 1.2 4.1 2.6 0.8 0.8 1.6 1.7 2.7 2.5 0-1.3-0.3-3-0.9-4.9-0.8-2.5-2.2-4.3-3.4-6-1.6-2.1-3-4.1-2.6-6.7q0.5-2.5 3-4.1c2-1.4 3.5-3.5 3.9-4.5q-0.2-0.1-0.5-0.2-0.3 0-0.5 0c-2.7 0-6.1 4.9-8.1 11.6-2 6.8 1 8.8 2.3 9.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m218.4 81.4q-0.2 0-0.4-0.1c-3.3-2-3.1-8-2.8-13.9 0.1-3.4 0.2-6.7-0.4-9.1-1-4.4 1.5-11.9 4.6-16.6 1.8-2.7 3.5-4.3 5-4.6 1.5-0.2 2.5 0.6 2.9 2.6 0.3 1.5 0.3 3.5 0.3 5.4 0 1.7 0 3.5 0.3 4.9 0.4 2.6 7.3 4.1 12.3 5.2 3.6 0.8 5.6 1.2 6 1.9q0.1 0.2 0 0.4c-0.9 1.9-7.3 5.2-13.5 5.8-3.5 0.4-6.9 6.6-9.5 11.6-2 3.6-3.5 6.5-4.8 6.5zm6.5-44q-0.2 0-0.5 0c-1.3 0.3-3 1.9-4.7 4.5-3 4.7-5.6 12-4.5 16.3 0.5 2.4 0.4 5.7 0.3 9.2-0.3 5.8-0.5 11.7 2.7 13.6q0.1 0.1 0.2 0.1c1.1 0 2.7-3.1 4.5-6.4 2.7-5 6.1-11.3 9.7-11.7 6.5-0.6 12.6-4.1 13.3-5.7q0 0 0-0.1c-0.3-0.5-3-1.1-5.8-1.7-5.4-1.2-12.1-2.6-12.6-5.5-0.2-1.4-0.2-3.2-0.2-4.9 0-1.9 0-3.9-0.3-5.4-0.4-1.6-1-2.3-2.1-2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m219.7 43.8c0.3-0.6 0.7-0.9 1-1.4 1.2-1.3 2.3-2 3.3-2.2 1.3-0.1 2.2 0.6 2.6 2.3 0.3 1.3 0.4 3 0.4 4.6 0 1.5 0.1 3 0.3 4.1 0.1 0.5 0.5 1 1.1 1.4 2 1.4 6.2 2.3 9.4 3.1q1.1 0.2 2 0.4c1.8 0.4 3 0.8 3.2 1.2q0.1 0.2 0 0.3c-0.2 0.5-1 1.2-2 1.8-2.3 1.4-6 2.9-9.7 3.3-1 0.1-2 0.7-3 1.7-1.9 1.9-3.8 5.3-5.3 8.2-1 1.8-1.9 3.4-2.7 4.5-0.5 0.7-1 1.2-1.5 1.2-0.1 0-0.2 0-0.3-0.1-0.8-0.5-1.3-1.2-1.7-2.1-1-2.5-0.8-6.2-0.7-9.9 0.1-3 0.2-5.8-0.2-7.9-0.8-3.3 0.6-8.4 2.6-12.5 0.4-0.7 0.8-1.4 1.2-2zm0.3 0.3c-1.2 1.9-2.3 4.3-3 6.7-0.9 2.7-1.3 5.4-0.8 7.4 0.5 2.1 0.4 5 0.2 7.9-0.2 4.9-0.4 10 2.3 11.7q0.1 0 0.2 0c0.9 0 2.3-2.7 3.9-5.4 1.6-3 3.4-6.4 5.4-8.4 1-0.9 1.9-1.5 3-1.6 1.5-0.2 3.1-0.6 4.5-1 3.6-1.2 6.4-2.9 6.9-3.9q0-0.1-0.1-0.1c-0.2-0.5-2.5-1-4.9-1.5-2.7-0.6-5.8-1.3-8-2.2-1.4-0.7-2.5-1.5-2.7-2.4-0.2-1.2-0.2-2.7-0.2-4.2 0-1.6-0.1-3.2-0.4-4.5-0.3-1.3-0.9-2-1.8-2q-0.2 0-0.4 0c-1.2 0.2-2.7 1.4-4.1 3.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m219.9 45.8c0.2-0.4 0.6-0.6 0.9-0.9 1-1 2-1.5 2.8-1.5 1.2-0.1 1.9 0.5 2.3 1.9 0.3 1.1 0.4 2.5 0.5 3.8 0 1.2 0.1 2.4 0.3 3.3 0.1 0.5 0.5 0.9 1 1.2 1.7 1.2 5.1 1.9 7.8 2.5q0.9 0.2 1.6 0.4c1.5 0.4 2.5 0.7 2.7 1q0.1 0.1 0 0.3c-0.2 0.4-0.9 0.9-1.7 1.4-2 1.2-5.2 2.4-8.3 2.8-0.8 0.1-1.6 0.6-2.4 1.4-1.7 1.7-3.3 4.5-4.7 6.9-0.8 1.5-1.5 2.9-2.2 3.8-0.4 0.6-0.9 1-1.3 1-0.1 0-0.2 0-0.3 0-0.6-0.4-1-1.1-1.3-1.8-0.8-2.1-0.6-5.3-0.5-8.3 0.1-2.5 0.2-4.9-0.2-6.7-0.6-2.8 0.5-7.2 2.1-10.7 0.3-0.5 0.6-1.3 0.9-1.8zm0.3 0.6c-0.9 1.6-1.8 3.6-2.4 5.6-0.7 2.3-1 4.6-0.6 6.3 0.4 1.7 0.3 4.1 0.2 6.5-0.2 4.1-0.3 8.2 1.8 9.7q0.1 0.1 0.2 0.1c0.7-0.1 1.9-2.3 3.2-4.6 1.4-2.4 2.9-5.2 4.6-6.9 0.8-0.8 1.7-1.3 2.5-1.4 1.3-0.1 2.6-0.5 3.8-0.8 2.9-1 5.2-2.4 5.7-3.2q0-0.1 0-0.1c-0.2-0.4-2.1-0.8-4-1.2-2.3-0.6-4.9-1.1-6.6-1.9-1.2-0.6-2.1-1.2-2.2-2-0.3-0.9-0.3-2.2-0.3-3.3-0.1-1.3-0.1-2.7-0.4-3.7-0.3-1.1-0.8-1.7-1.6-1.7q-0.2 0-0.4 0c-1 0-2.3 0.9-3.5 2.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m220.1 47.9c0.2-0.3 0.6-0.3 0.8-0.6 0.8-0.6 1.6-0.9 2.3-0.8 1 0 1.7 0.5 2.1 1.7 0.2 0.8 0.3 1.9 0.4 2.9 0.1 0.9 0.2 1.8 0.4 2.6q0.2 0.5 0.8 0.9c1.4 0.9 4.1 1.5 6.3 2q0.7 0.2 1.3 0.3c1.1 0.3 2 0.6 2.1 0.8q0.1 0.1 0 0.2c-0.1 0.3-0.8 0.8-1.4 1.1-1.7 0.9-4.3 1.9-6.8 2.3-0.6 0.1-1.3 0.6-2 1.2-1.4 1.3-2.7 3.5-3.9 5.5-0.7 1.2-1.3 2.3-1.9 3.1-0.3 0.4-0.7 0.8-1 0.8 0 0-0.1 0.1-0.2 0-0.5-0.3-0.7-0.9-1-1.4-0.6-1.8-0.5-4.3-0.4-6.8 0.1-2 0.2-3.9-0.1-5.4-0.4-2.4 0.4-6 1.5-8.9 0.3-0.4 0.5-1.1 0.7-1.5zm0.4 0.7c-0.7 1.3-1.4 3-1.8 4.6-0.5 1.9-0.8 3.7-0.5 5.1 0.3 1.4 0.2 3.3 0.2 5.2-0.2 3.2-0.3 6.5 1.3 7.8q0 0 0.1 0c0.7-0.2 1.6-1.9 2.7-3.7 1.1-1.9 2.4-4.1 3.8-5.4 0.6-0.6 1.3-1 1.9-1.1 1.1-0.2 2.1-0.4 3-0.8 2.3-0.7 4.2-1.9 4.7-2.5q0 0 0 0c-0.3-0.4-1.7-0.7-3.2-1-1.8-0.4-3.8-0.9-5.2-1.5-0.9-0.4-1.6-0.9-1.7-1.5-0.2-0.8-0.3-1.7-0.4-2.6 0-1-0.1-2.1-0.3-2.8-0.3-0.9-0.8-1.4-1.4-1.5q-0.2 0-0.3 0c-0.9 0-1.9 0.6-2.9 1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m220.3 50c0.2-0.2 0.5-0.1 0.7-0.2 0.6-0.3 1.2-0.3 1.9-0.2 0.7 0.1 1.3 0.5 1.7 1.4 0.2 0.6 0.4 1.3 0.5 2.1 0.1 0.6 0.3 1.3 0.5 1.8q0.1 0.4 0.6 0.6c1.1 0.7 3 1.2 4.6 1.6q0.6 0.1 1 0.3c0.7 0.1 1.6 0.4 1.6 0.6q0.1 0 0.1 0.1c-0.1 0.2-0.8 0.5-1.2 0.8-1.4 0.6-3.4 1.3-5.3 1.7-0.5 0.1-1 0.5-1.5 1-1.2 1-2.3 2.6-3.2 4.1-0.6 0.9-1 1.8-1.5 2.4-0.2 0.3-0.6 0.7-0.8 0.7 0 0-0.1 0-0.1 0-0.3-0.2-0.5-0.8-0.7-1.2-0.4-1.3-0.3-3.2-0.2-5.1 0.1-1.5 0.1-3-0.1-4.2-0.3-2 0.3-4.8 1-7.1 0.2-0.3 0.3-1 0.4-1.2zm0.4 0.8c-0.4 1.1-0.9 2.4-1.1 3.6-0.4 1.4-0.5 2.8-0.4 3.9 0.2 1.1 0.2 2.5 0.1 3.9-0.1 2.4-0.2 4.7 0.9 5.8q0 0 0.1 0c0.5-0.2 1.2-1.5 2-2.7 0.9-1.5 1.9-3 3-4 0.5-0.5 1-0.8 1.5-0.9q1.1-0.2 2.2-0.6c1.7-0.6 3.1-1.4 3.5-1.8q0 0 0-0.1c-0.2-0.2-1.2-0.4-2.3-0.7-1.3-0.3-2.7-0.7-3.7-1.1-0.7-0.3-1.2-0.7-1.3-1.1-0.2-0.5-0.3-1.2-0.4-1.8-0.1-0.7-0.2-1.4-0.4-2-0.3-0.6-0.7-1-1.2-1.1q-0.1 0-0.2 0c-0.7-0.1-1.5 0.1-2.3 0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m220.5 52.1c0.1-0.2 0.5 0.2 0.5 0.1q0.7 0.1 1.5 0.5c0.5 0.2 1 0.6 1.4 1.1 0.2 0.4 0.4 0.8 0.6 1.3 0.1 0.3 0.3 0.7 0.5 1q0.1 0.2 0.4 0.4c0.8 0.5 2 0.8 3.1 1.1q0.4 0.1 0.7 0.2c0.3 0.1 1 0.3 1.1 0.4q0 0 0 0c-0.1 0.1-0.7 0.4-0.9 0.5-1.1 0.4-2.5 0.9-3.8 1.3q-0.5 0.1-1.1 0.6c-0.9 0.7-1.7 1.8-2.4 2.8-0.4 0.6-0.8 1.2-1.1 1.7-0.2 0.1-0.5 0.5-0.6 0.5 0 0-0.1 0.1-0.1 0.1-0.1-0.1-0.2-0.7-0.3-0.9-0.1-1-0.1-2.3 0-3.6 0-1 0-2 0-2.8-0.2-1.7 0.1-3.7 0.4-5.4 0-0.1 0.1-0.8 0.1-0.9zm0.5 1c-0.2 0.8-0.4 1.6-0.6 2.5-0.1 1-0.2 2-0.1 2.8 0.1 0.7 0 1.6 0 2.5-0.1 1.5-0.1 3 0.4 3.8q0 0 0 0c0.4-0.3 0.9-1 1.5-1.8 0.6-0.9 1.4-1.9 2.1-2.5q0.5-0.5 1-0.6 0.8-0.2 1.5-0.5c1-0.4 1.9-0.9 2.4-1.1q0-0.1 0-0.1c-0.2-0.1-0.8-0.3-1.5-0.4-0.8-0.3-1.6-0.5-2.3-0.8-0.4-0.2-0.7-0.4-0.8-0.6-0.2-0.3-0.3-0.7-0.4-1.1-0.1-0.4-0.3-0.8-0.4-1.1-0.3-0.4-0.6-0.6-1-0.8q-0.1 0-0.1 0-0.9-0.4-1.7-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m220.8 62.5v-0.5c0.1-1.2 0.2-2.4 0.2-3.6 0-1.3 0-2.5-0.2-3.6v-0.7l0.3 0.6q0.8 1.1 2.1 2 0.7 0.4 1.5 0.8 0.8 0.4 1.8 0.7l0.6 0.2-0.6 0.1q-1.6 0.3-2.9 1.2-1.4 0.9-2.5 2.4zm0.4-7.2q0.1 0.7 0.1 1.5 0 0.8 0 1.6 0 1.5-0.1 3 1-1.2 2.2-2 0.6-0.4 1.2-0.7 0.6-0.3 1.3-0.4-0.8-0.3-1.5-0.6-0.7-0.4-1.3-0.7-1.1-0.8-1.9-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m245.7 58c-2.5 0-5.4-4.5-7.1-8.9-1.5-3.9-2.7-9.2-0.8-10.9 1.3-1.2 2.8-2.2 4.4-3.2 2.7-1.8 5.6-3.6 7.7-6.8 1.5-2.2 4.5-5 7.9-7.2 3.4-2.2 7.2-3.9 10.1-3.9q1.5 0 2.5 0.6 1 0.5 1.2 1.4c0.2 1.6-1.9 4-4.6 7.1-3.2 3.5-7.2 8-8.9 13.1-0.8 2.2-1.4 4.2-1.9 6-2.1 7-3.3 11.2-10.1 12.6q-0.2 0.1-0.4 0.1zm22.2-40.6c-2.8 0-6.6 1.7-9.9 3.9-3.4 2.2-6.3 4.9-7.8 7.1-2.2 3.3-5.1 5.1-7.8 6.9-1.6 1-3.1 1.9-4.4 3.1-1.6 1.5-0.7 6.4 0.9 10.6 1.6 4.2 4.5 8.7 6.8 8.7q0.2 0 0.3-0.1c6.6-1.3 7.8-5.3 9.9-12.4 0.5-1.8 1.1-3.8 1.9-6 1.7-5.2 5.7-9.7 9-13.3 2.6-2.9 4.7-5.3 4.4-6.8q-0.1-0.7-0.9-1.1-1-0.6-2.4-0.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m256.1 24.6c2.9-1.8 6.2-3.3 8.7-3.3q0.3 0 0.5 0c0.6 0.1 1.2 0.2 1.6 0.5 0.4 0.2 0.6 0.5 0.8 0.7q0.1 0.3 0.1 0.5c0.1 0.6-0.1 1.3-0.6 2.1-0.7 1.2-1.9 2.6-3.2 4.1q-1.2 1.4-2.5 2.9c-1.4 1.7-2.7 3.6-3.8 5.6q-0.8 1.5-1.4 3c-0.6 2-1.2 3.7-1.6 5.2-0.3 1-0.6 1.9-0.8 2.7-0.3 0.9-0.7 1.7-1 2.5-1.3 2.8-3 4.5-6.8 5.2q-0.1 0.1-0.3 0.1c-2.1-0.1-4.5-3.9-6-7.6-1.3-3.3-2.3-7.7-0.7-9.3 1-1 2.3-1.9 3.6-2.8 1.6-1.2 3.3-2.4 4.8-4q0.1-0.2 0.3-0.5 0.2-0.2 0.4-0.4 0.5-0.5 0.9-1.1c0.7-0.9 1.6-1.9 2.7-2.9 1.2-1.1 2.7-2.2 4.3-3.2zm0.1 0.3c-1.6 1.1-3.2 2.2-4.5 3.4-0.9 0.9-1.7 1.8-2.3 2.6q-0.6 0.9-1.3 1.6c-1.6 1.9-3.5 3.1-5.2 4.4-1.3 0.9-2.6 1.8-3.6 2.8-1.3 1.3-0.6 5.4 0.8 8.9 1.4 3.6 3.7 7.4 5.7 7.4q0.1 0 0.3 0c5.5-1.1 6.5-4.3 8.3-10.2 0.5-1.5 1-3.3 1.6-5.2 0.5-1.3 1.1-2.6 1.8-3.8 1.2-2.1 2.7-4 4.2-5.8q0.9-1 1.7-2c1.9-2.2 3.5-4 3.8-5.4q0-0.2 0-0.5-0.1-0.6-0.8-1-0.8-0.4-2-0.4c-2.4 0-5.6 1.4-8.5 3.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m254.4 28.2c2.4-1.5 5.1-2.6 7.2-2.7q0.3 0 0.5 0c0.5 0.1 1 0.2 1.3 0.4 0.3 0.1 0.5 0.4 0.6 0.6q0.1 0.2 0.1 0.4c0.1 0.6-0.1 1.2-0.5 1.8-0.6 1.1-1.6 2.2-2.7 3.6q-1 1.1-2 2.4c-1.1 1.5-2.3 3.1-3.2 4.8q-0.7 1.3-1.1 2.7c-0.6 1.6-1 3.1-1.5 4.4-0.2 0.7-0.4 1.5-0.6 2.2-0.3 0.7-0.6 1.3-0.8 1.9-1.1 2.2-2.5 3.5-5.5 4q-0.2 0.1-0.3 0c-1.7-0.1-3.7-3.1-4.9-6.2-1.1-2.7-1.8-6.3-0.6-7.6 0.8-0.9 1.7-1.7 2.7-2.5 1.3-1.1 2.6-2.1 3.8-3.6 0.1-0.1 0.2-0.2 0.3-0.3 0.1-0.2 0.2-0.3 0.3-0.4q0.4-0.4 0.8-0.9c0.6-0.7 1.4-1.5 2.3-2.3 1.1-0.9 2.4-1.8 3.8-2.7zm0.1 0.3c-1.4 0.9-2.8 1.9-3.9 2.8-0.8 0.7-1.5 1.4-2 2.1q-0.6 0.7-1.2 1.3c-1.2 1.6-2.7 2.7-4 3.8-1.1 0.8-2 1.6-2.8 2.5-1.1 1.1-0.4 4.4 0.7 7.3 1.1 2.9 3 6 4.6 6q0.1 0 0.2 0c4.5-0.8 5.3-3.3 6.8-7.9 0.4-1.3 0.8-2.8 1.4-4.4q0.6-1.7 1.5-3.2c1-1.8 2.2-3.5 3.5-5q0.7-0.8 1.3-1.7c1.6-1.8 2.9-3.4 3.2-4.6q0-0.2 0-0.4-0.1-0.5-0.6-0.9-0.7-0.3-1.7-0.3c-2.1 0-4.6 1.2-7 2.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m252.7 31.8c1.9-1.1 4.1-2 5.8-2.1q0.2 0 0.3 0c0.4 0.1 0.8 0.1 1.1 0.3 0.2 0.1 0.3 0.4 0.4 0.5q0.1 0.2 0.1 0.3c0 0.5-0.1 1-0.5 1.6-0.4 0.8-1.2 1.8-2 2.9q-0.8 1-1.6 2.1c-0.9 1.3-1.8 2.6-2.5 4q-0.6 1.1-1 2.2-0.7 2-1.2 3.6c-0.1 0.6-0.4 1.2-0.5 1.7-0.2 0.6-0.5 1-0.7 1.4-0.8 1.6-1.9 2.5-4.2 2.8q-0.1 0-0.2 0c-1.3-0.1-2.8-2.5-3.8-4.9-0.8-2.1-1.4-4.9-0.6-6 0.6-0.7 1.3-1.4 2-2.1 0.9-1 1.8-1.9 2.7-3.1 0.1-0.1 0.1-0.3 0.2-0.3 0.1-0.1 0.2-0.2 0.3-0.3q0.4-0.4 0.7-0.7c0.5-0.6 1.2-1.2 2-1.8 0.9-0.7 2-1.4 3.2-2.1zm0 0.3c-1.1 0.7-2.3 1.5-3.2 2.2-0.7 0.5-1.3 1.1-1.7 1.6q-0.5 0.5-1 1c-0.9 1.3-1.9 2.3-2.9 3.3-0.8 0.7-1.4 1.3-2 2.1-0.8 0.9-0.3 3.4 0.6 5.6 0.8 2.3 2.3 4.7 3.5 4.8q0.1 0 0.2-0.1c3.4-0.4 4.1-2.2 5.2-5.6q0.5-1.6 1.2-3.6 0.4-1.3 1.2-2.7c0.7-1.4 1.7-2.8 2.7-4.1q0.5-0.7 1.1-1.3c1.2-1.6 2.2-2.9 2.4-3.9q0.1-0.2 0-0.3 0-0.5-0.4-0.8-0.5-0.2-1.3-0.2c-1.7 0-3.7 0.9-5.6 2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m251 35.4c1.4-0.7 3-1.4 4.3-1.5q0.2 0 0.3 0c0.2 0 0.6 0.1 0.8 0.1 0.1 0.1 0.2 0.4 0.3 0.5q0 0.1 0 0.3c0 0.3-0.1 0.7-0.4 1.2-0.4 0.7-0.9 1.5-1.5 2.4q-0.6 0.8-1.1 1.7c-0.7 1-1.4 2.1-1.9 3.2q-0.4 0.9-0.7 1.7-0.6 1.7-1 2.9c-0.1 0.3-0.3 0.9-0.4 1.2-0.1 0.4-0.4 0.5-0.5 0.8-0.6 1-1.4 1.5-2.9 1.6q-0.1 0-0.2 0c-0.9-0.2-2-1.9-2.6-3.6-0.7-1.5-1.1-3.5-0.6-4.3 0.4-0.6 0.8-1.2 1.2-1.9 0.5-0.8 1.1-1.6 1.6-2.6 0 0 0.1-0.2 0.1-0.2 0.1-0.1 0.2-0.2 0.3-0.2q0.3-0.3 0.6-0.5c0.5-0.4 1-0.9 1.7-1.3 0.7-0.5 1.6-1 2.6-1.5zm0 0.4c-1 0.5-1.9 1-2.6 1.5q-0.8 0.6-1.4 1.1-0.4 0.4-0.8 0.7c-0.6 1.1-1.2 1.9-1.8 2.7-0.5 0.6-0.9 1.2-1.2 1.8-0.5 0.7-0.1 2.4 0.5 4 0.6 1.6 1.6 3.2 2.4 3.4q0.1 0 0.2 0c2.3-0.2 2.8-1.3 3.6-3.4q0.4-1.2 0.9-2.8 0.4-1 0.9-2.1c0.6-1.1 1.3-2.2 2-3.2q0.4-0.6 0.8-1.1c0.8-1.2 1.6-2.2 1.8-3.1q0-0.1 0-0.3 0-0.3-0.3-0.6-0.4-0.1-0.9-0.1c-1.3 0.1-2.7 0.7-4.1 1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m249.2 39c1-0.4 2.1-0.8 3-0.9q0.1 0 0.1 0c0.2 0 0.5 0 0.6 0 0.1 0.1 0 0.4 0.1 0.4q0 0.1 0 0.2-0.1 0.4-0.3 0.9-0.4 0.9-0.9 1.8-0.4 0.7-0.7 1.3-0.7 1.3-1.2 2.5-0.3 0.7-0.6 1.3-0.4 1.2-0.7 2c-0.1 0.2-0.3 0.6-0.3 0.8-0.1 0.1-0.2 0.1-0.3 0.3-0.4 0.3-0.8 0.4-1.7 0.3q0 0-0.1 0c-0.5-0.3-1.1-1.3-1.5-2.3-0.4-0.9-0.7-2-0.5-2.6 0.1-0.6 0.2-1.1 0.4-1.6q0.2-1 0.5-2.1c0 0 0-0.2 0.1-0.2 0-0.1 0.1-0.1 0.2-0.1q0.2-0.2 0.5-0.3 0.6-0.4 1.3-0.8c0.6-0.3 1.3-0.5 2-0.9zm0 0.4c-0.7 0.3-1.4 0.6-1.9 0.9q-0.6 0.3-1.1 0.6-0.3 0.2-0.7 0.4c-0.2 0.8-0.4 1.5-0.6 2.1-0.2 0.5-0.3 1-0.4 1.5-0.2 0.4 0 1.4 0.4 2.3 0.3 1 0.9 1.9 1.4 2.1q0 0 0 0c1.3 0.1 1.6-0.2 2.1-1.2q0.3-0.8 0.7-1.9 0.3-0.7 0.6-1.5 0.6-1.2 1.2-2.4 0.3-0.4 0.5-0.8c0.5-0.9 1-1.6 1.1-2.3q0.1-0.1 0.1-0.2 0-0.2-0.1-0.4-0.3-0.1-0.6-0.1c-0.9 0.1-1.8 0.5-2.7 0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m246.9 49.4l-0.1-0.2c-0.5-0.9-0.9-1.9-1.3-2.9-0.4-1-0.7-2-1-2.9v-0.1l0.2-0.1c0.5-0.1 1-0.2 1.4-0.3q0.7-0.1 1.4-0.2 0.8-0.2 1.6-0.4l0.3-0.1-0.1 0.3q-0.1 0.4-0.2 0.7-0.4 1.2-0.7 2.2-0.3 1-0.5 1.7c-0.3 0.9-0.6 1.6-0.9 2.1zm-2-5.9c0.2 0.8 0.5 1.7 0.9 2.6 0.3 0.9 0.7 1.8 1.1 2.6 0.3-0.5 0.5-1.2 0.8-2.1q0.3-0.6 0.5-1.5 0.3-0.9 0.6-2.1 0.1-0.2 0.2-0.4-0.8 0.2-1.5 0.3-0.7 0.2-1.3 0.3c-0.4 0.1-0.8 0.2-1.3 0.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m276.5 35.6c-1.3 0-5.4-0.5-6.6-6.5-0.4-1.9-0.2-3.4 0.6-4.5 1.6-2.2 5.1-2.6 8.5-3.1 2.2-0.2 4.3-0.5 5.6-1.2 3-1.7 10.5-5.5 16-5.5q0.3 0 0.5 0 1 0.1 1.2 0.6c0.5 1-1.3 3.1-3.3 5.5-1.7 2-3.5 4.1-3.8 5.5-0.4 1.8-3.7 2.4-7.2 3.1-3.2 0.6-6.6 1.3-6.8 2.9-0.2 1.8-2.3 3.2-4.7 3.2zm24.1-20.5c-5.4 0-12.9 3.8-15.8 5.4-1.4 0.8-3.5 1.1-5.8 1.4-3.3 0.4-6.8 0.8-8.2 2.9-0.8 1.1-1 2.5-0.6 4.3 0.8 3.9 3.2 6.2 6.3 6.2 2.2 0 4.2-1.3 4.4-2.9 0.2-1.9 3.5-2.6 7.1-3.2 3.2-0.7 6.6-1.3 6.9-2.9 0.3-1.5 2.1-3.6 3.9-5.6 1.8-2.1 3.6-4.3 3.2-5.2q-0.1-0.3-0.9-0.4-0.2 0-0.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m299.8 16.2c0.1 0.2 0.1 0.6 0 0.8-0.2 0.6-0.5 1.2-1 1.9-0.4 0.7-1.1 1.6-1.9 2.4-1.5 1.8-3.3 3.7-3.7 4.8-0.5 1.4-3.2 1.9-6.1 2.5-2.7 0.6-5.5 1.1-5.9 2.5-0.4 1.4-2.2 2.5-4.3 2.6-1.1 0.1-3.8-0.1-5.2-3q-0.5-0.7-0.8-1.8-0.2-1-0.1-1.7 0 0 0-0.1 0 0 0-0.1c0.1-0.7 0.4-1.4 0.9-1.9 1.3-1.4 3.5-1.9 5.9-2.3q0.9-0.1 1.8-0.2c1.9-0.3 3.8-0.5 5.1-1.1 1-0.5 2.5-1.3 4.2-2 3.2-1.5 6.8-3.1 9.7-3.5q0.2 0 0.4-0.1 0.1 0 0.2 0c0.4 0.1 0.7 0.1 0.8 0.3zm-0.3 0.4q-0.2-0.2-0.8-0.2-0.2 0-0.4 0.1c-2.7 0.3-6 1.7-9 3-1.9 0.9-3.6 1.7-4.7 2.3-1.4 0.6-3.2 0.9-5.2 1.1q-0.9 0.1-1.7 0.2c-2.3 0.4-4.5 0.9-5.7 2.2q-0.8 0.8-0.9 2.1 0 0.6 0.2 1.5c0 0.4 0.2 0.7 0.4 1 1.1 2.2 2.9 3.5 5.3 3.4 1.9 0 3.6-1.1 3.9-2.3 0.4-1.5 3.2-2.1 6.1-2.7 2.7-0.6 5.5-1.1 6-2.4 0.4-1.1 2-2.9 3.6-4.7 1-1.1 2-2.3 2.5-3.2 0.3-0.6 0.5-1.1 0.4-1.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m297.3 17c0 0.1 0 0.6-0.1 0.8q-0.1 0.7-0.7 1.8c-0.3 0.6-0.9 1.4-1.6 2.2-1.4 1.6-3.1 3.2-3.7 4-0.7 1-2.8 1.4-5.1 2-2.2 0.4-4.4 0.9-4.9 1.9-0.6 1.1-2.1 1.9-3.8 2.1-1.2 0.2-3.4 0.2-4.6-1.7q-0.6-0.5-0.8-1.4c-0.1-0.7-0.2-1.1-0.1-1.5 0 0 0-0.1 0-0.1 0 0 0 0 0-0.1 0.2-0.5 0.5-1 1.1-1.4 1.2-1 3.2-1.5 5.2-1.8q0.8-0.1 1.6-0.2c1.7-0.2 3.3-0.4 4.5-0.9 1-0.4 2.3-1 3.7-1.7 3-1.4 5.9-3.1 8.1-3.9q0.2 0 0.3-0.1 0.1 0 0.3 0c0.2 0 0.5-0.1 0.6 0zm-0.4 0.7q-0.2-0.1-0.6 0-0.2 0-0.3 0.1c-2.1 0.6-4.8 2.1-7.5 3.3-1.6 0.8-3.1 1.4-4.2 1.9-1.2 0.5-2.8 0.7-4.5 0.9q-0.7 0.1-1.5 0.2c-1.8 0.3-3.8 0.7-5 1.7-0.6 0.4-1 0.9-1.1 1.5q0 0.5 0.1 1.3c0.1 0.3 0.3 0.6 0.5 0.8 1.1 1.4 2.6 2.2 4.7 2 1.5-0.1 2.9-0.9 3.5-1.8 0.6-1.2 2.8-1.7 5.1-2.2 2.1-0.5 4.3-0.9 4.9-1.8 0.5-0.8 2.1-2.3 3.5-3.9 0.9-1 1.8-2.1 2.1-2.8 0.2-0.5 0.4-0.9 0.3-1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m294.8 17.8c0 0.1-0.1 0.6-0.1 0.7q-0.1 0.7-0.5 1.7c-0.2 0.5-0.7 1.2-1.4 2-1.3 1.4-2.9 2.8-3.6 3.3-0.8 0.6-2.4 1-4.1 1.4-1.6 0.4-3.2 0.8-3.9 1.5-0.8 0.6-2 1.2-3.3 1.5-1.3 0.3-3 0.4-4-0.5q-0.7-0.3-0.8-0.9c-0.2-0.7-0.2-1.1-0.1-1.3 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0.2-0.4 0.6-0.8 1.2-1.1 1.2-0.6 2.9-0.9 4.7-1.2q0.7 0 1.4-0.1c1.3-0.2 2.7-0.4 3.8-0.8 1-0.3 2.2-0.8 3.3-1.4 2.7-1.4 4.9-3.1 6.5-4.2q0.1-0.1 0.2-0.1 0.1-0.1 0.2-0.1c0.1 0 0.4-0.4 0.5-0.3zm-0.5 0.9q-0.1 0.1-0.5 0.3-0.1 0-0.2 0.1c-1.5 1-3.5 2.4-5.9 3.6-1.3 0.7-2.5 1.2-3.6 1.5-1.1 0.4-2.5 0.6-3.9 0.8q-0.6 0.1-1.3 0.2c-1.3 0.1-3.2 0.5-4.4 1.1-0.6 0.3-1 0.6-1.2 1 0 0.2 0 0.6 0.1 1.1q0.1 0.3 0.5 0.5c0.8 0.8 2.3 0.9 4.1 0.6 1.2-0.2 2.3-0.7 3-1.4 0.8-0.7 2.5-1.1 4.1-1.5 1.6-0.5 3.3-0.8 4-1.4 0.6-0.4 2-1.7 3.2-3 0.9-0.9 1.6-1.8 1.8-2.4q0.2-0.6 0.2-1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m275 28.7q-0.8 0-0.9-0.5c-0.1-0.6-0.1-0.9-0.1-1l0.1-0.1c0.7-0.6 3.2-1 5.4-1.2 2.6-0.4 5.2-0.7 7.2-1.8 2.7-1.5 4.2-3.6 5.2-5l0.3-0.5v0.6q-0.1 0.7-0.2 1.6c-0.3 1.3-3.5 4.2-4.8 4.4-1.6 0.3-3.9 1.1-6.1 1.8-2.5 0.9-4.9 1.7-6.1 1.7zm-0.6-1.4c-0.1 0.1 0 0.4 0.1 0.9q0 0.2 0.5 0.2c1.1 0 3.5-0.8 6-1.7 2.2-0.7 4.5-1.5 6.2-1.8 1.1-0.2 4.2-3 4.4-4.2q0.1-0.4 0.2-0.9c-1 1.4-2.5 3.2-4.9 4.6-2.1 1.1-4.8 1.5-7.3 1.8-1.5 0.2-4.4 0.5-5.2 1.1z"
  }))), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m222.1 38.8c-3.1 1.5-6.4 3.2-9.2 4.9-6.3 3.9-10.3 16.9-12.7 22.1 2.2 0.1 5.3 0 6.7 0.2 1.7 0.2 4.2-0.7 4.2-0.7 0 0 0.6-2 2-5.6 1.5-3.5 1.5-12.1 4.6-15.5 2-2.1 3.5-4.2 4.4-5.4z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m271.8 14.9c2.3 1.6 4 3.1 4 5.2 0 2.8-1.1 5.9-1.1 5.9 0 0 7.1-5.1 11-6.4 3-0.9 7.6-4.1 12.7-5.4-9.1-0.5-19.3-0.1-26.6 0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m331.5 28.5c13.2 1.1 10.4 7.7 18.7 8.3 8.3 0.5 12.1 11.6 12.1 16.5 0 5 4.9 10.4 4.9 18.6 0 8.3-2.1 25.5-8.7 31.1-6.6 5.5-14.9 5.5-14.9 5.5 0 0-5 9.9-14.3 19.3-9.4 9.3-22.7 12.7-27.1 12.7-4.4 0-3.3 2.2-8.8 3.3q-1.2 0.2-2.7 0.2c-6.2 0-15.5-2.4-15.5-2.4 0 0-6.2 5-13.4 5-1.4 0-2.8-0.2-4.2-0.6-2-0.7-3.8-0.9-5.5-0.9-4.8 0-9.1 1.8-15.5 1.8q-2.2 0-4.9-0.4c-12.2-1.6-18.2-13.2-18.2-19.8 0-6.6-5.5-16 3.8-25.4 4.4-4.4 7.7-9.4 6.6-16.5-1.1-7.2 12.7-19.3 18.8-22.1 6.1-2.7 13.8-2.7 17.6-9.4 3.9-6.6 16-12.1 22.1-16.5 6.1-4.4 16-2.2 18.2-7.2 0.9-2.1 4.4-2.8 9.2-2.8 6.1 0 14.2 1.1 21.7 1.7zm-30 1.5c-1.4 3.2-5.2 3.9-9.2 4.6-3.3 0.5-6.7 1.1-9.3 3-1.9 1.3-4.2 2.8-6.7 4.3-5.9 3.5-12.5 7.5-15.1 11.9-2.9 5.1-7.8 6.5-12.6 7.9-1.8 0.6-3.8 1.1-5.5 1.9-6.4 2.9-19.1 14.7-18.2 21 1.3 8-2.8 13.3-6.9 17.4-6.6 6.7-5.4 13.2-4.3 19 0.4 2 0.8 3.9 0.8 5.7 0 5.5 5.2 17.2 17.3 18.8 1.7 0.3 3.2 0.4 4.8 0.4 3.4 0 6.1-0.5 8.7-1 2.3-0.4 4.5-0.8 6.8-0.8 1.9 0 3.8 0.3 5.8 0.9q1.8 0.6 3.9 0.6c6.8 0 12.7-4.8 12.8-4.8l0.4-0.3 0.5 0.1c0.1 0 9.2 2.4 15.2 2.4q1.5 0 2.5-0.2c2.5-0.5 3.5-1.2 4.4-1.9 1-0.7 2.1-1.4 4.6-1.4 3.8 0 16.9-3 26.3-12.4 9.2-9.2 14.1-19 14.2-19.1l0.3-0.5h0.6c0.1 0 8-0.1 14.2-5.3 6.1-5.1 8.4-21.2 8.4-30.3 0-4.4-1.5-8-2.8-11.2-1.1-2.6-2.1-5-2.1-7.4 0-5-3.9-15-11.2-15.5-4-0.3-5.8-2-7.4-3.6-2.1-2-4.3-4.1-11.3-4.7-2.5-0.2-5-0.4-7.5-0.7-5.1-0.5-10.1-1-14.1-1-4.8 0-7.6 0.7-8.3 2.2z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m260.8 53.8q0.4-0.8 1-1.6c4.5-5.9 14.9-10.5 20.5-14.5 5.9-4.3 15.7-2.2 17.8-7 1-2.2 4.4-2.9 9.1-2.9 6 0 13.9 1.2 21.2 1.8 13 1.1 10.3 7.5 18.4 8.1 5.3 0.3 8.6 5.3 10.2 9.5 1.2 3.2 2.4 6.3 2.6 9.2q0 0.8 0.1 1.6c0.6 5.2 4.1 11.9 2.9 18.8-1.2 6.7-3.9 17.9-7.5 23.7-0.6 1-1.4 2-2.4 2.9-5.5 4.8-12.5 5.3-12.9 5.8-0.5 0.7-5 9.3-13.2 17.4-9 9.1-22.1 12.7-26.6 12.8q-0.7 0-1.2 0.1c-3.2 0.3-2.8 2.1-7.5 3.1q-0.4 0.1-0.8 0.1-0.9 0.2-2 0.2-0.3 0-0.6 0c-6-0.2-14.6-2.4-14.6-2.4 0 0-4.3 3.4-9.8 4.5q-1.5 0.3-3.1 0.3-0.7 0-1.4-0.1c-1.5-0.1-3-0.3-4.5-0.7-2-0.6-3.9-0.8-5.8-0.8-2.1-0.1-4.2 0.2-6.6 0.4-3.4 0.2-6.3 0.4-9.6 0-1.5-0.3-2.9-0.7-4.6-1.4-9.8-1.7-15.3-11.8-15-18.9 0-3.1-1.1-6.9-1-11 0.1-3.8 1.2-7.9 5.1-12 3.8-4.2 6.7-8.8 5.9-15.2-0.8-7 12.8-19.7 18.7-22.4 5.9-2.7 13.3-3.1 17.2-9.4zm-35.1 31.7c1 7.1-2.6 12-6.2 16q-0.5 0.6-1 1.1c-2.7 3.3-3.6 6.6-3.7 9.7-0.1 2.3 0.1 4.4 0.4 6.5 0.3 1.8 0.5 3.5 0.5 5.1-0.2 5.6 3.9 14.9 12.5 17.5q0.8 0.3 1.6 0.5c0.1 0 0.2 0 0.3 0.1 1.5 0.6 3 1 4.5 1.3 3.1 0.4 5.8 0.2 9.1 0 2.5-0.3 4.8-0.5 7.1-0.5q0.4 0 0.9 0c1.8 0.1 3.5 0.4 5.3 0.9q1.9 0.5 4.1 0.7 0.5 0 0.9 0 1.6 0.1 3.1-0.2c4.9-0.9 9-3.9 9.5-4.3q0.1 0 0.1-0.1 0 0 0.1 0c0 0 0.3-0.2 0.4-0.2 0 0 0.4 0.1 0.4 0.1 0.6 0.1 8.1 2 13.7 2.3q0.7 0 1.4 0 0.6 0 1.2-0.1 0.7 0 1.3-0.2c1.6-0.3 2.5-0.8 3.3-1.2q0.5-0.3 1-0.7c0.7-0.5 1.5-0.9 2.8-1.1q0.8-0.2 1.8-0.2c4-0.2 16.9-3.4 25.9-12.5 8-7.9 12.5-16.5 13.1-17.2 0 0 0.2-0.4 0.2-0.5 0 0 0.5 0 0.5 0 0.5-0.6 7.2-1.1 12.4-5.6q1.1-1.1 2-2.3 0-0.1 0.1-0.2 0-0.1 0.1-0.2c3.4-5.4 6.2-16.1 7.4-23.2 0.8-4.2-0.3-8.5-1.4-12.4q-0.4-1.4-0.8-2.8-0.4-1.6-0.7-3.1-0.1-1.2-0.2-2.3c-0.1-1.4-0.5-2.9-0.9-4.4-0.5-1.3-1-2.6-1.5-4-1.4-4-4.6-8.9-9.5-9.3-3.8-0.2-5.5-1.7-7.1-3.2q-0.1-0.2-0.2-0.3c-2.1-2-4.3-4-11.1-4.6-2.4-0.2-4.9-0.4-7.3-0.7-5.1-0.5-9.9-1-13.9-1q-7.1 0-8.2 2.2-0.2 0.3-0.3 0.6c-1.5 2.6-5 3.2-8.7 3.9-3.2 0.5-6.6 1.1-9.2 3-1.8 1.3-4.1 2.7-6.5 4.1q-0.4 0.2-0.8 0.4c-5 3-10.3 6.2-13.1 9.9q-0.5 0.7-0.9 1.4c-2.8 4.7-7.6 6.3-12.1 7.8-1.2 0.4-2.4 0.8-3.5 1.2q-1 0.4-1.9 0.8c-6.2 2.8-18.9 15.2-18.3 21.5z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m261.2 54.2q0.5-0.8 1-1.5c4.2-6 14.5-10.1 20-14.1 5.8-4.3 15.4-2.1 17.5-6.9 0.9-2.1 4.3-2.8 8.9-2.8 5.8 0 13.7 1.1 20.8 1.7 12.8 1.1 10.1 7.4 18.1 8 5.8 0.4 9.2 6.6 10.3 10.8 0.9 3.5 2.7 6.4 3 10q0.1 0.9 0.2 1.8c0.4 5.7 3.5 14.1 1.1 20.6-2.4 6.2-6.3 15.1-9.1 19.4-0.4 0.8-1.1 1.7-2 2.7-4.4 3.9-10.1 5-11 6.1-0.9 1.2-5.1 8.6-12 15.5-8.7 8.8-21.6 12.6-26.3 12.8q-0.6 0-1.1 0.1c-3.4 0.2-2.9 2.1-7.5 3.1q-0.4 0-0.8 0.1-0.8 0.1-1.9 0.1-0.3 0-0.6 0c-5.9-0.1-14.5-2.3-14.5-2.3 0 0-4.6 3.7-10.3 4.5q-1.7 0.3-3.4 0.1-0.7-0.1-1.4-0.2c-1.6-0.2-3.2-0.4-4.7-0.8-2.1-0.5-4-0.7-6.2-0.8-2.1 0-4.3 0.1-6.9 0.1-4.1 0-7.1-0.2-10-0.9-1.4-0.6-2.7-1.4-4.2-2.5-7.6-1.7-12.5-10.5-12-18 0.2-2.8-0.5-6.1-0.2-9.8 0.2-3.5 1.4-7.2 4.6-10.8 3.2-4 5.8-8.2 5.2-13.8-0.5-6.9 12.9-20.2 18.8-22.8 5.6-2.6 12.8-3.5 16.6-9.5zm-34.7 32.2c0.7 6.2-2.4 10.7-5.5 14.5q-0.4 0.6-0.8 1.1c-2.3 3-3.2 5.9-3.5 8.7-0.2 2.1-0.1 4 0 5.9 0.2 1.6 0.3 3.1 0.2 4.6-0.4 6 3.2 14 10 16.4q0.6 0.4 1.3 0.7c0.1 0 0.2 0.1 0.2 0.1 1.4 1.1 2.7 1.8 4.2 2.4 2.7 0.7 5.5 0.8 9.5 0.8 2.8 0 5.1-0.2 7.5-0.1q0.4 0 0.9 0.1c1.9 0.1 3.7 0.3 5.6 0.8q2 0.5 4.4 0.8 0.4 0 0.9 0.1 1.6 0.2 3.2 0c5.3-0.7 9.7-4.1 10.2-4.4 0 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0.3-0.1 0.4-0.1 0.1 0 0.5 0.1 0.5 0.1 1 0.2 8.2 2 13.5 2.2q0.7 0 1.4 0 0.6 0 1.2-0.1 0.7-0.1 1.3-0.2c1.5-0.4 2.4-0.8 3.2-1.3q0.5-0.3 0.9-0.6c0.8-0.5 1.5-0.9 2.9-1.1q0.7-0.1 1.8-0.1c4.3-0.4 16.8-3.9 25.5-12.6 6.8-6.8 10.9-14.1 11.9-15.4 0 0 0.2-0.4 0.2-0.4 0.1 0 0.5-0.1 0.5-0.1 0.9-1.1 6.3-2.2 10.5-5.9 0.7-0.8 1.3-1.5 1.7-2.1 0-0.1 0.1-0.1 0.1-0.2 0 0 0.1-0.1 0.1-0.1 2.6-4.1 6.6-12.6 8.9-19.1 1.6-4 0.9-9 0.1-13.6q-0.3-1.6-0.7-3.1-0.3-1.8-0.5-3.4-0.1-1.4-0.3-2.6c-0.1-1.6-0.6-3.2-1.2-4.7-0.6-1.4-1.2-2.8-1.5-4.4-1.1-4-4.3-10.2-9.9-10.6-3.6-0.2-5.3-1.7-6.9-3.2q-0.1-0.2-0.2-0.3c-2-1.9-4.2-3.9-10.9-4.5-2.4-0.2-4.8-0.4-7.2-0.7-5-0.5-9.7-1-13.6-1q-6.9 0-8.1 2.2-0.2 0.3-0.3 0.5c-1.4 2.6-4.9 3.2-8.5 3.9-3.2 0.5-6.5 1.1-9.1 3-1.8 1.3-4 2.6-6.4 3.9q-0.3 0.2-0.7 0.4c-4.9 2.8-10.1 5.9-12.8 9.7q-0.4 0.6-0.8 1.3c-2.9 4.5-7.4 6.3-11.8 7.9q-1.7 0.5-3.3 1.2-1 0.3-1.9 0.8c-6 2.6-18.8 15.7-18.4 22z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m261.6 54.6q0.5-0.7 1-1.5c4-5.9 14-9.6 19.5-13.6 5.7-4.2 15.1-2.1 17.2-6.8 0.9-2 4.2-2.7 8.7-2.7 5.7 0 13.4 1.1 20.4 1.7 12.5 1 9.9 7.2 17.7 7.8 6.4 0.4 9.8 7.9 10.6 12.2 0.6 3.6 2.9 6.4 3.4 10.8q0.1 0.9 0.1 1.9c0.3 6.3 3 16.3-0.6 22.3-3.6 5.8-8.8 12.3-10.6 15.2-0.3 0.5-0.9 1.4-1.8 2.4-3.3 3.2-7.6 4.7-9 6.5-1.4 1.8-5.1 7.9-10.8 13.6-8.5 8.4-21.2 12.5-25.9 12.8q-0.7 0.1-1.2 0.1c-3.5 0.2-2.9 2-7.4 3q-0.3 0.1-0.7 0.2-0.9 0.1-1.9 0.1-0.3 0-0.7 0c-5.7 0-14.3-2.3-14.3-2.3 0 0-4.9 4-10.9 4.6q-1.7 0.1-3.5-0.2-0.8-0.1-1.5-0.2c-1.8-0.4-3.4-0.7-4.9-1-2.2-0.4-4.2-0.6-6.5-0.7-2.2-0.1-4.5-0.1-7.3-0.3-4.9-0.3-7.8-0.8-10.4-1.9-1.4-0.8-2.5-1.9-3.8-3.5-5.3-1.7-9.7-9.1-8.9-17 0.2-2.6 0-5.5 0.4-8.7 0.5-3.1 1.7-6.4 4.2-9.7 2.7-3.7 4.9-7.6 4.6-12.3-0.2-6.8 13-20.6 18.7-23.2 5.5-2.5 12.3-3.9 16.1-9.6zm-34.3 32.8c0.4 5.1-2.2 9.3-4.8 13q-0.4 0.5-0.7 1c-1.9 2.7-2.8 5.3-3.2 7.8-0.3 1.8-0.4 3.5-0.4 5.1 0 1.5 0 2.8 0 4.1-0.7 6.4 2.5 13.2 7.3 15.5q0.6 0.5 1.1 0.8c0 0 0.1 0.1 0.1 0.1 1.3 1.5 2.4 2.6 3.9 3.4 2.4 1 5.2 1.5 9.9 1.8 3 0.1 5.5 0.1 7.8 0.2q0.5 0 1 0.1c2.1 0.1 3.9 0.3 5.9 0.8 1.4 0.3 2.9 0.6 4.6 0.9q0.5 0.1 1 0.2 1.6 0.3 3.4 0.1c5.6-0.4 10.4-4.1 10.7-4.4 0 0 0.1-0.1 0.1-0.1 0 0 0.1 0 0.1 0 0 0.1 0.3-0.1 0.4 0 0.1 0 0.4 0.1 0.5 0.1 1.4 0.3 8.4 2 13.4 2.1q0.7 0 1.3 0 0.6 0 1.1-0.1 0.8-0.1 1.3-0.2c1.6-0.4 2.4-0.9 3.1-1.4q0.5-0.3 1-0.6c0.7-0.5 1.5-0.8 2.9-0.9q0.7-0.1 1.7-0.2c4.6-0.5 16.9-4.4 25.2-12.6 5.6-5.6 9.3-11.7 10.8-13.6 0 0 0.1-0.3 0.2-0.3 0-0.1 0.3-0.1 0.3-0.2 1.4-1.7 5.6-3.2 8.6-6.2 0.7-0.8 1.2-1.5 1.5-1.9 0 0 0.1-0.1 0.1-0.2 0 0 0.1 0 0.1-0.1 1.7-2.7 6.9-9 10.5-15 2.4-3.8 2-9.4 1.4-14.7q-0.2-1.7-0.4-3.4c-0.2-1.3-0.3-2.6-0.4-3.7q-0.1-1.5-0.3-2.8c-0.3-1.9-0.9-3.6-1.6-5.1-0.7-1.6-1.4-3.1-1.6-4.8-0.7-3.9-3.9-11.5-10.1-12-3.6-0.2-5.2-1.6-6.8-3.1q-0.1-0.2-0.2-0.3c-2-1.8-4.2-3.8-10.7-4.4-2.3-0.2-4.7-0.4-7-0.6-5-0.5-9.6-1-13.4-1q-6.7 0-8 2.1-0.2 0.2-0.3 0.5c-1.3 2.6-4.7 3.2-8.3 3.8-3.1 0.5-6.4 1.1-9 2.9-1.7 1.3-3.9 2.5-6.2 3.8q-0.4 0.2-0.7 0.4c-4.9 2.7-9.9 5.6-12.4 9.4q-0.5 0.7-0.9 1.3c-2.8 4.2-7.1 6.2-11.4 7.9q-1.6 0.6-3.2 1.2-1 0.4-1.8 0.8c-5.7 2.6-18.6 16.3-18.5 22.7z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m262 55.1q0.5-0.7 1-1.5c3.7-6 13.5-9.2 19-13.2 5.6-4.1 14.8-2.1 16.8-6.7 0.9-2 4.2-2.6 8.5-2.6 5.7 0 13.2 1 20.1 1.6 12.2 1 9.7 7.1 17.3 7.7 7 0.4 10.4 9.2 10.8 13.6 0.3 3.8 3.2 6.4 3.8 11.5q0.1 1 0.2 2.1c0.1 6.9 2.4 18.5-2.4 24-4.8 5.4-11.3 9.6-12.2 11.1-0.1 0.2-0.6 1-1.4 2.1-2.2 2.4-5.3 4.4-7.1 6.8-1.9 2.4-5.2 7.2-9.6 11.6-8.2 8.2-20.7 12.5-25.6 13q-0.6 0-1.1 0.1c-3.6 0-3 1.8-7.3 2.9q-0.4 0.1-0.8 0.1-0.8 0.2-1.8 0.2-0.4 0-0.7 0c-5.6 0-14.1-2.2-14.1-2.2 0 0-5.3 4.2-11.6 4.5-1.2 0.1-2.4 0-3.7-0.3q-0.7-0.2-1.5-0.4c-1.9-0.5-3.5-0.8-5.2-1.1-2.2-0.3-4.3-0.5-6.8-0.7-2.2-0.1-4.6-0.2-7.7-0.5-5.5-0.6-8.5-1.4-10.7-2.9-1.4-1.1-2.3-2.6-3.4-4.5-3.1-1.8-6.9-7.8-5.8-16.2 0.3-2.2 0.4-4.8 1.1-7.6 0.6-2.7 1.9-5.5 3.7-8.4 2.2-3.4 4-7 3.9-10.9 0.1-6.7 13.1-21.1 18.8-23.6 5.2-2.4 11.8-4.3 15.5-9.6zm-33.8 33.2c0 4.2-2.1 8-4.2 11.5q-0.3 0.5-0.6 1c-1.4 2.3-2.4 4.6-2.9 6.8-0.4 1.6-0.6 3.1-0.8 4.5-0.1 1.2-0.2 2.4-0.3 3.6-0.8 6.8 1.8 12.3 4.8 14.5q0.4 0.5 0.7 0.9c0.1 0 0.1 0.1 0.2 0.1 1.1 1.9 2 3.4 3.4 4.5 2.1 1.3 5 2.1 10.4 2.7 3.2 0.3 5.8 0.4 8.2 0.5q0.5 0.1 0.9 0.1c2.3 0.2 4.2 0.3 6.3 0.7 1.5 0.3 3 0.6 4.8 1.1q0.5 0.1 1 0.2 1.8 0.5 3.6 0.4c6-0.2 11.2-4.3 11.4-4.5 0 0 0.1 0 0.1-0.1 0 0 0.1 0.1 0.1 0.1 0 0 0.2-0.1 0.4 0 0.1 0 0.3 0.1 0.5 0.1 1.8 0.5 8.5 2 13.2 2.1q0.7 0 1.3-0.1 0.6 0 1.1-0.1 0.7-0.1 1.3-0.3c1.5-0.4 2.3-0.9 3-1.4q0.5-0.3 1-0.6c0.7-0.4 1.5-0.7 2.9-0.8q0.7 0 1.7-0.1c4.9-0.8 16.9-4.9 24.8-12.8 4.4-4.4 7.7-9.2 9.6-11.7 0.1 0 0.2-0.2 0.2-0.3 0.1 0 0.2-0.1 0.3-0.2 1.8-2.3 4.7-4.2 6.7-6.5 0.7-0.9 1.1-1.5 1.2-1.7 0 0 0.1-0.1 0.1-0.1 0 0 0.1-0.1 0.1-0.1 0.9-1.4 7.3-5.5 12-10.9 3.2-3.6 3.3-9.9 2.9-15.8q-0.1-2-0.3-3.8c-0.1-1.4-0.2-2.8-0.3-4.1q0-1.6-0.2-3c-0.4-2.1-1.2-3.8-2-5.4-0.8-1.7-1.6-3.3-1.7-5.2-0.3-3.9-3.5-12.8-10.4-13.3-3.5-0.2-5-1.6-6.6-3.1q-0.1-0.2-0.2-0.3c-1.9-1.8-4.1-3.7-10.6-4.3-2.2-0.1-4.5-0.4-6.8-0.6-4.8-0.5-9.4-1-13.2-1-4.3 0-6.9 0.7-7.8 2q-0.2 0.3-0.3 0.5c-1.3 2.6-4.6 3.2-8.1 3.8-3 0.5-6.3 1.1-8.8 2.9-1.8 1.3-3.9 2.4-6.2 3.7q-0.3 0.2-0.7 0.4c-4.7 2.5-9.7 5.2-12 9.1q-0.5 0.6-0.9 1.2c-2.7 4-6.9 6.1-11 7.9q-1.5 0.7-3.1 1.3-0.9 0.4-1.8 0.8c-5.4 2.5-18.3 16.8-18.4 23.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m326.4 33.7c12 1 9.5 7 17 7.5 7.5 0.5 10.9 10.5 10.9 15 0 4.5 4.4 7.1 4.4 14.6 0 7.5 1.8 20.7-4.2 25.7-6 5-13.6 6.9-13.6 6.9 0 0-6.2 10.2-14.7 18.7-8.5 8.5-22.3 13.1-26.3 13.1-4 0-3 2-8 3q-1.1 0.2-2.5 0.2c-5.6 0-14-2.2-14-2.2 0 0-5.6 4.6-12.2 4.6-1.2 0-2.5-0.2-3.8-0.6-8-2.5-11.2-1.7-22.2-3.2-11-1.5-11.9-3.9-14.2-9.4-0.9-2.2-5.6-8.6-0.9-21.7 1.9-5.3 6.2-11.3 6.6-16.7 0.4-6.6 13.2-21.5 18.7-24 5.5-2.5 12.5-5.1 16-11.1 3.5-6 13-8.9 18.5-12.9 5.5-4 14.5-2 16.5-6.5 0.9-1.9 4-2.5 8.3-2.5 5.6 0 12.9 1 19.7 1.5zm-27.7 1.2c-1.2 2.5-4.5 3.1-7.9 3.7-3 0.5-6.2 1.1-8.7 2.9-1.9 1.4-4.2 2.6-6.7 3.9-4.6 2.4-9.5 4.9-11.7 8.8-3.2 5.5-9.2 8.1-14.4 10.5q-0.9 0.4-1.8 0.7c-5.2 2.4-18.1 17.3-18.5 23.8-0.3 3.6-2.1 7.3-4 11-1 2-1.9 3.9-2.6 5.8-4.1 11.5-0.9 17.8 0.4 20.5q0.3 0.5 0.5 0.9l0.1 0.2c2.2 5.4 3.2 7.7 13.9 9.1 4 0.6 6.9 0.8 9.5 1 4.4 0.4 7.6 0.6 12.7 2.2q1.8 0.6 3.7 0.6c6.4 0 12-4.5 12-4.5l0.1-0.1h0.2c0.1 0 8.4 2.2 13.9 2.2q1.4 0 2.4-0.2c2.4-0.5 3.4-1.2 4.2-1.8 0.9-0.6 1.7-1.2 3.9-1.2 3.8 0 17.6-4.6 26-13 8.4-8.4 14.7-18.6 14.7-18.7l0.1-0.1h0.1c0.1 0 7.7-2 13.5-6.9 4.9-4 4.5-13.4 4.2-21 0-1.6-0.1-3.1-0.1-4.4 0-4.1-1.3-6.8-2.5-9.1-1-1.7-1.9-3.4-1.9-5.5 0-3.9-3.1-14.2-10.7-14.7-3.4-0.2-4.8-1.6-6.4-3-1.9-1.8-4-3.9-10.6-4.5-2.2-0.1-4.5-0.4-6.7-0.6-4.7-0.5-9.2-0.9-12.9-0.9-4.7 0-7.3 0.7-8 2.4z"
  }))), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m286.8 143.7c0.4-3.3 1.3-7.7 2.8-11 2.7-6 9.9-6 22-14.3 8-5.4 11.3-16.7 12.6-23.7 0.2-1.4-1.6-2-2.2-0.8-3.1 5.3-7.6 13.2-10.4 17.3-4.4 6.6-14.9 6.1-14.9 6.1 0 0-3.3 7.7-10.5 7.7-7.1 0-12.6-5.5-12.6-5.5 0 0 4.9 11 4.9 14.9 0 3.8-3.3 7.2-3.3 7.2 0 0 6 1.5 11.6 2.1z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m282.9 143.2c-2.7-0.4-5.3-1.1-7.1-1.5 1-1.5 7-6 7-8.4 0-2.3-4.1-5.5-5.5-9.1 2.4 1.3 5.5 2.5 8.9 2.5 6.6 0 10.3-5.4 11.5-7.7 3.1-0.1 11.3-0.8 15.3-6.9 2.3-3.5 5.9-9.6 8.9-14.9-1.5 6.4-4.7 15.4-11.2 19.8-5 3.4-9.2 5.4-12.5 7-4.8 2.3-8.3 4-10.2 8.1-1.3 2.9-4.6 8-5.1 11.1z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m302.2 140.5c0 0-3.7-2.4 0.9-6.1 4.5-3.7 11.1-3.3 14.4-7.9 3.3-4.5 5-12.4 5-12.4 0 0 0 12.8-5.4 16.6-5.4 3.7-14.9 9.8-14.9 9.8z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m302.3 139.4c-0.3-0.3 2.2-3 3.5-4.1 1.9-1.6 4.3-2.4 6.6-3.2 3-1 3.8-2.3 5.8-5.1 1-1.3 1.8-2.8 2.4-4.4-0.7 3-1.9 6-3.9 7.4-4.6 3.2-12.4 8.1-14.4 9.4z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m344.9 108.4c1.1-0.1 2.6-0.3 4.4-0.8 1.8-2.8 4.5-7.1 4.2-7.9-0.4-1.3-0.8-3.4 3.3-11.6 4.2-8.3-3.7-17.4-3.7-17.4 0 0 0.4 7.9 0.8 10.8 0.4 2.9-2.5 7.4-7.8 13.6-5.4 6.2-2.5 13.4-2.5 13.4l1.2-0.2z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m335.7 112.1c0 0-1.2-16.2 1.7-19.5 2.9-3.3 8.7-6.2 8.7-6.2 0 0-6.2-2.9-6.2-5.8 0-2.9 6.2-10.3 5.3-16.1-0.8-5.8-1.2-10.3 5.4-6.6 6.6 3.7 9.1 8.3 9.1 8.3 0 0-2.5-11.2-9.1-12.9-6.6-1.6-6.2-9.7-6.2-9.7 0 0-4.1 6-3.3 12.6 0.8 6.7-2.1 14.1-5.8 13.3-3.7-0.9-8.3-7.1-8.3-7.1 0 0 2.5 9.5 7.1 10 4.5 0.4 2.9 5.5 2 10.5-0.8 5-3.5 1.7-3.7 9.7-0.1 5.5 3.3 19.5 3.3 19.5z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m362.9 56.5c-0.4-1.1-0.6-2.1-0.6-3.2q0-0.2 0-0.4c-0.6-0.4-1.7-1.1-3.6-2.7-3.5-2.9-5.6-5.1-5.6-5.1 0 0 2.7 8 5.8 9.7 1.3 0.7 2.7 1.3 4 1.7z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m257.6 146c0 0-10.8-6.2-10.8-10.4 0-4.1 8.3-9.1 8.3-9.1 0 0-10.8-4.1-14.5 2.1-3.7 6.2-6.2 8.7-9.5 7.4-3.3-1.2-16.9-11.1-16.9-11.1 0 0 5.1 12.4 9.7 14 4.5 1.7 15.3 3.8 15.3 3.8z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m227.8 117.4c0 0-0.4-16.9 7.4-21.5 7.9-4.5 8.3-15.7 15.3-18.6 7.1-2.9 15.8-8.2 15.8-8.2 0 0-6.7 11.5-12.4 13.6-5.8 2.1-7.1 10.8-7.1 10.8l7.9-1.3c0 0-7 8.7-12.4 8.7-5.4 0-14.5 16.5-14.5 16.5z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m244.8 112.9c0 0 10.7-1 11.9-3.9 1.3-2.9 7.9-11 15.8-11 7.8 0 21.1-0.8 23.5-6.2 2.5-5.4-15.7-7.4-17.3-12.4-1.7-5 16.1-14.1 16.1-14.1 0 0-10.8 8.7-10.3 11.6 0.4 2.9 11.5 4.6 15.7 8.7 4.1 4.1 9.1 2.9 9.1 2.9 0 0-8.7 5-11.2 7.8-2.5 2.9-0.8 5 0 9.1 0.8 4.2-0.4 6.7-0.4 6.7 0 0 0-10-8.3-10.4-8.3-0.4-19-1.2-21.9 2.5-2.9 3.7-10.3 9.9-10.3 9.9 0 0 1.2 0.4 2.4 5.4 1.3 5 0 7.4 0 7.4 0 0-2.9-8.6-4.9-10.3-2.1-1.6-9.9-3.7-9.9-3.7z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m321.7 78.6c-8.3-3.8-9.1-14.5-8.7-17.4 0.4-2.9 4.1-13.2-3.3-18.6-7.5-5.4-9.1-13-9.1-13l-9.1 3.9c0 0 7.8 5 10.7 9.5 2.9 4.6 5.8 6.2-0.4 6.6-6.2 0.4-11.6 0-11.6 0 0 0 8.3 6.6 12 4.6 3.8-2.1 7.9-2.9 6.7 0.4-1.3 3.3-2.5 11.1 2 16.1 4.6 5 10.8 7.9 10.8 7.9z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m256.7 57.5c0.9 3.3 8.7 0 14.5 2.5 5.8 2.4 11.2 2.9 11.2 2.9 0 0 0-7.5-7.5-8.7-7.4-1.3-18.2 3.3-18.2 3.3z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m324.6 28.1c2 2.5 6.2 8.3 2.9 12.8-3.3 4.6-4.6 10.8 0.4 13.3 4.9 2.4 4.9 2.4 4.9 2.4 0 0-5.8-5.3-3.3-9.9 2.5-4.5 3.3-7.4 4.2-9.5 0.8-2.1-9.1-9.1-9.1-9.1z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m345.5 108.1c0 0-0.8-3.5 1.1-7.6 2-4.2 6.4-10.4 7.6-12.8 1.2-2.5 2.1-5.3 1.5-6.5-0.5-1.3-0.8-3.6-0.8-3.6 0 0 4 2.5 0.7 9.1-3.3 6.6-6.5 9.9-5.7 11.6 0.9 1.6 1.4 2 1.4 2 0 0-1.6-0.8-2.1 1.8-0.4 2.7-1.3 5.4-1.3 5.4z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m334.8 93c0 0 0.9-3.7 3.8-4.6 2.9-1 3.2-1.8 3.2-1.8 0 0-3.9-2.9-3.4-5.3 0.4-2.3 3-8.9 3.8-11.6 0.8-2.6 0.4-11.1 1.4-13.6 1-2.5 2.1-2.5 5.6-0.7 3.6 1.8 5.6 4.3 5.6 4.3 0 0-0.3-3.6-4.9-5.1-4.5-1.5-6.2-5-6.2-5 0 0-1.5 3.6-1.5 9.9 0 6.4 0.3 11.6-2.9 11.6-3.2 0-7.6-1.9-7.2-1.9 0.5 0 7.1 1 6.7 3.9-0.4 2.8-2.9 10.4-1.6 11.5 1.4 1.1 2 1.1 0.3 2.1-1.6 1-2.7 6.3-2.7 6.3z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m356.1 49.6c0 0 1.1 2.9 2.8 4 1.6 1.1 3.2 1.7 3.2 1.7l0.2-2c0 0-1.8 0-3-0.6-1.2-0.7-3.2-3.1-3.2-3.1z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m328 52.5c0 0-2.9-4.7-1.1-7.4 1.8-2.8 3.9-6.2 3.6-7.8-0.3-1.5-1-3.5-1-3.5 0 0 3.6 2 1.5 5.8-2 3.7-4 6.8-3.7 7.7 0.3 0.8 0.7 5.2 0.7 5.2z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m298.8 32c0 0 2.1 5.3 4.7 8.5 2.6 3.2 6.9 2.2 7.4 7.7 0.6 5.6-0.1 10.7 0 14.2 0.2 3.6 2.9 9 2.9 9 0 0-5.8-5.5-4.8-8.3 1-2.7 1.4-9.6 0.4-11.4-1-1.8-2.2-0.3-4.4 0.3-2.2 0.5-8.4 0-8.4 0 0 0 6.5-0.7 8-1.3 1.5-0.5 4.8-1.4 3.6-3.1-1.3-1.8-5.4-5.8-7.8-8.5-2.3-2.6-4.5-5.9-4.5-5.9z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m260.6 57.2c0 0 8.7-0.6 12.3 1.7 3.6 2.2 8 3 8 3 0 0-2.5-4.4-6.4-5.3-3.8-0.8-13.9 0.6-13.9 0.6z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m230.1 110.8c0 0 4.2-10.9 9-11.3 4.8-0.4 10.8-4.7 10.8-4.7l-5.6 0.3c0 0 0-9.6 4.9-12.1 4.8-2.5 12.2-9.4 12.2-9.4 0 0-8.9 5-12.8 6.9-3.8 1.9-4.5 11-8 13.2-3.4 2.2-8.2 5.7-9.2 10.8-1 5.1-1.3 6.3-1.3 6.3z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m218.7 130.3c0 0 4.3 5.9 8.7 7.3 4.4 1.3 11.7 0.9 14.5 2.3 2.7 1.4 9.7 4.1 9.7 4.1 0 0-8.9-5.9-7.5-8.6 1.3-2.8 4.2-7.2 4.2-7.2 0 0-4.4 1.2-6 4.1-1.7 2.9-2.1 5-2.1 5 0 0-6.2 0.4-11.6-1.1-5.3-1.5-9.9-5.9-9.9-5.9z"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m251.8 113.6c0 0 6.1-2.1 7.4-4.8 1.4-2.8 7.1-9.4 13.8-9.6 6.8-0.1 20.7-1.6 22.9-4.9 2.2-3.3 3-6.2-2.9-8.4-5.9-2.2-12.8-4.6-12.4-7.5 0.4-2.9 4.3-6.2 4.3-6.2 0 0-3.5 6.1-1.3 7.1 2.2 0.9 13.3 5.7 15.2 7.9 1.9 2.3 4.8 2.1 4.8 2.1 0 0-5.5 3.7-7.3 6.4-1.8 2.6 0.1 8.4 0.1 8.4 0 0-0.2-5-6.7-5.1-6.5-0.2-18.5 0.9-23.6 4.5-5.1 3.6-10.3 10.2-10.3 10.2l2.2 5.7c0 0-1.9-4.9-3.5-5-1.5-0.1-2.7-0.8-2.7-0.8z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m343.6 108.5c-1.3-1.5-7.5 5.6-12.2 7.5-4.8 1.8-1.9-12.2-2.5-19.4-0.6-7.3-4.7-7.7-7 0.6-2.2 8.4-11.6 19.2-17.4 22.1-5.8 2.9-15.1 7-17.4 9.9-1.8 2.4-5 8.1-7.9 13.3 4.2 0.9 10.7 2 14.2 1.3 5.5-1.1 4.4-3.3 8.8-3.3 4.4 0 17.7-3.4 27.1-12.7 9.3-9.4 14.3-19.3 14.3-19.3z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m348.1 99.2c-1.2 3.1-1.8 6.2-2 9.1 3-0.5 8-1.7 12.4-5.3 6.6-5.6 8.7-22.8 8.7-31.1 0-6.5-3.1-11.2-4.3-15.4-1.8 1.1 0.5 4.9 1 10.1 0.4 5.1-0.5 6.8-1.9 10.7-1.5 4-8.9-6.6-8.9-6.6 0 0 3.9 8.3 3.3 12.4-0.6 4.1-6.8 12.6-8.3 16.1z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m253.2 145.2c-4.1-1.9-7.7-4.5-9.1-6.3-1.8-2.2-8.4-0.2-14.9-1.6-5.1-1.1-11.9-8.8-16.1-14.3 0.2 1.3 0.4 2.5 0.4 3.7 0 6.6 6 18.2 18.2 19.8 9.9 1.4 15.1-1.7 21.5-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m256.3 61c-3-0.3-6.9 0.4-11 2-4 1.6-8.3 4.2-12.1 7.7-7.7 7-7.3 19.3-8.9 23-3.3 7.4-0.6 7.7 3.5 4.7 4-3 9.3-9.3 11.2-14.9 1.8-5.6 7.8-9.9 13.5-13.1 5.6-3.1 11-5 11.5-5.5 1-1-5.4-3.7-7.7-3.9z"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m245.2 63.4c3.8-1.6 7.5-2.2 10.4-2 0.9 0.1 2.4 0.5 3.8 1.1q0.9 0.3 1.7 0.7c1.3 0.7 2.2 1.4 1.9 1.8-0.7 0.5-5.8 2.3-11.1 5.3-1.4 0.8-2.8 1.6-4.2 2.5-3.9 2.7-7.5 6.1-8.9 10.1-0.5 1.3-1.1 2.6-1.8 3.9-2.4 4.3-6.1 8.3-9 10.4-1.5 1.1-2.8 1.6-3.6 1.5-1.2-0.3-1.3-2.1 0.5-6.2 0.5-1.2 0.8-3.1 1.2-5.5 0.7-3.6 1.7-8.1 4-12 1-1.6 2.1-3 3.5-4.3 3.6-3.3 7.7-5.8 11.6-7.3z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m245 63.8c3.7-1.5 7.2-2.1 9.9-2 0.9 0.1 2.3 0.5 3.6 1q0.9 0.3 1.6 0.6c1.2 0.6 2.1 1.3 1.8 1.7-0.7 0.6-5.6 2.3-10.6 5.1q-2.1 1.1-4 2.4c-3.9 2.6-7.3 5.9-8.7 9.7-0.5 1.2-1.1 2.5-1.7 3.8-2.3 4.1-5.8 7.9-8.7 10-1.3 0.9-2.5 1.3-3.2 1.1-1-0.4-1.1-2.1 0.6-5.9 0.4-1.1 0.7-3 1.1-5.2 0.7-3.4 1.7-7.7 4-11.4 0.9-1.5 1.9-2.8 3.3-4 3.5-3.2 7.3-5.5 11-6.9z"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m244.8 64.1c3.5-1.4 6.8-2 9.4-1.8 0.9 0 2.2 0.3 3.5 0.8q0.7 0.2 1.4 0.6c1.2 0.5 2 1.1 1.8 1.5-0.9 0.6-5.5 2.2-10.3 4.9q-1.9 1.1-3.8 2.3c-3.7 2.5-7 5.6-8.4 9.3-0.5 1.2-1 2.4-1.7 3.6-2.1 4.1-5.5 7.7-8.3 9.7-1.1 0.7-2.1 1-2.8 0.7-0.8-0.4-0.9-2.1 0.6-5.6 0.4-1.1 0.7-2.9 1.1-4.9 0.7-3.3 1.7-7.3 3.9-10.8 0.9-1.3 1.9-2.6 3.2-3.7 3.3-3 6.9-5.2 10.4-6.6z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m244.7 64.5c3.2-1.3 6.3-1.9 8.8-1.8 0.9 0 2.1 0.3 3.3 0.7q0.7 0.2 1.4 0.5c1 0.4 1.8 1 1.7 1.4-1 0.6-5.4 2.2-9.9 4.7q-1.8 1-3.6 2.2c-3.6 2.4-6.8 5.4-8.2 8.9-0.4 1.1-1 2.3-1.6 3.5-2 4-5.3 7.4-7.9 9.3-1 0.5-1.9 0.7-2.4 0.3-0.8-0.5-0.8-2.1 0.5-5.3 0.5-1.1 0.7-2.7 1.1-4.6 0.7-3.2 1.7-6.9 3.8-10.1 0.9-1.3 1.9-2.5 3-3.5 3.2-2.8 6.7-4.9 10-6.2z"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m244.5 64.9c3-1.3 6-1.8 8.3-1.8 0.8 0 2 0.2 3.1 0.6q0.7 0.2 1.3 0.4c0.9 0.4 1.7 0.9 1.7 1.3-1.2 0.6-5.3 2.1-9.5 4.5q-1.8 1-3.5 2.1c-3.4 2.3-6.4 5.2-7.9 8.5-0.4 1.1-1 2.2-1.5 3.3-1.9 4-5.1 7.2-7.6 8.9-0.9 0.4-1.6 0.5-2 0.1-0.6-0.6-0.6-2.2 0.6-5.1 0.4-1.1 0.6-2.6 1-4.3 0.7-3 1.7-6.5 3.7-9.5q1.3-1.8 2.9-3.2c3-2.6 6.3-4.6 9.4-5.8z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m244.3 65.3c2.9-1.2 5.6-1.7 7.8-1.8 0.8 0 1.9 0.2 2.9 0.5q0.6 0.1 1.2 0.4c0.9 0.3 1.6 0.7 1.7 1-1.4 0.7-5.2 2.2-9.1 4.4q-1.7 0.9-3.4 2c-3.2 2.2-6.1 4.9-7.6 8.1q-0.7 1.6-1.4 3.2c-1.8 3.8-4.8 6.9-7.3 8.5-0.7 0.2-1.3 0.1-1.6-0.3-0.5-0.7-0.4-2.2 0.6-4.8 0.4-1 0.6-2.5 1-4.1 0.7-2.8 1.7-6 3.7-8.7q1.2-1.7 2.7-3c2.8-2.5 5.9-4.3 8.8-5.4z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m244.2 65.6c2.6-1 5.1-1.6 7.2-1.7 0.8 0 1.8 0.2 2.7 0.4q0.6 0.1 1.2 0.3c0.7 0.2 1.4 0.6 1.6 0.9-1.5 0.7-5.1 2.1-8.7 4.2q-1.7 0.9-3.2 1.9c-3.1 2.1-5.9 4.7-7.3 7.7q-0.8 1.5-1.5 3.1c-1.6 3.7-4.5 6.6-6.9 8.1-0.5 0-0.9-0.2-1.2-0.7-0.3-0.8-0.2-2.2 0.6-4.5 0.4-1 0.6-2.3 1-3.8 0.7-2.7 1.7-5.6 3.6-8.1q1.1-1.5 2.6-2.8c2.7-2.2 5.5-3.8 8.3-5z"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m244 66c2.4-1 4.8-1.5 6.7-1.6 0.8-0.1 1.7 0 2.5 0.2q0.6 0.1 1.1 0.2c0.6 0.2 1.2 0.6 1.5 0.8-1.6 0.8-4.9 2.1-8.2 4q-1.6 0.8-3.1 1.8c-2.9 2-5.6 4.4-7 7.3q-0.8 1.4-1.4 2.9c-1.5 3.7-4.3 6.3-6.5 7.8-0.4-0.2-0.7-0.5-0.8-1.1-0.2-0.8-0.1-2.1 0.6-4.2 0.3-1 0.5-2.2 0.9-3.5 0.6-2.5 1.7-5.2 3.5-7.5q1.1-1.3 2.5-2.5c2.5-2 5.1-3.5 7.7-4.6z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m243.8 66.4c2.3-0.9 4.4-1.5 6.2-1.6 0.7-0.1 1.6 0 2.3 0.1q0.5 0 1 0.1c0.5 0.2 1.1 0.5 1.5 0.7-1.7 0.8-4.8 2-7.9 3.7q-1.4 0.9-2.9 1.8c-2.8 1.9-5.3 4.2-6.7 6.9q-0.7 1.3-1.3 2.8c-1.4 3.6-4.1 6-6.2 7.3-0.2-0.3-0.4-0.7-0.4-1.4-0.1-0.9 0.1-2.1 0.6-3.9 0.3-0.9 0.5-2.1 0.9-3.2 0.6-2.4 1.7-4.8 3.4-6.8q1.1-1.2 2.4-2.3c2.3-1.8 4.8-3.2 7.1-4.2z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m243.6 66.8c2.1-0.9 4-1.4 5.7-1.6 0.7-0.1 1.4-0.1 2.1 0q0.5 0 1 0.1c0.4 0.1 0.9 0.3 1.4 0.5-1.9 0.8-4.7 2-7.5 3.5q-1.4 0.8-2.7 1.7c-2.7 1.8-5.1 4-6.5 6.5q-0.7 1.3-1.2 2.6c-1.3 3.5-3.9 5.8-5.9 7q0-0.7 0-1.7c0.1-1 0.3-2.2 0.7-3.7 0.2-0.9 0.4-1.9 0.8-3 0.6-2.2 1.7-4.3 3.3-6.1q1.1-1.1 2.3-2c2.1-1.7 4.4-2.9 6.5-3.8z"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m230.2 86q0.2-1 0.4-2.1c0.4-1.9 0.7-4.1 1.4-6.1 0.7-2 1.8-3.9 3.4-5.4 2.6-2.4 5.4-4.1 8.1-5.3 2.6-1.1 5.1-1.6 7-1.6q0.5 0 0.9 0c0.3 0 0.8 0.2 1.4 0.4-2.7 1.1-6.4 2.7-9.7 4.9-3.3 2.3-6.2 5.1-7.4 8.6-1.1 3.4-3.5 5.5-5.5 6.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m303.3 27.1c-2.6 0.9 0.2 8.3 4.6 12.9 4.4 4.5 8.4 6.3 8 13.9-0.4 7.6 5.9 6.9 6.2 2.1 0.1-2.5-0.1-6-0.3-9.6-0.1-3.5-0.1-7.1 0.4-9.6 1.1-5 0.3-9-1.8-9.4-1-0.2-4.2-0.6-7.7-0.8-3.5-0.2-7.2-0.1-9.4 0.5z"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m303.4 27.2c0.9-0.3 2.2-0.5 3.7-0.5 1.7-0.2 3.6-0.1 5.5 0 3.3 0.1 6.3 0.5 7.3 0.7 1.4 0.3 2.2 2.6 2.1 5.7q-0.1 1.6-0.5 3.4c-0.4 2.4-0.4 5.9-0.2 9.3q0 0.7 0.1 1.4c0.1 2.6 0.3 5.2 0.2 7.2q0 0.3 0 0.7c-0.1 1.2-0.6 2.1-1.3 2.6-1.8 1.2-4.7 0-4.5-5.1 0.2-5.7-2.3-8-5.4-10.9-0.8-0.7-1.6-1.4-2.4-2.3q-0.5-0.4-0.8-0.8c-3.8-4.3-6-10.5-3.8-11.4z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m303.4 27.3c0.9-0.3 2.2-0.5 3.6-0.6 1.7-0.1 3.6-0.1 5.4 0 3.1 0.1 5.9 0.5 6.9 0.7 1.3 0.3 2.1 2.5 2 5.5q-0.1 1.6-0.4 3.3c-0.5 2.4-0.4 5.7-0.2 9.1q0.1 0.6 0.1 1.2c0.2 2.6 0.3 5.1 0.3 7q0 0.4 0 0.7c-0.1 1.1-0.6 1.8-1.3 2.1-1.6 0.9-4.2-0.3-4.1-4.9 0.1-5.5-2.3-7.6-5.4-10.4q-1.1-0.9-2.3-2.1-0.4-0.4-0.8-0.8c-3.6-4.1-5.7-9.9-3.8-10.8z"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m303.5 27.4c0.8-0.3 2-0.5 3.5-0.6 1.7-0.1 3.5-0.1 5.3-0.1 2.9 0.2 5.5 0.5 6.4 0.6 1.2 0.4 2 2.5 1.8 5.5q0 1.5-0.3 3.2c-0.4 2.3-0.2 5.5 0 8.7q0 0.6 0 1.2c0.2 2.5 0.4 4.9 0.4 6.7q0 0.4 0 0.7c-0.1 0.9-0.6 1.5-1.2 1.7-1.4 0.6-3.8-0.6-3.8-4.9 0-5.1-2.4-7.1-5.3-9.7q-1.1-0.9-2.2-2.1-0.4-0.3-0.8-0.7c-3.4-3.8-5.5-9.3-3.8-10.2z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m303.5 27.5q1.3-0.4 3.5-0.6c1.6-0.1 3.4-0.2 5.1-0.1 2.7 0.1 5.2 0.3 6.1 0.5 1.1 0.4 1.8 2.4 1.6 5.3q-0.1 1.4-0.3 3.1c-0.3 2.2-0.1 5.3 0.1 8.4q0 0.6 0.1 1.2c0.2 2.4 0.4 4.7 0.4 6.5q0 0.3 0 0.6c-0.1 0.8-0.6 1.2-1.1 1.3-1.3 0.2-3.4-1-3.5-4.9-0.1-4.7-2.4-6.7-5.2-9.1q-1.1-0.9-2.2-1.9-0.3-0.3-0.7-0.7c-3.3-3.6-5.3-8.7-3.9-9.6z"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m303.6 27.6q1.2-0.4 3.3-0.6c1.7-0.2 3.4-0.2 5.1-0.2 2.5 0.1 4.8 0.3 5.6 0.4 1 0.4 1.7 2.4 1.5 5.2q-0.1 1.4-0.3 3c-0.2 2.2 0 5.2 0.2 8.1q0.1 0.6 0.1 1.2c0.3 2.3 0.5 4.5 0.5 6.2q0 0.4 0 0.6c-0.1 0.6-0.5 0.9-1 0.9-1.1-0.1-3-1.4-3.2-4.9-0.2-4.3-2.5-6.2-5.2-8.4q-0.9-0.9-2-1.8-0.3-0.4-0.7-0.7c-3.2-3.3-5.1-8-3.9-9z"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m303.6 27.7q1.2-0.4 3.3-0.6c1.6-0.2 3.3-0.2 4.9-0.2 2.4 0 4.4 0.2 5.2 0.3 0.9 0.4 1.6 2.3 1.4 5.1q-0.1 1.3-0.2 2.8c-0.2 2.2 0 5 0.3 7.8q0 0.6 0.1 1.1c0.2 2.3 0.5 4.4 0.5 6q0 0.4 0 0.6c-0.2 0.5-0.5 0.7-0.9 0.5-0.9-0.5-2.6-1.7-2.8-4.8-0.4-4-2.7-5.8-5.2-7.9q-0.9-0.8-1.9-1.7-0.4-0.3-0.7-0.6c-3-3.1-4.9-7.4-4-8.4z"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m303.7 27.7q1-0.3 3.2-0.5c1.5-0.2 3.3-0.3 4.8-0.3 2.1 0.1 4 0.2 4.8 0.3 0.7 0.4 1.3 2.2 1.2 4.9q-0.1 1.3-0.2 2.7c-0.1 2.1 0.1 4.8 0.4 7.5q0.1 0.6 0.1 1.1c0.3 2.2 0.6 4.2 0.6 5.8q0 0.3 0 0.6c-0.2 0.3-0.5 0.3-0.8-0.1-0.8-0.7-2.2-2-2.5-4.7-0.5-3.7-2.7-5.3-5.1-7.3q-0.9-0.7-1.9-1.5-0.3-0.3-0.6-0.6c-2.9-2.8-4.7-6.8-4-7.9z"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m303.7 27.8c0.7-0.2 1.7-0.4 3.2-0.6 1.5-0.1 3.2-0.2 4.7-0.2 1.9 0 3.6 0.1 4.3 0.1 0.7 0.5 1.2 2.2 1 4.8q0 1.2-0.1 2.6c-0.1 2.1 0.2 4.7 0.6 7.2q0 0.5 0.1 1.1c0.3 2.1 0.5 4.1 0.6 5.5q0 0.3 0 0.6c-0.2 0.1-0.4 0-0.7-0.5-0.6-1-1.8-2.3-2.2-4.7-0.7-3.3-2.8-4.8-5.1-6.6q-0.8-0.7-1.7-1.5-0.3-0.2-0.6-0.5c-2.8-2.6-4.5-6.2-4.1-7.3z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m303.7 27.9c0.7-0.2 1.7-0.4 3.1-0.6 1.5-0.2 3.2-0.3 4.6-0.3 1.7 0 3.3 0.1 4 0.1 0.5 0.4 1 2.1 0.8 4.6q-0.1 1.2-0.1 2.6c0 2 0.3 4.4 0.7 6.8q0.1 0.5 0.1 1c0.3 2 0.6 4 0.7 5.3q0 0.4 0 0.6c-0.2 0-0.4-0.2-0.7-0.9-0.4-1.3-1.3-2.7-1.8-4.6-0.8-3-2.8-4.5-5-6.1q-0.8-0.6-1.6-1.3-0.3-0.2-0.6-0.5c-2.6-2.3-4.3-5.6-4.2-6.7z"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m303.8 28c0.6-0.2 1.6-0.4 3-0.6 1.5-0.2 3.1-0.3 4.5-0.3 1.5-0.1 2.8-0.1 3.5 0 0.4 0.4 0.9 2 0.7 4.5q-0.1 1.1 0 2.4c0 2 0.4 4.3 0.7 6.6q0.1 0.4 0.2 0.9c0.3 1.9 0.6 3.8 0.7 5.1q0 0.3 0 0.5c-0.2-0.1-0.4-0.5-0.6-1.3-0.3-1.6-0.9-3-1.5-4.6-0.9-2.6-2.9-4-4.9-5.5q-0.8-0.5-1.6-1.1-0.2-0.2-0.5-0.5c-2.5-2.1-4.1-4.9-4.2-6.1z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m316.6 46.2c-0.2-0.3-0.4-0.8-0.5-1.7-0.4-5.5-3.2-7.4-6-9.4q-1-0.7-2-1.5c-2.3-1.8-3.9-4.3-4.3-5.5 0.6-0.2 1.5-0.4 3-0.6 1.4-0.2 3-0.3 4.3-0.4 1.4-0.1 2.5-0.1 3.1-0.1 0.3 0.5 0.8 2 0.6 4.4-0.2 2.6 0.4 6.1 1 9.5 0.4 1.8 0.7 3.6 0.8 4.8q0 0.3 0 0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m257.6 103.1c3.9 0.1 13.8-9 24-8.5 10.2 0.4 10.4-3.6 3-8.2-7.5-4.5-3.2-14-10.9-15.1-7.7-1.1-5 10.7-10.1 15.4-5.1 4.7-19.9 16.1-6 16.4z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m273.6 72.1q0.3 0 0.5 0.1c2.3 0.4 3.3 1.7 4 3.5 1.4 3.3 1.4 8.1 6 10.9q1.9 1.2 3 2.3 1.3 1.2 1.5 2.2 0.3 0.7 0 1.3-0.2 0.4-0.6 0.7c-1.2 0.8-3.5 1.2-7.1 1.1-5.2-0.2-10.3 2.3-14.5 4.5-2.3 1.2-4.3 2.4-5.9 3-1 0.4-1.8 0.7-2.4 0.7-12.6-0.4 1.2-11 5.9-15.4 0.7-0.6 1.3-1.4 1.7-2.3 1.7-3.1 2-7.5 3.4-10.2 0.9-1.8 2.2-2.7 4.5-2.4z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m273.6 72.9q0.2 0 0.5 0.1c2.1 0.4 3 1.6 3.7 3.4 1.3 3.2 1.3 7.8 5.8 10.5q1.8 1.1 2.9 2.1c0.7 0.7 1.1 1.4 1.2 2 0.1 0.4 0 0.8-0.2 1.2q-0.2 0.3-0.6 0.6c-1.1 0.7-3.3 1.1-6.7 1-4.9 0-9.8 2.3-13.8 4.4-2.1 1.1-4.1 2.3-5.5 2.9-1 0.3-1.8 0.5-2.4 0.5-11.2-0.5 1.5-10.3 5.9-14.3 0.7-0.6 1.2-1.4 1.6-2.1 1.7-3.1 2.1-7.2 3.4-9.8 0.8-1.9 2-2.8 4.2-2.5z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m273.5 73.7q0.2 0.1 0.5 0.1c2 0.4 2.8 1.5 3.5 3.3 1.2 3.1 1.3 7.4 5.6 10q1.7 1.1 2.7 2c0.6 0.6 0.9 1.2 0.9 1.8 0.1 0.4 0 0.7-0.2 1q-0.2 0.3-0.6 0.6-1.7 1-6.4 1c-4.7 0-9.2 2.2-13 4.2-2 1.1-3.9 2.2-5.2 2.7q-1.4 0.5-2.3 0.5c-9.9-0.6 1.7-9.6 5.8-13.3 0.6-0.6 1.1-1.3 1.6-2 1.7-2.9 2-6.8 3.2-9.3 0.9-2 1.9-2.8 3.9-2.6z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m273.5 74.5q0.2 0.1 0.4 0.1c1.8 0.4 2.6 1.4 3.3 3.2 1.1 2.9 1.3 7.1 5.3 9.5q1.7 1 2.6 1.9c0.5 0.6 0.7 1.1 0.6 1.6 0 0.3 0 0.6-0.2 0.9q-0.2 0.3-0.6 0.5c-1.1 0.6-3.2 0.9-6 0.9-4.5 0.1-8.8 2.2-12.3 4.1-1.9 1-3.7 2.1-5 2.5q-1.3 0.5-2.1 0.4c-8.6-0.6 2-8.8 5.6-12.2q1-0.9 1.6-1.9c1.7-2.7 2.1-6.4 3.2-8.9 0.8-1.9 1.8-2.8 3.6-2.6z"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m273.4 75.4q0.2 0 0.4 0c1.7 0.4 2.4 1.3 3.1 3.2 1 2.7 1.3 6.6 5.1 9q1.6 0.9 2.5 1.7 0.5 0.8 0.3 1.4 0 0.4-0.4 0.8-0.2 0.2-0.5 0.4c-1.2 0.5-3.1 0.8-5.7 0.9-4.2 0.1-8.2 2.1-11.5 3.9-1.8 0.9-3.6 2-4.7 2.4q-1.3 0.3-2 0.3c-7.3-0.8 2.2-8.2 5.5-11.2q0.9-0.9 1.5-1.8c1.7-2.5 2.2-6 3.1-8.4 0.8-2 1.7-2.8 3.3-2.6z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m273.3 76.2q0.2 0 0.4 0c1.6 0.3 2.2 1.1 2.9 3.1 0.9 2.6 1.2 6.2 4.9 8.5q1.5 0.9 2.3 1.6 0.4 0.7 0 1.2 0 0.4-0.4 0.6-0.2 0.2-0.5 0.4c-1.2 0.4-3 0.7-5.4 0.8-3.9 0.2-7.7 2.1-10.8 3.8-1.6 0.9-3.3 1.8-4.3 2.2q-1.3 0.3-1.9 0.3c-6-0.9 2.4-7.5 5.4-10.2q0.9-0.8 1.5-1.7c1.6-2.4 2.1-5.6 3-7.9 0.8-2.1 1.5-2.9 2.9-2.7z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m273.3 77q0.1 0 0.3 0.1c1.5 0.2 2 0.9 2.7 2.9 0.8 2.4 1.2 5.9 4.7 8q1.4 0.9 2.1 1.6 0.2 0.5-0.2 0.9-0.2 0.3-0.5 0.5-0.2 0.2-0.5 0.3c-1.2 0.4-2.9 0.6-5 0.7-3.7 0.3-7.2 2.2-10.1 3.7-1.5 0.8-3.2 1.7-4.1 2q-1.1 0.3-1.8 0.2c-4.5-0.9 2.7-6.8 5.4-9.1q0.8-0.8 1.4-1.6c1.7-2.2 2.2-5.2 2.9-7.5 0.8-2.1 1.4-2.8 2.7-2.7z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m273.2 77.8q0.2 0.1 0.4 0.1c1.3 0.2 1.7 0.8 2.4 2.8 0.7 2.3 1.2 5.5 4.5 7.5q1.3 0.8 2 1.5 0 0.4-0.6 0.7-0.2 0.2-0.6 0.4-0.2 0.1-0.5 0.2c-1.2 0.3-2.7 0.5-4.6 0.7-3.5 0.4-6.7 2.1-9.3 3.5-1.4 0.7-3 1.6-3.8 1.9q-1.1 0.2-1.7 0.1c-3.2-1.1 3-6.1 5.2-8.1q0.8-0.8 1.4-1.5c1.7-2 2.2-4.8 2.9-7 0.7-2.2 1.3-2.8 2.3-2.8z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m273.1 78.7q0.2 0 0.4 0c1.2 0.2 1.5 0.7 2.1 2.7 0.7 2.2 1.2 5.2 4.4 7.1q1.2 0.7 1.8 1.3c-0.1 0.2-0.4 0.3-0.9 0.5-0.1 0.1-0.3 0.2-0.6 0.3q-0.2 0-0.5 0.1c-1.2 0.2-2.6 0.4-4.3 0.6-3.2 0.5-6.1 2.1-8.5 3.4-1.3 0.7-2.9 1.5-3.6 1.7q-1 0.1-1.5 0c-1.9-1.1 3.2-5.3 5.1-7q0.8-0.7 1.4-1.4c1.6-1.8 2.1-4.4 2.8-6.6 0.6-2.3 1.1-2.8 1.9-2.7z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m273.1 79.5q0.1 0 0.3 0c1.1 0.2 1.4 0.6 1.9 2.6 0.6 2 1.2 4.8 4.2 6.6q1.1 0.7 1.6 1.2c-0.2 0.1-0.6 0.2-1.1 0.3q-0.3 0.1-0.7 0.1-0.2 0.1-0.5 0.1-1.8 0.1-4 0.6c-2.9 0.5-5.6 2-7.7 3.2-1.2 0.6-2.7 1.4-3.3 1.6q-1 0-1.4-0.1c-0.6-1.3 3.4-4.6 5-6q0.7-0.7 1.3-1.2c1.6-1.8 2.2-4.2 2.7-6.2 0.7-2.4 1-2.8 1.7-2.8z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m264.2 95.1c-0.6 0-1.1-0.1-1.3-0.1 0.7-1.4 3.7-4 4.9-5q0.7-0.6 1.2-1.1c1.7-1.6 2.2-3.8 2.7-5.7 0.6-2.5 0.8-2.9 1.3-2.9q0.2 0 0.3 0c1 0.2 1.2 0.5 1.7 2.5 0.5 1.9 1.2 4.5 3.9 6.1q1.1 0.7 1.6 1.1-0.6 0.1-1.5 0.1-0.4 0-0.7 0-0.3 0-0.5 0c-4.1 0-7.9 2.1-10.7 3.6-1 0.6-2.4 1.3-2.9 1.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m248.9 131.8c-1.6 1-0.2 5 2.7 8.5 2.9 3.5 7.5 6.4 12.3 5.1 4.8-1.2 8.6-3.2 10.8-5.6 2.2-2.4 2.9-5.2 1.6-8.2-1.3-2.9-6-4.3-11.4-4.2-2.7 0-5.7 0.4-8.4 1.1-2.8 0.8-5.4 1.9-7.6 3.3z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m249.5 132.3c2.2-1.2 4.7-2.1 7.3-2.8q2.7-0.7 5.6-0.9 1.2-0.2 2.5-0.2c1.9-0.1 3.7 0 5.2 0.3 2.9 0.5 5.1 1.6 5.9 3.4 0.4 0.9 0.6 1.9 0.6 2.7q0 2.2-1.6 4.1-0.3 0.5-0.7 0.9c-2.2 2.2-5.8 4.1-10.5 5.3q-1.8 0.4-3.5 0.1 0 0 0 0c-3.3-0.4-6.2-2.5-8.3-4.9-2.7-3.3-4-7-2.5-8z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m250 132.8c2.3-0.9 4.6-1.8 7.1-2.3q2.6-0.6 5.4-0.9 1.2-0.1 2.4-0.2c1.8-0.1 3.5 0 5.1 0.2 2.7 0.4 4.9 1.3 5.6 2.9 0.5 1 0.6 1.8 0.6 2.7q-0.1 1.9-1.6 3.8-0.4 0.4-0.8 0.8c-2.1 2.1-5.6 3.8-10.2 4.9q-1.6 0.4-3.2 0.2 0 0 0 0c-3.2-0.4-6-2.4-7.9-4.6-2.6-3.1-3.8-6.5-2.5-7.5z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m250.6 133.4c2.3-0.8 4.5-1.5 6.8-2 1.7-0.3 3.4-0.6 5.2-0.7 0.8-0.1 1.5-0.2 2.4-0.2 1.6-0.2 3.3-0.2 4.8 0 2.6 0.2 4.8 1 5.5 2.5 0.5 0.9 0.6 1.7 0.5 2.5-0.1 1.2-0.6 2.4-1.7 3.6q-0.4 0.3-0.8 0.7c-2 1.9-5.4 3.5-9.8 4.5q-1.6 0.4-3.1 0.2c-3-0.3-5.7-2.2-7.5-4.2-2.4-2.8-3.5-6.1-2.3-6.9z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m251.2 133.9c2.3-0.5 4.4-1.1 6.6-1.5 1.5-0.3 3.1-0.5 5-0.6 0.6-0.1 1.4-0.2 2.2-0.3 1.6-0.2 3.1-0.2 4.6-0.2 2.6 0.2 4.7 0.7 5.4 2.1 0.4 0.9 0.5 1.7 0.4 2.4-0.1 1.1-0.6 2.2-1.8 3.3q-0.3 0.4-0.7 0.7c-2 1.7-5.2 3.2-9.5 4.2q-1.5 0.3-2.9 0.2c-3-0.4-5.4-2.1-7.1-4-2.3-2.5-3.3-5.5-2.2-6.3z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m251.7 134.4c2.4-0.3 4.3-0.7 6.4-1 1.5-0.3 3-0.5 4.8-0.6 0.6 0 1.3-0.1 2.1-0.3 1.5-0.2 3-0.3 4.4-0.3 2.5 0 4.6 0.4 5.2 1.7 0.5 0.9 0.5 1.6 0.4 2.3-0.1 0.9-0.7 1.9-1.9 3q-0.3 0.3-0.7 0.6c-1.9 1.6-5 2.9-9.2 3.8q-1.4 0.3-2.7 0.2c-2.8-0.3-5.1-1.9-6.7-3.6-2.1-2.3-3-5-2.1-5.8z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m252.3 135c2.4-0.1 4.2-0.4 6.1-0.7 1.4-0.2 2.8-0.3 4.6-0.4 0.6 0 1.3-0.2 2-0.3 1.4-0.3 2.9-0.4 4.2-0.5 2.4-0.2 4.5 0.1 5.1 1.2 0.5 0.9 0.5 1.6 0.4 2.2-0.2 0.9-0.8 1.8-2 2.8q-0.4 0.2-0.7 0.5c-1.9 1.4-4.9 2.6-8.9 3.5q-1.3 0.2-2.5 0.1c-2.8-0.2-4.9-1.7-6.3-3.2-2-2.1-2.8-4.5-2-5.2z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m252.9 135.5c2.3 0.2 4 0 5.8-0.2 1.3-0.1 2.7-0.3 4.4-0.3 0.5-0.1 1.2-0.2 2-0.4 1.2-0.2 2.6-0.5 3.9-0.6 2.4-0.3 4.4-0.3 5 0.8 0.5 0.8 0.4 1.5 0.3 2-0.2 0.8-0.8 1.6-2.1 2.5q-0.3 0.3-0.7 0.5c-1.8 1.2-4.6 2.3-8.5 3.1q-1.3 0.3-2.4 0.2 0 0 0 0c-2.6-0.2-4.6-1.5-5.9-2.9-1.8-1.9-2.5-4-1.8-4.7z"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m253.4 136c2.4 0.4 4 0.4 5.6 0.3 1.3-0.1 2.5-0.2 4.3-0.3 0.4 0 1-0.2 1.8-0.3 1.2-0.3 2.5-0.6 3.8-0.9 2.2-0.4 4.2-0.5 4.7 0.4 0.5 0.9 0.4 1.5 0.3 2-0.2 0.6-0.8 1.3-2.2 2.2q-0.3 0.2-0.7 0.4c-1.7 1.1-4.4 2-8.2 2.7q-1.1 0.3-2.2 0.2 0 0 0 0c-2.4-0.1-4.3-1.3-5.4-2.5-1.7-1.7-2.3-3.6-1.8-4.2z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m254 136.6c2.4 0.6 3.9 0.7 5.4 0.6 1.1 0 2.3-0.1 4-0.1 0.4 0 1-0.2 1.7-0.4 1.1-0.3 2.4-0.7 3.6-1 2.1-0.5 4.1-0.8 4.6 0 0.5 0.8 0.4 1.3 0.2 1.8-0.2 0.5-0.8 1.2-2.2 2q-0.4 0.1-0.7 0.3c-1.7 0.9-4.3 1.7-7.9 2.4q-1.1 0.2-2 0.1c-2.4-0.1-4-1.1-5.1-2.1-1.5-1.5-2-3.1-1.6-3.6z"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m254.6 137.1c2.4 0.8 3.7 1 5.1 1.1 1 0 2.1 0 3.8-0.1 0.4 0 0.9-0.1 1.6-0.4 1-0.3 2.2-0.7 3.4-1.1 2-0.7 4-1.2 4.4-0.5 0.6 0.8 0.4 1.3 0.2 1.7-0.2 0.4-0.8 1-2.3 1.7q-0.3 0.2-0.7 0.3c-1.6 0.7-4 1.4-7.6 2q-0.9 0.2-1.8 0.2c-2.2-0.1-3.7-1-4.6-1.8-1.4-1.3-1.8-2.6-1.5-3.1z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m260.8 141.6c-2.1 0-3.5-0.8-4.3-1.4-1.2-1.1-1.4-2.1-1.4-2.5 4.5 1.8 4.7 1.5 8.5 1.5 0.7 0 2.7-0.9 4.7-1.7 2-0.8 3.9-1.5 4.3-0.9 0.6 0.8 0.4 1.2 0.1 1.5-0.2 0.3-0.8 0.9-2.4 1.5-1.5 0.6-4 1.3-7.9 1.9q-0.8 0.1-1.6 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m336 106c0.2 2 2.9 0.9 6.1-2 3.3-2.9 7.2-7.5 9.6-12.7 5-10.4 5.3-17.8 0.1-17.7-2.7 0.1-6.9 5-10.3 11.6-1.7 3.2-3.2 6.9-4.2 10.5-1.1 3.6-1.6 7.2-1.3 10.3z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m351.9 74.2c2.5-0.1 3.6 1.9 3.4 5.2-0.2 2.9-1.5 6.9-3.7 11.5-1.5 3.3-3.7 6.3-5.8 8.8-1.1 1.3-2.2 2.4-3.2 3.3-1.5 1.4-2.9 2.4-4 2.8-1.2 0.5-1.9 0.3-2-0.5-0.2-2.7 0.2-5.7 1-8.7q0.2-0.6 0.3-1.2c0.8-2.3 1.7-4.7 2.8-7q0.7-1.5 1.5-3.1c2.4-4.8 5.4-8.9 7.7-10.4 0.8-0.5 1.5-0.7 2-0.7z"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m352 74.8c2.3 0.1 3.3 1.8 3 5-0.2 2.7-1.4 6.4-3.5 10.8-1.5 3-3.4 5.9-5.5 8.3-0.9 1.2-2 2.2-2.9 3.1-1.5 1.5-2.9 2.4-4 2.9-1.2 0.5-1.7 0.3-2-0.2-0.1-2.8 0.3-5.6 1.2-8.4q0.1-0.6 0.3-1.2c0.8-2.2 1.7-4.4 2.8-6.6 0.4-1 0.9-2 1.4-3 2.3-4.6 5.1-8.8 7.4-10.2 0.7-0.5 1.3-0.6 1.8-0.5z"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "e1",
    d: "m352.2 75.3c2 0.3 2.8 1.8 2.5 4.8-0.2 2.5-1.4 6-3.3 10.1-1.4 2.8-3.2 5.5-5.1 7.8-0.9 1.1-1.8 2.1-2.7 2.9-1.5 1.6-2.9 2.6-4 3-1.2 0.6-1.6 0.5-1.9 0.1-0.1-2.7 0.3-5.4 1.2-8.1q0.2-0.5 0.4-1c0.8-2.1 1.8-4.2 2.8-6.4 0.4-0.9 0.9-1.8 1.4-2.9 2.2-4.4 4.8-8.6 6.9-9.9 0.8-0.4 1.3-0.4 1.8-0.4z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "ek",
    d: "m352.3 75.9c1.8 0.3 2.5 1.7 2.2 4.5-0.3 2.4-1.4 5.6-3.2 9.4-1.3 2.6-3 5.2-4.7 7.4-0.9 1-1.7 1.9-2.6 2.7-1.4 1.6-2.9 2.6-3.9 3.1-1.3 0.5-1.5 0.5-1.8 0.3-0.1-2.6 0.4-5.2 1.3-7.7q0.2-0.5 0.4-1c0.8-2 1.8-3.9 2.8-6 0.4-0.8 0.9-1.8 1.3-2.8 2.1-4.2 4.6-8.5 6.5-9.6 0.8-0.5 1.3-0.4 1.7-0.3z"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "m352.4 76.4c1.6 0.2 2.2 1.7 1.8 4.3-0.3 2.2-1.3 5.2-3.1 8.8-1.1 2.4-2.6 4.7-4.3 6.8q-1.1 1.5-2.3 2.6c-1.5 1.7-2.9 2.7-3.9 3.1-1.3 0.6-1.3 0.6-1.8 0.7 0-2.7 0.5-5.1 1.5-7.4q0.1-0.5 0.4-1c0.8-1.8 1.8-3.6 2.8-5.7 0.4-0.7 0.8-1.6 1.3-2.6 1.9-4.1 4.3-8.4 6.1-9.4 0.8-0.4 1.2-0.3 1.5-0.2z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "el",
    d: "m352.6 77c1.3 0.2 1.7 1.5 1.3 4.1-0.3 2-1.3 4.7-2.9 8-1 2.2-2.4 4.4-3.9 6.3q-1.1 1.4-2.1 2.5c-1.5 1.7-2.9 2.7-3.9 3.2-1.3 0.6-1.2 0.6-1.7 0.9 0-2.6 0.6-4.9 1.5-7q0.2-0.5 0.4-0.9c0.9-1.7 1.9-3.4 3-5.4 0.3-0.7 0.7-1.6 1.2-2.6 1.7-3.8 3.9-8.2 5.6-9 0.8-0.4 1.2-0.3 1.5-0.1z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "em",
    d: "m352.7 77.6c1 0.2 1.4 1.4 0.9 3.8-0.3 1.8-1.2 4.3-2.7 7.3-1 2-2.2 4-3.6 5.9q-0.9 1.3-1.8 2.3c-1.5 1.8-2.9 2.7-3.9 3.2-1.3 0.6-1.1 0.7-1.6 1.2 0-2.5 0.6-4.6 1.6-6.6q0.2-0.5 0.4-0.9c0.9-1.6 1.9-3.2 3-5 0.3-0.6 0.7-1.5 1.1-2.5 1.6-3.6 3.7-8.1 5.2-8.8 0.8-0.4 1.2-0.2 1.4 0.1z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "en",
    d: "m352.9 78.1c0.7 0.3 1 1.4 0.4 3.6-0.3 1.7-1.1 3.9-2.5 6.7-0.9 1.7-2 3.5-3.2 5.3q-0.8 1.2-1.7 2.1c-1.4 1.9-2.8 2.9-3.7 3.4-1.4 0.6-1.1 0.7-1.7 1.5 0.1-2.6 0.8-4.5 1.7-6.4q0.3-0.4 0.5-0.7c0.9-1.5 2-3 3-4.8 0.3-0.5 0.7-1.3 1.1-2.3 1.4-3.5 3.4-8 4.7-8.6 0.9-0.3 1.2-0.1 1.4 0.2z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "eo",
    d: "m353 78.7c0.5 0.3 0.6 1.3 0.1 3.4-0.4 1.4-1.2 3.4-2.4 5.9-0.8 1.5-1.7 3.2-2.8 4.9q-0.8 1-1.5 1.9c-1.4 1.9-2.8 2.9-3.7 3.4-1.4 0.7-0.9 0.8-1.6 1.8 0.1-2.5 0.8-4.3 1.8-6q0.2-0.3 0.5-0.7c0.9-1.4 2-2.7 3-4.4 0.3-0.5 0.6-1.3 1-2.3 1.4-3.2 3.2-7.8 4.4-8.2 0.8-0.4 1.1 0 1.2 0.3z"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "ep",
    d: "m353.1 79.2c0.3 0.4 0.3 1.3-0.3 3.2-0.4 1.3-1.1 3-2.2 5.2q-1 2-2.5 4.4-0.6 1-1.2 1.8c-1.4 2-2.8 3-3.7 3.5-1.4 0.7-0.8 0.8-1.6 2.1 0.2-2.6 0.9-4.2 2-5.7q0.2-0.3 0.5-0.7c0.9-1.2 2-2.4 3-4 0.3-0.4 0.6-1.2 1-2.2 1.2-3.1 2.9-7.6 3.9-8 0.9-0.3 1.1 0.1 1.1 0.4z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "m347.4 92.8c-1.4 2-2.8 3-3.7 3.5-1.4 0.8-0.7 0.9-1.5 2.4 0.2-2.5 1-4 2-5.3 1.1-1.4 2.4-2.5 3.7-4.4 0.8-1.2 3.1-9.4 4.3-9.8 0.9-0.2 1 0.2 1.1 0.6 0 0.4-0.1 1.2-0.8 2.9-0.6 1.7-1.9 4.4-4.1 8.4q-0.5 0.9-1 1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m295.7 137.1c-0.5 2 2.4 1.8 6.4 0.1 4-1.7 9.2-4.9 13.2-9 4-4.1 6.7-7.9 7.7-10.8 1.1-3 0.5-5.1-2-5.9-2.5-0.8-8.1 2.6-13.4 7.6-2.7 2.6-5.3 5.5-7.4 8.6-2.1 3.1-3.8 6.4-4.5 9.4z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m320.9 112c0.9 0.3 1.5 0.8 1.9 1.5 0.6 1 0.5 2.4-0.1 4.1q-0.2 0.5-0.5 1c-1.2 2.6-3.6 5.9-7 9.4q-1.7 1.7-3.7 3.2-1.3 1.1-2.7 2c-2.2 1.5-4.3 2.6-6.2 3.4q-1.1 0.4-2 0.7c-2.8 0.8-4.4 0.7-4.2-0.6 0.7-2.8 2.2-5.7 4.1-8.4q0.2-0.3 0.4-0.6c1.6-2.3 3.6-4.5 5.6-6.5q0.8-0.8 1.6-1.6c1.7-1.7 3.5-3.2 5.2-4.5 3.2-2.3 6-3.5 7.6-3.1z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m320.7 112.5c1 0.3 1.6 0.8 1.9 1.4q0.7 1.4-0.3 3.9-0.2 0.5-0.4 1c-1.2 2.5-3.5 5.5-6.8 8.9q-1.7 1.6-3.5 3.1-1.3 1-2.6 1.9 0 0 0 0c-2.1 1.4-4.2 2.5-6 3.2q-1 0.4-1.8 0.7c-2.7 0.8-4.1 0.7-4-0.4 0.7-2.7 2.2-5.4 4-8q0.2-0.2 0.4-0.5c1.6-2.1 3.5-4.2 5.5-6.2q0.7-0.7 1.5-1.5c1.6-1.6 3.4-3.1 5-4.3 3-2.3 5.7-3.6 7.1-3.2z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "e1",
    d: "m320.6 113c1 0.3 1.5 0.8 1.7 1.4 0.5 0.8 0.4 2.1-0.3 3.7q-0.2 0.4-0.5 0.9c-1.1 2.3-3.3 5.2-6.5 8.4q-1.6 1.6-3.4 3-1.2 1-2.4 1.8 0 0 0 0c-2 1.4-4 2.4-5.7 3.1q-1 0.4-1.8 0.6c-2.5 0.7-3.7 0.7-3.8-0.1 0.8-2.7 2.2-5.2 4-7.6q0.2-0.3 0.4-0.5c1.5-2 3.4-3.9 5.4-5.8q0.6-0.7 1.4-1.5c1.6-1.5 3.2-3 4.8-4.2 2.8-2.2 5.3-3.5 6.7-3.2z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "ek",
    d: "m320.5 113.5c0.9 0.3 1.4 0.7 1.6 1.3 0.3 0.8 0.2 1.9-0.5 3.5q-0.2 0.4-0.4 0.8c-1.1 2.2-3.3 4.9-6.3 8q-1.5 1.5-3.2 2.9-1.2 0.9-2.3 1.7 0 0 0 0c-2 1.3-3.8 2.3-5.4 2.9q-1 0.4-1.8 0.6c-2.4 0.7-3.3 0.7-3.5 0.1 0.8-2.6 2.1-5 3.9-7.2q0.2-0.2 0.4-0.4c1.5-1.9 3.3-3.6 5.2-5.4q0.7-0.7 1.4-1.4c1.5-1.5 3-2.9 4.5-4.2 2.7-2.1 5.1-3.5 6.4-3.2z"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "m320.4 114c0.9 0.2 1.3 0.7 1.5 1.2 0.2 0.8 0.1 1.8-0.6 3.3q-0.2 0.4-0.4 0.8c-1.2 2-3.2 4.6-6.1 7.5q-1.4 1.4-3 2.8-1.1 0.9-2.3 1.6 0 0 0 0c-1.8 1.3-3.6 2.2-5.1 2.8q-0.9 0.3-1.6 0.5c-2.3 0.7-3 0.7-3.4 0.4 0.8-2.6 2.2-4.8 3.9-6.8q0.2-0.2 0.3-0.4c1.6-1.7 3.4-3.3 5.2-5.1q0.6-0.5 1.4-1.3c1.3-1.4 2.8-2.8 4.2-4 2.5-2.1 4.8-3.6 6-3.3z"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "el",
    d: "m320.2 114.5c1 0.2 1.3 0.7 1.4 1.2 0.2 0.6 0.1 1.6-0.7 3q-0.2 0.4-0.4 0.8c-1.1 1.9-3 4.2-5.8 7q-1.3 1.4-2.9 2.6-1 0.9-2.1 1.6 0 0 0 0c-1.7 1.3-3.4 2.1-4.8 2.7q-0.9 0.3-1.6 0.4c-2.1 0.6-2.6 0.7-3.1 0.6 0.8-2.5 2.1-4.5 3.8-6.4q0.2-0.1 0.3-0.3c1.5-1.6 3.3-3 5.1-4.7 0.4-0.3 0.8-0.8 1.3-1.3 1.2-1.3 2.6-2.6 4-3.9 2.3-2 4.4-3.5 5.5-3.3z"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "em",
    d: "m320.1 115c0.9 0.2 1.2 0.6 1.3 1.1 0.1 0.6-0.1 1.5-0.8 2.9q-0.2 0.3-0.4 0.7c-1.1 1.7-2.9 3.9-5.6 6.6q-1.3 1.2-2.7 2.4-1 0.8-2 1.5c-1.7 1.2-3.2 2-4.6 2.5q-0.8 0.3-1.4 0.5c-2.1 0.5-2.3 0.6-3 0.8 0.9-2.5 2.2-4.4 3.8-6q0.2-0.2 0.3-0.3c1.5-1.5 3.2-2.7 5-4.3 0.3-0.3 0.7-0.8 1.2-1.2 1.1-1.2 2.4-2.6 3.7-3.8 2.2-2.1 4.2-3.6 5.2-3.4z"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "en",
    d: "m320 115.5c0.9 0.1 1.1 0.6 1.1 1 0.1 0.6-0.1 1.4-0.9 2.7q-0.2 0.3-0.4 0.6c-1 1.6-2.7 3.7-5.3 6.2q-1.2 1.1-2.5 2.3-1 0.8-1.9 1.4 0 0 0 0c-1.6 1.2-3.1 1.9-4.3 2.4q-0.8 0.2-1.4 0.4c-1.9 0.4-1.9 0.6-2.7 1 0.9-2.4 2.1-4.1 3.7-5.5q0.2-0.2 0.3-0.3c1.5-1.3 3.1-2.4 4.9-4 0.3-0.2 0.7-0.6 1.1-1.1 1-1.1 2.3-2.5 3.5-3.7 2-2 3.9-3.5 4.8-3.4z"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "eo",
    d: "m319.9 116c0.9 0.1 1 0.5 1 1 0 0.4-0.2 1.2-1 2.4q-0.2 0.3-0.4 0.6c-1 1.4-2.6 3.3-5.1 5.7q-1.1 1.1-2.4 2.2-0.8 0.7-1.7 1.3 0 0 0 0c-1.5 1.1-2.9 1.8-4 2.2q-0.8 0.3-1.3 0.4c-1.9 0.4-1.6 0.6-2.6 1.3 0.9-2.4 2.2-3.9 3.7-5.2q0.2-0.1 0.3-0.3c1.4-1.1 3-2.1 4.8-3.5 0.2-0.2 0.6-0.6 1-1.1 1-1 2.1-2.3 3.2-3.5 1.9-2 3.7-3.6 4.5-3.5z"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "ep",
    d: "m319.7 116.5c1 0.1 1 0.5 1 0.9-0.1 0.4-0.3 1.1-1.2 2.2q-0.2 0.3-0.4 0.6c-0.9 1.3-2.5 3-4.8 5.2q-1 1-2.2 2-0.8 0.8-1.6 1.3c-1.5 1.1-2.7 1.7-3.8 2.1q-0.7 0.2-1.2 0.3c-1.7 0.3-1.2 0.6-2.4 1.5 1-2.3 2.2-3.6 3.7-4.7q0.2-0.2 0.3-0.3c1.4-1 3-1.8 4.7-3.1 0.2-0.2 0.5-0.6 1-1.1 0.8-0.9 1.8-2.2 2.9-3.4 1.7-1.9 3.3-3.6 4-3.5z"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "m310.7 128.2c-2 1.5-3.6 2-4.7 2.2-1.5 0.3-0.8 0.6-2.1 1.8 1-2.3 2.2-3.5 3.6-4.4 1.4-0.9 3-1.6 4.8-3 0.6-0.4 2.1-2.4 3.7-4.2 1.5-1.9 3-3.6 3.6-3.6 0.9 0 0.9 0.5 0.8 0.8-0.1 0.4-0.4 1.1-1.6 2.6-1.2 1.4-3.2 3.5-6.6 6.6q-0.8 0.7-1.5 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m295.6 116.7c1.8-0.5 3-4.2 1.7-8-1.3-3.7-5.1-7.4-13-7.9-5-0.3-11 0.8-15.7 2.8-4.6 2-7.9 4.8-7.6 8 0.4 3.3 6.5 5.2 13.9 6.1 3.6 0.4 7.6 0.5 11.2 0.3 3.7-0.1 7-0.6 9.5-1.3z"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m269.1 103.7c1.8-0.7 3.9-1.4 6.1-1.9 3-0.6 6.1-0.9 8.9-0.7 2.2 0.1 4.1 0.5 5.8 1.1q1.2 0.4 2.3 1 0 0 0 0c2.4 1.5 3.9 3.5 4.6 5.4 1.2 3.5 0.2 7-1.5 7.5-2.2 0.5-4.9 0.8-7.9 0.9q-0.6 0-1.1 0-2.8 0.1-5.8 0c-1.6-0.1-3.3-0.2-5-0.4-1.9-0.1-3.8-0.4-5.5-0.8-4.4-0.9-7.6-2.4-7.9-4.6-0.4-3 2.7-5.6 7-7.5z"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m269.5 103.9c1.6-0.7 3.7-1.4 5.9-1.8 2.8-0.6 5.8-0.9 8.6-0.7q3.1 0.2 5.5 1 1.3 0.4 2.3 1c2.4 1.3 3.8 3.2 4.5 5.1 1.2 3.3 0.2 6.6-1.3 7-2.2 0.3-4.7 0.5-7.5 0.6q-0.5 0-1.1 0-2.6 0-5.5-0.2c-1.5-0.1-3.1-0.2-4.8-0.3-1.8-0.1-3.6-0.4-5.2-0.7-4.3-0.8-7.5-2.1-7.7-4.1-0.4-2.8 2.4-5.2 6.3-6.9z"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m269.9 104.1c1.5-0.7 3.5-1.3 5.7-1.8 2.7-0.5 5.5-0.8 8.3-0.7q2.9 0.2 5.3 1 1.2 0.4 2.2 0.9c2.3 1.3 3.7 3.1 4.3 4.8 1.2 3.1 0.4 6.2-1 6.6-2.1 0.1-4.5 0.2-7.1 0.2q-0.5 0-1 0c-1.7-0.1-3.4-0.2-5.2-0.3-1.4-0.1-3-0.1-4.7-0.2-1.7-0.1-3.4-0.3-5-0.6-4.1-0.6-7.2-1.8-7.4-3.6-0.4-2.6 2.1-4.8 5.6-6.3z"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m270.3 104.2c1.4-0.6 3.3-1.2 5.5-1.6 2.5-0.6 5.3-0.8 7.9-0.7q2.8 0.2 5.1 0.9 1.2 0.4 2.1 0.9 0 0 0 0c2.4 1.2 3.7 2.9 4.3 4.5 1.2 2.9 0.4 5.7-0.8 6.1-2.1-0.1-4.3-0.1-6.7-0.2q-0.5 0-1 0c-1.5-0.1-3.1-0.2-4.9-0.4-1.3-0.1-2.9-0.1-4.5-0.1-1.6-0.1-3.2-0.3-4.7-0.5-4-0.5-7-1.4-7.3-3.2-0.3-2.4 1.9-4.3 5-5.7z"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m270.7 104.4c1.2-0.5 3-1.2 5.3-1.6 2.4-0.5 5-0.7 7.6-0.6q2.7 0.2 4.9 0.8 1.1 0.3 2 0.8 0 0 0 0c2.3 1.1 3.6 2.8 4.2 4.3 1.1 2.6 0.5 5.2-0.6 5.6-2.1-0.3-4.1-0.4-6.3-0.5q-0.5-0.1-0.9-0.1c-1.4-0.1-3-0.3-4.7-0.5-1.2-0.1-2.7 0-4.3-0.1-1.5 0-3.1-0.1-4.5-0.3-3.7-0.3-6.7-1.1-7-2.7-0.3-2.2 1.6-3.9 4.3-5.1z"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m271.1 104.6c1.1-0.5 2.8-1.1 5.1-1.6 2.2-0.4 4.7-0.6 7.2-0.5q2.6 0.1 4.8 0.7 1 0.3 1.9 0.8 0 0 0 0c2.3 1 3.5 2.6 4.1 4 1.1 2.4 0.5 4.7-0.4 5.1-2-0.5-3.9-0.7-5.9-0.9q-0.4-0.1-0.9-0.1c-1.3-0.2-2.7-0.3-4.4-0.6-1-0.1-2.5 0-4 0-1.5 0-3-0.1-4.4-0.2-3.5-0.2-6.5-0.8-6.7-2.2-0.4-2 1.4-3.5 3.6-4.5z"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m271.6 104.7c0.9-0.4 2.5-1 4.8-1.4 2.1-0.4 4.4-0.6 6.9-0.5q2.4 0.1 4.5 0.6 1 0.3 1.9 0.7 0 0 0 0c2.2 0.9 3.4 2.4 4 3.7 1 2.2 0.6 4.3-0.2 4.7-2-0.7-3.7-1-5.5-1.3q-0.4 0-0.8-0.1c-1.2-0.2-2.5-0.4-4.2-0.7-0.9-0.1-2.3 0-3.8 0.1-1.4 0-2.8 0-4.1 0-3.4-0.2-6.3-0.6-6.5-1.8-0.4-1.8 1.1-3.1 3-4z"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m272 104.9c0.8-0.4 2.3-1 4.6-1.4 1.9-0.3 4.2-0.5 6.6-0.4q2.2 0.1 4.3 0.6 1 0.2 1.8 0.5 0 0 0 0c2.1 0.9 3.3 2.3 3.9 3.5 1 2 0.6 3.8 0 4.2-2-0.9-3.5-1.3-5.1-1.6q-0.4-0.1-0.7-0.2c-1.2-0.2-2.4-0.5-4-0.7-0.8-0.2-2.1 0-3.6 0-1.3 0.1-2.6 0.1-3.9 0.2-3.2 0-6-0.3-6.3-1.4-0.3-1.5 0.9-2.6 2.4-3.3z"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m272.4 105.1c0.6-0.3 2.1-0.9 4.4-1.3 1.7-0.4 3.9-0.5 6.2-0.4q2.1 0.1 4.1 0.5 1 0.2 1.8 0.5c2.1 0.8 3.2 2.1 3.8 3.2 0.9 1.7 0.7 3.3 0.2 3.7-2-1.1-3.3-1.6-4.7-2q-0.3-0.1-0.7-0.2c-1-0.3-2.1-0.5-3.7-0.8-0.6-0.2-1.9 0-3.4 0.1-1.1 0.1-2.4 0.2-3.6 0.3-3.1 0.1-5.8 0.1-6.1-0.9-0.3-1.3 0.6-2.2 1.7-2.7z"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m272.8 105.2c0.5-0.2 1.9-0.8 4.2-1.2 1.6-0.3 3.6-0.4 5.9-0.3q1.9 0 3.9 0.4 0.9 0.2 1.7 0.4c2 0.7 3.1 2 3.7 2.9 0.9 1.6 0.7 2.9 0.4 3.3-1.9-1.3-3.1-1.9-4.3-2.4q-0.3-0.1-0.6-0.2c-1-0.3-2-0.5-3.5-0.9-0.5-0.1-1.7 0-3.2 0.2-1 0.1-2.2 0.2-3.4 0.4-2.9 0.3-5.6 0.4-5.8-0.4-0.3-1.2 0.3-1.8 1-2.2z"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m288 104.7c2.1 0.6 3.1 1.8 3.7 2.6 0.8 1.3 0.8 2.4 0.6 2.8-1.9-1.5-2.9-2.2-3.9-2.7-1-0.5-2-0.7-3.8-1.3-0.6-0.2-3.4 0.3-6.2 0.8-2.7 0.4-5.3 0.7-5.5 0.1-0.4-1 0-1.4 0.3-1.6 0.4-0.2 1.7-0.8 4-1.2 2.2-0.3 5.3-0.5 9.3 0.1q0.8 0.1 1.5 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m302.4 49.8c1.6-1 1.8-4.9-0.4-8.2-2.2-3.3-6.7-6-14.6-4.5-4.8 0.9-10.4 3.5-14.4 6.5-4 3.1-6.6 6.7-5.4 9.7 1.1 3.1 7.6 3.5 14.9 2.5 3.6-0.5 7.5-1.4 11-2.4 3.5-1.1 6.6-2.3 8.9-3.6z"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m287.7 37.4q2.2-0.4 4-0.4 0 0 0 0c5 0 8.1 2.1 9.8 4.6 2.1 3.1 1.9 6.8 0.4 7.7-2.2 1-5.2 2.1-8.5 3.1q-2.6 0.7-5.5 1.3c-1.7 0.3-3.4 0.7-5.1 0.9-1.9 0.3-3.7 0.5-5.4 0.6-4.5 0.2-8.1-0.5-8.9-2.5-0.4-1.1-0.3-2.2 0.1-3.3 0.7-2 2.6-4 5.2-5.9 3.8-2.8 9.1-5.2 13.9-6.1z"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m288 37.6q2-0.3 3.7-0.3 0 0 0 0c4.8 0 7.7 2 9.3 4.3 2 2.9 1.8 6.3 0.5 7.2-2.3 0.8-5.1 1.8-8.2 2.6q-2.5 0.6-5.3 1.1c-1.5 0.3-3.2 0.7-4.8 1-1.8 0.3-3.6 0.5-5.2 0.6-4.4 0.3-7.8-0.2-8.5-2.1-0.5-1.1-0.4-2.1 0-3.1 0.7-1.8 2.5-3.7 5-5.5 3.7-2.7 8.8-4.9 13.5-5.8z"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m288.3 37.9q1.9-0.3 3.5-0.3 0 0 0 0c4.4 0 7.2 1.9 8.6 4 1.9 2.7 1.9 5.9 0.7 6.7-2.4 0.6-5 1.4-7.9 2.1-1.6 0.4-3.2 0.7-5.1 1-1.4 0.2-3 0.6-4.6 0.9-1.7 0.4-3.4 0.6-4.9 0.7-4.2 0.4-7.4 0.1-8.2-1.7-0.4-1-0.3-2 0.1-2.9 0.6-1.6 2.4-3.5 4.8-5.1 3.5-2.5 8.3-4.6 13-5.4z"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m288.5 38.1q1.8-0.3 3.3-0.2 0 0 0 0c4.2 0 6.7 1.8 8.1 3.7 1.8 2.5 1.8 5.4 0.7 6.2-2.4 0.3-4.8 1-7.5 1.6-1.5 0.3-3.1 0.5-4.8 0.8-1.3 0.2-2.8 0.6-4.4 1-1.6 0.3-3.2 0.6-4.7 0.8-4 0.4-7.1 0.2-7.8-1.4-0.5-1-0.4-1.9 0-2.7 0.6-1.5 2.3-3.2 4.7-4.8 3.3-2.2 7.9-4.2 12.4-5z"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m288.8 38.4q1.6-0.3 3-0.2 0 0 0 0c3.9 0 6.3 1.6 7.6 3.4 1.7 2.3 1.7 4.9 0.8 5.6-2.5 0.2-4.7 0.7-7.2 1.2-1.4 0.2-2.9 0.4-4.6 0.7-1.2 0.1-2.6 0.6-4.2 0.9-1.5 0.4-3 0.7-4.4 0.9-3.8 0.5-6.8 0.5-7.5-1-0.5-0.9-0.3-1.8 0-2.6 0.6-1.2 2.2-2.8 4.5-4.3 3.2-2.1 7.6-3.9 12-4.6z"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m289.1 38.7q1.5-0.3 2.8-0.2 0 0 0 0c3.6 0 5.8 1.5 7 3.1 1.6 2.1 1.6 4.5 0.8 5.1-2.5-0.1-4.5 0.3-6.8 0.7-1.3 0.2-2.7 0.3-4.4 0.5-1 0.2-2.4 0.6-4 1-1.3 0.4-2.8 0.7-4.2 0.9-3.5 0.7-6.4 0.8-7.1-0.5-0.4-1-0.3-1.8 0.1-2.5 0.5-1.1 2-2.5 4.3-3.9 3-1.9 7.1-3.6 11.5-4.2z"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m289.4 38.9q1.3-0.2 2.5-0.1 0 0 0 0c3.3 0 5.3 1.4 6.5 2.8 1.5 1.9 1.5 4 0.9 4.6-2.5-0.3-4.4-0.1-6.5 0.2-1.2 0.1-2.5 0.2-4.2 0.4-0.9 0.1-2.2 0.5-3.7 0.9-1.3 0.4-2.7 0.7-4 1-3.3 0.8-6.1 1-6.7-0.1-0.5-0.9-0.3-1.6 0-2.3 0.5-0.9 1.9-2.2 4.2-3.6 2.8-1.6 6.7-3.1 11-3.8z"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m289.6 39.2q1.3-0.2 2.4-0.2c2.9 0.1 4.8 1.4 5.8 2.6 1.4 1.7 1.6 3.5 1 4.1-2.5-0.5-4.2-0.5-6.1-0.3-1.1 0.1-2.3 0.1-4 0.2-0.7 0.1-2 0.5-3.5 1-1.2 0.4-2.4 0.7-3.7 1.1-3.1 0.8-5.9 1.2-6.4 0.2-0.5-0.9-0.3-1.5 0-2.1 0.4-0.8 1.8-2 4-3.2 2.6-1.5 6.3-2.8 10.5-3.4z"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m289.9 39.5q1.1-0.2 2.1-0.2 0 0 0 0c2.7 0.1 4.4 1.3 5.3 2.3 1.3 1.5 1.5 3.1 1.1 3.6-2.6-0.8-4.1-0.9-5.8-0.8-1 0-2.2 0-3.7 0.1-0.7 0-1.9 0.5-3.3 0.9-1.1 0.4-2.3 0.8-3.5 1.2-2.9 0.9-5.6 1.5-6 0.6-0.6-0.9-0.3-1.4-0.1-1.9 0.4-0.6 1.7-1.7 3.9-2.8 2.4-1.3 5.9-2.5 10-3z"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m290.2 39.7q1-0.1 1.8-0.1c2.4 0.1 3.9 1.1 4.8 2 1.2 1.3 1.4 2.6 1.2 3.1-2.7-1-4-1.3-5.5-1.3-0.9-0.1-2-0.1-3.5-0.1-0.5 0-1.7 0.5-3.1 1-1 0.4-2.1 0.8-3.2 1.2-2.7 1-5.3 1.8-5.7 1.1-0.5-0.9-0.3-1.4 0-1.8 0.3-0.5 1.5-1.4 3.6-2.5 2.3-1.1 5.5-2.1 9.6-2.6z"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m292.1 39.9c2.1 0.2 3.4 1 4.2 1.7 1.1 1.1 1.3 2.2 1.2 2.6-4.4-2.1-4.6-1.8-8.4-2-0.6-0.1-3.3 1.1-5.8 2.2-2.5 1.1-5 2.1-5.4 1.5-0.5-0.9-0.3-1.3 0-1.6 0.3-0.3 1.4-1.2 3.5-2.1 2.1-0.9 5.1-1.8 9-2.2q0.9-0.1 1.7-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m218.4 105.2c-1.8 0.5-5.1 5-5.5 10.3-0.4 5.3 2.1 11.2 12 14.5 11.9 3.9 14.2-5.3 17.9-6.2 3.7-1 2.9-11.1-4.7-7.6-7.5 3.4-12 2.8-12.6 0-0.7-2.8 0.1-13-7.1-11z"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m218.5 105.7q0 0 0.1 0c2.1-0.5 3.4 0.4 4.3 1.6 0.5 0.7 0.9 1.6 1.1 2.6 0.8 2.6 1 5.7 1.5 7 0.3 0.8 0.9 1.5 1.9 1.8 2.1 0.7 5.4 0.3 10-1.6q0.5-0.2 0.9-0.4 0.5-0.2 1-0.4c5.8-1.8 6.2 6.6 2.9 7.6-2.7 0.8-4.7 5.8-10.3 6.7-1.9 0.3-4.1 0.1-7-0.8-9.5-3.1-12-8.8-11.7-13.9 0.3-5.2 3.5-9.7 5.3-10.2z"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m218.5 106.2q0.1 0 0.1 0c2-0.3 3.3 0.7 4 2 0.5 0.7 0.8 1.6 1.1 2.6 0.7 2.6 1.1 5.5 1.8 6.8 0.4 0.8 1.1 1.4 2.1 1.7 2.1 0.6 5.5 0.2 10-1.8q0.5-0.2 0.9-0.4 0.5-0.1 0.9-0.2c5-1.6 5.2 6.1 2.2 7.1-2.7 0.9-4.6 5.6-9.9 6.4-1.8 0.2-4 0.1-6.7-0.8-9.1-3-11.8-8.4-11.5-13.3 0.2-5.1 3.4-9.5 5-10.1z"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m218.6 106.7q0.1 0 0.1 0c1.8-0.2 3 1.1 3.7 2.3 0.4 0.8 0.7 1.8 1 2.7 0.7 2.6 1.3 5.4 2.2 6.6 0.4 0.7 1.1 1.3 2.1 1.6 2.2 0.6 5.6 0 10-1.9q0.5-0.2 0.9-0.4 0.5-0.1 0.8-0.2c4.4-1.2 4.4 5.7 1.5 6.7-2.5 1-4.4 5.4-9.5 6.1-1.7 0.2-3.8 0-6.4-0.8-8.7-2.9-11.4-7.9-11.2-12.8 0.1-4.8 3.2-9.2 4.8-9.9z"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m218.6 107.2q0.1 0 0.2 0c1.6 0 2.7 1.5 3.3 2.7 0.4 0.9 0.7 1.8 0.9 2.7 0.7 2.6 1.5 5.2 2.6 6.5 0.5 0.6 1.2 1.1 2.2 1.4 2.3 0.5 5.7-0.1 10.1-2q0.5-0.3 0.9-0.4 0.4-0.1 0.7-0.1c3.6-1 3.4 5.1 0.8 6.3-2.5 1-4.3 5.1-9.1 5.7-1.7 0.2-3.7 0-6.1-0.8-8.3-2.7-11.1-7.5-11-12.2 0-4.7 3-9.1 4.5-9.8z"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m218.7 107.8q0.1-0.1 0.1-0.1c1.5 0.1 2.5 1.9 3 3.1 0.4 0.9 0.6 1.8 0.9 2.7 0.7 2.6 1.6 5.1 2.9 6.3 0.6 0.5 1.3 1 2.4 1.2 2.3 0.5 5.7-0.2 10.1-2.1q0.5-0.2 0.9-0.3 0.3-0.1 0.6 0c2.8-0.8 2.5 4.6 0 5.8-2.4 1.1-4.1 4.9-8.7 5.4-1.6 0.2-3.5 0-5.8-0.8-7.9-2.6-10.7-7.1-10.7-11.6 0-4.6 2.8-8.9 4.3-9.6z"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m218.8 108.3q0 0 0.1 0c1.3 0.2 2.2 2.1 2.7 3.4 0.3 0.9 0.5 1.8 0.7 2.7 0.7 2.6 1.8 4.9 3.3 6.1 0.7 0.5 1.5 0.9 2.5 1.1 2.4 0.4 5.9-0.3 10.1-2.2q0.6-0.2 0.9-0.3 0.3-0.1 0.6 0c2-0.5 1.5 4.2-0.7 5.4-2.3 1.3-4 4.7-8.3 5.1-1.5 0.1-3.4-0.1-5.5-0.8-7.6-2.4-10.4-6.7-10.5-11-0.1-4.5 2.6-8.8 4.1-9.5z"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m218.8 108.8q0.1 0 0.1 0c1.3 0.4 2 2.5 2.4 3.7 0.3 1 0.5 2 0.7 2.8 0.7 2.6 1.9 4.8 3.7 5.9 0.7 0.4 1.5 0.8 2.5 1 2.6 0.3 6-0.5 10.2-2.3q0.6-0.3 0.9-0.4 0.2 0.1 0.4 0.2c1.3-0.3 0.7 3.7-1.3 4.9-2.3 1.4-3.9 4.5-8 4.8-1.4 0.1-3.2-0.1-5.2-0.8-7.1-2.3-10-6.2-10.2-10.5-0.2-4.3 2.5-8.5 3.8-9.3z"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m218.9 109.3q0 0 0.1 0c1.1 0.5 1.7 2.9 2 4.1 0.3 1 0.4 2 0.6 2.9 0.7 2.5 2.1 4.6 4.1 5.6 0.7 0.4 1.6 0.7 2.7 0.8 2.6 0.3 6-0.5 10.1-2.4q0.6-0.2 1-0.3 0.2 0.1 0.3 0.2c0.5 0-0.3 3.3-2.1 4.6-2.1 1.4-3.7 4.1-7.5 4.4-1.4 0.1-3-0.2-5-0.8-6.7-2.2-9.6-5.8-9.9-9.9-0.3-4.2 2.3-8.3 3.6-9.2z"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m218.9 109.8q0.1 0 0.2 0c0.9 0.7 1.4 3.3 1.7 4.5 0.2 1 0.3 2 0.5 2.9 0.7 2.5 2.2 4.5 4.4 5.4 0.8 0.4 1.7 0.7 2.8 0.7 2.7 0.2 6.1-0.7 10.2-2.5q0.6-0.3 0.9-0.3 0.2 0.1 0.3 0.3c-0.2 0.2-1.2 2.8-2.8 4.1-2 1.6-3.6 3.9-7.1 4.1q-2 0.1-4.7-0.8c-6.3-2-9.3-5.4-9.7-9.3-0.4-4.1 2.1-8.2 3.3-9.1z"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m219 110.4q0.1-0.1 0.1-0.1c0.8 0.8 1.2 3.7 1.4 4.9 0.1 1.1 0.2 2 0.5 2.9 0.6 2.5 2.3 4.4 4.8 5.3 0.8 0.3 1.8 0.5 2.8 0.5 2.8 0.1 6.3-0.8 10.3-2.6 0.4-0.2 0.7-0.3 0.9-0.3q0.1 0.1 0.1 0.3c-0.9 0.5-2 2.5-3.4 3.7-2 1.7-3.5 3.7-6.8 3.8q-1.9 0-4.4-0.8c-5.9-1.9-8.9-5-9.4-8.8-0.5-3.9 1.9-7.9 3.1-8.8z"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m229.5 128.6q-1.8 0-4.1-0.8c-5.6-1.8-8.6-4.5-9.2-8.2-0.5-3.8 1.7-7.7 2.8-8.7q0.1 0 0.2 0c0.6 0.9 0.9 4 1 5.2 0.1 1.1 0.2 2 0.4 2.9 0.9 3.4 3.9 5.5 8.1 5.5 2.9 0 6.4-1 10.3-2.7 0.5-0.3 0.8-0.3 1-0.4q0 0.2 0 0.5c-1.7 0.7-3 2-4.2 3.2-1.8 1.9-3.4 3.5-6.3 3.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m293.4 67.8c-1 1.6 1.7 9 7.1 14.9 2.7 3 6 5.6 9.9 7 3.9 1.4 8.3 1.5 13.1-0.6 11.5-5 9.7-10.6 8.5-14.3-2-5.9-11.3-13-11.6-4.6-0.3 8.3-2.3 8.3-4.7 6.7-1.1-0.8-5.7-4.6-10.5-7.5-4.7-2.8-9.7-4.7-11.8-1.6z"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m294.8 68.6c1.9-2.6 6.2-1 10.3 1.4q0.4 0.2 0.8 0.5c1.3 0.7 2.5 1.6 3.7 2.4 2.9 2.1 5.4 4 6.3 4.5 1.1 0.7 2.1 1.1 2.9 0.4 0.8-0.8 1.5-2.7 1.7-6.6 0.2-2.7 1.3-3.7 2.9-3.6 2 0.1 4.5 2.1 6.3 4.4 0.8 0.9 1.4 1.9 1.7 3 0.5 1.5 1.1 3.4 0.7 5.5-0.3 1.5-1.1 3.1-3 4.6-1.3 1.2-3.2 2.3-5.8 3.4-4.5 2-8.7 2-12.4 0.7-3.6-1.2-6.8-3.6-9.4-6.4-2.2-2.5-4-5.3-5.2-7.7-1.3-2.9-1.9-5.3-1.5-6.3q0-0.1 0-0.2z"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m296.3 69.4c1.7-2.4 5.7-0.6 9.5 1.6q0.4 0.3 0.7 0.5c1.2 0.7 2.4 1.5 3.5 2.3 2.7 1.9 5.1 3.7 6 4.2 1 0.5 2 0.9 2.7 0.3 0.9-0.8 1.6-2.5 1.9-6.1 0.2-2.5 1.3-3.4 2.8-3.3 1.8 0 4.1 1.7 5.9 3.6 0.7 0.7 1.2 1.6 1.6 2.6 0.4 1.5 1 3.3 0.6 5.2-0.3 1.5-1.1 3-2.8 4.5-1.3 1.1-3.1 2.2-5.5 3.2-4.3 1.9-8.3 1.9-11.7 0.8-3.5-1.2-6.5-3.4-8.9-6-2.2-2.3-3.8-5-4.9-7.3-1.3-2.7-1.8-5-1.5-6q0-0.1 0.1-0.1z"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m297.7 70.1c1.6-2 5.4-0.1 8.8 2q0.3 0.2 0.7 0.4c1.1 0.7 2.2 1.5 3.2 2.2 2.6 1.8 4.8 3.3 5.7 3.8 1 0.5 1.9 0.8 2.6 0.2 0.9-0.6 1.6-2.2 2-5.5 0.3-2.2 1.3-3.1 2.7-3.1 1.7 0 3.8 1.4 5.4 2.9 0.6 0.6 1.2 1.2 1.5 2.2 0.4 1.5 0.9 3.2 0.5 5-0.2 1.4-1 2.8-2.6 4.2-1.2 1-2.9 2.1-5.2 3.1-4 1.7-7.8 1.8-11 0.8-3.3-1-6.1-3-8.4-5.5-2-2.2-3.6-4.6-4.6-6.9-1.2-2.5-1.7-4.7-1.4-5.6q0.1-0.1 0.1-0.2z"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m299.1 70.9c1.6-1.8 5 0.3 8.1 2.2q0.3 0.2 0.6 0.4c1.1 0.7 2.1 1.4 3.1 2.1 2.3 1.6 4.4 3 5.3 3.4 1 0.4 1.8 0.7 2.5 0.2 0.9-0.6 1.6-2.1 2.1-4.9 0.3-2 1.3-2.8 2.5-2.9 1.7-0.1 3.5 1 5.1 2.1 0.5 0.5 1.1 0.9 1.3 1.9 0.3 1.4 0.8 3 0.5 4.7-0.2 1.3-0.9 2.6-2.5 3.9-1.1 1-2.7 2-4.9 2.9-3.8 1.7-7.2 1.8-10.3 0.9-3.1-0.9-5.7-2.7-7.8-4.9-1.9-2.1-3.4-4.4-4.4-6.5-1.1-2.4-1.5-4.5-1.2-5.3q0-0.1 0-0.2z"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m300.6 71.7c1.4-1.5 4.5 0.7 7.3 2.5q0.3 0.2 0.6 0.4c0.9 0.6 1.9 1.3 2.8 1.9 2.1 1.5 4.1 2.6 5.1 3 0.8 0.4 1.6 0.6 2.2 0.2 1-0.6 1.7-1.9 2.3-4.4 0.3-1.8 1.3-2.5 2.4-2.7 1.6-0.2 3.4 0.4 4.6 1.4 0.6 0.2 1 0.6 1.2 1.5 0.3 1.3 0.7 2.8 0.5 4.4-0.3 1.3-0.9 2.5-2.3 3.8-1.1 0.9-2.6 1.8-4.6 2.7-3.6 1.5-6.8 1.7-9.7 0.9-2.8-0.7-5.3-2.4-7.3-4.4-1.8-1.9-3.2-4.1-4-6.1-1-2.2-1.5-4.1-1.2-4.9q0-0.1 0.1-0.2z"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m302 72.5c1.4-1.2 4.2 1.1 6.6 2.7q0.3 0.2 0.5 0.4 1.4 0.9 2.6 1.8c1.9 1.3 3.7 2.3 4.8 2.6 0.8 0.3 1.5 0.5 2.1 0.1 0.9-0.5 1.8-1.6 2.4-3.8 0.4-1.5 1.3-2.2 2.3-2.4 1.5-0.3 3.1 0 4.1 0.7 0.6-0.1 1 0.1 1.2 1 0.2 1.3 0.5 2.7 0.3 4.2-0.2 1.1-0.7 2.3-2.1 3.5-1 0.9-2.4 1.7-4.3 2.6-3.3 1.4-6.3 1.6-9 1-2.6-0.7-4.9-2.1-6.7-4-1.7-1.7-3-3.8-3.8-5.6-0.9-2.1-1.3-3.9-1.1-4.7q0.1-0.1 0.1-0.1z"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m303.4 73.3c1.3-1 3.8 1.5 5.9 2.9q0.2 0.2 0.5 0.4 1.2 0.9 2.3 1.7c1.7 1.2 3.4 2 4.5 2.3 0.7 0.2 1.4 0.3 2 0 0.9-0.5 1.8-1.4 2.4-3.3 0.5-1.3 1.4-1.9 2.3-2.1 1.3-0.4 2.7-0.5 3.7-0.1 0.5-0.2 0.9-0.2 1 0.7 0.1 1.2 0.5 2.5 0.3 3.8-0.2 1.1-0.7 2.2-1.9 3.3q-1.5 1.3-4 2.4c-3.1 1.4-5.9 1.6-8.4 1.1-2.4-0.5-4.5-1.8-6.2-3.4-1.6-1.6-2.7-3.6-3.5-5.3-0.8-1.9-1.1-3.6-0.9-4.3q0-0.1 0-0.1z"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m304.9 74c1.1-0.6 3.4 2.1 5.1 3.3q0.2 0.2 0.4 0.3 1.1 0.9 2.2 1.6c1.4 1 3 1.7 4.1 1.9 0.7 0.1 1.3 0.2 1.9 0 0.9-0.4 1.8-1.2 2.5-2.7 0.6-1.1 1.4-1.7 2.2-2 1.2-0.5 2.4-0.8 3.2-0.8 0.5-0.4 0.8-0.5 0.9 0.3 0.1 1.2 0.4 2.4 0.2 3.6-0.1 1-0.5 2.1-1.7 3.1q-1.3 1.1-3.7 2.2c-2.8 1.2-5.4 1.5-7.6 1.1-2.3-0.4-4.2-1.4-5.7-2.9-1.5-1.4-2.6-3.2-3.3-4.8-0.7-1.8-1-3.3-0.8-4q0-0.1 0.1-0.2z"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m306.3 74.8c1.1-0.3 3 2.5 4.4 3.5q0.2 0.2 0.4 0.4 1 0.8 1.9 1.4c1.2 0.9 2.7 1.4 3.8 1.5 0.6 0.1 1.2 0.1 1.7-0.1 1-0.3 1.9-1 2.7-2.1 0.6-0.8 1.4-1.4 2.1-1.7 1.1-0.6 2.1-1.3 2.8-1.6 0.4-0.6 0.7-0.9 0.7-0.1 0.1 1.1 0.3 2.3 0.2 3.3-0.1 1-0.5 2-1.6 2.9q-1.2 1.1-3.4 2c-2.6 1.2-4.9 1.5-6.9 1.3-2-0.3-3.8-1.2-5.2-2.5-1.4-1.3-2.3-2.9-2.9-4.4-0.7-1.6-0.9-3-0.8-3.7q0.1 0 0.1-0.1z"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m307.7 75.6c1-0.1 2.6 2.9 3.7 3.8q0.1 0.1 0.3 0.3 0.9 0.8 1.7 1.3c1.1 0.7 2.4 1 3.6 1.1q0.7 0.1 1.5-0.1c1-0.3 1.9-0.8 2.8-1.6 0.6-0.6 1.4-1 2-1.5 1-0.6 1.8-1.6 2.3-2.3 0.5-0.7 0.6-1.2 0.7-0.5 0 1.1 0.1 2.1 0.1 3.1-0.1 0.9-0.4 1.8-1.4 2.6q-1.2 1.1-3.1 1.9c-2.4 1-4.5 1.4-6.3 1.3-1.8-0.1-3.4-0.8-4.6-1.9-1.3-1.2-2.2-2.7-2.7-4.1-0.5-1.4-0.7-2.7-0.6-3.3q0-0.1 0-0.1z"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m324.5 81.5q-1 0.9-2.8 1.7-3.2 1.3-5.6 1.3-2.4 0-4.1-1.4c-1.2-1-1.9-2.4-2.4-3.6-0.4-1.3-0.6-2.5-0.5-3q0-0.1 0.1-0.1c0.8 0.2 2.2 3.4 2.9 4 0.6 0.6 1.2 1.1 1.7 1.5 1.2 0.8 2.9 0.9 4.7 0.6 1.7-0.4 3.5-1.2 4.8-2.3 0.8-0.8 1.4-2.1 1.8-3 0.4-1 0.6-1.6 0.6-0.9-0.1 1 0.1 1.9 0 2.8 0 0.8-0.3 1.6-1.2 2.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m220.8 111.1q-1 0-1.4-0.7c-0.8-1.2-0.3-4 1.6-8.2 0.6-1.4 1-3.6 1.5-6.5 1.2-7 3.1-17.7 10.6-24.5 4.3-4.1 9.4-7.4 14.5-9.7 5.2-2.3 10.3-3.6 14.9-3.6q1 0 1.9 0.1c2.8 0.3 9.9 3.2 10.6 4.9q0.1 0.4-0.2 0.7c-0.3 0.3-1.5 0.8-3.6 1.7-3.9 1.7-10.4 4.5-16.4 8.4-6.1 3.9-11.7 8.9-13.7 14.9-3.5 10.6-15.8 22.5-20.3 22.5zm41.7-52.8c-4.5 0-9.7 1.2-14.7 3.5-5.1 2.3-10.2 5.6-14.5 9.6-7.4 6.8-9.2 17.4-10.5 24.4-0.5 2.8-0.9 5.1-1.5 6.5-2.3 5.2-2.1 7.2-1.6 8q0.3 0.5 1.1 0.5c4.3 0 16.6-12 20-22.3 2-6.1 7.7-11.1 13.7-15 6.1-3.9 12.7-6.8 16.6-8.5 1.9-0.8 3.2-1.4 3.5-1.6q0.1-0.2 0.1-0.4c-0.6-1.6-7.7-4.4-10.3-4.7q-0.9 0-1.9 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eq",
    d: "m247.8 62.4c4.6-2.1 9.3-3.3 13.4-3.4q0.8 0 1.6 0c0.9 0.1 2.1 0.4 3.3 0.8 0.9 0.3 1.8 0.6 2.6 0.9 1.8 0.8 3.4 1.8 3.7 2.5 0.1 0.2 0.1 0.4 0 0.6-0.1 0.1-0.4 0.2-0.7 0.4q-0.8 0.4-2.6 1.1c-3.7 1.6-9.7 4.2-15.3 7.8q-1.4 0.9-2.8 1.9c-4.4 3.2-8.2 7.1-9.9 11.6-1.5 3.8-4.1 7.8-6.8 11.4-4.2 5.5-9 9.4-11.6 9.7q-0.5 0-0.9-0.2c-0.1-0.1-0.3-0.2-0.4-0.4-0.1-0.1-0.2-0.3-0.2-0.5-0.2-0.8 0-2 0.4-3.6q0.5-1.5 1.4-3.5 0.1-0.4 0.3-0.9c0-0.2 0.1-0.4 0.1-0.6 0.3-1.2 0.6-2.7 0.9-4.4 0.9-4.8 2-10.9 5.5-16.5 1.2-2.1 2.8-4.1 4.6-5.8 4.1-3.7 8.8-6.8 13.4-8.9zm0.1 0.3c-4.6 2.1-9.2 5.1-13.2 8.8-2 1.8-3.6 3.9-4.9 6.2-3.2 5.4-4.3 11.3-5.2 15.9-0.3 2-0.6 3.8-1 5.1-0.1 0.2-0.2 0.5-0.3 0.7q0 0.1 0 0.2c-0.8 1.8-1.3 3.3-1.6 4.4-0.4 1.6-0.3 2.4 0 2.9q0.3 0.4 1 0.4c2.4-0.2 6.9-3.9 11-9.1 2.9-3.7 5.6-7.8 7-11.7 1.8-4.6 5.7-8.5 10.1-11.7q1.4-1 2.8-1.9c5.5-3.6 11.5-6.2 15.2-7.8 1.7-0.7 2.9-1.2 3.2-1.5q0.1-0.1 0.1-0.3c-0.3-0.6-1.5-1.3-2.9-1.9-0.7-0.4-1.6-0.7-2.4-1-1.6-0.6-3.1-1-4-1q-0.8-0.1-1.7-0.1c-4 0.1-8.6 1.3-13.2 3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "er",
    d: "m248 63.2c4.1-1.9 8.2-3 11.8-3.1q0.8-0.1 1.5 0c0.8 0 1.8 0.2 2.9 0.6 0.8 0.2 1.6 0.4 2.3 0.7 1.5 0.6 3 1.5 3.4 2.1 0 0.1 0.1 0.3 0 0.5-0.1 0-0.4 0.2-0.6 0.3q-0.8 0.4-2.4 1.1c-3.4 1.4-8.8 3.8-14 7q-1.3 0.9-2.5 1.8c-4.1 2.9-7.6 6.4-9.4 10.4-1.5 3.4-3.9 7.1-6.2 10.4-3.7 5.3-7.7 8.7-10.3 9.2q-0.4 0-0.7-0.1c-0.2-0.1-0.4-0.1-0.5-0.2 0-0.2-0.1-0.4-0.1-0.6-0.1-0.7 0.1-1.8 0.5-3.2 0.3-1 0.7-2.1 1.2-3.2q0.1-0.4 0.3-0.9c0-0.1 0.1-0.4 0.1-0.5 0.3-1.2 0.5-2.5 0.8-4 0.8-4.5 1.9-9.8 5.4-14.9 1.2-1.9 2.6-3.6 4.3-5.2 3.8-3.4 8-6.2 12.2-8.2zm0.1 0.3c-4.1 2-8.3 4.7-12 8.1-1.8 1.7-3.3 3.5-4.6 5.5-3.2 5-4.3 10-5.1 14.3-0.3 1.8-0.6 3.4-0.9 4.7-0.1 0.1-0.2 0.4-0.2 0.6q-0.1 0.1-0.1 0.1-1 2.4-1.4 4.1c-0.3 1.4-0.3 2.2-0.1 2.6q0.3 0.3 0.9 0.3c2.4-0.4 6.1-3.7 9.7-8.7 2.4-3.4 4.9-7.1 6.4-10.6 1.8-4.1 5.3-7.6 9.4-10.5q1.2-0.9 2.5-1.7c5.1-3.3 10.5-5.6 13.9-7.1 1.4-0.6 2.5-1.1 2.9-1.3q0.1-0.2 0.1-0.3c-0.4-0.5-1.4-1.1-2.6-1.6-0.6-0.3-1.4-0.6-2.2-0.8-1.3-0.5-2.6-0.8-3.5-0.8q-0.7 0-1.5 0c-3.5 0.1-7.6 1.2-11.6 3.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "es",
    d: "m248.1 64.1c3.6-1.8 7.2-2.8 10.3-3q0.7 0 1.3 0c0.7 0 1.7 0.2 2.6 0.4 0.7 0.2 1.4 0.4 2 0.6 1.3 0.5 2.6 1.1 3 1.6 0.1 0.2 0.2 0.4 0.1 0.5 0 0-0.3 0.2-0.5 0.3q-0.8 0.3-2.2 0.9c-3.1 1.3-8 3.5-12.7 6.4q-1.2 0.8-2.3 1.6c-3.7 2.5-6.9 5.6-8.8 9.2-1.5 3-3.7 6.3-5.6 9.4-3.2 5-6.4 8-8.9 8.7q-0.4 0.1-0.7 0c-0.1 0-0.3 0-0.4-0.1 0-0.1 0-0.4-0.1-0.5 0-0.6 0.2-1.7 0.6-2.9 0.2-0.9 0.6-1.9 1-3q0.1-0.3 0.2-0.7c0.1-0.1 0.1-0.4 0.2-0.5 0.2-1.1 0.4-2.4 0.7-3.7 0.7-4.1 1.8-8.5 5.2-13.2 1.3-1.6 2.6-3.2 4.1-4.6 3.5-3.1 7.3-5.6 10.9-7.4zm0.2 0.3c-3.6 1.7-7.3 4.2-10.8 7.3-1.6 1.5-3 3.1-4.3 4.9-3.2 4.5-4.2 8.7-5 12.6-0.3 1.6-0.5 3-0.8 4.2-0.1 0.1-0.2 0.5-0.2 0.6q0 0 0 0.1c-0.6 1.3-1 2.6-1.3 3.7-0.3 1.2-0.3 1.9-0.2 2.4q0.3 0.2 0.9 0.1c2.2-0.6 5.2-3.5 8.2-8.2 2-3.2 4.2-6.5 5.8-9.6 1.8-3.6 5.1-6.7 8.7-9.3q1.1-0.8 2.3-1.5c4.6-2.9 9.4-5 12.5-6.4 1.3-0.5 2.3-0.9 2.7-1.2q0.1-0.1 0.1-0.2c-0.4-0.4-1.3-0.9-2.3-1.3-0.6-0.2-1.2-0.4-1.9-0.6-1.2-0.3-2.3-0.6-3.1-0.6q-0.6 0-1.3 0.1c-3.1 0.1-6.5 1.2-10 2.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "et",
    d: "m248.3 64.9c3.1-1.5 6.1-2.5 8.8-2.7q0.5-0.1 1.1-0.1c0.6 0 1.4 0.1 2.2 0.3 0.6 0.1 1.2 0.2 1.7 0.4 1 0.3 2.2 0.8 2.7 1.2 0 0.1 0.2 0.3 0.2 0.4-0.1 0-0.4 0.2-0.5 0.2q-0.8 0.3-2 0.9c-2.8 1.2-7.1 3.1-11.4 5.7q-1 0.6-2.1 1.3c-3.2 2.3-6.2 5-8.1 8.1-1.7 2.6-3.6 5.5-5.1 8.4-2.6 4.8-5.1 7.3-7.5 8.2q-0.4 0.1-0.6 0.1c-0.1 0-0.3 0-0.4 0 0-0.1 0-0.4 0-0.5 0-0.5 0.2-1.5 0.5-2.6 0.3-0.8 0.6-1.7 0.9-2.6q0.1-0.3 0.2-0.7c0-0.1 0.1-0.4 0.1-0.5q0.3-1.5 0.6-3.2c0.8-3.8 1.8-7.4 5.2-11.5 1.2-1.5 2.4-2.8 3.8-4 3.3-2.9 6.5-5.2 9.7-6.8zm0.1 0.3c-3.1 1.6-6.3 3.8-9.5 6.6-1.4 1.3-2.7 2.7-3.9 4.2-3.2 4-4.3 7.4-5 11-0.3 1.3-0.5 2.6-0.7 3.8-0.1 0.1-0.1 0.4-0.2 0.5q0 0 0 0.1c-0.4 1.1-0.8 2.3-1.1 3.3-0.2 1-0.3 1.7-0.3 2.1q0.3 0.1 0.8-0.1c2.2-0.7 4.4-3.2 6.9-7.7 1.6-2.9 3.5-5.8 5.1-8.5 1.9-3.1 4.8-5.8 8.1-8.1q1-0.7 2-1.3c4.1-2.6 8.4-4.5 11.2-5.7 1.1-0.5 2-0.8 2.4-1q0.1-0.1 0.1-0.2c-0.5-0.4-1.2-0.7-2-1-0.5-0.2-1.1-0.3-1.7-0.4-0.9-0.2-1.8-0.4-2.6-0.3q-0.5 0-1 0c-2.7 0.3-5.6 1.2-8.6 2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eu",
    d: "m248.5 65.8c2.6-1.4 5-2.3 7.2-2.6q0.5 0 0.9-0.1 0.9 0 1.9 0.1 0.7 0.1 1.4 0.2c0.8 0.2 1.8 0.6 2.3 0.9 0 0.1 0.3 0.2 0.3 0.3 0 0-0.4 0.1-0.4 0.2q-0.7 0.3-1.8 0.7c-2.5 1.1-6.3 2.7-10.1 5q-0.9 0.6-1.9 1.2c-2.8 1.9-5.5 4.2-7.5 6.8-1.7 2.4-3.4 4.9-4.5 7.5-2.1 4.6-3.7 6.5-6.2 7.7q-0.2 0.2-0.5 0.2c0 0-0.3 0.1-0.3 0.1 0 0 0-0.4 0-0.4 0-0.5 0.3-1.3 0.6-2.3 0.2-0.8 0.5-1.6 0.7-2.3q0.1-0.4 0.2-0.6c0-0.1 0.1-0.4 0.1-0.5q0.3-1.4 0.5-2.8c0.7-3.6 1.7-6.2 5.1-9.9q1.7-1.9 3.5-3.4 4.5-3.9 8.5-6zm0.1 0.3q-3.9 2.1-8.3 5.9c-1.2 1-2.4 2.2-3.6 3.5-3.2 3.5-4.2 6.1-4.9 9.3-0.2 1.1-0.4 2.2-0.6 3.3-0.1 0.1-0.1 0.4-0.1 0.5q-0.1 0-0.1 0.1c-0.2 0.8-0.6 1.9-0.9 2.9q-0.3 1.2-0.4 1.8 0.3 0 0.7-0.2c2.1-1 3.6-3 5.5-7.2 1.2-2.7 2.9-5.2 4.6-7.5 1.9-2.6 4.5-4.9 7.3-6.8q0.9-0.6 1.8-1.2c3.6-2.2 7.3-3.9 9.9-5 0.9-0.4 1.6-0.7 2.1-0.9q0.1 0 0.1-0.1c-0.5-0.3-1.2-0.5-1.7-0.7q-0.7-0.1-1.4-0.2c-0.7-0.1-1.5-0.2-2.2-0.1q-0.4 0-0.8 0.1c-2.2 0.3-4.5 1.1-7 2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ev",
    d: "m231.3 90.7v-0.4c0.1-0.4 0.4-1.1 0.6-1.9 0.3-1 0.7-2.1 0.8-2.6v-0.4c0.9-4.9 1.2-6.8 5.5-10.7 4-3.7 7.4-6.3 10.4-8.1 3-1.7 5.6-2.5 8-2.5q0.6 0 1.1 0c0.6 0.1 1.4 0.3 1.9 0.5l0.5 0.2-0.4 0.1c-2.5 1-7.3 3-12 6-4.7 3-9.3 7-10.9 12.1-1.6 4.6-2.5 6-5.2 7.5zm25.3-26.3c-2.3 0-4.9 0.8-7.8 2.6-3 1.7-6.4 4.3-10.4 8-4.2 3.8-4.5 5.7-5.3 10.5l-0.1 0.4c-0.1 0.5-0.4 1.6-0.8 2.6-0.1 0.6-0.3 1.2-0.4 1.6 2.3-1.4 3.2-2.8 4.7-7.2 1.6-5 6-9 10.6-12 4.6-3 9.4-5 12-6.1-0.6-0.2-1.1-0.3-1.4-0.3q-0.5-0.1-1.1-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m323.5 69.1q0 0 0 0c-1 0-1.8-0.4-2.5-1.2-0.8-0.8-1.8-2.6-1.6-6.2 0.4-7.6-2.8-10.6-6.9-14.4-1-0.9-2-1.9-3.1-3-4.5-4.6-7.8-11.6-7-14.9q0.3-1.1 1.3-1.5c1.7-0.5 4.2-0.8 7.6-0.8 5.8 0 12.4 0.8 14 1.2q1.1 0.2 1.8 1.3c1.4 2.1 1.6 6.2 0.6 10.7-0.9 3.8-0.6 9.9-0.3 15.3 0.1 3.3 0.3 6.4 0.1 8.7-0.2 3.1-2.2 4.8-4 4.8zm-12.2-41.7c-3.3 0-5.8 0.3-7.5 0.8q-0.8 0.3-1.1 1.3c-0.7 3.1 2.6 10.2 6.9 14.6 1.1 1.1 2.1 2.1 3.1 3 4.2 3.8 7.4 6.9 7 14.6-0.2 3.5 0.7 5.2 1.5 6 0.7 0.7 1.4 1 2.3 1 1.7 0 3.5-1.5 3.7-4.4 0.1-2.3 0-5.4-0.2-8.7-0.2-5.4-0.5-11.5 0.4-15.4 1-4.4 0.8-8.4-0.6-10.4q-0.6-1-1.6-1.2c-1.6-0.3-8.1-1.2-13.9-1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ew",
    d: "m304.1 28.3q0.1 0 0.1 0c0.4-0.1 0.9-0.1 1.4-0.1 0.7 0 1.6 0 2.5-0.1q1.2-0.1 2.4-0.1 0.8 0 1.5 0c3.6 0 7.5 0.3 10 0.6q0.4 0.1 0.7 0.1 0.4 0.1 0.7 0.2 0.3 0 0.5 0.1 0.9 0.2 1.5 1.1c0.8 1.1 1.1 2.7 1.1 5 0 1.4-0.2 3-0.5 4.7-0.3 1.7-0.4 3.9-0.3 6.2 0 2.5 0.2 5.2 0.4 7.8q0 0.4 0 0.8c0.2 2.7 0.3 5.3 0.2 7.2 0 1.8-0.7 3-1.6 3.8q-0.5 0.4-1.1 0.6c-0.2 0-0.4 0.1-0.6 0.1q0 0 0 0c-0.2 0-0.4-0.1-0.6-0.1q-0.9-0.2-1.6-1.1c-0.3-0.3-0.6-0.9-0.9-1.6-0.3-1.1-0.6-2.4-0.5-4.2 0.2-6.9-2.8-9.8-6.6-13.2-0.9-0.9-1.9-1.8-2.9-2.8q-0.2-0.2-0.5-0.4c-1.1-1.3-2.2-2.6-3.1-4-2.4-3.5-3.6-7.1-3.2-9.1q0.2-0.9 0.8-1.3 0.1-0.1 0.2-0.2zm0.2 0.3q-0.7 0.3-0.9 1.2c-0.4 2 0.9 5.6 3.2 9.1 1 1.4 2.1 2.8 3.3 4q0.1 0.1 0.2 0.2c1 1 2 1.9 2.9 2.7 3.8 3.5 6.9 6.4 6.7 13.4-0.1 2.8 0.5 4.4 1.2 5.3q0 0.2 0.1 0.3c0.6 0.6 1.2 1 1.9 1 1.4-0.1 3-1.5 3.1-4.1 0.1-1.7 0-3.9-0.2-6.3q0-0.8-0.1-1.7c-0.1-2.3-0.3-4.8-0.3-7.2-0.1-2.5 0-4.9 0.3-6.7 0.3-1.8 0.5-3.5 0.5-5.1 0-2-0.4-3.5-1-4.4q-0.6-0.9-1.4-1c-0.4-0.1-1.1-0.2-2-0.4-2.5-0.2-6.3-0.6-9.8-0.6q-0.7 0-1.5 0-1.2 0-2.4 0.1c-1 0.1-2 0.1-2.8 0.1q-0.6 0.1-1 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ex",
    d: "m304.6 28.8c0 0 0.1-0.1 0.1-0.1 0.4-0.1 0.8 0 1.4 0 0.7 0.2 1.6 0.3 2.6 0.2q1.3-0.1 2.5-0.1c0.5 0 1 0 1.5 0 3 0.1 6.2 0.3 8.2 0.6q0.3 0 0.6 0 0.3 0.1 0.6 0.2 0.2 0 0.4 0 0.7 0.2 1.3 1c0.6 0.9 1 2.2 0.9 4.5q0 2-0.4 4.3c-0.2 1.6-0.2 3.5-0.1 5.6 0.2 2.2 0.4 4.6 0.6 7q0 0.4 0 0.8c0.2 2.4 0.4 4.7 0.3 6.5 0 1.5-0.5 2.7-1.2 3.4q-0.4 0.4-0.9 0.6c-0.2 0.1-0.4 0.2-0.5 0.2-0.2 0-0.4-0.1-0.5-0.1q-0.8-0.3-1.4-1.1c-0.2-0.4-0.5-0.9-0.7-1.6-0.3-0.9-0.5-2.2-0.5-3.8 0-6.3-2.8-9-6.2-12.1-0.9-0.8-1.8-1.6-2.8-2.5q-0.2-0.2-0.4-0.4c-1.1-1.1-2.1-2.3-3.1-3.5-2.3-3.2-3.4-6.4-3.1-8.3q0.1-0.8 0.6-1.2c0.1 0 0.1-0.1 0.2-0.1zm0.2 0.3q-0.5 0.3-0.7 1.1c-0.3 1.8 0.9 5 3.2 8.1 0.9 1.3 2 2.5 3 3.6q0.2 0.1 0.3 0.2c0.9 0.8 1.8 1.6 2.7 2.4 3.5 3.2 6.4 5.8 6.3 12.2 0 2.4 0.5 3.9 1.1 4.9q0.1 0.1 0.1 0.2 0.7 1 1.6 1.2c1.1-0.3 2.3-1.7 2.4-4 0-1.5-0.1-3.5-0.3-5.6q0-0.7-0.1-1.5c-0.2-2.2-0.4-4.4-0.5-6.5-0.1-2.3-0.1-4.4 0.1-6.1 0.3-1.6 0.4-3.1 0.4-4.5 0-2.1-0.3-3.2-0.9-4q-0.4-0.7-1.1-0.8c-0.3-0.1-0.9-0.2-1.7-0.3-2-0.3-5.1-0.6-8-0.6-0.5 0-1 0-1.5 0q-1.3 0-2.5 0.2c-1.1 0.1-2.1-0.1-2.9-0.2-0.4 0-0.7-0.1-1 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ey",
    d: "m305 29.2c0 0 0.1-0.1 0.1-0.1 0.4-0.1 0.9 0.1 1.5 0.2 0.7 0.3 1.7 0.6 2.6 0.5q1.4-0.2 2.6-0.2c0.6 0 1.1 0 1.6 0 2.3 0.1 4.8 0.3 6.5 0.5 0.1 0 0.3 0 0.4 0.1 0.2 0 0.4 0 0.5 0.1q0.2 0 0.3 0 0.6 0.2 1 0.8c0.6 0.7 0.9 1.7 0.8 4q-0.1 1.8-0.2 3.9c-0.2 1.4-0.1 3.1 0.1 4.9 0.2 2 0.5 4.2 0.7 6.3q0 0.4 0 0.7c0.2 2.2 0.4 4.2 0.4 5.8 0 1.4-0.3 2.5-0.8 3.2q-0.3 0.4-0.7 0.6c-0.1 0.1-0.3 0.3-0.4 0.3-0.1 0-0.3-0.2-0.5-0.2q-0.5-0.3-1.1-1.1c-0.2-0.4-0.4-0.8-0.6-1.5-0.2-0.9-0.4-2.1-0.4-3.4-0.2-5.7-2.8-8.3-5.9-11-0.9-0.7-1.7-1.4-2.6-2.2q-0.2-0.2-0.4-0.4-1.5-1.5-2.9-3.1c-2.3-2.9-3.2-5.7-3.1-7.4q0.1-0.8 0.4-1.2c0 0 0-0.1 0.1-0.1zm0.3 0.3q-0.4 0.3-0.5 1c-0.1 1.7 0.8 4.5 3.1 7.3 0.9 1.1 1.9 2.1 2.9 3.1q0.1 0.1 0.2 0.1c0.9 0.8 1.7 1.5 2.5 2.2 3.2 2.8 5.9 5.3 6.1 11 0.1 2 0.5 3.4 0.9 4.5q0.1 0.1 0.1 0.2 0.6 0.9 1.3 1.2c0.8-0.4 1.7-1.7 1.7-3.7-0.1-1.4-0.2-3.1-0.4-5q0-0.7-0.1-1.4c-0.2-1.9-0.4-3.9-0.6-5.7-0.2-2-0.3-3.8-0.2-5.4q0.2-2.1 0.3-4c0-2.1-0.3-3-0.7-3.6q-0.4-0.5-0.9-0.6c-0.2-0.1-0.7-0.2-1.3-0.3-1.6-0.2-4.1-0.4-6.3-0.4-0.5-0.1-1-0.1-1.6-0.1q-1.2 0-2.6 0.2c-1 0.1-2.1-0.2-2.9-0.4-0.4-0.1-0.8-0.3-1-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ez",
    d: "m305.4 29.6c0 0 0.1 0 0.1 0 0.4-0.2 0.9 0 1.5 0.3 0.8 0.4 1.8 0.8 2.8 0.7q1.4-0.2 2.6-0.2c0.7 0 1.2 0.1 1.7 0.1 1.7 0.1 3.5 0.2 4.7 0.3 0.1 0 0.3 0 0.3 0.1 0.2 0 0.3 0 0.4 0.1q0.1 0 0.2 0 0.4 0.2 0.7 0.6c0.5 0.5 0.8 1.2 0.7 3.5q-0.1 1.7-0.1 3.4c0 1.3 0.1 2.8 0.4 4.4 0.2 1.7 0.5 3.6 0.8 5.5q0 0.3 0 0.6c0.3 1.9 0.5 3.7 0.5 5.2 0.1 1.2-0.1 2.2-0.5 2.9q-0.1 0.4-0.4 0.6c-0.1 0-0.3 0.3-0.3 0.3-0.1 0-0.3-0.2-0.4-0.2q-0.4-0.3-0.9-1.1c-0.1-0.4-0.3-0.8-0.4-1.4q-0.3-1.4-0.4-3.1c-0.4-5.1-2.8-7.4-5.6-9.9q-1.2-0.9-2.4-1.9-0.2-0.2-0.3-0.4-1.5-1.2-2.8-2.6c-2.4-2.6-3.1-5-3.1-6.6q0-0.6 0.2-1.1c0 0 0-0.1 0-0.1zm0.3 0.3q-0.2 0.3-0.2 0.9c0 1.6 0.8 3.9 3.1 6.4q1.3 1.4 2.7 2.7 0.1 0 0.2 0.1 1.2 1 2.3 1.9c2.9 2.5 5.3 4.8 5.8 9.8 0.1 1.7 0.4 3 0.8 4q0 0.1 0 0.2 0.4 1 1 1.3c0.5-0.6 1-1.7 0.9-3.4 0-1.3-0.2-2.8-0.4-4.4q0-0.6-0.1-1.2c-0.2-1.7-0.5-3.4-0.7-5-0.3-1.7-0.5-3.3-0.4-4.7q0-1.9 0.1-3.6c0.1-2-0.2-2.7-0.6-3.1q-0.2-0.3-0.6-0.4-0.3-0.1-0.9-0.3c-1.3-0.1-3-0.3-4.6-0.3-0.5 0-1-0.1-1.7-0.1q-1.1 0-2.6 0.2c-1.1 0.2-2.2-0.3-3-0.7-0.4-0.2-0.8-0.3-1.1-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eA",
    d: "m305.8 30c0 0 0.2 0 0.2 0 0.3-0.2 0.9 0.1 1.5 0.5 0.8 0.5 1.8 1.1 2.8 0.9q1.6-0.2 2.8-0.2c0.7 0 1.2 0.1 1.7 0.1 1 0.1 2.1 0.2 3 0.2 0 0 0.1 0.1 0.2 0.1 0 0 0.1 0 0.1 0q0.1 0.1 0.2 0.1 0.2 0.1 0.4 0.3c0.5 0.4 0.7 0.9 0.6 3.1q-0.1 1.5 0 3c0.1 1.2 0.4 2.4 0.6 3.8 0.3 1.4 0.7 3 1 4.7q0 0.3 0.1 0.6c0.2 1.6 0.4 3.2 0.5 4.5 0.1 1 0.1 1.9-0.1 2.5q0 0.4-0.2 0.7c-0.1 0-0.2 0.3-0.2 0.3-0.1 0-0.3-0.2-0.3-0.3-0.2-0.1-0.4-0.5-0.6-1-0.2-0.4-0.3-0.8-0.4-1.3q-0.2-1.4-0.4-2.8c-0.5-4.4-2.7-6.6-5.2-8.7q-1-0.9-2.1-1.7-0.2-0.1-0.4-0.3-1.3-1-2.6-2.2c-2.4-2.3-3-4.3-3.1-5.7q-0.1-0.6-0.1-1c0-0.1 0-0.2 0-0.2zm0.4 0.3q-0.1 0.3 0 0.8c0.1 1.5 0.7 3.4 3 5.6q1.3 1.2 2.6 2.2 0.1 0 0.2 0.1 1 0.8 2 1.6c2.6 2.1 4.9 4.3 5.5 8.6 0.2 1.3 0.4 2.5 0.7 3.6q0 0.1 0 0.2 0.3 0.9 0.6 1.3c0.3-0.7 0.5-1.8 0.3-3.2-0.1-1.1-0.3-2.4-0.5-3.7q0-0.5-0.1-1c-0.3-1.6-0.6-3-0.9-4.3-0.3-1.5-0.5-2.8-0.6-4q-0.1-1.6 0-3.1c0.1-2.1-0.1-2.4-0.4-2.7q-0.2-0.2-0.4-0.2-0.2-0.1-0.6-0.2c-0.8-0.1-1.8-0.2-2.8-0.3-0.5 0-1-0.1-1.7-0.1q-1.2 0-2.8 0.3c-1 0.1-2.1-0.5-3-1-0.4-0.3-0.8-0.5-1.1-0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eB",
    d: "m320.5 52.5l-0.2-0.4c-0.2-0.3-0.5-0.9-0.6-2.2-0.6-6.8-4-9.2-7.6-11.7-0.8-0.6-1.6-1.2-2.4-1.8-2.5-1.9-2.8-3.6-3.2-4.9q-0.1-0.5-0.2-0.9v-0.2h0.1c0.4-0.1 0.9 0.2 1.6 0.7 0.8 0.6 1.9 1.3 2.9 1.2q1.6-0.3 2.8-0.3c0.8 0 1.3 0.1 1.8 0.2 0.4 0 0.8 0.1 1.2 0.1h0.1c0.1 0.2 0.2 0.2 0.3 0.2 0.4 0.2 0.6 0.4 0.4 2.6-0.2 1.9 0.4 3.7 1 5.8 0.4 1.3 0.9 2.7 1.2 4.4 0.4 2.3 0.8 4.5 0.9 6.1q0.1 0.4 0 0.7zm-13.8-21.8q0.1 0.4 0.2 0.8c0.3 1.3 0.6 2.8 3 4.7q1.2 0.9 2.4 1.7c3.7 2.6 7.1 5 7.7 12 0.1 0.7 0.2 1.2 0.3 1.5-0.1-1.5-0.5-3.7-0.9-6-0.4-1.6-0.8-3-1.2-4.4-0.6-2.1-1.2-3.9-1-5.9 0.1-2.1-0.1-2.2-0.2-2.2-0.1-0.1-0.3-0.1-0.4-0.3-0.4 0-0.8 0-1.1-0.1-0.5 0-1-0.1-1.8-0.1q-1.1 0-2.8 0.2c-1.1 0.2-2.2-0.6-3.1-1.2-0.4-0.3-0.9-0.6-1.1-0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "J",
    d: "m245.3 111.4q0 0 0 0h-0.1c-5.3-0.1-8.3-1.2-9.1-3.4-1.7-4.8 8.5-13.8 15.3-19.8 1.2-1.1 2.4-2.1 3.3-2.9 3.3-3 4.5-7.9 5.6-12.6 1.5-6.2 2.9-11.9 8.9-11.9q0.7 0 1.5 0.1c6.5 0.9 7.7 5.4 9.1 10.7 1.2 4.6 2.6 9.8 8.1 13.2 6 3.7 8.9 7.1 8.1 9.6-0.6 2.4-4.3 3.6-10.7 3.6q-1.1 0-2.2 0-0.6-0.1-1.1-0.1c-9.6 0-18.8 5.1-26.1 9.1-4.6 2.5-8.2 4.4-10.6 4.4zm23.9-50.3c-5.8 0-7.1 5.4-8.6 11.6-1.1 4.8-2.3 9.7-5.7 12.8-0.9 0.9-2.1 1.9-3.3 3-6.7 5.9-16.9 14.8-15.1 19.4 0.7 2 3.6 3.1 8.7 3.2h0.1q0 0 0 0c2.3 0 5.9-1.9 10.4-4.4 7.7-4.2 17.3-9.5 27.4-9.1q1.1 0.1 2.2 0.1c6.1 0 9.8-1.2 10.4-3.4 0.7-2.3-2.2-5.7-7.9-9.2-5.7-3.5-7.1-8.8-8.4-13.4-1.3-5.2-2.5-9.6-8.7-10.5q-0.8-0.1-1.5-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eC",
    d: "m269.2 64.4q0.6 0 1.2 0.1 0.6 0 1.1 0.2c4.4 1 5.4 4.3 6.5 8.8 1.2 4.2 2.5 9.1 7.7 12.3 3.3 2 5.5 4 6.4 5.7 0.2 0.3 0.3 0.6 0.4 0.9 0.1 0.3 0 0.6-0.1 0.9q0 0.1 0 0.2c-0.7 1.8-3.9 2.8-9 2.7q-0.6 0-1.3 0-0.3 0-0.6 0-0.5 0-1 0c-8.4 0.1-16.4 4.3-22.8 7.8-1.8 1-3.5 1.9-5 2.6-1.6 0.8-3 1.3-4.2 1.4q0 0 0 0c0 0 0 0 0 0-2 0.1-3.5 0.1-4.7-0.2q0 0 0 0 0 0-0.1 0-2.2-0.6-3.1-1.8c0-0.1-0.1-0.2-0.1-0.3-0.1-0.1-0.1-0.3-0.1-0.4-0.3-2.5 2.7-6.1 6.3-9.6 1.5-1.4 3-2.7 4.3-4 1.1-1 2.4-2 3.6-3q0.6-0.5 1.1-0.9 1-0.9 1.8-1.6c0.8-0.6 1.4-1.3 1.9-2q0.8-1.2 1.5-2.6c0.9-1.9 1.5-3.9 1.9-6.2q0.2-1.4 0.4-2.8c0.8-4.3 2.1-7.8 6-8.2zm0 0.3c-3.6 0.2-4.9 3.6-5.6 7.9q-0.3 1.4-0.5 2.9c-0.4 2.4-1 4.6-2.1 6.7q-0.7 1.3-1.6 2.5-0.6 0.9-1.6 1.7c-0.6 0.6-1.4 1.3-2.2 1.9q-0.4 0.3-0.8 0.6c-1.2 1.1-2.6 2.2-3.8 3.3-1.5 1.3-3 2.7-4.4 4.1-3.5 3.4-6.3 6.9-5.8 9.2q0.7 1.4 3 2c1.1 0.3 2.7 0.3 4.6 0.3 0 0 0 0 0 0q0 0 0 0c1.4-0.2 3.3-1 5.5-2.2q1.6-0.8 3.3-1.7c6.6-3.6 14.7-8 23.3-7.9q1 0 1.9 0c3.1-0.1 5.5-0.4 7.2-1.1q0.8-0.3 1.3-0.8 0.3-0.3 0.5-0.7c0.5-1.1 0-2.6-1.5-4.1q-1.7-1.6-4.4-3.2c-5.3-3.3-6.6-8.3-7.8-12.5-1.2-4.6-2.1-7.9-6.9-8.8q-0.2 0-0.3 0-0.4-0.1-0.7-0.1-0.3 0-0.6 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eD",
    d: "m269.2 68.1q0.5-0.1 1-0.1 0.4 0.1 0.8 0.2c3.5 0.7 4.2 3.1 5.3 7.2 1 3.8 2.3 8.4 7.2 11.4 2.5 1.6 4.2 3 5.1 4.4 0.1 0.2 0.3 0.5 0.3 0.6 0 0.3-0.1 0.5-0.2 0.7q0 0 0 0.1c-0.8 1.3-3.3 1.9-7.1 1.9q-0.6 0-1.2 0-0.2-0.1-0.5-0.1-0.4 0-0.8 0c-7.2 0.2-14 3.7-19.6 6.6-1.5 0.9-2.9 1.6-4.2 2.3-1.3 0.6-2.6 1.1-3.6 1.3q0 0 0 0c0 0 0 0 0 0-1.7 0.3-3 0.4-3.9 0.2q-0.1 0-0.1 0 0 0 0 0-1.9-0.4-2.8-1.3c0 0-0.1-0.1-0.1-0.2-0.1-0.1 0-0.2-0.1-0.3 0.1-2.2 2.9-5.2 6.1-8 1.3-1.1 2.7-2.2 3.8-3.3 0.8-0.7 2-1.6 3.1-2.5q0.5-0.4 1.1-0.7 0.8-0.7 1.6-1.3c0.7-0.6 1.3-1.2 1.6-1.7q0.9-1.1 1.5-2.1c1.1-1.6 1.6-3.1 1.7-5.2 0.1-0.8 0.2-1.6 0.2-2.4 0.1-3.9 1-7 3.8-7.7zm0.1 0.3c-2.6 0.3-3.5 3.4-3.6 7.3 0 0.9-0.1 1.7-0.1 2.5-0.2 2.3-0.8 3.9-1.9 5.7q-0.7 1-1.6 2.1-0.5 0.6-1.4 1.4c-0.6 0.4-1.3 1-2 1.5q-0.3 0.3-0.6 0.5c-1.3 1-2.6 1.9-3.5 2.8-1.1 1-2.5 2.2-3.9 3.3-3 2.8-5.6 5.6-5.5 7.6q0.6 1 2.6 1.4c0.8 0.1 2.1 0.1 3.7-0.1 0 0 0 0 0 0q0 0 0 0c1.2-0.2 2.8-1 4.5-1.9q1.3-0.6 2.7-1.4c5.4-3 12.1-6.5 19.2-6.7q0.8-0.1 1.6-0.1c2.4-0.1 4.4-0.3 5.9-0.8q0.7-0.2 1.1-0.6 0.3-0.2 0.5-0.4c0.7-0.8 0.7-1.7-0.1-2.8q-1.4-1.3-3.6-2.6c-5-3.1-6.3-7.8-7.3-11.6-1.1-4.2-1.8-6.5-5.4-7.1q-0.2 0-0.3 0-0.3-0.1-0.6-0.1-0.2 0-0.4 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eE",
    d: "m269.2 71.8q0.3-0.2 0.7-0.2 0.3 0 0.6 0.1c2.6 0.5 3.1 1.9 4.1 5.6 0.9 3.4 2.1 7.7 6.7 10.5 1.7 1.1 3 2.1 3.7 3 0.1 0.1 0.3 0.4 0.3 0.5 0 0.1-0.2 0.3-0.2 0.3q-0.1 0.1-0.1 0.1c-0.8 0.8-2.7 1.1-5.3 1q-0.5 0-0.9 0-0.3 0-0.5 0-0.3 0-0.7 0c-6 0.2-11.6 2.9-16.3 5.4-1.2 0.6-2.4 1.3-3.5 1.8-1 0.5-2 1-2.8 1.3q-0.1 0-0.1 0c-1.3 0.4-2.5 0.7-3.2 0.6q0 0 0 0 0 0 0 0-1.6-0.2-2.4-0.7c-0.1-0.1-0.2-0.1-0.2-0.2-0.1 0 0-0.2 0-0.2 0.4-1.8 3.1-4.1 5.8-6.3 1.2-0.9 2.4-1.9 3.3-2.6 0.5-0.6 1.6-1.3 2.7-2q0.4-0.4 0.9-0.7 0.7-0.5 1.4-1c0.7-0.5 1.3-0.9 1.5-1.2 0.6-0.7 1-1.2 1.5-1.7 1.1-1.3 1.6-2.2 1.5-4.2q0-1-0.2-2.1c-0.5-3.4 0.1-6.3 1.7-7.1zm0.2 0.2c-1.6 0.5-2.1 3.4-1.6 6.9q0.2 1.1 0.2 2c0.2 2.2-0.5 3.3-1.7 4.7q-0.6 0.7-1.4 1.6c-0.3 0.3-0.7 0.7-1.3 1.1-0.5 0.3-1.1 0.8-1.8 1.2q-0.2 0.2-0.5 0.4c-1.2 0.8-2.4 1.6-3 2.2-0.9 0.8-2.2 1.7-3.4 2.7-2.5 2-5 4.3-5.4 5.9q0.7 0.6 2.2 0.8c0.6 0 1.7-0.2 2.9-0.5q0 0 0 0c1-0.3 2.3-0.9 3.5-1.6q1-0.5 2.1-1.1c4.3-2.3 9.6-5.1 15.1-5.6q0.7 0 1.2-0.1c1.8-0.2 3.4-0.3 4.8-0.6q0.5-0.1 0.9-0.2 0.3-0.1 0.5-0.3c0.8-0.4 1.2-0.8 1.2-1.4q-1.1-1-2.8-2c-4.7-2.9-5.9-7.3-6.8-10.7-1-3.7-1.5-5-4-5.4q-0.1-0.1-0.2-0.1-0.2 0-0.4 0c-0.1 0-0.3 0.1-0.3 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eF",
    d: "m255.7 98.8h-0.1q-1.2 0-2-0.2h-0.2l0.1-0.2c0.8-1.5 3.2-3.1 5.4-4.6 1.1-0.7 2.2-1.5 2.8-2 0.4-0.4 1.8-1.2 3.1-2 1.2-0.7 2.4-1.4 2.6-1.6 0.5-0.5 1-0.9 1.4-1.2 1.6-1.2 2.1-1.6 0.8-4.9-1-3-1.1-5.8-0.4-6.7 0.1-0.2 0.3-0.2 0.4-0.2q0.2 0 0.5 0c1.6 0.2 1.9 0.8 2.8 4.1 0.8 2.9 1.9 6.9 6.1 9.5q1.5 0.9 2.5 1.7l0.2 0.3h-0.3q-1.4 0.2-3.5 0.1-0.4 0-0.8 0c-6.4 0-12.3 3.3-16.7 5.7-1.8 0.9-4 2.1-4.7 2.2zm-1.8-0.5q0.7 0.2 1.8 0.2c0.7-0.1 3-1.4 4.5-2.2 4.4-2.4 10.5-5.7 16.9-5.7q0.4 0 0.8 0 1.8 0.1 3.1-0.1-0.9-0.7-2.1-1.4c-4.4-2.7-5.5-6.8-6.3-9.8-0.9-3.3-1.2-3.6-2.6-3.8q-0.2 0-0.4 0c-0.1 0-0.1 0.1-0.2 0.1-0.5 0.7-0.5 3.3 0.6 6.4 1.2 3.5 0.6 4-1 5.3-0.4 0.3-0.8 0.6-1.4 1.1-0.2 0.3-1.3 0.9-2.6 1.7-1.3 0.7-2.7 1.6-3 1.9-0.7 0.6-1.8 1.3-2.9 2.1-2.1 1.4-4.4 2.9-5.2 4.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m262.3 146.8q0 0 0 0c-9.2 0-17.4-10-18.8-15.5-0.5-1.9-0.2-3.2 0.8-3.8 6.8-3.7 16.9-6 26.4-6 9.3 0 16 2.2 17.9 5.9 0.9 1.8 1.2 3.3 0.7 4.7-1 3.1-5.4 5.3-11.4 8.2-2.8 1.3-6.1 2.9-9.4 4.8q-3 1.7-6.2 1.7zm8.4-24.9c-9.5 0-19.5 2.2-26.2 5.9-0.9 0.5-1.1 1.7-0.7 3.4 1.4 5.4 9.4 15.3 18.5 15.3q3.1 0 6-1.7c3.4-1.9 6.6-3.5 9.5-4.8 5.9-2.9 10.2-5 11.2-8 0.4-1.3 0.2-2.8-0.7-4.5-1.9-3.5-8.5-5.6-17.6-5.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eG",
    d: "m286.5 128.3c0.9 1.6 1.1 2.9 0.7 4.1q0 0.1-0.1 0.3c-0.8 2.7-4.5 4.4-10.4 7.2-1.9 0.9-3.9 1.9-6.1 3-0.8 0.4-1.7 0.9-2.5 1.4-1.5 0.8-3.2 1.3-4.9 1.4q-0.4 0-0.8 0 0 0 0 0c-4.9 0-9.3-2.7-12.5-6-2.5-2.7-4.1-5.6-4.6-7.7-0.1-0.1-0.1-0.2-0.1-0.4 0-0.1 0-0.2 0-0.3-0.1-1.2 0.3-2 1.1-2.4 2.9-1.3 6.4-2.5 10.2-3.3q2.3-0.5 4.8-0.9c2.8-0.4 5.7-0.7 8.7-0.7q0.1 0 0.3 0c2.8 0 5.4 0 7.6 0.3 3.4 0.4 6 1.3 7.5 2.7q0.7 0.6 1.1 1.3zm-0.3 0.2q-0.3-0.5-0.7-0.9c-1.4-1.4-3.8-2.4-7.1-2.9-2.3-0.3-5.1-0.4-8.1-0.4-3 0-6 0.3-8.8 0.7q-2.6 0.4-5.1 1c-3.6 0.8-7 1.9-9.9 3.2-0.9 0.4-1.2 1.4-0.9 2.8 0.5 1.9 1.9 4.5 4.2 7 3.1 3.4 7.6 6.4 12.6 6.4q0.4 0 0.8-0.1c1.6-0.1 3.2-0.5 4.7-1.4 0.8-0.4 1.8-0.9 2.5-1.3 2.2-1.1 4.2-2.1 6.1-3 5.7-2.7 9.4-4.5 10.3-7q0.1-0.4 0.2-0.7c0.2-1-0.1-2.1-0.8-3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eH",
    d: "m284.4 129.3c0.9 1.5 1 2.7 0.6 3.7q0 0.2-0.1 0.3c-0.6 2.2-3.6 3.6-9.4 6.3q-2.6 1.1-5.6 2.6c-0.6 0.3-1.6 0.8-2.2 1.2-1.3 0.7-2.9 1.1-4.4 1.2q-0.4 0-0.7 0 0 0 0 0c-4.6 0-8.5-2.2-11.3-5-2.5-2.5-3.9-5.1-4.2-6.9-0.1-0.1-0.1-0.2-0.1-0.3 0-0.1 0-0.2 0-0.3 0.1-0.9 0.5-1.5 1.2-1.8 2.8-1 5.9-1.8 9.2-2.4q2.1-0.5 4.4-0.8c2.5-0.4 5.1-0.6 7.8-0.6q0.2 0 0.3 0c2.4-0.1 4.7-0.2 6.8-0.1 2.9 0.1 5.3 0.6 6.7 1.7q0.6 0.5 1 1.2zm-0.3 0.1q-0.2-0.4-0.6-0.7c-1.3-1.1-3.5-1.8-6.4-1.9-2.2-0.1-4.7 0-7.3 0-2.7 0-5.4 0.3-7.9 0.6q-2.3 0.4-4.5 0.8c-3.2 0.7-6.3 1.5-9 2.4-0.8 0.3-1.1 1.1-1 2.2 0.4 1.6 1.6 3.9 3.8 6.2 2.7 2.9 6.8 5.2 11.4 5.2q0.3 0 0.7 0c1.4-0.1 3-0.4 4.3-1.1 0.6-0.4 1.6-0.9 2.2-1.2q3-1.5 5.5-2.6c5.3-2.5 8.6-4.1 9.3-6.1q0.1-0.3 0.2-0.7c0.2-0.8 0.1-1.8-0.7-3.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eI",
    d: "m282.3 130.2c1 1.4 1 2.5 0.5 3.4q0 0.2-0.1 0.3c-0.5 1.7-2.7 2.7-8.5 5.3q-2.2 1-4.9 2.3c-0.4 0.2-1.5 0.7-2 1-1.1 0.6-2.6 0.9-3.9 1q-0.4 0-0.6 0 0 0 0 0 0 0 0 0c-4.3 0-7.8-1.7-10.2-4-2.4-2.3-3.5-4.6-3.7-6.1-0.1 0-0.1-0.2-0.1-0.3 0 0 0.1-0.1 0.1-0.2 0.2-0.6 0.6-1.1 1.2-1.2 2.7-0.6 5.4-1.1 8.3-1.6 1.3-0.2 2.5-0.4 3.9-0.6 2.1-0.3 4.4-0.5 6.9-0.5q0.2 0 0.3 0c2-0.1 4-0.4 5.9-0.6 2.6-0.2 4.7 0.1 6 0.9q0.6 0.3 0.9 0.9zm-0.2 0.2q-0.3-0.4-0.7-0.6c-1.1-0.9-3.1-1.2-5.6-1-2 0.1-4.2 0.5-6.4 0.5-2.5 0-4.8 0.2-7 0.5-1.4 0.2-2.7 0.4-4 0.7q-4.2 0.7-8 1.6c-0.7 0.1-1.1 0.7-1.2 1.4 0.3 1.4 1.3 3.4 3.4 5.4 2.4 2.4 5.9 4.2 10.2 4.2q0.2 0 0.6 0c1.2 0 2.7-0.3 3.8-0.9 0.4-0.3 1.5-0.8 2-1q2.6-1.3 4.8-2.3c5.1-2.3 7.8-3.5 8.4-5.1q0-0.3 0.2-0.6c0.3-0.8 0.2-1.6-0.5-2.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eJ",
    d: "m280.3 131.1c0.9 1.4 0.8 2.4 0.3 3.1 0 0.1 0 0.2-0.1 0.2-0.3 1.3-1.8 2-7.5 4.5q-1.9 0.8-4.3 1.9c-0.3 0.2-1.4 0.6-1.7 0.8-1 0.5-2.4 0.7-3.5 0.8q-0.4 0-0.5 0 0 0 0 0c-4 0-7-1.2-9.1-3.1-2.2-1.9-3.1-4-3.2-5.2-0.1 0 0-0.2 0-0.2-0.1-0.1 0.1-0.1 0.1-0.1 0.2-0.4 0.7-0.7 1.3-0.7 2.5-0.2 4.9-0.4 7.3-0.7 1.1-0.2 2.2-0.3 3.4-0.5 1.8-0.2 3.8-0.4 6.1-0.4q0.1 0 0.2 0c1.6-0.1 3.4-0.7 5-1 2.2-0.5 4.1-0.6 5.3-0.1q0.5 0.3 0.9 0.7zm-0.3 0.2q-0.2-0.3-0.6-0.4c-1.1-0.6-2.9-0.5-4.9-0.1-1.8 0.4-3.7 1-5.5 1-2.3 0-4.3 0.2-6.1 0.4-1.3 0.2-2.4 0.4-3.5 0.5-2.4 0.3-4.7 0.6-7.1 0.8-0.6 0.1-1.1 0.4-1.3 0.8 0.2 1.1 1 2.8 3 4.6 2 1.9 5.1 3.1 9 3.1q0.1 0 0.5 0c0.9 0 2.4-0.2 3.3-0.7 0.3-0.2 1.5-0.7 1.8-0.8q2.3-1.1 4.2-1.9c4.8-2.1 7-3.1 7.4-4.2 0-0.2 0.1-0.3 0.2-0.6 0.3-0.6 0.4-1.3-0.4-2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eK",
    d: "m278.2 132.1c1 1.3 0.7 2.1 0.3 2.7-0.1 0.1-0.1 0.2-0.2 0.2-0.1 0.8-0.9 1.2-6.5 3.5q-1.7 0.7-3.7 1.6c-0.2 0.1-1.4 0.5-1.5 0.6-0.8 0.4-2.1 0.5-3 0.5q-0.4 0.1-0.4 0.1 0 0 0 0c-3.7 0-6.3-0.7-8-2.1-2.1-1.7-2.7-3.5-2.7-4.3-0.1-0.1 0-0.3 0-0.3 0 0 0.1 0 0.1 0q0.6-0.2 1.4-0.1c2.4 0.2 4.4 0.3 6.3 0.1 1-0.1 1.9-0.2 3-0.3 1.5-0.2 3.1-0.3 5.2-0.3q0.1 0 0.2 0c1.2-0.1 2.7-0.9 4.2-1.5 1.8-0.7 3.4-1.2 4.4-1q0.6 0.2 0.9 0.6zm-0.3 0.2q-0.2-0.3-0.6-0.4c-0.9-0.2-2.5 0.3-4.1 1-1.7 0.6-3.3 1.4-4.6 1.4-2.1 0-3.8 0.2-5.3 0.4-1 0.1-2 0.2-3 0.3-1.9 0.1-3.8 0.1-6-0.1q-0.9 0-1.5 0.2c0.1 0.8 0.7 2.3 2.6 3.8 1.6 1.3 4.2 2 7.8 2q0.1 0 0.4 0c0.7 0 2.1-0.1 2.8-0.5 0.2-0.1 1.4-0.6 1.5-0.6q2-0.9 3.6-1.6c4.6-1.9 6.2-2.6 6.5-3.2 0-0.1 0.1-0.3 0.2-0.5 0.4-0.5 0.5-1.2-0.3-2.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eL",
    d: "m263.7 140.1q-0.3 0-0.4 0 0 0 0 0c-3.3 0-5.4 0-6.8-1-2-1.5-2.4-3-2.3-3.5l0.1-0.2h0.2c3 1.1 5 1.5 6.8 1.5 0.8 0 1.6-0.1 2.5-0.2 1.1-0.1 2.4-0.2 4.3-0.2 0.9 0 2.2-1 3.5-1.9 1.4-1 2.8-1.9 3.7-1.9q0.5 0 0.8 0.3c1.1 1.2 0.6 2 0.2 2.4-0.1 0.1-0.1 0.2-0.2 0.2 0 0.4 0 0.4-8.7 3.8l-1.2 0.5c-0.6 0.2-1.8 0.2-2.5 0.2zm-9.1-4.3c0 0.6 0.4 1.8 2.1 3 1.3 0.9 3.5 1 6.7 1q0 0 0.3 0c0.5 0 1.8 0 2.4-0.3l1.2-0.5c6.8-2.6 8.4-3.2 8.5-3.4 0-0.1 0-0.2 0.2-0.4 0.4-0.4 0.7-1-0.2-1.9q-0.2-0.3-0.5-0.3c-0.8 0-2.2 1-3.5 1.9-1.4 1-2.7 1.9-3.7 1.9-1.8 0-3.1 0.1-4.3 0.3-0.9 0-1.7 0.1-2.5 0.1-1.8 0-3.8-0.4-6.7-1.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m326.4 122.2c-1.2 0-1.9-0.7-2-2-0.8-9.3 2-20.3 6.2-30.3 4.2-10 9.8-19.1 14.5-24.4 3.5-3.8 6.5-5.9 8.9-5.9 2.6-0.1 4.6 0.9 5.8 2.8 3.2 5 1.1 16-5.7 30.4-3.9 7.9-9.5 15.3-14.8 20.7-5.2 5.3-10.2 8.7-12.9 8.7zm27.8-62.3q-0.1 0-0.2 0c-2.3 0-5.3 2.1-8.7 5.8-4.7 5.3-10.3 14.3-14.4 24.3-4.2 10-7 21-6.2 30.2q0.1 1.7 1.7 1.7c2.6 0 7.5-3.4 12.8-8.7 5.2-5.3 10.8-12.6 14.6-20.6 6.7-14.2 8.9-25.1 5.8-30q-1.7-2.7-5.4-2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m345.8 68.2c3-3.7 5.8-5.9 7.9-6.3 2-0.4 3.5 0 4.7 1q0.4 0.3 0.8 0.7c0.7 0.9 1 2.1 1.2 3.4 0.4 2.5 0 5.9-1.2 10.2-1.1 4.1-2.9 8.8-5.5 14.2-2.4 5-5.6 9.9-9 14.2-1.4 1.8-2.9 3.4-4.3 4.9-3.2 3.4-6.3 5.9-8.7 7.3-1.2 0.7-2.1 1.1-2.9 1.4q-0.3 0.1-0.6 0.1-1.2 0.1-1.7-0.7c-0.1-0.2-0.2-0.3-0.2-0.6 0-0.4-0.1-0.9-0.1-1.4-0.2-8.5 2.5-17.6 6.3-26.1 1.8-3.9 3.8-7.7 5.8-11.2 2.5-4.1 5.1-8.1 7.5-11.1zm0.2 0.2c-2.5 3.2-5.3 7.4-7.8 11.9-1.9 3.2-3.7 6.7-5.3 10.2q-0.4 0.8-0.7 1.6c-3.7 8.5-6.1 17.5-5.6 25.6q0.2 1 0.9 1.1 0.3 0.1 0.7 0c0.7 0 1.6-0.4 2.9-1 2.4-1.3 5.7-3.9 9.2-7.6 1.4-1.5 2.8-3.1 4.2-4.9 3.4-4.2 6.5-9 8.9-14.1 2.7-5.5 4.5-10.4 5.6-14.6 1.2-4.3 1.5-7.7 1-10.2q-0.3-1.6-1.1-2.6-0.3-0.3-0.6-0.6c-1.1-1-2.5-1.3-4.3-1q-0.1 0-0.2 0c-2.1 0.4-4.8 2.6-7.8 6.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m346.5 70.9c2.6-3.5 5-5.9 7-6.7 1.7-0.7 3.1-0.6 4.2 0.1q0.4 0.3 0.8 0.6c0.8 0.7 1.1 1.8 1.2 3 0.3 2.1 0 5.1-1.2 9.2-1.1 3.6-2.7 7.9-5.1 12.8-2.2 4.6-5 9-8.1 13.1-1.2 1.6-2.5 3.1-3.8 4.5-3.1 3.5-6.1 5.9-8.3 7.2-1.4 0.7-2.1 1.1-2.7 1.5q-0.3 0.1-0.5 0.2-1 0.2-1.5-0.2c-0.1-0.1-0.3-0.1-0.3-0.3 0-0.4 0-1 0-1.3-0.1-8.1 2.6-16 6.3-23.5 1.6-3.4 3.5-6.7 5.5-10 2.1-3.5 4.3-7.2 6.5-10.2zm0.2 0.2c-2.3 3.1-4.6 7.1-6.8 10.8-1.7 3-3.4 6-5 9.2q-0.3 0.7-0.7 1.4c-3.5 7.4-5.9 15.1-5.6 22.8 0.1 0.4 0.4 0.6 0.8 0.6q0.2 0 0.5-0.1c0.7-0.2 1.5-0.6 2.7-1.2 2.3-1.2 5.4-3.7 8.7-7.3 1.3-1.4 2.6-2.9 3.8-4.6 3-4 5.8-8.4 8-12.8 2.4-5.1 4.1-9.6 5.2-13.3 1.1-4.1 1.4-7.1 1-9.2-0.2-1-0.5-1.8-1-2.3-0.2-0.2-0.5-0.3-0.7-0.5-1-0.7-2.3-0.7-3.9-0.1q-0.1 0-0.2 0.1c-1.9 0.6-4.2 3.1-6.8 6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m347.2 73.6c2.2-3.4 4.3-5.9 6-7 1.5-1 2.8-1.3 3.8-0.8 0.3 0.1 0.5 0.2 0.8 0.3 0.8 0.6 1.1 1.7 1.2 2.6 0.2 1.8-0.1 4.4-1.3 8.3-0.9 3.2-2.4 7-4.6 11.5-1.9 4-4.4 8-7.2 11.9-1.1 1.5-2.2 2.8-3.3 4.1-3 3.6-5.9 5.9-8 7-1.4 0.8-1.9 1.2-2.5 1.7q-0.2 0.1-0.4 0.3c-0.5 0.2-0.9 0.3-1.3 0.3 0-0.1-0.2 0.1-0.3-0.1 0-0.2 0-0.9 0-1.1 0.1-7.7 2.8-14.4 6.3-20.8 1.6-3 3.4-5.9 5.2-8.8 1.7-2.9 3.6-6.4 5.6-9.4zm0.3 0.2c-2.1 3.1-4.1 6.7-5.9 9.8-1.6 2.7-3.2 5.3-4.6 8q-0.4 0.6-0.7 1.2c-3.4 6.4-5.8 12.9-5.8 20.1 0.2 0.1 0.4 0.2 0.8 0.1q0.2-0.1 0.4-0.3c0.5-0.2 1.2-0.6 2.4-1.3 2.2-1.1 5.2-3.4 8.3-7.1 1.1-1.3 2.2-2.7 3.3-4.2 2.7-3.7 5.2-7.7 7-11.6 2.3-4.6 3.8-8.6 4.8-11.9 1.2-3.9 1.4-6.5 1.1-8.3-0.1-0.9-0.4-1.5-1-1.9-0.2-0.2-0.4-0.2-0.7-0.4-0.9-0.4-2-0.1-3.5 0.8q0 0-0.1 0.1c-1.7 1-3.7 3.7-5.8 6.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m347.9 76.3c1.7-3.2 3.5-5.9 5-7.4q2-2 3.3-1.7c0.4 0.1 0.6 0.1 0.9 0.2 1 0.4 1.1 1.4 1.2 2.1 0.2 1.5-0.1 3.7-1.3 7.4-0.9 2.8-2.2 6.2-4.2 10.2-1.7 3.4-3.8 7-6.3 10.6-0.9 1.4-1.8 2.7-2.8 3.8-2.9 3.7-5.7 5.8-7.7 6.9-1.4 0.8-1.8 1.2-2.2 1.8q-0.1 0.2-0.3 0.4c-0.4 0.3-0.7 0.5-1.1 0.8-0.1-0.1-0.3 0.3-0.3 0.2-0.1-0.2 0-0.9 0-1 0.2-7.3 2.9-12.8 6.3-18.2 1.5-2.5 3.2-5 4.8-7.6 1.4-2.2 3-5.5 4.7-8.5zm0.3 0.1c-1.8 3.2-3.4 6.5-4.9 8.8-1.4 2.4-2.9 4.7-4.3 6.9q-0.3 0.5-0.6 1.1c-3.3 5.4-5.7 10.6-5.9 17.3 0.2-0.2 0.4-0.3 0.6-0.5q0.2-0.1 0.4-0.3c0.4-0.4 0.9-0.8 2.2-1.4 2-1.1 4.8-3.3 7.8-7 0.9-1.2 1.9-2.4 2.8-3.8 2.4-3.5 4.5-7 6.1-10.4 2.1-4.2 3.4-7.7 4.3-10.5 1.2-3.7 1.4-5.9 1.3-7.3-0.2-0.9-0.4-1.4-1-1.6-0.2-0.1-0.5-0.1-0.8-0.2-0.8-0.2-1.8 0.4-3 1.6q-0.1 0.1-0.1 0.1c-1.6 1.5-3.3 4.2-4.9 7.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m348.6 79c1.3-3 2.8-5.8 4-7.7 1.2-1.7 2.2-2.5 2.9-2.7 0.4 0 0.6 0 0.9 0 1.1 0.3 1.2 1.3 1.2 1.8 0.1 1-0.1 2.9-1.3 6.4-0.8 2.3-2.1 5.3-3.9 8.9q-2.1 4.3-5.2 9.4c-0.8 1.2-1.6 2.4-2.4 3.4-2.8 3.8-5.5 5.8-7.3 6.8-1.5 0.8-1.7 1.2-2 1.9q-0.1 0.2-0.2 0.4c-0.3 0.4-0.6 0.9-1 1.4 0 0-0.3 0.5-0.3 0.4 0-0.1 0-0.8 0-0.9 0.4-6.9 3.1-11.1 6.3-15.5 1.5-2 3-4 4.6-6.4 1-1.6 2.2-4.5 3.7-7.6zm0.3 0.1c-1.5 3.1-2.8 6.2-3.8 7.8-1.4 2.1-2.7 3.9-4 5.7q-0.4 0.5-0.7 0.9c-3.1 4.4-5.5 8.3-6 14.6 0.3-0.4 0.4-0.7 0.6-1q0.1-0.2 0.2-0.4c0.3-0.5 0.8-0.9 2-1.6 1.9-1 4.5-3 7.4-6.8 0.7-1 1.5-2.1 2.3-3.4q3.1-4.9 5.2-9.2c1.8-3.7 3.1-6.7 3.9-9.1 1.2-3.4 1.4-5.3 1.3-6.3-0.1-0.8-0.4-1.2-0.9-1.4-0.3 0-0.5 0-0.8 0-0.7 0-1.6 1-2.7 2.5q0 0.1-0.1 0.2c-1.3 1.8-2.6 4.7-3.9 7.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m335.9 107.3l0.1-0.8c0.5-6.5 3.2-9.5 6.2-12.9 1.4-1.5 2.9-3.1 4.3-5.2 0.6-0.9 1.6-3.6 2.7-6.7 2-5.3 4.1-11.2 5.6-11.7q0.5-0.1 0.9-0.1c1.2 0 1.2 1 1.2 1.3 0.1 0.7-0.1 2.2-1.4 5.5-1.2 3.2-3.5 8.2-7.7 15.8q-0.9 1.6-1.9 3c-2.7 3.9-5.3 5.8-7 6.7-1.5 0.8-1.6 1.2-1.8 2-0.1 0.5-0.2 1.3-0.8 2.4zm19.8-37q-0.4 0-0.8 0.1c-1.4 0.4-3.7 6.7-5.4 11.4-1.1 3.2-2.1 5.9-2.7 6.8-1.5 2.1-2.9 3.7-4.3 5.3-3.1 3.3-5.5 6-6.2 11.8 0.3-0.7 0.4-1.1 0.5-1.5 0.2-0.9 0.3-1.4 1.9-2.2 1.7-0.9 4.3-2.8 6.9-6.6q1-1.4 1.9-3c4.2-7.6 6.5-12.5 7.7-15.7 1.2-3.3 1.4-4.8 1.4-5.4-0.1-0.8-0.3-1-0.9-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m288 144.2q0 0 0 0-1.7 0-2.4-0.7-0.4-0.7-0.2-1.7c1.1-4.6 3.5-9.5 6.7-14.2 3.1-4.7 6.9-9.2 10.9-13.2 8-8 16.7-13.6 21.5-13.6q0.7 0 1.4 0.2 3.2 1 3.9 3.8c0.6 2.5-0.2 5.8-2.5 9.7-2.2 3.9-5.7 8.5-10.4 13.3-5 5.1-10.9 9.2-16.2 12-5.3 2.9-10 4.4-12.7 4.4zm36.5-43.1c-4.5 0-13 5.4-21.2 13.5-4.6 4.5-8.5 9.3-11.5 13.9-3 4.7-5.1 9.2-6.1 13.4q-0.2 0.9 0.2 1.4 0.5 0.6 2.1 0.6c2.6 0 7.3-1.5 12.6-4.4 5.3-2.8 11.1-6.9 16-11.9 4.7-4.8 8.2-9.3 10.4-13.2 2.2-3.8 3.1-7.1 2.5-9.5q-0.7-2.6-3.7-3.6-0.6-0.2-1.3-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eM",
    d: "m305.2 114.9c6.3-6.5 13.2-11.5 17.6-12.4q0.9-0.2 1.7-0.2 0.7 0 1.2 0.2c0.8 0.3 1.3 0.7 1.8 1.1q1.1 0.9 1.4 2.5c0.3 1.7-0.1 3.9-1.3 6.4q-0.5 1.1-1.2 2.3c-2.1 3.5-5.3 7.6-9.6 12-2.9 2.9-6.1 5.6-9.3 7.8q-2.7 1.8-5.2 3.2-0.1 0-0.1 0c-3.4 1.9-6.4 3.2-8.8 3.8-1.1 0.3-1.9 0.5-2.6 0.6q-0.5 0.1-0.9 0.2-0.9 0-1.5-0.1c-0.2-0.1-0.5-0.1-0.7-0.3-0.1-0.2-0.2-0.6-0.2-0.9q0-0.3 0.1-0.7c1.3-4.6 3.8-8.9 7-13.2 1.5-2 3.2-4 4.9-6.1 1.7-1.9 3.7-4.1 5.7-6.2zm20.4-12.1q-0.5-0.2-1.2-0.2-0.3 0-0.7 0c-3.3 0.4-8.9 4-14.5 9.1q-2.1 1.8-4.1 3.9-1.6 1.6-3 3.1c-2.2 2.3-4.3 4.7-6.1 7q-1 1.2-1.9 2.5c-2.9 4.1-5 8.1-6.1 12.1q-0.2 0.8 0.1 1.3c0.3 0.2 0.7 0.4 1.2 0.3q0.3 0 0.7 0c0.7-0.1 1.5-0.2 2.6-0.4 2.5-0.6 5.8-1.9 9.5-3.9q0-0.1 0.1-0.1 2.4-1.4 5-3.1c3.3-2.3 6.5-4.9 9.3-7.8 4.3-4.3 7.5-8.4 9.5-11.9q0.8-1.3 1.3-2.5c1.2-2.4 1.6-4.4 1.3-6-0.2-1.1-0.8-2-1.7-2.7q-0.5-0.4-1.3-0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eN",
    d: "m307.3 115.4c5.7-5.9 11.9-10.8 15.7-11.5q0.8-0.1 1.5-0.1 0.6 0 1.1 0.3c0.6 0.2 1 0.6 1.4 1q0.9 0.9 1 2.3c0.2 1.5-0.3 3.4-1.4 5.6q-0.5 1-1.2 2.1c-1.9 3.1-4.8 6.7-8.7 10.7-2.6 2.6-5.4 5-8.4 7.1q-2.3 1.6-4.6 2.9 0 0-0.1 0c-3.3 2-6.2 3.2-8.5 3.7-1.1 0.3-1.8 0.5-2.5 0.8q-0.4 0.1-0.7 0.2 0 0 0 0-0.8 0.2-1.4 0.2c-0.2-0.1-0.6 0-0.7-0.2-0.1-0.2-0.1-0.6-0.1-0.8q0-0.3 0.1-0.7c1.5-4.6 4.1-8.4 7.3-12.2 1.5-1.8 3.2-3.5 4.9-5.5 1.5-1.6 3.4-3.8 5.3-5.9zm18.1-11.1q-0.4-0.2-1.1-0.2-0.3 0-0.6 0c-2.9 0.3-8.1 4.1-13.1 8.8q-1.9 1.8-3.7 3.6c-1 1.1-1.9 2.1-2.8 2.9-2.1 2.2-4.1 4.2-5.8 6.2q-1 1.2-1.9 2.3c-2.8 3.5-4.9 7.1-6.1 10.8q-0.2 0.7 0 1.2c0.3 0.1 0.7 0.2 1.1 0.1q0.3 0 0.6-0.1c0.6-0.1 1.4-0.3 2.5-0.5 2.3-0.5 5.5-1.7 9-3.8q0.1-0.1 0.1-0.1 2.2-1.3 4.5-2.9c2.9-2.1 5.8-4.4 8.3-7 3.9-3.9 6.8-7.5 8.7-10.6q0.7-1.1 1.2-2.2c1.1-2.1 1.5-3.9 1.4-5.3-0.1-1.1-0.5-1.8-1.2-2.4-0.3-0.3-0.6-0.6-1.1-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eO",
    d: "m309.5 116c5-5.4 10.5-10.2 13.6-10.7q0.8-0.1 1.4 0 0.5 0.1 0.9 0.3c0.6 0.3 0.9 0.7 1.1 1 0.4 0.5 0.6 1.2 0.6 2.1 0 1.3-0.5 2.9-1.6 4.9q-0.4 0.8-1 1.8c-1.8 2.7-4.4 5.8-7.9 9.4-2.2 2.2-4.8 4.4-7.4 6.3q-2 1.5-4 2.7-0.1 0-0.1 0.1c-3.3 2-6.1 3.1-8.2 3.6-1.3 0.2-1.8 0.5-2.4 0.8q-0.3 0.2-0.7 0.3-0.6 0.3-1.3 0.4c-0.1 0-0.5 0.2-0.6 0-0.1-0.1 0-0.6 0-0.8q0.1-0.3 0.2-0.6c1.6-4.7 4.3-7.9 7.5-11.2 1.5-1.5 3.2-3.1 4.9-4.8 1.3-1.4 3.1-3.6 5-5.6zm15.7-10.2q-0.3-0.2-0.9-0.2-0.3 0-0.6 0c-2.5 0.2-7.3 4.2-11.7 8.5-1.1 1.1-2.3 2.3-3.3 3.4-1 1-1.8 2-2.6 2.7-2 1.9-3.9 3.7-5.6 5.4q-1 1-1.8 1.9c-2.7 3-4.8 6.1-6.1 9.7q-0.2 0.6-0.1 1c0.3 0 0.6 0 1-0.1q0.3-0.1 0.5-0.2c0.6-0.2 1.3-0.4 2.4-0.6 2.1-0.5 5.1-1.6 8.6-3.7q0-0.1 0-0.1 2-1.1 4-2.6c2.6-2 5.1-4.1 7.3-6.3 3.5-3.5 6.1-6.6 7.8-9.3q0.7-1 1.2-1.9c1-1.9 1.4-3.5 1.5-4.7 0-0.9-0.3-1.6-0.7-2.1-0.3-0.3-0.5-0.6-0.9-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eP",
    d: "m311.7 116.5c4.2-4.9 9-9.4 11.6-9.7q0.7-0.1 1.2 0 0.5 0.1 0.8 0.3c0.4 0.3 0.6 0.7 0.7 1.1 0.3 0.4 0.3 1 0.2 1.8-0.1 1-0.6 2.4-1.7 4.2q-0.4 0.7-1 1.5c-1.5 2.2-3.9 4.9-7 8.1-1.9 1.9-4.1 3.8-6.4 5.6q-1.8 1.3-3.5 2.4c0 0 0 0.1 0 0.1-3.3 2.1-6.1 3.1-8 3.5-1.3 0.3-1.7 0.5-2.2 0.9q-0.3 0.2-0.6 0.5 0 0 0 0-0.6 0.3-1.2 0.6c-0.1 0-0.5 0.2-0.6 0.2-0.1-0.1 0.1-0.7 0.1-0.8q0.1-0.3 0.2-0.6c1.8-4.7 4.5-7.3 7.8-10.2 1.5-1.3 3.2-2.6 4.9-4.2 1.1-1.1 2.8-3.2 4.7-5.3zm13.4-9.2q-0.3-0.2-0.9-0.2-0.2-0.1-0.5-0.1c-2.1 0.2-6.5 4.3-10.3 8.3-1 1.1-2 2.2-3 3.2-0.9 1-1.6 1.9-2.3 2.4-1.9 1.8-3.7 3.2-5.4 4.7q-0.9 0.8-1.7 1.6c-2.6 2.4-4.7 5-6.1 8.4q-0.2 0.5-0.2 1c0.3-0.2 0.6-0.3 0.9-0.5q0.2-0.1 0.5-0.2c0.4-0.3 1-0.5 2.1-0.7 2-0.4 4.9-1.4 8.2-3.6 0 0 0.1-0.1 0.1-0.1q1.7-1 3.4-2.4c2.3-1.8 4.4-3.6 6.3-5.5 3.1-3.1 5.4-5.8 7-8q0.6-0.9 1-1.6c1-1.7 1.5-3 1.7-4 0.1-0.9 0-1.5-0.3-1.9-0.1-0.3-0.3-0.6-0.5-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eQ",
    d: "m313.8 117c3.6-4.3 7.7-8.7 9.7-8.8q0.6 0 1 0.1 0.4 0.1 0.6 0.3c0.4 0.4 0.4 0.8 0.4 1.1 0.1 0.3 0.1 0.8-0.2 1.6-0.3 0.8-0.8 2-1.8 3.4q-0.4 0.6-0.9 1.2c-1.4 1.9-3.5 4.2-6.2 6.9q-2.4 2.3-5.4 4.8-1.5 1.3-2.9 2.2c0 0-0.1 0.1-0.1 0.1-3.2 2.2-5.9 3.1-7.7 3.5-1.3 0.2-1.6 0.5-2.1 1q-0.2 0.2-0.5 0.5-0.4 0.4-1 0.9c-0.1-0.1-0.6 0.3-0.6 0.3 0 0 0.2-0.7 0.2-0.7q0.1-0.3 0.2-0.6c2-4.7 4.8-6.8 8.1-9.2 1.5-1.1 3.2-2.1 4.9-3.6 0.9-0.8 2.5-2.9 4.3-5zm11.1-8.1q-0.2-0.3-0.8-0.4-0.2 0-0.5 0c-1.6 0.1-5.6 4.4-8.8 8-0.9 1.1-1.8 2.1-2.6 3-0.8 1-1.5 1.7-2 2.2-1.9 1.5-3.6 2.7-5.2 3.9q-0.9 0.6-1.8 1.2c-2.4 2-4.5 4-6 7.2q-0.2 0.5-0.2 0.9c0.3-0.3 0.5-0.5 0.7-0.7q0.2-0.2 0.4-0.4c0.4-0.3 0.9-0.5 2-0.7 1.8-0.3 4.5-1.2 7.8-3.5 0 0 0-0.1 0-0.1q1.4-0.9 2.9-2.1 3-2.5 5.3-4.8c2.7-2.7 4.7-4.9 6.1-6.7q0.6-0.7 1-1.4c0.9-1.3 1.5-2.4 1.7-3.2 0.3-0.8 0.3-1.3 0.3-1.7-0.1-0.3-0.1-0.6-0.3-0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eR",
    d: "m298.2 134.6l0.3-0.7c2.2-5.1 5.2-6.7 8.6-8.6 1.5-0.9 3.1-1.8 4.9-3.1 0.7-0.6 2.3-2.6 4-4.7 2.9-3.7 6.3-7.8 7.6-7.8q1.1 0 1.4 0.5c0.2 0.3 0.1 0.7 0.1 1-0.2 0.6-0.8 1.8-2.7 4.1-1.8 2.2-5.1 5.6-10.5 10.6q-1.2 1.1-2.4 1.9v0.1c-3.2 2.3-5.8 3.2-7.4 3.4-1.5 0.3-1.6 0.5-2 1.1-0.2 0.4-0.6 1-1.4 1.7zm25.5-24.6c-1.2 0-4.8 4.4-7.4 7.7-1.8 2.2-3.3 4.2-4.1 4.7-1.7 1.3-3.3 2.2-4.9 3.1-3.3 1.9-6 3.4-8.1 7.7 0.4-0.4 0.5-0.7 0.7-1 0.4-0.6 0.7-1 2.2-1.2 1.6-0.3 4.2-1.1 7.3-3.4v-0.1q1.2-0.8 2.3-1.9c5.5-4.9 8.6-8.3 10.5-10.5 1.9-2.3 2.5-3.5 2.6-4q0.2-0.5 0-0.8-0.3-0.3-1.1-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m280.8 125.3q0 0 0 0c-10.9 0-20.5-4.3-21.7-9.7-0.8-3.8 2.5-7.7 9.4-10.9 9.1-4.3 26.4-8.9 37.6-8.9 6 0 9.5 1.3 10.5 3.9 0.8 2 0.4 4.4-1.1 7.2-4.1 7.5-16.2 15.6-26.3 17.6-2.8 0.5-5.6 0.8-8.4 0.8zm25.3-29.1c-11 0-28.5 4.6-37.5 8.8-6.7 3.1-10 6.9-9.1 10.5 1.1 5.3 10.5 9.5 21.3 9.5 2.8 0 5.6-0.3 8.3-0.8 10-2 22-10 26.2-17.5 1.4-2.6 1.8-5 1-6.9-0.9-2.4-4.4-3.6-10.2-3.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m314.2 101.4q0.2 0.2 0.2 0.5c0.4 1.8-0.4 3.6-2.1 6-3.9 5.5-12.3 11.9-20.6 14.4q-1.3 0.4-2.6 0.7c-2.4 0.5-4.8 0.7-7.3 0.8-3 0.1-5.8 0-8.3-0.5q-0.1 0-0.2-0.1c-1.3-0.3-2.6-1-3.7-1.5q-2.8-1-4.6-2.3-1-0.7-1.7-1.5-0.9-1-1.2-2.2-0.2-0.8-0.1-1.7c0.4-2.8 3.4-5.6 8.7-8 3.9-1.8 9.3-3.6 14.9-5 6.9-1.7 13.8-2.9 19.1-3q2.6 0 4.5 0.3c2.7 0.5 4.4 1.5 5 3.1zm-0.3 0.1c-0.5-1.3-2-2.3-4.4-2.8q-2-0.4-4.8-0.3c-5 0-11.7 1.1-18.3 2.7-5.9 1.5-11.7 3.4-15.7 5.2-4.1 1.9-6.9 4.1-7.9 6.3q-0.2 0.4-0.3 0.9-0.3 1.1 0.1 2.2 0.3 1 1.1 1.9c0.9 1.1 2.2 2 3.9 2.9q0.5 0.2 1.1 0.5 0.1 0 0.2 0.1c1.2 0.5 2.7 1.4 4.1 1.7 2.6 0.6 5.7 0.8 8.8 0.7 2.4-0.1 4.9-0.3 7.2-0.8q1.4-0.3 2.7-0.8c8.2-2.4 16.5-8.7 20.3-14.2 1.7-2.4 2.5-4.3 2-6q0-0.1-0.1-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m311.9 103.1q0.1 0.3 0.1 0.5c0.2 1.6-0.9 2.9-3 5.3-3.7 4.3-10.7 9.8-17.8 11.9q-1.1 0.4-2.2 0.7c-2 0.4-4.1 0.6-6.2 0.8-2.8 0.3-5.4 0.5-7.4 0-0.1 0-0.2 0-0.2 0-1.1-0.3-2.2-1.3-3.1-1.7q-2.5-0.8-4.2-1.8-0.9-0.5-1.6-1.1-0.9-0.9-1.2-1.9-0.3-0.7-0.2-1.5c0.4-2.4 3.3-4.9 8-7 3.5-1.6 8.4-3.2 13.4-4.4 6.3-1.5 12.4-2.6 17-2.7q2.3 0 4 0.2c2.5 0.4 3.9 1.3 4.6 2.7zm-0.3 0.1c-0.6-1.1-1.8-2-4-2.4q-1.8-0.3-4.3-0.2c-4.4 0.1-10.3 1-16.4 2.5-5.3 1.2-10.4 2.9-14.1 4.6-3.8 1.7-6.3 3.6-7.2 5.5q-0.1 0.4-0.2 0.8-0.1 0.9 0.3 1.8 0.4 0.8 1.1 1.6 1.3 1.2 3.6 2.2 0.5 0.2 1 0.4c0.1 0 0.2 0 0.2 0.1 1 0.4 2.2 1.5 3.4 1.8 2.2 0.5 5 0.4 7.8 0.1 2-0.1 4.1-0.4 6.1-0.9q1.2-0.2 2.3-0.6c7.1-2.1 13.9-7.5 17.6-11.8 2-2.3 3.2-3.7 2.9-5.2q-0.1-0.1-0.1-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m309.5 104.8q0.1 0.3 0.1 0.5c0.1 1.4-1.3 2.3-3.9 4.7-3.4 3.1-9 7.6-15 9.4q-0.9 0.3-1.8 0.5c-1.6 0.5-3.4 0.7-5.1 1-2.6 0.4-4.9 0.8-6.5 0.5-0.1 0-0.2 0-0.2-0.1-0.8-0.1-1.8-1.5-2.5-1.7q-2.3-0.7-3.8-1.4-0.9-0.4-1.5-0.8-0.9-0.6-1.3-1.5-0.2-0.6-0.1-1.3c0.3-2 3-4.2 7.1-6 3.3-1.4 7.6-2.8 11.9-3.8 5.8-1.3 11.1-2.2 15-2.4q2.1 0 3.5 0.2c2.2 0.2 3.5 1 4.1 2.2zm-0.3 0.2c-0.5-1.1-1.5-1.8-3.5-2.1q-1.6-0.2-3.9-0.1c-3.7 0.1-8.8 1-14.4 2.2-4.6 1.1-9.2 2.6-12.5 4-3.4 1.5-5.7 3.2-6.4 4.7q-0.2 0.4-0.1 0.8c0 0.5 0.1 1 0.4 1.4q0.4 0.6 1.2 1.2 1.2 0.8 3.3 1.6 0.4 0.1 0.9 0.3c0 0 0.1 0 0.1 0.1 0.7 0.3 1.8 1.6 2.7 1.9 1.8 0.3 4.3 0 6.7-0.4q0 0 0 0c1.8-0.2 3.5-0.5 5.1-1q1-0.2 1.9-0.5c5.9-1.8 11.5-6.2 14.8-9.4 2.4-2.2 3.9-3.2 3.8-4.5q0-0.1-0.1-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m307.1 106.5q0.2 0.3 0.2 0.6c-0.1 1.1-1.4 2.2-4.9 3.9-2.4 2.6-7.3 5.5-12.2 7q-0.6 0.2-1.4 0.4c-1.3 0.4-2.6 0.6-4 1-2.5 0.6-4.4 1.2-5.7 1 0 0-0.1 0-0.2 0-0.5-0.1-1.3-1.7-1.8-1.9q-2.1-0.5-3.5-0.8-0.7-0.3-1.3-0.5c-0.6-0.3-1-0.7-1.3-1.2q-0.3-0.5-0.2-1.1c0.3-1.7 2.8-3.4 6.4-4.9 3-1.3 6.8-2.5 10.3-3.3 5.3-1.1 9.8-1.9 13-2q1.8-0.1 3.1 0c1.9 0.2 3 0.8 3.5 1.8zm-0.2 0.2c-0.5-0.9-1.4-1.5-3.2-1.7q-1.3-0.1-3.3 0c-3.1 0.2-7.4 0.9-12.6 2-3.8 0.8-7.8 2.1-10.8 3.4-3 1.3-5.1 2.7-5.7 3.9q-0.1 0.4 0 0.7c0.1 0.4 0.3 0.8 0.7 1.1q0.4 0.3 1.1 0.7 1.1 0.5 3 1 0.4 0.1 0.8 0.2c0 0 0.1 0 0.1 0 0.5 0.3 1.4 1.9 2 2 1.4 0.2 3.7-0.4 5.7-0.9 1.4-0.3 2.7-0.6 3.9-1q0.9-0.2 1.5-0.5c4.9-1.4 9.3-4.7 12.2-6.8 2.8-2.2 4.6-2.8 4.6-3.9 0 0 0-0.1 0-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m304.8 108.2q0.1 0.3 0.1 0.6c-0.2 0.9-2 1.2-5.8 3.3-2.3 1.2-5.6 3.3-9.4 4.4q-0.4 0.2-1.1 0.4c-0.8 0.3-1.8 0.6-2.8 1-2.3 0.9-4 1.7-4.8 1.6 0 0-0.2-0.1-0.2-0.1-0.2 0-0.9-1.9-1.1-2-1.3-0.2-2.4-0.2-3.2-0.3q-0.7-0.1-1.3-0.2c-0.5-0.1-0.9-0.4-1.2-0.8q-0.3-0.4-0.2-0.9c0.3-1.3 2.5-2.7 5.6-3.9 2.6-1.1 5.9-2 8.7-2.6 4.8-1 8.4-1.6 11-1.8q1.6-0.2 2.6-0.1c1.6 0.1 2.5 0.5 3.1 1.4zm-0.3 0.2c-0.4-0.7-1.1-1.2-2.7-1.3q-1.1 0-2.8 0.1c-2.5 0.2-6.1 0.8-10.7 1.8-3.1 0.6-6.6 1.7-9.2 2.7-2.7 1.1-4.6 2.3-4.9 3.2q-0.1 0.3 0 0.5c0.2 0.4 0.5 0.6 0.9 0.8q0.4 0.2 1.1 0.3c0.7 0.1 1.6 0.2 2.7 0.4q0.3 0 0.7 0.1c0 0 0.1 0 0.1 0 0.3 0.1 1 2 1.3 2.1 0.9 0 3-0.8 4.7-1.5q0 0 0 0c1-0.3 2-0.6 2.8-1q0.7-0.2 1.1-0.4c3.8-1.1 7.1-3.2 9.4-4.4 3.4-1.9 5.4-2.3 5.6-3.1 0-0.1 0-0.2-0.1-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m282.8 118.5h-0.1l-0.5-2.2c-1.2 0-2.1 0.1-2.8 0.2q-0.7 0.1-1.2 0.1c-0.5 0-0.9-0.1-1.3-0.4q-0.3-0.3-0.2-0.8c0.5-1.6 7.6-4 12-4.8 6.2-1.1 9.3-1.7 11.1-1.7 1.4 0 2.1 0.3 2.6 1.1q0.2 0.2 0.1 0.5c-0.3 0.7-2.1 1.3-6.6 2.6q-2.7 0.8-6.7 2c-0.3 0.1-1.3 0.7-2.4 1.3-2 1.2-3.5 2.1-4 2.1zm-1.1-2.5q0.3 0 0.6 0h0.1l0.6 2.2c0.5-0.2 2.3-1.3 3.6-2.1 1.2-0.6 2.2-1.2 2.5-1.3q4-1.2 6.7-2c4-1.2 6.2-1.8 6.4-2.4 0-0.1 0-0.1-0.1-0.3-0.3-0.5-0.9-0.9-2.3-0.9-1.8 0-4.8 0.6-11 1.7-4.9 0.9-11.4 3.3-11.8 4.6q0 0.3 0.2 0.4c0.2 0.3 0.6 0.4 1 0.4q0.5 0 1.2-0.1c0.6-0.1 1.4-0.2 2.3-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m274.3 64.4q0 0 0 0c-6.7 0-10.8-1.5-11.8-4.2-0.9-2.2-0.4-5.1 1.3-8.1 2.2-3.9 6.1-7.9 10.7-11 4.6-3.2 9.8-5.6 14.6-6.6q2.8-0.5 5.3-0.5c10.5 0 16.1 6.9 17.9 13.3 1 3.8 0.5 7.1-1.2 8-4.2 2.4-10.5 4.7-17.3 6.4-6.7 1.6-13.8 2.7-19.5 2.7zm20.1-30.1q-2.5 0-5.2 0.6c-4.8 0.9-10 3.3-14.5 6.4-4.6 3.2-8.5 7.1-10.6 10.9-1.7 3-2.2 5.7-1.3 7.9 0.9 2.6 4.9 4 11.5 4q0 0 0 0c5.6 0 12.7-1.1 19.4-2.7 6.8-1.7 13.1-3.9 17.3-6.3 1.5-0.9 1.9-4.2 0.9-7.8-1.6-6.2-7.1-13-17.5-13z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eS",
    d: "m290 35.7q2.4-0.5 4.7-0.5 0.5 0 1 0.1c7 0.3 11.4 4 13.7 8.1q0.9 1.7 1.4 3.5c0.9 3 0.7 5.7-0.4 6.8-0.1 0.2-0.3 0.3-0.4 0.4-0.1 0-0.2 0-0.3 0.1-4.3 1.5-9.7 3.3-15.8 4.7q-1.4 0.3-2.9 0.5c-3.2 0.7-6.7 1.4-10 1.8q-2.7 0.4-5.1 0.5 0 0 0 0c-5 0.2-8.6-0.5-10.2-2.1q-0.6-0.5-0.8-1.1c-0.4-0.9-0.5-1.7-0.4-2.6 0.1-1.4 1-3.2 2.3-5.1 2.2-3.3 5.7-6.7 9.9-9.5 4.2-2.7 8.9-4.8 13.3-5.6zm0 0.3c-4.3 0.8-9 2.9-13.1 5.6-4.2 2.7-7.6 6.1-9.8 9.4-1.4 2-2.2 3.7-2.3 5.2 0 0.7 0 1.4 0.4 2.2q0.1 0.4 0.4 0.7c1.5 1.7 5.1 2.4 10.3 2.2q0 0 0 0 2.3 0 4.8-0.4c3.4-0.4 6.9-1.1 10.2-1.8q0 0 0.1 0 1.4-0.2 2.8-0.6c6.2-1.3 11.7-3.2 16-4.8 1.3-0.8 1.6-3.6 0.7-6.8q-0.4-1.3-1-2.6c-2.2-4.3-6.5-8.3-13.5-8.7q-0.6 0-1.3 0-0.3 0-0.6 0-1.9 0-4.1 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eT",
    d: "m290.9 36.8q2.1-0.4 4.1-0.4 0.5 0 0.9 0.1c6.2 0.3 10 3.5 12.1 7q0.9 1.4 1.4 2.9c0.8 2.7 0.7 5.1-0.2 6.1-0.1 0.1-0.2 0.2-0.3 0.3-0.1 0-0.2 0-0.3 0.1-4.5 0.7-9 2.1-14.6 3.2q-1.3 0.2-2.7 0.4 0 0 0 0c-2.7 0.5-6 1.3-9.1 1.9-1.6 0.3-3.2 0.4-4.7 0.6q0 0 0 0c-4.5 0.3-7.7-0.2-9.4-1.3q0 0 0 0-0.6-0.4-0.8-0.9c-0.5-1-0.4-1.8-0.3-2.6 0.2-1.2 1.2-2.8 2.8-4.7 2.2-2.6 5.3-5.6 9.2-8 3.7-2.2 7.9-4 11.9-4.7zm0 0.3c-3.9 0.7-8.1 2.5-11.8 4.7-3.8 2.3-6.9 5.3-9.1 7.9-1.5 1.9-2.6 3.5-2.7 4.8-0.1 0.6-0.1 1.3 0.2 2.1q0.2 0.4 0.6 0.7 0 0 0 0c1.3 1.3 4.7 1.8 9.5 1.3q0 0 0 0c1.3-0.1 2.8-0.3 4.3-0.5 3.2-0.6 6.5-1.4 9.3-1.9q0.1 0 0.1 0 1.4-0.2 2.6-0.5c5.7-1 10.3-2.5 14.8-3.3 1-0.7 1.2-3.2 0.3-5.9q-0.4-1.2-1-2.3c-1.9-3.6-5.7-7-11.9-7.4q-0.5 0-1.1 0-0.3 0-0.5 0-1.7 0-3.6 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eU",
    d: "m291.8 38q1.8-0.3 3.5-0.3 0.4 0 0.8 0c5.4 0.2 8.7 3 10.6 5.8q0.8 1.3 1.2 2.5c0.9 2.3 0.8 4.4 0.1 5.2-0.1 0.1-0.2 0.2-0.3 0.3 0 0-0.1 0-0.2 0-4.7-0.1-8.3 1-13.4 1.8q-1.2 0.1-2.5 0.3 0 0 0 0c-2.2 0.4-5.3 1.2-8.3 1.9-1.4 0.3-2.8 0.6-4.2 0.8q0 0 0 0c-4 0.5-7 0.3-8.6-0.4q0 0 0 0-0.6-0.4-0.8-0.9c-0.6-1-0.4-1.8-0.3-2.5 0.3-1 1.6-2.4 3.4-4.2 2.2-2.1 4.9-4.6 8.4-6.5 3.3-1.8 7-3.2 10.6-3.8zm0 0.3c-3.6 0.6-7.2 2-10.5 3.7-3.4 1.9-6.2 4.4-8.3 6.5-1.8 1.8-3 3.2-3.3 4.3-0.1 0.6-0.2 1.2 0.2 2.1 0.2 0.2 0.4 0.4 0.6 0.5 1.3 1 4.4 1.1 8.7 0.5q0 0 0 0 1.9-0.2 3.9-0.7c3.1-0.7 6.2-1.5 8.4-1.9q0.1 0 0.1-0.1 1.3-0.1 2.4-0.3c5.2-0.7 8.9-1.8 13.5-1.8 0.8-0.7 0.9-2.8 0-5.1q-0.3-0.9-0.9-1.9c-1.7-2.9-4.9-5.8-10.3-6.1q-0.5 0-1 0-0.2 0-0.4 0-1.5 0-3.1 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eV",
    d: "m292.6 39.1q1.6-0.2 3.1-0.2 0.3 0 0.6 0c4.6 0.2 7.4 2.4 9 4.7q0.8 1 1.2 2c0.8 2 0.8 3.6 0.3 4.4 0 0-0.1 0.2-0.2 0.2 0 0-0.2 0-0.2 0-4.9-0.9-7.6-0.2-12.2 0.2q-1.1 0.2-2.3 0.2c-1.7 0.3-4.6 1.2-7.4 2.1-1.3 0.3-2.6 0.6-3.8 0.9q0 0 0 0c-3.6 0.7-6.4 1-7.8 0.4q-0.6-0.2-0.8-0.7c-0.7-1.1-0.4-1.9-0.2-2.5 0.4-0.8 1.8-2.1 3.9-3.8 2-1.6 4.5-3.5 7.6-5 2.8-1.3 6-2.4 9.2-2.9zm0.1 0.3c-3.2 0.5-6.4 1.6-9.1 2.9-3.1 1.5-5.6 3.4-7.6 4.9-2.1 1.8-3.5 3-3.8 3.9-0.2 0.5-0.4 1.1 0.1 2 0.1 0.2 0.4 0.4 0.6 0.5 1.3 0.6 4.2 0.5 7.9-0.4q0 0 0 0 1.7-0.3 3.5-0.8c3-0.9 5.8-1.8 7.6-2.1 0 0 0 0 0 0q1.2-0.1 2.2-0.2c4.7-0.4 7.4-1.1 12.3-0.3 0.5-0.7 0.5-2.4-0.3-4.2q-0.4-0.8-0.9-1.5c-1.4-2.3-4.2-4.6-8.8-4.9q-0.4 0-0.8 0-0.2 0-0.4 0-1.2 0-2.5 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eW",
    d: "m293.5 40.2q1.3-0.1 2.5-0.1 0.2 0 0.5 0c3.8 0.2 6.2 1.9 7.5 3.5q0.6 0.8 1 1.6c0.9 1.6 0.9 2.9 0.6 3.5 0 0-0.1 0.2-0.1 0.2 0 0-0.2 0-0.2 0-5.1-1.7-6.9-1.4-11.1-1.3q-0.9 0.1-2 0.1c-1.2 0.1-3.8 1.1-6.6 2.1-1.1 0.4-2.2 0.7-3.3 1.1q0 0 0 0c-3.1 0.9-5.7 1.4-7 1.2q0 0 0 0-0.6-0.1-0.8-0.5c-0.8-1.2-0.4-1.9-0.1-2.5 0.4-0.6 1.9-1.8 4.5-3.4 1.7-1.1 4-2.4 6.8-3.5 2.3-0.9 5-1.6 7.8-2zm0.1 0.4c-2.8 0.3-5.5 1-7.8 1.9-2.8 1.1-5 2.4-6.8 3.5-2.5 1.5-4 2.7-4.4 3.4-0.3 0.4-0.5 1 0.1 2 0.1 0.2 0.4 0.3 0.6 0.3q0 0 0 0c1.2 0.2 3.9-0.2 7.1-1.2q1.5-0.5 3.1-1c2.8-1 5.4-2 6.7-2.1 0 0 0 0 0 0q1.1 0 2-0.1c4.2-0.1 6-0.5 11.1 1.2 0.2-0.6 0.1-1.9-0.7-3.3q-0.3-0.6-0.8-1.2c-1.2-1.6-3.5-3.3-7.3-3.6q-0.3 0-0.6 0-0.2 0-0.3 0-1 0-2 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eX",
    d: "m277.7 50.2q-0.6 0-0.8-0.3c-0.9-1.3-0.4-2-0.1-2.5 0.5-0.4 2.1-1.7 5.1-2.9 2.9-1.3 7.1-2.6 12.5-3.1q1.2-0.1 2.3-0.1c3 0.2 4.9 1.4 5.9 2.4 1.7 1.6 1.9 3.2 1.8 3.7v0.2h-0.2c-5.3-2.6-6.2-2.6-9.9-2.8q-0.8 0-1.8 0c-0.7 0-3.2 1-5.7 2.1-3.5 1.5-7.5 3.3-9.1 3.3zm18.3-8.6q-0.8 0-1.6 0.1c-5.4 0.5-9.5 1.8-12.4 3-2.9 1.3-4.5 2.5-4.9 2.9-0.4 0.5-0.7 1 0 2.1 0.1 0.1 0.4 0.1 0.6 0.1 1.6 0 5.5-1.7 8.9-3.2 2.8-1.1 5.1-2.2 5.9-2.2q1 0.1 1.8 0.1c3.7 0.2 4.6 0.2 9.8 2.7 0.1-0.7-0.3-2-1.7-3.3-1-0.9-2.8-2.1-5.7-2.3q-0.4 0-0.7 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m236.9 144.6q-2.8 0-6-1.1c-7.7-2.5-12.3-6.4-14.9-10.7-2.6-4.4-3.3-9.1-3.2-13.1 0.2-10.4 5.8-19.5 8.5-20.2q1.4-0.4 2.6-0.4c6.4 0 7.2 8.1 7.7 13.5 0.1 1.4 0.2 2.7 0.4 3.5 0.6 2.1 2.7 3.3 6 3.3 3.4 0 7.8-1.2 12.8-3.4q2.4-1.1 4.4-1.1c3.8 0 5.6 3 6 5.8 0.3 2.9-0.7 6.2-3.3 6.9-1.7 0.4-3.3 2.8-5.1 5.5-3.4 5.1-7.7 11.5-15.9 11.5zm-13-45.2q-1.2 0-2.5 0.4c-2.6 0.7-8 9.8-8.3 19.9-0.2 8 2.7 18.6 17.9 23.5q3.1 1.1 5.9 1.1c8.1 0 12.3-6.3 15.6-11.4 1.9-2.7 3.5-5.1 5.3-5.6 2.4-0.6 3.4-3.8 3-6.5-0.3-2.7-2-5.6-5.6-5.6q-2 0-4.3 1.1c-5 2.2-9.5 3.5-12.9 3.5-3.4 0-5.7-1.3-6.3-3.7-0.2-0.8-0.3-2-0.4-3.4-0.5-5.3-1.3-13.3-7.4-13.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eY",
    d: "m223.7 101.2c5.1-0.1 5.7 6.5 6.1 10.8 0.3 1.5 0.4 3.2 0.6 4.1q0.3 1.1 1 1.9-0.4-0.6-0.6-1.2c-0.2-0.8-0.3-1.9-0.4-3.2-0.1-1.4-0.3-3-0.5-4.5-0.7-3.9-2.2-7.8-6.1-8.2q-1-0.1-2.2 0.1-0.5 0.1-1.1 0.5-0.1 0.1-0.2 0.1 0 0.1-0.1 0.2c-0.7 0.6-1.5 1.7-2.2 3.3-0.6 1.2-1.2 2.7-1.8 4.1-1.1 2.8-2 6.4-2 10.2-0.1 3.4 0.5 7.3 2.4 11q0.3 0.5 0.6 1c2.2 3.8 6.2 7.6 13.4 10q2.9 1 5.5 1.1c3.1 0 5.6-0.9 7.8-2.3 3-1.9 5.2-4.8 7.1-7.5 0.1-0.2 0.3-0.5 0.5-0.8 1-1.3 1.7-2.3 2.3-3q0.1-0.1 0.2-0.2 0 0 0.1-0.1 0.2-0.2 0.4-0.4 0.1 0 0.1 0 0.3-0.3 0.7-0.4c1-0.2 1.6-1 2-2.1-0.5 1-1.2 1.9-2.2 2.1-1.7 0.6-3.4 2.7-5.2 5-3.2 4.2-6.9 9.9-13.8 9.3-2.8-0.2-4.5-1.3-6.4-2-12.4-4.9-15-13-14.9-19.8 0-9.2 4.4-17.5 6.8-18.4 0.8-0.2 1.5-0.3 2.1-0.7zm12.1 18.7q1 0.1 2.2 0.2-1 0-1.9 0c-2.2-0.2-3.9-0.9-4.7-2.1 0.9 1 2.4 1.5 4.4 1.9zm13.2-1.4q2.2-0.8 4.1-1 0.4 0 0.8 0.1-1-0.4-2.3-0.5-1.8-0.1-4 0.8-1.4 0.5-2.7 0.9c-2.6 0.7-4.9 1.2-6.9 1.3 3 0.2 6.9 0 11-1.6zm8.7 3.8c0.1 1.1 0 2.4-0.4 3.4q0.1-0.6 0.2-1.2c0-0.8 0-1.6-0.2-2.3-0.4-1.8-1.4-3.7-3.4-4.6 2.4 0.4 3.6 2.6 3.8 4.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eZ",
    d: "m223.5 103q0.8-0.1 1.5 0.2-0.6-0.4-1.3-0.5c-0.6-0.2-1.2-0.3-1.8-0.2-0.3 0.1-0.6 0.1-1 0.3q0 0.1-0.1 0.1-0.1 0-0.2 0.1c-0.6 0.5-1.1 1.4-1.7 3.1-0.5 1.1-1 2.5-1.4 3.8-1.2 2.4-1.9 5.6-1.9 9.1 0 3.1 0.6 6.7 2.3 10.1q0.2 0.4 0.4 0.9c1.9 3.4 5.2 6.9 12 9.3q2.6 0.9 5 1c2.7 0.2 5-0.5 7.1-1.6 2.9-1.5 5-4 6.7-6.4 0.1-0.2 0.4-0.5 0.5-0.7 1-1.3 1.6-2.1 2.1-2.7 0.1-0.1 0.1-0.1 0.1-0.2 0 0 0 0 0.1 0q0-0.1 0.1-0.2c-1.5 0.9-3.1 2.4-4.8 4.2-3 3.2-6.2 8-11.9 7.3-3.7-0.4-5.2-2.3-6.9-3.1-9.6-4.6-11.9-10.5-12-15.9-0.1-8.4 3.1-15.9 5.4-16.9 0.7-0.2 1.2-0.4 1.7-1.1zm4.9 8.4c0.3 1.5 0.5 3.6 0.7 4.7q0.2 0.7 0.5 1.3c-0.2-0.7-0.3-1.7-0.4-2.9-0.1-1.2-0.2-2.6-0.5-4-0.2-1.6-0.6-3.3-1.3-4.6 0.6 1.7 0.8 3.8 1 5.5zm5.1 8.5c0.9 0.4 2 0.7 3.4 1q-1.5 0-2.7-0.2c-2.5-0.4-4.1-1.5-4.6-3.2q0-0.1 0-0.1c0.8 1.2 2.2 1.9 3.9 2.5zm13.6 0.9q1.8-0.6 3.3-0.8-1-0.5-2.4-0.7-1.6-0.1-3.6 0.4-1.2 0.4-2.4 0.6-2.8 0.6-5.1 0.6c2.8 0.7 6.6 1 10.2-0.1zm3.9-0.9c2.3 0.1 3.4 2.1 3.5 4 0.2 1.8-0.5 4-2.1 4.4q-0.2 0.1-0.4 0.2 0.1-0.1 0.2-0.1 0-0.1 0-0.1 0.2-0.1 0.5-0.2c0.9-0.2 1.3-1.3 1.2-2.6-0.1-0.6-0.2-1.3-0.4-1.9-0.5-1.3-1.5-2.8-3.1-3.6q0.3-0.1 0.6-0.1zm-26-16.7c1.1 0.4 1.9 1.4 2.4 2.7-0.6-1.2-1.4-2.1-2.4-2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f0",
    d: "m223.3 104.7q0.5 0 0.9 0.1-0.3-0.2-0.6-0.3c-0.5-0.2-0.9-0.3-1.5-0.4-0.2-0.1-0.5-0.1-0.8 0 0 0 0 0-0.1 0.1 0 0-0.1 0-0.1 0-0.5 0.5-0.9 1.1-1.4 2.9-0.3 1.1-0.7 2.4-1 3.4-1.1 2.1-1.7 5-1.7 8.2 0.1 2.8 0.6 6 2.1 9.1q0.2 0.4 0.4 0.8c1.5 2.9 4.2 6.2 10.5 8.5q2.2 0.9 4.5 1.1c2.2 0.2 4.4-0.2 6.5-1 2.6-1.2 4.6-3.2 6.2-5.3 0.1-0.1 0.4-0.5 0.5-0.6 1.1-1.3 1.5-1.9 1.9-2.4-1.5 0.9-3.3 2.2-5.1 3.7-2.7 2.3-5.5 6-10 5.3-4.7-0.7-6.1-3-7.4-4.2-7.6-2.5-8.8-7.9-9-12-0.3-7.6 1.8-14.3 3.9-15.5 0.5-0.1 1-0.3 1.3-1.5zm3.7 6c0.4 1.6 0.6 4.2 0.8 5.3q0.2 0.9 0.5 1.6-0.2-0.9-0.3-2.1c-0.1-1.2-0.2-2.4-0.4-3.7-0.2-1.3-0.5-2.7-1-3.9 0.2 0.9 0.3 2 0.4 2.8zm4.3 9.3c0.6 0.6 1.4 1.2 2.5 1.7q-0.8-0.1-1.5-0.3c-2.1-0.6-3.5-1.6-3.9-3.2q0-0.3-0.1-0.6c0.6 1.2 1.6 2 3 2.4zm13.9 3.1q1.1-0.3 2.1-0.5c-0.8-0.5-1.7-0.9-2.8-1q-1.6-0.2-3.2 0-1.1 0.2-2.2 0.3-3 0.2-5.3-0.2c3 1.4 7.4 2.3 11.4 1.4zm3.7-0.9c1.7 0.1 2.4 1.7 2.4 3.2 0.2 1.4-0.5 3.2-1.7 3.5q0 0 0 0 0 0 0 0c0-0.1 0-0.1 0.1-0.2 0 0-0.1 0 0 0 0-0.1 0.1-0.2 0.1-0.2 0 0 0 0 0 0q0.1-0.1 0.2-0.2c0.5 0 0.6-0.8 0.3-1.8q-0.2-0.7-0.7-1.4c-0.5-0.9-1.3-1.8-2.3-2.5q0.8-0.2 1.6-0.4zm-24.7-17.4c1.3 0.3 2 1.6 2.4 3.1-0.6-1.3-1.4-2.4-2.4-3.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f1",
    d: "m223.1 106.5q0.4-0.1 0.7 0-0.2-0.1-0.3-0.2-0.5-0.4-1.1-0.7c-0.2-0.1-0.4-0.2-0.6-0.2 0 0-0.1 0-0.1 0 0 0-0.1 0.1-0.1 0.1-0.4 0.3-0.7 0.7-1 2.6-0.2 1-0.4 2.3-0.6 3.1-1.1 1.7-1.7 4.2-1.5 7.2 0.1 2.4 0.6 5.3 1.9 8.1q0.1 0.3 0.3 0.7c1.1 2.4 3.2 5.5 9 7.8q1.9 0.8 4 1.1c1.8 0.2 3.8 0.1 5.8-0.4 2.5-0.8 4.4-2.4 5.9-4.2 0-0.1 0.3-0.4 0.4-0.5 0.8-0.9 1.2-1.4 1.4-1.8q-0.1 0.2-0.3 0.2c-1.4 1-3.2 2-5.1 3.1-2.4 1.5-4.7 3.9-8.1 3.3-5.6-1-6.8-3.8-7.8-5.2-5.1-1.8-5.9-5.5-6.1-8.2-0.6-6.9 0.5-12.7 2.5-14 0.3-0.1 0.6-0.3 0.8-1.9zm2.4 3.6c0.6 1.6 0.8 4.6 1 5.9q0.1 1 0.5 1.9-0.1-0.7-0.2-1.5c-0.1-1-0.2-2.1-0.3-3.2-0.2-1.3-0.5-2.8-1.1-4.2q0.1 0.6 0.1 1.1zm3.5 10c0.5 0.8 1.4 1.6 2.4 2.4q-0.5-0.2-1-0.5c-1.7-0.7-2.8-1.7-3.2-3.1q-0.1-0.5-0.2-1 0.7 1.4 2 2.2zm14.3 5.2q0.4 0 0.8-0.1c-0.8-0.6-1.9-1.1-3.2-1.4-0.9-0.2-1.8-0.3-2.8-0.3-0.7 0-1.3 0-1.9-0.1-1.8-0.1-3.4-0.5-4.8-0.9 3 2 7.8 3.5 11.9 2.8zm3.5-0.7c1.1 0.1 1.4 1.3 1.3 2.4 0.1 0.8-0.3 1.8-0.9 2.2q0.2-0.2 0.3-0.3c0-0.1 0-0.1 0-0.2 0 0 0 0 0 0 0-0.1 0-0.1-0.1-0.1 0 0 0 0 0 0q0 0 0 0c0.1 0-0.2-0.5-0.7-1.1q-0.4-0.4-0.9-1c-0.5-0.4-1-0.9-1.7-1.3q1.5-0.3 2.7-0.6zm0.6 4q0 0 0 0 0 0 0 0zm-23.6-22.1c1.1 0.2 1.4 1.4 1.6 2.5-0.4-1-0.9-1.9-1.6-2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f2",
    d: "m232.8 134q-1.8-0.5-3.4-1.1c-5.3-2.3-6.8-5.2-7.6-7.1q-0.1-0.4-0.2-0.7c-1.1-2.5-1.6-4.9-1.7-7-0.2-2.7 0.3-4.9 1.3-6.3 0.1-0.5 0.2-1.8 0.3-2.7 0.1-2 0.2-2.2 0.5-2.4 0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0q0.2 0.1 0.5 0.4 0.4 0.4 0.7 1 0.1 0 0.1 0.1-0.2-0.1-0.6 0.1c-0.1 1.9-0.2 2.2-0.4 2.3-1.8 1.4-1.9 6.4-1.1 12.4 0.2 1.5 0.6 3.4 3.2 4.4 0.8 1.6 1.8 4.9 8.3 6.3 2.2 0.5 4.2-0.6 6.2-1.3 2.1-0.6 3.8-1.4 5.1-2.5 0.3-0.1 0.7-0.7 0.7-1.1q0.1 0 0.1 0c0 0 0.1-0.1 0.1-0.1 0.1 0 0.1 0 0.2 0 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0.2-0.1 0.2-0.3 0.4-1.5 1.8 0 0-0.3 0.3-0.4 0.4-1.4 1.6-3.2 2.7-5.5 3.1-1.9 0.2-3.7 0.1-5.2-0.2zm-7.5-19.5c0.2 1 0.2 2 0.4 2.9q0 0.4 0.1 0.9-0.4-1-0.6-2.3c-0.2-1.5-0.5-4.9-1.1-6.6q0 0 0-0.1c0.7 1.7 1.1 3.8 1.2 5.2zm0.7 5.1c0.3 1.2 1.2 2.2 2.5 3.1q0.6 0.4 1.4 0.8c-1.4-1-2.5-2.2-3.1-3.3-0.4-0.6-0.7-1.2-1-1.9q0.1 0.7 0.2 1.3zm7.3 5.4q0.8 0.2 1.6 0.4 1.2 0.3 2.4 0.6c1.5 0.5 2.8 1.1 3.9 1.6-3.9 0.2-8.3-1.7-11.3-4.1q1.5 0.9 3.4 1.5zm8.7 3q0.6 0.3 1.1 0.5c0.7 0.4 1.3 0.5 1.7 0.4q0.1-0.1 0.1-0.1 0.1-0.1 0-0.2c0.3-0.8 0.2-1.5-0.2-1.7q-1.5 0.5-3.3 0.7-0.1 0-0.2 0 0.4 0.2 0.8 0.4zm-18.5-19.8q0.3 0.5 0.6 1.1c-0.1-0.4-0.2-0.9-0.6-1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f3",
    d: "m236.5 132.6c-1.8 0-3.4-0.4-4.5-0.7-7.4-2.5-8.5-5.8-9-7.6q-0.1-0.3-0.2-0.5c-1.9-5.2-2.1-9.7-0.4-11.3 0.1-0.3 0-1.5 0-2.5-0.1-2-0.1-2 0.1-2h0.1c1 1.4 1.4 6.1 1.6 7.9 0.2 1.7 0.3 3.1 0.6 4.3 0.6 2.2 2.8 4.5 5.6 6.3 2.8 1.8 6.2 3 9 3q1.8 0 3.2-0.6h0.1c0.2-0.1 0.3-0.2 0.4-0.2h0.1v0.1c0.1 0.2 0.1 0.2-1.2 1.5l-0.3 0.4q-1.9 1.9-5.2 1.9zm-13.8-19.9c-1.7 1.6-1.5 6 0.4 11q0.1 0.2 0.2 0.6c0.5 1.7 1.5 4.9 8.8 7.3 1.1 0.3 2.7 0.7 4.4 0.7q3.1 0 4.9-1.8l0.4-0.4q0.5-0.5 0.8-0.8-1.4 0.6-3.2 0.6c-5.8 0-13.8-5.1-14.9-9.6-0.3-1.2-0.5-2.7-0.6-4.4-0.2-1.5-0.5-5.3-1.2-7.1 0 0.3 0 0.8 0 1.2 0.1 2.4 0.1 2.7 0 2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "U",
    d: "m311.8 96.6c-15.2 0-27.5-12.7-34-24.6-3.3-6.2-4.8-11.6-3.6-13.4q1.8-2.7 5.5-2.7c8.7 0 23 11.1 29.1 15.8 1.1 0.9 2 1.6 2.5 1.9q0.5 0.3 1.1 0.3c4.4 0 13.6-11.5 20.1-22.3 4.2-7.1 8.3-11 11.5-11 1.3 0 2.3 0.6 3.1 1.7 2.2 3.2 1.8 10.3-1.1 17.6-0.4 1.1-0.8 2.8-1.2 4.7-2 8.5-5.3 22.7-20.7 29.4-4.1 1.7-8.2 2.6-12.3 2.6zm-32.1-40.4q-3.5 0-5.2 2.6c-1 1.4 0 6.3 3.6 13 6.4 11.9 18.6 24.5 33.7 24.5 4 0 8.1-0.9 12.1-2.6 7.7-3.3 12.3-8.5 15.3-13.9 3-5.4 4.3-11.1 5.3-15.3 0.4-1.9 0.8-3.6 1.2-4.7 3.3-8.3 2.9-14.7 1.1-17.3q-1-1.6-2.8-1.6c-1.7 0-5.6 1.4-11.2 10.8-6.7 11.2-15.9 22.5-20.4 22.5q-0.7 0-1.3-0.3c-0.5-0.4-1.3-1-2.5-2-6.1-4.7-20.3-15.7-28.9-15.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f4",
    d: "m283 59.2q0.1 0 0.3 0c4.5 0.1 10.8 3.7 16.1 7.3 3.1 2.2 6 4.4 8.1 6q0.7 0.5 1.3 0.9c1 0.8 1.8 1.4 2.2 1.7q0.4 0.3 1 0.3c1.6 0.1 3.7-1.4 6.1-3.6 4-3.7 8.5-9.6 12.2-15.4q0.6-0.9 1.1-1.6c1.7-2.6 3.4-4.6 4.9-6 1.6-1.4 3-2.2 4.3-2.2 1.1-0.1 2.1 0.4 2.8 1.3 0.6 0.9 1 2.1 1.2 3.5 0.5 3.2-0.3 7.6-2.1 12-0.4 1-0.8 2.5-1.2 4.1-1.8 7.1-4.7 18.6-17.4 24.6-0.7 0.4-1.4 0.7-2.3 1-3.3 1.2-6.6 1.8-9.8 1.8-9.4 0-17.6-5.4-23.6-12.4-2.5-2.8-4.6-5.9-6.2-8.8-2.6-4.5-4-8.3-3.8-10.6q0-0.1 0-0.1 0-0.7 0.3-1.2c0.4-0.6 0.9-1.2 1.4-1.6 0.8-0.7 1.8-1 2.9-1q0.1 0 0.2 0zm0.1 0.3q-1.3 0.1-2.3 0.6c-0.8 0.4-1.5 1-2 1.9q-0.2 0.4-0.3 1c-0.2 2 1 5.6 3.7 10.5 1.8 3 3.9 6.2 6.4 9.1 5.9 6.7 14 12 23.2 12 3.5 0 7.1-0.7 10.7-2.2 6.7-2.9 10.8-7.3 13.7-11.9 1.7-2.9 2.7-5.8 3.5-8.4 0.5-1.7 0.9-3.3 1.3-4.7 0.4-1.7 0.8-3.1 1.2-4.1 2.1-5.1 2.6-9.4 2-12.3-0.2-1.2-0.6-2.2-1.1-2.9q-0.9-1.3-2.5-1.2c-0.8 0-2.1 0.4-3.9 2-1.4 1.2-3.1 3.1-5 6q-0.6 0.8-1.1 1.7c-3.9 6.1-8.6 12.1-12.6 15.8-2.4 2.1-4.4 3.4-6 3.3q-0.6 0-1.1-0.3-0.7-0.5-2.3-1.7-0.9-0.6-2-1.5c-2.2-1.7-5.1-3.9-8.2-5.9-5.1-3.4-11.1-6.7-15.3-6.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f5",
    d: "m286.3 62.4q0.1 0 0.2 0c3.9 0.2 9.6 3.6 14.1 6.7 2.7 1.9 5.1 3.8 7.1 5.3q0.5 0.4 1 0.8c0.9 0.6 1.6 1.2 2 1.4q0.4 0.3 0.9 0.3c1.4 0.1 3.3-1 5.5-2.8 3.5-3 7.7-7.8 11.1-12.9q0.5-0.7 0.9-1.4c1.6-2.2 3.1-3.9 4.4-5.2q2-1.8 3.7-2 1.4-0.2 2.4 1 0.9 1 1.2 2.9c0.5 2.7-0.2 6.6-1.8 10.4-0.4 0.9-0.8 2.1-1.2 3.5-1.5 5.7-4 14.7-14.1 19.9-0.6 0.3-1.3 0.7-2.2 1-3.4 1.3-6.6 1.9-9.6 1.9-8.2 0-15.2-4.5-20.4-10.4-2.1-2.4-3.9-5-5.4-7.4-2.4-3.9-3.7-7.1-3.6-9.3q0 0 0 0c0.1-0.4 0.1-0.8 0.3-1.1 0.2-0.6 0.7-1 1.1-1.5 0.7-0.7 1.3-1 2.2-1.1q0.1 0 0.2 0zm0.1 0.4q-1 0.1-1.7 0.6c-0.7 0.5-1.3 1.1-1.6 1.8q-0.2 0.4-0.2 0.9c-0.2 1.9 0.9 4.8 3.4 9.1 1.6 2.5 3.4 5.1 5.6 7.6 5.1 5.7 12 10.1 19.9 10.1 3.1 0 6.2-0.6 9.3-1.9 5.7-2.3 9.4-5.9 12-9.8 1.7-2.4 2.5-4.8 3.2-7q0.7-2.1 1.2-3.9c0.4-1.4 0.8-2.6 1.2-3.5 1.8-4.3 2.3-8.1 1.8-10.6q-0.4-1.6-1.1-2.4-0.8-1.1-2.2-0.9c-0.7 0.1-1.9 0.5-3.4 1.9-1.2 1.1-2.7 2.7-4.4 5.2q-0.5 0.7-1 1.4c-3.5 5.3-7.8 10.3-11.5 13.2-2 1.7-3.8 2.7-5.3 2.6q-0.5 0-0.9-0.3-0.7-0.4-2.1-1.4-0.7-0.6-1.7-1.3c-2-1.5-4.5-3.4-7.1-5.2-4.4-3-9.7-6.1-13.4-6.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f6",
    d: "m289.7 65.7c0 0 0.1 0 0.1 0 3.3 0.2 8.3 3.4 11.9 6 2.4 1.7 4.4 3.3 6.1 4.6q0.5 0.3 0.9 0.6c0.7 0.6 1.4 1 1.8 1.3q0.3 0.2 0.7 0.2c1.3 0.1 2.9-0.7 4.8-2 3.2-2.3 6.9-6.1 10-10.3q0.5-0.6 0.9-1.2c1.4-1.8 2.6-3.4 3.8-4.5q1.7-1.5 3.1-1.8 1.2-0.2 2.1 0.6 0.8 0.8 1.1 2.4c0.6 2.3-0.1 5.6-1.6 8.8-0.3 0.8-0.7 1.8-1.1 2.9-1.3 4.4-3.3 10.9-10.7 15.1-0.6 0.3-1.2 0.7-2.2 1.2-3.4 1.3-6.6 1.9-9.5 1.9-6.8 0-12.6-3.6-17-8.4-1.9-2-3.4-4.1-4.7-6-2.2-3.4-3.5-5.9-3.3-7.9q0 0 0 0c0-0.3 0-0.7 0.1-0.9 0.2-0.6 0.5-1 0.8-1.4 0.4-1 1-1.1 1.7-1.2 0 0 0.1 0 0.2 0zm0.1 0.4q-0.8 0.1-1.3 0.7c-0.5 0.5-0.9 1-1.1 1.6-0.1 0.3-0.2 0.5-0.2 0.8-0.1 1.7 0.9 4.1 3.3 7.7 1.3 2 2.8 4.1 4.7 6.2 4.3 4.6 10 8.1 16.6 8.1 2.6 0 5.2-0.5 7.8-1.5 4.7-1.8 8-4.7 10.5-7.9 1.5-1.9 2.3-3.7 2.9-5.5q0.5-1.7 1.1-3.2c0.4-1.1 0.7-2.1 1-2.9 1.6-3.4 2.2-6.7 1.6-8.8q-0.4-1.3-1-1.9-0.7-0.8-1.9-0.6c-0.6 0.2-1.6 0.6-2.8 1.7-1.1 1-2.4 2.5-3.9 4.5q-0.4 0.6-0.8 1.2c-3.3 4.5-7.1 8.4-10.4 10.6-1.8 1.2-3.4 2-4.6 1.8q-0.5 0-0.9-0.2-0.6-0.4-1.7-1.2-0.7-0.5-1.5-1.1c-1.8-1.3-3.8-2.9-6.1-4.6-3.5-2.5-8.2-5.3-11.3-5.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f7",
    d: "m293 68.9c0 0 0.1 0.1 0.1 0.1 2.7 0.2 7 3.1 9.8 5.2 1.9 1.5 3.6 2.9 5 3.9q0.4 0.3 0.8 0.6c0.6 0.4 1.1 0.8 1.5 1q0.3 0.1 0.6 0.2c1.2 0.2 2.6-0.3 4.1-1.2 2.9-1.5 6.2-4.3 9-7.8q0.4-0.5 0.7-0.9c1.2-1.5 2.3-2.8 3.3-3.7q1.3-1.3 2.5-1.7 1-0.3 1.7 0.2 0.7 0.6 1.2 1.9c0.6 1.8-0.2 4.6-1.4 7.1-0.4 0.7-0.8 1.5-1.1 2.4-1 3-2.5 7.3-7.4 10.3-0.6 0.4-1 0.8-2.1 1.3-3.4 1.4-6.5 2-9.4 2-5.4 0-10.1-2.6-13.7-6.4-1.5-1.6-2.7-3.2-3.8-4.6-2.2-2.8-3.3-4.7-3.1-6.5q0 0 0 0c0-0.3 0-0.6 0-0.8 0.1-0.5 0.3-0.9 0.5-1.3 0.1-1 0.5-1.1 1-1.2 0.1 0 0.1-0.1 0.2-0.1zm0.1 0.4c-0.3 0.2-0.6 0.5-0.8 0.8-0.3 0.6-0.5 1-0.6 1.5-0.1 0.3-0.1 0.5-0.1 0.7-0.2 1.6 0.7 3.3 3 6.3 1.1 1.4 2.4 3.1 3.9 4.7 3.5 3.6 8 6.2 13.3 6.2q3.1 0 6.4-1.1c3.7-1.3 6.5-3.5 8.9-5.9 1.4-1.4 2-2.8 2.5-4.1q0.5-1.2 1-2.4c0.4-0.8 0.7-1.6 1-2.3 1.3-2.7 1.9-5.4 1.3-7.1q-0.3-1.1-0.9-1.5-0.6-0.5-1.6-0.2c-0.5 0.2-1.3 0.7-2.3 1.6-0.9 0.8-1.9 2.1-3.2 3.7q-0.4 0.4-0.8 0.9c-2.9 3.7-6.3 6.5-9.2 8.1-1.5 0.8-2.9 1.2-4 1.1q-0.4-0.1-0.7-0.3-0.6-0.3-1.5-0.9-0.6-0.4-1.3-0.9c-1.4-1.1-3.1-2.5-5-3.9-2.7-2-6.7-4.6-9.3-5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f8",
    d: "m296.3 72.2c0 0 0.1 0 0.1 0 2 0.3 5.7 3 7.7 4.6 1.5 1.2 2.8 2.4 3.9 3.2q0.4 0.2 0.7 0.5 0.7 0.4 1.2 0.7 0.3 0.1 0.5 0.2c1 0.2 2.2 0.1 3.4-0.3 2.6-0.9 5.4-2.7 7.9-5.4q0.4-0.3 0.7-0.7c1-1.1 1.8-2.1 2.6-2.9q1.1-1 1.9-1.5 0.8-0.4 1.5-0.1 0.6 0.3 1.1 1.2c0.6 1.5-0.1 3.8-1.1 5.6-0.4 0.6-0.8 1.2-1 1.8-0.8 1.6-1.7 3.8-4.1 5.6-0.6 0.3-0.9 0.8-2.1 1.3-3.4 1.4-6.5 2.1-9.3 2.1-4.1 0-7.6-1.7-10.3-4.3-1.2-1.2-2.2-2.4-3.1-3.3-2.1-2.3-3-3.4-2.9-5.2q0 0 0 0c0-0.1 0-0.4 0-0.6 0-0.4 0.1-0.8 0.1-1.1 0.1-1.2 0.2-1.3 0.5-1.3 0 0 0.1-0.1 0.1-0.1zm0.2 0.4c-0.2 0.2-0.3 0.6-0.3 0.9-0.1 0.6-0.2 1-0.2 1.4-0.1 0.2 0 0.4-0.1 0.5-0.1 1.5 0.7 2.5 2.8 4.8 0.9 1 1.9 2.2 3.1 3.4 2.7 2.5 6.1 4.2 10.1 4.2q2.3 0 4.9-0.7c2.7-0.8 5-2.2 7.2-3.9 1.3-1 1.8-1.8 2.2-2.7 0.3-0.5 0.6-1 0.9-1.6 0.4-0.6 0.6-1.2 0.9-1.7 1.1-1.9 1.8-4.1 1.2-5.4q-0.4-0.8-0.9-1-0.5-0.3-1.2 0.2c-0.5 0.2-1.1 0.6-1.8 1.3-0.8 0.8-1.6 1.8-2.7 2.9q-0.3 0.4-0.7 0.8c-2.6 2.8-5.5 4.6-8.1 5.4-1.2 0.4-2.3 0.6-3.3 0.4q-0.3-0.1-0.6-0.2-0.5-0.3-1.2-0.7-0.5-0.4-1-0.7c-1.2-0.9-2.5-2-4-3.2-1.9-1.5-5.2-4-7.2-4.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f9",
    d: "m311.9 86.4c-2.7 0-5.1-0.8-7-2.3q-1.3-1.2-2.3-1.9c-2-1.6-2.8-2.2-2.6-3.8 0-0.1-0.2-0.9-0.3-1.5-0.3-1.3-0.3-1.3-0.2-1.4h0.1 0.1c1.4 0.4 4.3 2.8 5.5 3.9 1.1 1 2 1.9 2.9 2.5q2.2 1.5 4.7 1.5c2.4 0 4.9-1.1 7.3-3.3 0.8-0.7 1.5-1.5 2.1-2.1 1-1.1 1.7-1.9 2.4-1.9q0.6 0 1.1 0.7c1 1.4-0.9 4.2-1.8 5.2-0.4 0.3-0.6 0.6-0.8 0.8-0.4 0.5-0.7 0.8-2 1.4-3.4 1.5-6.5 2.2-9.2 2.2zm-11.6-7.9c-0.1 1.3 0.5 1.8 2.5 3.4q1 0.8 2.4 1.9 2.7 2.3 6.7 2.3 3.9 0 9.1-2.2c1.2-0.5 1.5-0.8 1.8-1.3 0.2-0.2 0.5-0.5 0.9-0.9 1-1 2.5-3.5 1.7-4.7q-0.4-0.5-0.8-0.5c-0.5 0-1.3 0.7-2.2 1.7-0.6 0.7-1.2 1.4-2.1 2.1-2.5 2.3-5 3.4-7.5 3.4q-2.6 0-4.8-1.6c-1-0.6-1.9-1.5-3-2.5-1.1-1-3.7-3.2-5.2-3.7 0.1 0.2 0.1 0.6 0.2 1 0.3 1.2 0.3 1.5 0.3 1.6z"
  })))), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    className: "fa",
    d: "m307.8 109.1c0 4-3.3 7.3-7.3 7.3-4 0-7.3-3.3-7.3-7.3 0-4 3.3-7.3 7.3-7.3 4 0 7.3 3.3 7.3 7.3z"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    className: "fb",
    d: "m282.8 85.6c0 4.1-3.3 7.3-7.3 7.3-4 0-7.3-3.2-7.3-7.3 0-4 3.3-7.2 7.3-7.2 4 0 7.3 3.2 7.3 7.2z"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    className: "fc",
    d: "m282.6 106.5c0 4-3.3 7.3-7.3 7.3-4 0-7.3-3.3-7.3-7.3 0-4 3.3-7.3 7.3-7.3 4 0 7.3 3.3 7.3 7.3z"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    className: "fd",
    d: "m227.5 55.3c0 4-3.3 7.2-7.3 7.2-4 0-7.2-3.2-7.2-7.2 0-4.1 3.2-7.3 7.2-7.3 4 0 7.3 3.2 7.3 7.3z"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    className: "fe",
    d: "m258.4 39c0 4-3.3 7.2-7.3 7.2-4 0-7.2-3.2-7.2-7.2 0-4.1 3.2-7.3 7.2-7.3 4 0 7.3 3.2 7.3 7.3z"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    className: "ff",
    d: "m272.6 65.3c0 4-3.2 7.3-7.2 7.3-4.1 0-7.3-3.3-7.3-7.3 0-4 3.2-7.3 7.3-7.3 4 0 7.2 3.3 7.2 7.3z"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    className: "fg",
    d: "m253.7 102.6c0 4-3.2 7.2-7.2 7.2-4 0-7.3-3.2-7.3-7.2 0-4 3.3-7.3 7.3-7.3 4 0 7.2 3.3 7.2 7.3z"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    className: "fh",
    d: "m249 71.9c0 4-3.2 7.2-7.3 7.2-4 0-7.2-3.2-7.2-7.2 0-4.1 3.2-7.3 7.2-7.3 4.1 0 7.3 3.2 7.3 7.3z"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    className: "fi",
    d: "m303.4 44.9c0 4.1-3.3 7.3-7.3 7.3-4 0-7.3-3.2-7.3-7.3 0-4 3.3-7.2 7.3-7.2 4 0 7.3 3.2 7.3 7.2z"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    className: "fj",
    d: "m341.9 59.7c0 4-3.2 7.2-7.3 7.2-4 0-7.2-3.2-7.2-7.2 0-4 3.2-7.3 7.2-7.3 4.1 0 7.3 3.3 7.3 7.3z"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    className: "fk",
    d: "m328.4 35.5c0 4-3.3 7.2-7.3 7.2-4 0-7.2-3.2-7.2-7.2 0-4.1 3.2-7.3 7.2-7.3 4 0 7.3 3.2 7.3 7.3z"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    className: "fl",
    d: "m324.6 87.3c0 4-3.3 7.3-7.3 7.3-4 0-7.2-3.3-7.2-7.3 0-4 3.2-7.3 7.2-7.3 4 0 7.3 3.3 7.3 7.3z"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    className: "fm",
    d: "m300.6 67.1c0 4-3.3 7.2-7.3 7.2-4 0-7.3-3.2-7.3-7.2 0-4.1 3.3-7.3 7.3-7.3 4 0 7.3 3.2 7.3 7.3z"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    className: "fn",
    d: "m508.2 63.1v48.2l5.7-3.4v-48.3z"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    className: "fo",
    d: "m508.2 63.1v48.2l-1.5-0.9v-48.2z"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    className: "fp",
    d: "m506.7 62.2l1.5 0.9 5.7-3.5-1.5-0.8z"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    className: "fq",
    d: "m514.3 70.2l-1.9 1v-6.5h-1.2v7.2l-0.4 0.3v8.1l0.4-0.2v24.3c0 0.2 0.3 0.4 0.6 0.4 0.3 0 0.6-0.2 0.6-0.4v-25l1.9-1.1z"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    className: "fr",
    d: "m539.4 107v4.3l1.6-0.9v-4.3z"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    className: "fs",
    d: "m539.4 107v4.3l-6.5-3.8v-4.3z"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    className: "ft",
    d: "m532.9 103.2l6.5 3.8 1.6-0.9-6.6-3.8z"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    className: "fu",
    d: "m507.5 108.6v4.7l8.3-4.8v-4.7z"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    className: "fv",
    d: "m507.5 108.6v4.7l-1.7-1v-4.6z"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    className: "fw",
    d: "m505.8 107.7l1.7 0.9 8.3-4.8-1.8-1z"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    className: "fx",
    d: "m507.5 108.4v1.1l8.3-4.8v-1.1z"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    className: "fy",
    d: "m507.5 108.4v1.1l-1.7-1v-1.1z"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    className: "fz",
    d: "m505.8 107.4l1.7 1 8.3-4.8-1.8-1z"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    className: "fA",
    d: "m532.3 124.9v1l6.7-3.9v-0.9z"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    className: "fB",
    d: "m532.3 124.9v1l-22.3-12.8v-1z"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    className: "fC",
    d: "m510 112.1l22.3 12.8 6.7-3.8-22.2-12.8z"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    className: "fq",
    d: "m534.9 118.7l-18.1-10.4-6.8 3.8 18.2 10.5z"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    className: "fD",
    d: "m515 71.2v8.2l1.1-0.7v-8.1z"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    className: "fE",
    d: "m515 71.2v8.2l-2.6-1.5v-8.2z"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    className: "fF",
    d: "m512.4 69.7l2.6 1.5 1.1-0.6-2.6-1.5z"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    className: "fG",
    d: "m534 123.9v4.7l8.3-4.8v-4.7z"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    className: "fH",
    d: "m534 123.9v4.7l-1.8-1v-4.6z"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    className: "fI",
    d: "m532.2 123l1.8 0.9 8.3-4.8-1.8-0.9z"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    className: "fJ",
    d: "m534 123.6v1.1l8.3-4.8v-1.1z"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    className: "fK",
    d: "m534 123.6v1.1l-1.8-1v-1.1z"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    className: "fL",
    d: "m532.2 122.6l1.8 1 8.3-4.8-1.8-1z"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    className: "fM",
    d: "m513.9 65.6h-1.2v38.6q0 0 0 0c0 0.2 0.3 0.3 0.6 0.3 0.3 0 0.6-0.1 0.6-0.3q0 0 0 0z"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    className: "fN",
    d: "m523.5 88.8h-0.8v2.1c0 0.1 0.1 0.3 0.4 0.3 0.2 0 0.4-0.2 0.4-0.3z"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    className: "fO",
    d: "m524.2 83.6h-2.2v5.6q0 0 0 0c0 0.3 0.5 0.6 1.1 0.6 0.6 0 1.1-0.3 1.1-0.6q0 0 0 0z"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    className: "fP",
    d: "m512.7 72.6v8.2l3.4-2.1v-8.1z"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    className: "fQ",
    d: "m512.7 72.6v8.2l-1.2-0.7v-8.2z"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    className: "fR",
    d: "m511.5 71.9l1.2 0.7 3.4-2-1.1-0.7z"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    className: "fS",
    d: "m537.5 78.9v3.4l3-1.7v-3.4z"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    className: "fT",
    d: "m537.5 78.9v3.4l-28.2-16.2v-3.3z"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    className: "fU",
    d: "m509.3 62.8l28.2 16.1 3-1.7-28.3-16.1z"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    className: "fV",
    d: "m525.1 79.8v0.6l-10.8-6.2v-0.6z"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    className: "fW",
    d: "m525.1 79.8v0.6l0.7-0.3v-0.7z"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    className: "fX",
    d: "m525.8 79.4l-0.7 0.4-10.8-6.2 0.6-0.4z"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    className: "fY",
    d: "m525.1 83.2v0.6l-10.8-6.2v-0.6z"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    className: "fZ",
    d: "m525.1 83.2v0.6l0.7-0.3v-0.6z"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    className: "g0",
    d: "m525.8 82.9l-0.7 0.3-10.8-6.2 0.6-0.3z"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    className: "g1",
    d: "m513.7 124.6v1l26.9-15.7v-0.9z"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    className: "g2",
    d: "m506.2 120.3l7.5 4.3 26.9-15.6-7.5-4.3z"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    className: "fq",
    d: "m518 122.1l22.6-13.1-7.5-4.3-22.6 13.1z"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    className: "g3",
    d: "m509.2 121.1v0.6l26.9-15.5v-0.7z"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    className: "g4",
    d: "m509.2 121.1v0.6l-0.7-0.4v-0.6z"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    className: "g5",
    d: "m508.5 120.7l0.7 0.4 26.9-15.6-0.6-0.4z"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    className: "g6",
    d: "m511.7 122.5v0.7l26.9-15.6v-0.6z"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    className: "g7",
    d: "m511.7 122.5v0.7l-0.7-0.4v-0.7z"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    className: "g8",
    d: "m511 122.1l0.7 0.4 26.9-15.5-0.6-0.4z"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    className: "g9",
    d: "m523.3 122.7v0.9l15.9-9.3v-0.9z"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    className: "ga",
    d: "m523.3 122.7v0.9l-16.5-9.4v-0.9z"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    className: "gb",
    d: "m506.8 113.3l16.5 9.4 15.9-9.3-16.4-9.4z"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    className: "gc",
    d: "m523.3 121.8v1l15.9-9.3v-1z"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    className: "gd",
    d: "m523.3 121.8v1l-16.5-9.5v-0.9z"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    className: "ge",
    d: "m506.8 112.4l16.5 9.4 15.9-9.3-16.4-9.4z"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    className: "gf",
    d: "m506.8 112.4l16.5 9.4 15.9-9.3-15.9 9z"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    className: "gg",
    d: "m527.4 81.9v6.5l3.6-2.3v-6.4z"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    className: "gh",
    d: "m527.4 81.9v6.5l-6.6-3.9v-6.4z"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    className: "gi",
    d: "m520.8 78.1l6.6 3.8 3.6-2.2-6.6-3.8z"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    className: "gj",
    d: "m512.4 123.1v4.3l1.5-0.9v-4.3z"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    className: "gk",
    d: "m512.4 123.1v4.3l-6.6-3.8v-4.3z"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    className: "gl",
    d: "m505.8 119.3l6.6 3.8 1.5-0.9-6.6-3.9z"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    className: "gm",
    d: "m512.4 122.2v1.2l1.5-0.9v-1.2z"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    className: "gn",
    d: "m512.4 122.2v1.2l-6.6-3.8v-1.2z"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    className: "go",
    d: "m505.8 118.4l6.6 3.8 1.5-0.9-6.6-3.8z"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    className: "gp",
    d: "m539.4 105.9v1.2l1.6-0.9v-1.2z"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    className: "gq",
    d: "m539.4 105.9v1.2l-6.5-3.8v-1.2z"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    className: "gr",
    d: "m532.9 102.1l6.5 3.8 1.6-0.9-6.6-3.8z"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    className: "gs",
    d: "m540.7 88.9v0.6l-11.8-6.8v-0.6z"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    className: "gt",
    d: "m540.7 88.9v0.6l0.6-0.4v-0.6z"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    className: "gu",
    d: "m541.3 88.5l-0.6 0.4-11.8-6.8 0.6-0.4z"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    className: "gv",
    d: "m540.7 92.3v0.6l-11.8-6.8v-0.6z"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    className: "gw",
    d: "m540.7 92.3v0.6l0.6-0.4v-0.6z"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    className: "gx",
    d: "m541.3 91.9l-0.6 0.4-11.8-6.8 0.6-0.4z"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    className: "gy",
    d: "m523.1 85.6v3.4l3-1.7v-3.4z"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    className: "gz",
    d: "m523.1 85.6v3.4l-3.4-2v-3.4z"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    className: "gA",
    d: "m519.7 83.6l3.4 2 3-1.7-3.5-2z"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    className: "gB",
    d: "m523.1 85.4v1.3l3-1.7v-1.2z"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    className: "gC",
    d: "m523.1 85.4v1.3l-3.4-2v-1.2z"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    className: "gD",
    d: "m519.7 83.5l3.4 1.9 3-1.6-3.5-2z"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    className: "gE",
    d: "m537.8 80v48.2l5.7-3.4v-48.2z"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    className: "gF",
    d: "m537.8 80v48.2l-1.5-0.8v-48.2z"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    className: "gG",
    d: "m536.3 79.2l1.5 0.8 5.7-3.4-1.5-0.9z"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    className: "gH",
    d: "m508.5 122.1c0 0.3-0.2 0.4-0.5 0.2-0.2-0.1-0.4-0.4-0.4-0.7 0-0.3 0.2-0.4 0.4-0.3 0.3 0.2 0.5 0.5 0.5 0.8z"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    className: "gI",
    d: "m510.6 123.3c0 0.3-0.2 0.4-0.4 0.3-0.2-0.2-0.4-0.5-0.4-0.8 0-0.3 0.2-0.4 0.4-0.2 0.2 0.1 0.4 0.4 0.4 0.7z"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    className: "gJ",
    d: "m541.3 80.1c0 0.3 0.2 0.4 0.4 0.3 0.3-0.2 0.5-0.5 0.5-0.8 0-0.3-0.2-0.4-0.5-0.2-0.2 0.1-0.4 0.4-0.4 0.7z"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    className: "gK",
    d: "m539.5 81.2c0 0.3 0.2 0.4 0.4 0.2 0.3-0.1 0.5-0.5 0.5-0.7 0-0.3-0.2-0.4-0.5-0.3-0.2 0.1-0.4 0.5-0.4 0.8z"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    className: "gL",
    d: "m541.3 82.3c0 0.3 0.2 0.4 0.4 0.2 0.3-0.1 0.5-0.5 0.5-0.7 0-0.3-0.2-0.4-0.5-0.3-0.2 0.2-0.4 0.5-0.4 0.8z"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    className: "gM",
    d: "m539.5 83.3c0 0.3 0.2 0.4 0.4 0.3 0.3-0.2 0.5-0.5 0.5-0.8 0-0.3-0.2-0.4-0.5-0.2-0.2 0.1-0.4 0.4-0.4 0.7z"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    className: "gN",
    d: "m541.3 122.1c0 0.3 0.2 0.4 0.4 0.2 0.3-0.1 0.5-0.4 0.5-0.7 0-0.3-0.2-0.4-0.5-0.3-0.2 0.2-0.4 0.5-0.4 0.8z"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    className: "gO",
    d: "m539.5 123.1c0 0.3 0.2 0.4 0.4 0.3 0.3-0.2 0.5-0.5 0.5-0.8 0-0.3-0.2-0.4-0.5-0.2-0.2 0.1-0.4 0.5-0.4 0.7z"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    className: "gP",
    d: "m541.3 124.2c0 0.3 0.2 0.4 0.4 0.3 0.3-0.1 0.5-0.5 0.5-0.8 0-0.3-0.2-0.4-0.5-0.2-0.2 0.1-0.4 0.5-0.4 0.7z"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    className: "gQ",
    d: "m539.5 125.3c0 0.3 0.2 0.4 0.4 0.2 0.3-0.1 0.5-0.4 0.5-0.7 0-0.3-0.2-0.4-0.5-0.3-0.2 0.2-0.4 0.5-0.4 0.8z"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    className: "gR",
    d: "m543.5 76.6l-5.7 3.2-1.5-0.6 1.3 0.9 0.2 46.7 0.2-46.7z"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    className: "gS",
    d: "m531 79.7l-3.6 2-6.6-3.6 6.4 4 0.2 6.2 0.1-6.2z"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    className: "gT",
    d: "m526.1 83.8l-2.9 1.4-3.5-1.7 3.3 2.1 0.1 3.4 0.2-3.4z"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    className: "gU",
    d: "m513.9 121.4l-1.5 0.7-6.5-3.6 6.3 3.9 0.2 4.9 0.1-4.9z"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    className: "gV",
    d: "m513.9 59.6l-5.7 3.2-1.5-0.6 1.3 1 0.2 46.7 0.1-46.7z"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    className: "gW",
    d: "m560.1 366.1l-40.6 23.1c-7 4-15.5 4-22.4 0l-9.4-5.5c-1-0.5-1-1.9 0-2.5l50.7-29.4c0.5-0.3 1-0.3 1.5 0l20.2 11.8c0.9 0.5 0.9 1.9 0 2.5z"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    className: "gX",
    d: "m558.4 362.4l-4.8-2.7 2.1-2.8c0 0 3.6 3.4 3.5 3.7-0.2 0.2-0.8 1.8-0.8 1.8z"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    className: "gX",
    d: "m523 382.8l-7.3-4.3c0 0 5-2.5 5.2-2.5 0.3 0 3.3 1.9 3.3 1.9z"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    className: "gY",
    d: "m511.8 385.5c0 1.3 0.5 2.2 1.2 2.7 0 0 2.3 1.3 2.3 1.3 0.8 0.4 0.3-0.5 1.5-1.2 2.3-1.3 4.2-4.6 4.2-7.2 0-1.4 1.2-1.4 0.4-1.8 0 0-2.4-1.4-2.4-1.4-0.8-0.4-1.8-0.3-3 0.3-2.3 1.4-4.2 4.6-4.2 7.3z"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    className: "gZ",
    d: "m514.3 386.9c0 2.6 1.8 3.7 4.2 2.4 2.3-1.4 4.2-4.6 4.2-7.3 0-2.6-1.9-3.7-4.2-2.4-2.4 1.4-4.2 4.6-4.2 7.3z"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    className: "h0",
    d: "m518.3 379.5c1.1-0.6 2.1-0.7 2.8-0.3-0.7-0.2-1.5-0.1-2.5 0.5-2.3 1.3-4.2 4.5-4.2 7.2 0 1.4 0.5 2.4 1.4 2.8-1.1-0.3-1.7-1.3-1.7-2.9 0-2.7 1.8-5.9 4.2-7.3z"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h1",
    d: "m518.3 380.8c1.8-1 3.3-0.2 3.3 1.8 0 2.1-1.5 4.6-3.3 5.6-1.8 1.1-3.2 0.2-3.2-1.8 0-2.1 1.4-4.6 3.2-5.6zm-1.2 4.1l-1-0.1c-0.2 0-0.4 0.2-0.4 0.4q-0.1 0.5-0.1 0.9 0 0.4 0.1 0.8c0 0.1 0.2 0.1 0.4-0.1l1-1.2c0.1-0.1 0.1-0.3 0.1-0.4q0 0 0-0.1 0 0 0 0 0-0.2-0.1-0.2zm-0.6-1l1 0.1q0.1 0 0.2-0.2 0.1-0.1 0.1-0.1 0.2-0.2 0.2-0.4v-1.3c0-0.2-0.2-0.3-0.4-0.1-0.4 0.4-0.9 0.9-1.2 1.5-0.1 0.2-0.1 0.5 0.1 0.5zm2.2-2.3v1.3q0 0.2 0.1 0.2 0.1 0 0.1 0 0.2 0 0.3-0.2l1-1.2c0.2-0.2 0.2-0.4 0.1-0.5q-0.6-0.3-1.3-0.1c-0.1 0-0.3 0.3-0.3 0.5zm1.9 0.6l-1 1.3c-0.1 0.1-0.2 0.2-0.2 0.3q0 0 0 0.1 0 0 0 0 0 0.2 0.2 0.2l1 0.1c0.1 0 0.3-0.2 0.4-0.4q0.1-0.4 0.1-0.9 0-0.4-0.1-0.7c-0.1-0.2-0.3-0.2-0.4 0zm-0.4 3l-1-0.1q-0.1 0-0.3 0.1 0 0.1-0.1 0.1-0.1 0.2-0.1 0.4v1.3c0 0.2 0.2 0.3 0.3 0.1 0.5-0.4 0.9-0.9 1.3-1.5 0.1-0.2 0.1-0.4-0.1-0.4zm-2.2 2.2v-1.3q0-0.2-0.2-0.2 0 0-0.1 0-0.1 0-0.2 0.2l-1 1.2c-0.2 0.2-0.2 0.5-0.1 0.5q0.5 0.3 1.2 0.1c0.2 0 0.4-0.2 0.4-0.5z"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h2",
    d: "m518.5 380.9c1.8-1.1 3.3-0.2 3.3 1.8 0 2.1-1.5 4.6-3.3 5.6-1.8 1-3.2 0.2-3.2-1.8 0-2.1 1.4-4.6 3.2-5.6zm-1.2 4.1l-1-0.1c-0.2 0-0.4 0.2-0.4 0.4q-0.1 0.4-0.1 0.9 0 0.4 0.1 0.7c0 0.2 0.2 0.2 0.4 0l1-1.3c0.1-0.1 0.1-0.2 0.1-0.3q0 0 0-0.1 0 0 0 0 0-0.2-0.1-0.2zm-0.6-1h1q0.1 0 0.2-0.1 0.1-0.1 0.1-0.1 0.2-0.2 0.2-0.4v-1.3c0-0.2-0.2-0.3-0.4-0.1-0.4 0.4-0.9 0.9-1.2 1.5-0.1 0.2-0.1 0.4 0.1 0.5zm2.2-2.3v1.3q0 0.2 0.1 0.2 0.1 0 0.1 0 0.2 0 0.3-0.2l1-1.2c0.2-0.2 0.2-0.5 0.1-0.5q-0.5-0.3-1.3-0.1c-0.1 0-0.3 0.3-0.3 0.5zm1.9 0.6l-1 1.2c-0.1 0.1-0.2 0.3-0.2 0.4q0 0 0 0.1 0 0 0 0 0 0.2 0.2 0.2l1 0.1c0.1 0 0.3-0.2 0.4-0.4q0.1-0.5 0.1-0.9 0-0.4-0.1-0.7c-0.1-0.2-0.3-0.2-0.4 0zm-0.4 2.9l-1-0.1q-0.1 0-0.3 0.2 0 0.1-0.1 0.1-0.1 0.2-0.1 0.4v1.3c0 0.2 0.2 0.3 0.3 0.1 0.5-0.4 0.9-0.9 1.3-1.5 0.1-0.2 0.1-0.5-0.1-0.5zm-2.2 2.3v-1.3q0-0.2-0.2-0.2 0 0-0.1 0-0.1 0-0.2 0.2l-1 1.2c-0.2 0.2-0.2 0.4-0.1 0.5q0.5 0.3 1.2 0.1c0.2 0 0.4-0.3 0.4-0.5z"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    className: "h3",
    d: "m547.1 365.7c0 1.3 0.5 2.2 1.2 2.6 0 0 2.3 1.4 2.3 1.4 0.8 0.4 0.3-0.6 1.5-1.2 2.3-1.4 4.2-4.6 4.2-7.3 0-1.3 1.2-1.3 0.4-1.8 0 0-2.4-1.3-2.4-1.3-0.8-0.4-1.8-0.4-3 0.3-2.3 1.3-4.2 4.6-4.2 7.3z"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    className: "h4",
    d: "m549.6 367c0 2.7 1.9 3.8 4.2 2.4 2.3-1.3 4.2-4.6 4.2-7.2 0-2.7-1.9-3.8-4.2-2.4-2.3 1.3-4.2 4.6-4.2 7.2z"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    className: "h5",
    d: "m553.6 359.7c1.1-0.7 2.1-0.7 2.8-0.4-0.7-0.2-1.5 0-2.5 0.5-2.3 1.4-4.2 4.6-4.2 7.3 0 1.4 0.5 2.3 1.4 2.7-1.1-0.3-1.7-1.3-1.7-2.9 0-2.6 1.9-5.9 4.2-7.2z"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h6",
    d: "m553.6 361c1.8-1.1 3.3-0.2 3.3 1.8 0 2.1-1.5 4.6-3.3 5.6-1.8 1-3.2 0.2-3.2-1.9 0-2 1.4-4.5 3.2-5.5zm-1.2 4.1l-1-0.1c-0.2 0-0.3 0.2-0.4 0.4q-0.1 0.4-0.1 0.9 0 0.4 0.1 0.7c0.1 0.2 0.2 0.2 0.4 0l1-1.3c0.1-0.1 0.1-0.2 0.1-0.3q0-0.1 0-0.1 0 0 0 0 0-0.2-0.1-0.2zm-0.6-1.1l1 0.1q0.1 0 0.2-0.1 0.1-0.1 0.1-0.2 0.2-0.1 0.2-0.3v-1.3c0-0.2-0.2-0.3-0.4-0.1-0.4 0.4-0.9 0.9-1.2 1.5-0.1 0.2-0.1 0.4 0.1 0.4zm2.2-2.3v1.4q0 0.2 0.1 0.2 0.1 0 0.1 0 0.2 0 0.3-0.2l1-1.2c0.2-0.2 0.2-0.5 0.1-0.5q-0.5-0.3-1.3-0.2c-0.1 0.1-0.3 0.3-0.3 0.5zm1.9 0.7l-1 1.2c-0.1 0.1-0.2 0.3-0.2 0.4q0 0 0 0 0 0.1 0 0.1 0 0.2 0.2 0.2l1 0.1c0.1 0 0.3-0.2 0.4-0.4q0.1-0.5 0.1-0.9 0-0.4-0.1-0.8c-0.1-0.1-0.3-0.1-0.4 0.1zm-0.4 2.9l-1-0.1q-0.1 0-0.3 0.2 0 0.1-0.1 0.1-0.1 0.2-0.1 0.4v1.3c0 0.2 0.2 0.2 0.3 0.1 0.5-0.4 0.9-1 1.3-1.5 0.1-0.3 0.1-0.5-0.1-0.5zm-2.2 2.3v-1.3q0-0.2-0.2-0.2 0 0-0.1 0-0.1 0-0.2 0.1l-1 1.3c-0.2 0.2-0.2 0.4-0.1 0.5q0.5 0.3 1.2 0.1c0.2 0 0.4-0.3 0.4-0.5z"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h7",
    d: "m553.8 361c1.8-1 3.3-0.2 3.3 1.9 0 2-1.5 4.5-3.3 5.6-1.7 1-3.2 0.2-3.2-1.9 0-2 1.5-4.5 3.2-5.6zm-1.2 4.1l-1-0.1c-0.2 0-0.3 0.2-0.4 0.5q-0.1 0.4-0.1 0.8 0 0.5 0.1 0.8c0.1 0.2 0.2 0.1 0.4 0l1-1.3c0.1-0.1 0.1-0.2 0.1-0.3q0-0.1 0-0.1 0 0 0-0.1 0-0.1-0.1-0.2zm-0.6-1l1 0.1q0.1 0 0.2-0.2 0.1 0 0.1-0.1 0.2-0.1 0.2-0.3v-1.4c0-0.2-0.2-0.2-0.4-0.1-0.4 0.5-0.9 1-1.2 1.6-0.1 0.2-0.1 0.4 0.1 0.4zm2.2-2.3v1.3q0 0.2 0.1 0.2 0.1 0 0.1 0.1 0.2 0 0.3-0.2l1-1.2c0.2-0.2 0.2-0.5 0.1-0.6q-0.5-0.3-1.3-0.1c-0.1 0.1-0.3 0.3-0.3 0.5zm1.9 0.7l-1 1.2c-0.1 0.1-0.2 0.3-0.2 0.4q0 0 0 0 0 0.1 0 0.1 0 0.2 0.2 0.2l1 0.1c0.1 0 0.3-0.2 0.4-0.4q0.1-0.5 0.1-0.9 0-0.4-0.1-0.8c-0.1-0.2-0.3-0.1-0.4 0.1zm-0.4 2.9l-1-0.1q-0.1 0-0.3 0.2 0 0-0.1 0.1-0.1 0.2-0.1 0.3v1.4c0 0.2 0.2 0.2 0.3 0.1 0.5-0.4 0.9-1 1.3-1.6 0.1-0.2 0.1-0.4-0.1-0.4zm-2.2 2.3v-1.3q0-0.2-0.2-0.2 0 0-0.1 0-0.1 0-0.2 0.1l-1 1.3c-0.2 0.2-0.2 0.4-0.1 0.5q0.5 0.3 1.2 0.1c0.2-0.1 0.4-0.3 0.4-0.5z"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    className: "h8",
    d: "m504.7 355.5c0 0-0.9-2.4-1.7-1.4-0.8 1-0.4 4.5-0.4 4.5z"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    className: "h9",
    d: "m488 371.3c1.3-2.5 15.4-14.9 22.8-20.7 7.4-5.9 17.6-10.2 20-11 2.4-0.9 8.9-1.4 12.3-1.3 3.8 0.1 15.2 7.5 16.7 8.8 0 0 2.1 8.4 2.1 9.3 0 0.8-1.7 4.6-3.5 6q0-0.2 0-0.4c0-3.1-2.2-4.3-4.9-2.8-2.7 1.6-4.9 5.4-4.9 8.4q0 0.3 0.1 0.5c-7.5 4.3-17.9 10.2-25.7 14.7q0.2-0.9 0.2-1.7c0-3.1-2.2-4.3-4.9-2.8-2.7 1.6-4.9 5.3-4.9 8.4q0 0.8 0.2 1.4-0.9 0.5-1.3 0.8c-4 2.2-12.1-1.1-19.9-5.4-7.6-4.3-5.8-9.7-4.4-12.2z"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "m519.7 371.7c3.5-3.6 5.9-9.5 9-14.2 3.1-4.7 14.3-9.4 16.6-9.7 2.1-0.3 10.4 0 14.5-0.8q0 0.1 0 0.1c0 0 2.1 8.4 2.1 9.3 0 0.8-1.7 4.6-3.5 6q0-0.2 0-0.4c0-3.1-2.2-4.3-4.9-2.8-2.7 1.6-4.9 5.4-4.9 8.4q0 0.3 0.1 0.5c-7.5 4.3-17.9 10.2-25.7 14.7q0.2-0.9 0.2-1.7c0-3.1-2.2-4.3-4.9-2.8-2.7 1.6-4.9 5.3-4.9 8.4q0 0.8 0.2 1.4-0.9 0.5-1.3 0.8c-1.2 0.6-2.7 0.8-4.4 0.6-0.2-2.3-0.3-5.6 0.7-6.8 1.6-1.9 7.5-7.4 11.1-11z"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    className: "ha",
    d: "m508.1 382.4c1.6-1.9 7.4-7.3 11-11 3.6-3.6 6.4-9.8 9.5-14.5 3.1-4.7 13.8-9 16.1-9.4 2.1-0.3 10.5 0.1 14.5-0.7 0 0-11.2 0.6-13.1 0.9-2.3 0.3-13.5 4.5-16.6 9.2-3 4.7-5.4 10.6-9 14.3-3.6 3.6-9.4 9.5-11 11.4-1 1.2-1 4.4-0.8 6.7q-0.6 0-1.4 0c-0.2-2.4-0.3-5.7 0.8-6.9z"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    className: "hb",
    d: "m545.7 346.6l-11.9-6.8c0 0 5.3-1.5 10.4 0.2 5.2 1.7 9.8 5.2 9.6 6.1-0.2 0.9-6.8 0.8-8.1 0.5z"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m542.5 340c-1.2-0.4-2.5-0.7-3.7-0.8 1.7 0 3.6 0.2 5.4 0.8 5.2 1.7 9.8 5.2 9.6 6.1-0.1 0.2-0.4 0.4-0.8 0.5-0.2-1.2-5.1-4.8-10.5-6.6z"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m526.3 358c-0.4-1.7-11.9-7.9-13-7.9-1.2-0.1-12.5 8.7-12.1 10.8 0.4 2.2 13.2 10.4 17.4 8.7 4.7-1.9 8.1-10.1 7.7-11.6z"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    className: "hd",
    d: "m525.9 358.2c-0.5-1.7-11.7-7.7-12.7-7.8-1.1 0-12.1 8.5-11.8 10.6 0.4 2.1 12.8 10.1 17 8.4 4.5-1.8 7.8-9.8 7.5-11.2z"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m503 358.1q-0.4 0.6-0.3 1c0.4 2.2 13.2 10.5 18 9.2q-1 0.8-2.1 1.3c-4.2 1.7-17-6.5-17.4-8.7-0.1-0.5 0.6-1.6 1.8-2.8z"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m524 370l30.2-17.6c0 0-6.8-4.4-11.9-2.6-5.2 1.8-12.9 7.2-14.3 10.5-1.4 3.2-4 9.7-4 9.7z"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    className: "he",
    d: "m524.8 369.3l28.6-16.6c0 0-6.4-4.2-11.3-2.5-4.9 1.7-12.2 6.9-13.5 9.9-1.3 3.1-3.8 9.2-3.8 9.2z"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    className: "gX",
    d: "m503 381.2c0 0-1.6 2.8-2.4 2.8-0.8 0.1-2.8-0.7-7-3.1-2.6-1.5-3.8-2.6-4.1-3.4-0.2-0.9 0.4-3.8 0.4-3.8 0 0 1.6 1.8 5.9 4.2 3.3 1.9 7.2 3.3 7.2 3.3z"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    className: "hf",
    d: "m489.9 373.7q0 0 0.3 0.2c-0.2 0.9-0.5 2.7-0.3 3.3 0.3 0.8 1.4 1.9 4.1 3.4 4.1 2.4 6.2 3.2 7 3.1q0.1 0 0.2 0-0.3 0.3-0.6 0.3c-0.8 0.1-2.8-0.7-7-3.1-2.6-1.5-3.8-2.6-4.1-3.4-0.2-0.9 0.4-3.8 0.4-3.8z"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    className: "hg",
    d: "m504.1 381.4l-2 3.1c0 0 2.5 0.6 4.2 0.5 1.7-0.1 3-1.2 3.5-2.1 0.6-0.9 0.7-2.5 0.7-2.5 0 0-2.1 0.9-3.6 1.1-1.6 0.3-2.8-0.1-2.8-0.1z"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    className: "hh",
    d: "m504.1 381.4l-2 3.1c0 0 2.9-0.3 5.1-1.5 2.3-1.2 3.3-2.6 3.3-2.6 0 0-2.1 0.9-3.6 1.1-1.6 0.3-2.8-0.1-2.8-0.1z"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    className: "hi",
    d: "m489.2 373.5l-0.4 3.5c0 0-1.9-1.6-2-2.8-0.1-1.3 0.9-2.7 0.9-2.7 0 0 0.4 1 1.5 2z"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    className: "hj",
    d: "m489.2 373.5l-0.4 3.5c0 0-0.9-2.1-1-3.3-0.1-1.3-0.1-2.2-0.1-2.2 0 0 0.4 1 1.5 2z"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    className: "hk",
    d: "m559.1 346.4c0 0 0.9 0.4 1.2 0.9 0.3 0.5 0.8 5.1 0.8 5.1 0 0-2.6-4.3-2.8-4.7-0.2-0.5 0.8-1.3 0.8-1.3z"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    className: "hl",
    d: "m503.9 382.7l0.8 1.7c0 0 2.4-1.5 2.2-2-0.3-0.5-3 0.3-3 0.3z"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    className: "hm",
    d: "m504.9 383.9c0 0.5-0.3 0.6-0.6 0.4-0.4-0.2-0.7-0.7-0.7-1.1 0-0.5 0.3-0.6 0.7-0.4 0.3 0.2 0.6 0.7 0.6 1.1z"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    className: "hn",
    d: "m505.8 382.7l0.8 1.7c0 0 2.4-1.5 2.2-2-0.3-0.6-3 0.3-3 0.3z"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    className: "ho",
    d: "m506.8 383.9c0 0.4-0.3 0.6-0.6 0.4-0.4-0.2-0.7-0.8-0.7-1.2 0-0.4 0.3-0.6 0.7-0.4 0.3 0.2 0.6 0.8 0.6 1.2z"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    className: "hp",
    d: "m507.3 381.7l0.7 1.5c0 0 2.1-1.3 1.9-1.8-0.2-0.4-2.6 0.3-2.6 0.3z"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    className: "hq",
    d: "m508.2 382.8c0 0.4-0.3 0.5-0.6 0.3-0.3-0.2-0.6-0.6-0.6-1 0-0.4 0.3-0.5 0.6-0.4 0.3 0.2 0.6 0.7 0.6 1.1z"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    className: "hr",
    d: "m487.7 373.8l0.7 1.5c0 0 0.9-1 0.7-1.5-0.2-0.4-1.4 0-1.4 0z"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    className: "hs",
    d: "m488.7 374.9c0 0.4-0.3 0.5-0.6 0.3-0.4-0.1-0.6-0.6-0.6-1 0-0.4 0.2-0.5 0.6-0.3 0.3 0.2 0.6 0.6 0.6 1z"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    className: "ht",
    d: "m487.3 372.6l0.6 1.1c0 0 0.8-0.5 0.6-0.9-0.2-0.3-1.2-0.2-1.2-0.2z"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    className: "hu",
    d: "m488.1 373.4c0 0.3-0.3 0.4-0.5 0.3-0.3-0.2-0.5-0.6-0.5-0.8 0-0.3 0.2-0.4 0.5-0.3 0.2 0.1 0.5 0.5 0.5 0.8z"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    className: "hv",
    d: "m554.1 352.7l-30.5 17.5-5.4 5.8 0.5 0.5 4.7-1.6 34.4-19.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    className: "hw",
    d: "m558.4 362.4q0-0.2 0-0.4c0-1.8-0.8-3-2-3.4 2.3-1.3 4.1-2.4 5.4-3.1q0.1 0.7 0.1 0.9c0 0.8-1.7 4.6-3.5 6z"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    className: "hx",
    d: "m487.3 378.3c1.3 1.2 3.2 2.9 5.1 4.3 3.6 2.6 12.5 5.5 15.8 3.8 0.6-0.3 2.9-1.5 6.1-3.4-0.6 1.3-0.9 2.6-0.9 3.7q0 0.8 0.2 1.4-0.9 0.5-1.3 0.8c-4 2.2-12.1-1.1-19.9-5.4-2.9-1.7-4.4-3.5-5.1-5.2z"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    className: "hy",
    d: "m523 382.8q0.2-0.9 0.2-1.7c0-1.2-0.3-2.1-0.9-2.7 8.7-5 19.8-11.4 28.3-16.4-1.2 1.7-2 3.8-2 5.6q0 0.3 0.1 0.5c-7.5 4.3-17.9 10.2-25.7 14.7z"
  }))), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    className: "hz",
    d: "m511.3 383.2c0 0-3.6 2.2-5.2 2.3-2.3 0-7-1.1-11.8-4-7.3-4.5-7.5-7.4-7.5-7.4 0 0-0.6 3.5-0.4 5.1 0.2 1.7 1.7 3.8 8.1 7.1 6.1 3.2 11.1 3.9 13.6 3.6 2.4-0.3 4.2-1 4.2-1z"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    className: "hA",
    d: "m505.9 386c-2.4 0-7.1-1.1-11.8-4.1-5.6-3.4-7.1-5.9-7.5-6.9 0.1-0.6 0.2-0.9 0.2-0.9 0 0 0.2 2.9 7.5 7.4 4.8 2.9 9.5 4 11.8 4 1.6-0.1 5.2-2.3 5.2-2.3l0.1 0.5c-1.6 0.8-4.5 2.2-5.5 2.3z"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    className: "hB",
    d: "m486.4 379.2c0-0.5 0-1.1 0-1.8 1.3 1.3 3.6 3.5 6 5.2 3.6 2.6 12.5 5.5 15.8 3.8 0.5-0.2 1.6-0.8 3.3-1.8l0.8 4.3c0 0-1.8 0.7-4.2 1-2.5 0.3-7.5-0.4-13.6-3.6-6.4-3.3-7.9-5.4-8.1-7.1z"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    className: "hC",
    d: "m486.4 379.2c0-0.5 0-1.1 0-1.8 1.3 1.3 3.6 3.5 6 5.2 3.6 2.6 12.5 5.5 15.8 3.8 0.5-0.2 1.6-0.8 3.3-1.8l0.8 4.3c0 0-1.8 0.7-4.2 1-2.5 0.3-7.5-0.4-13.6-3.6-6.4-3.3-7.9-5.4-8.1-7.1z"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m527.5 367.9l-3.5 2.1c0 0 1.5-3.6 2.8-6.8z"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m545.2 349.4c4.5 0.1 9 3 9 3l-5.8 3.4c-0.2-0.7-0.4-1.7-0.6-2.6-0.3-1.5-1.9-3.2-2.6-3.8z"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    className: "hD",
    d: "m524.7 356.4c-8.3 2.4-17 2.4-22.1 2.1 3-3.4 9.8-8.5 10.7-8.4 0.8 0 8.1 3.8 11.4 6.3z"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    className: "hE",
    d: "m495.3 386.2c-5.6-2.8-8-5.2-8.2-6-0.3-0.8 0.2-0.1 1.3 0.8 1.5 1.1 3.7 2.5 7.4 4.4 6.1 3.2 10.2 3.1 10.4 3.4 0.2 0.4-2.7 1.5-10.9-2.6z"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    className: "hF",
    d: "m499.7 361.3c0 0-10.8 8.6-9.2 10.8 1.5 2.2 11.9 9.1 16 7.8 4.1-1.3 10.4-8.6 10.4-8.6 0 0-7.3-1.8-12-5-4.8-3.2-5.2-5-5.2-5z"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    className: "hG",
    d: "m504.1 381.4c0 0 1 3 4.7 1.6 1-0.3 1.7-2.6 1.7-2.6 0 0-2.1 0.9-3.6 1.1-1.6 0.3-2.8-0.1-2.8-0.1z"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    className: "hH",
    d: "m526.7 356.1c0 0-11.8-6.6-11.9-7-0.2-0.4 15.3-8.9 17.3-8.9 2.1 0 11 6.1 10.5 6.6-0.4 0.5-7.3 3.2-9.5 4.6-3 1.9-4.6 3.1-6.4 4.7z"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    className: "hc",
    d: "m539.7 360.9l-3.2 1.7-1.1-9.2 1.8-1.1z"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    className: "hI",
    d: "m523.9 370.1c0.1 0.1 0.9 2.2 1.1 5.3 0.1 2.3 0.1 4.1 0.1 4.8l13.1-7.5c0.1-1 0.1-4.9-0.2-9.1-0.4-4.9-2.1-10.5-2.1-10.5l0.5-0.2c0 0.1 1.6 5.7 2 10.6 0.4 4 0.3 7.6 0.3 8.9l7.5-4.3c0.2-0.5 1.5-3.3 2.9-6.5 1.5-3.4 0.3-6.2 0.3-6.2l0.4-0.2c0 0.1 1.3 3-0.3 6.6-1.5 3.4-2.9 6.5-3 6.5v0.1l-21.8 12.6v-0.4c0 0 0-2.2-0.2-5.2-0.1-3-1-5.1-1-5.1z"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    className: "hJ",
    d: "m524.3 369.8c0 0 3.9 3.2 5.9 2.1 2-1.1-3.9-3.4-3.9-3.4z"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    className: "hK",
    d: "m526.7 366.8c0.6-0.1 3.4 0.2 3.9 1.4 0.5 1.3-6.2 1.9-6.5 1.7-0.2-0.3 1.3-3 2.6-3.1z"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    className: "hL",
    d: "m526.8 367c0.5-0.1 2.7 0.1 3 1 0.4 0.8-4.9 1.4-5 1.2-0.2-0.2 1-2.1 2-2.2z"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    className: "hM",
    d: "m552.7 352.3c-6.5 1.7-13.2 2-18 1.9 2.4-1.7 5.2-3.2 7.4-4 4-1.4 8.9 1.1 10.6 2.1z"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    className: "hN",
    d: "m372.9 67.7c0 15.2 12.4 27.5 27.6 27.5 15.2 0 27.6-12.3 27.6-27.5 0-15.2-12.4-27.6-27.6-27.6-15.2 0-27.6 12.4-27.6 27.6z"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    className: "hO",
    d: "m486.8 118.2c0 15.3 12.4 27.6 27.6 27.6 15.2 0 27.6-12.3 27.6-27.6 0-15.2-12.4-27.5-27.6-27.5-15.2 0-27.6 12.3-27.6 27.5z"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    className: "hP",
    d: "m436.2 242.7c0 15.2 12.4 27.5 27.6 27.5 15.2 0 27.6-12.3 27.6-27.5 0-15.3-12.4-27.6-27.6-27.6-15.2 0-27.6 12.3-27.6 27.6z"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    className: "hQ",
    d: "m465.7 384.2c0 15.2 12.4 27.6 27.6 27.6 15.2 0 27.6-12.4 27.6-27.6 0-15.2-12.4-27.6-27.6-27.6-15.2 0-27.6 12.4-27.6 27.6z"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    className: "hR",
    d: "m330.4 378c0 15.2 12.3 27.6 27.6 27.6 15.2 0 27.5-12.4 27.5-27.6 0-15.2-12.3-27.6-27.5-27.6-15.3 0-27.6 12.4-27.6 27.6z"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    className: "hS",
    d: "m33.2 291.8c0 15.2 12.3 27.5 27.5 27.5 15.3 0 27.6-12.3 27.6-27.5 0-15.2-12.3-27.6-27.6-27.6-15.2 0-27.5 12.4-27.5 27.6z"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    className: "hT",
    d: "m137.2 416.2c0 15.2 12.3 27.6 27.6 27.6 15.2 0 27.5-12.4 27.5-27.6 0-15.2-12.3-27.6-27.5-27.6-15.3 0-27.6 12.4-27.6 27.6z"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    className: "hU",
    d: "m136.1 48.4c0 15.2 12.4 27.6 27.6 27.6 15.2 0 27.6-12.4 27.6-27.6 0-15.2-12.4-27.6-27.6-27.6-15.2 0-27.6 12.4-27.6 27.6z"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    className: "hV",
    d: "m35 123c0 15.2 12.3 27.5 27.5 27.5 15.3 0 27.6-12.3 27.6-27.5 0-15.3-12.3-27.6-27.6-27.6-15.2 0-27.5 12.3-27.5 27.6z"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    className: "hW",
    d: "m91 92h-5.7v4c0 0.9 1.3 1.6 2.8 1.6 1.6 0 2.9-0.7 2.9-1.6z"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    className: "hX",
    d: "m85.3 92c0 0.9 1.3 1.7 2.8 1.7 1.6 0 2.9-0.8 2.9-1.7 0-0.9-1.3-1.6-2.9-1.6-1.5 0-2.8 0.7-2.8 1.6z"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    className: "hY",
    d: "m88.1 93.7c-1.5 0-2.8-0.8-2.8-1.6q0 0 0 0c0 0.9 1.3 1.6 2.8 1.6 1.6 0 2.9-0.7 2.9-1.6q0 0 0 0c-0.1 0.8-1.3 1.6-2.9 1.6z"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    className: "hZ",
    d: "m33.5 92h5.6v4c0 0.9-1.2 1.6-2.8 1.6-1.6 0-2.8-0.7-2.8-1.6z"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    className: "i0",
    d: "m39.1 92c0 0.9-1.2 1.7-2.8 1.7-1.6 0-2.8-0.8-2.8-1.7 0-0.9 1.2-1.6 2.8-1.6 1.6 0 2.8 0.7 2.8 1.6z"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    className: "i1",
    d: "m36.3 93.7c1.5 0 2.8-0.8 2.8-1.6q0 0 0 0c0 0.9-1.2 1.6-2.8 1.6-1.6 0-2.8-0.7-2.8-1.6q0 0 0 0c0 0.8 1.2 1.6 2.8 1.6z"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    className: "i2",
    d: "m91 121.3h-5.7v3.9c0 0.9 1.3 1.7 2.8 1.7 1.6 0 2.9-0.8 2.9-1.7z"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    className: "i3",
    d: "m85.3 121.3c0 0.9 1.3 1.6 2.8 1.6 1.6 0 2.9-0.7 2.9-1.6 0-0.9-1.3-1.7-2.9-1.7-1.5 0-2.8 0.8-2.8 1.7z"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    className: "i4",
    d: "m88.1 122.9c-1.5 0-2.8-0.7-2.8-1.6q0 0 0 0c0 0.9 1.3 1.7 2.8 1.7 1.6 0 2.9-0.8 2.9-1.7q0 0 0 0c-0.1 0.9-1.3 1.6-2.9 1.6z"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    className: "i5",
    d: "m72.6 101.3v2.8l-3.6-2.1v-2.8z"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    className: "i6",
    d: "m72.6 101.3v2.8l18-11.6v-1.7z"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    className: "i7",
    d: "m90.6 90.8l-18 10.5-3.6-2.1 18-10.5z"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    className: "i8",
    d: "m51.9 101.3v2.8l3.6-2.1v-2.8z"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    className: "i9",
    d: "m51.9 101.3v2.8l-18-11.6v-1.7z"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    className: "ia",
    d: "m33.9 90.8l18 10.5 3.6-2.1-18-10.5z"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    className: "ib",
    d: "m73.9 108.4h-23.5v5.8c0 0 0 0.1 0 0.1 0 3.8 5.3 6.9 11.8 6.9 6.5 0 11.7-3.1 11.7-6.9q0 0 0-0.1z"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    className: "ic",
    d: "m75.6 103.8h-26.8v6.6c0 0 0 0.1 0 0.1 0 4.3 6 7.8 13.4 7.8 7.4 0 13.4-3.5 13.4-7.8q0-0.1 0-0.1z"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    className: "id",
    d: "m48.8 103.8c0 4.4 6 7.9 13.4 7.9 7.4 0 13.4-3.5 13.4-7.9 0-4.3-6-7.8-13.4-7.8-7.4 0-13.4 3.5-13.4 7.8z"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    className: "ie",
    d: "m62.2 111.6c-7.3 0-13.3-3.4-13.4-7.6q0 0 0 0.1c0 4.3 6 7.8 13.4 7.8 7.4 0 13.4-3.5 13.4-7.8q0-0.1 0-0.1c-0.1 4.2-6.1 7.6-13.4 7.6z"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    className: "if",
    d: "m70 103.3c0 1.9-3 3.4-6.8 3.4-3.7 0-6.8-1.5-6.8-3.4 0-1.9 3.1-3.5 6.8-3.5 3.8 0 6.8 1.6 6.8 3.5z"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    className: "ig",
    d: "m67.6 101.3h-10.8v2q0 0.1 0 0.1c0 1.7 2.4 3.1 5.4 3.1 2.9 0 5.4-1.4 5.4-3.1q0 0-0.1-0.1h0.1z"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    className: "ih",
    d: "m56.8 101.3c0 1.7 2.4 3.1 5.4 3.1 2.9 0 5.4-1.4 5.4-3.1 0-1.7-2.5-3.1-5.4-3.1-3 0-5.4 1.4-5.4 3.1z"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    className: "ii",
    d: "m59.8 101.3c0 0.8 1.1 1.4 2.4 1.4 1.3 0 2.4-0.6 2.4-1.4 0-0.7-1.1-1.4-2.4-1.4-1.3 0-2.4 0.7-2.4 1.4z"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    className: "ij",
    d: "m62.2 104.4c-2.9 0-5.3-1.4-5.4-3.1q0 0.1 0 0.1c0 1.7 2.4 3.1 5.4 3.1 2.9 0 5.4-1.4 5.4-3.1q0 0-0.1-0.1c0 1.7-2.4 3.1-5.3 3.1z"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    className: "ik",
    d: "m88 122v1.7l3.6-2.1v-1.7z"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    className: "il",
    d: "m88 122v1.7l-18.8-8.8v-3.9z"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    className: "im",
    d: "m69.2 111l18.8 11 3.6-2.1-18.8-11z"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    className: "in",
    d: "m90.7 115.6h-5.1v3.6c0 0.8 1.1 1.5 2.5 1.5 1.4 0 2.6-0.7 2.6-1.5z"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    className: "io",
    d: "m85.6 115.7c0 0.8 1.1 1.4 2.5 1.4 1.4 0 2.6-0.6 2.6-1.4 0-0.9-1.2-1.5-2.6-1.5-1.4 0-2.5 0.6-2.5 1.5z"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    className: "ip",
    d: "m88.1 117.1c-1.4 0-2.5-0.6-2.5-1.4q0 0 0 0c0 0.8 1.1 1.5 2.5 1.5 1.4 0 2.6-0.7 2.6-1.5q0 0 0 0c0 0.8-1.2 1.4-2.6 1.4z"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    className: "iq",
    d: "m89.5 113.5h-2.7v1.9c0 0.5 0.6 0.8 1.3 0.8 0.8 0 1.4-0.3 1.4-0.8z"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    className: "ir",
    d: "m86.8 113.5c0 0.5 0.6 0.8 1.3 0.8 0.8 0 1.4-0.3 1.4-0.8 0-0.4-0.6-0.8-1.4-0.8-0.7 0-1.3 0.4-1.3 0.8z"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    className: "is",
    d: "m88.1 114.3c-0.7 0-1.3-0.3-1.3-0.8v0.1c0 0.4 0.6 0.8 1.3 0.8 0.8 0 1.4-0.4 1.4-0.8v-0.1c0 0.5-0.6 0.8-1.4 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m72.2 115.4c0-5.1 7.1-9.3 15.9-9.3 4.5 0 8.6 1.1 11.5 2.8l-22.8 13.1c-2.9-1.7-4.6-4-4.6-6.6z"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m104.1 115.4c0 5.2-7.2 9.3-16 9.3-4.4 0-8.4-1-11.3-2.7l22.8-13.1c2.8 1.7 4.5 4 4.5 6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m104.1 115.4c0-5.1-7.2-9.3-16-9.3-4.5 0-8.5 1.1-11.4 2.8l22.7 13.1c2.9-1.7 4.7-4 4.7-6.6z"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m72.2 115.4c0 5.2 7.1 9.3 15.9 9.3 4.4 0 8.4-1 11.3-2.7l-22.7-13.1c-2.8 1.7-4.5 4-4.5 6.5z"
  }))), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    className: "iv",
    d: "m33.5 121.3h5.6v3.9c0 0.9-1.2 1.7-2.8 1.7-1.6 0-2.8-0.8-2.8-1.7z"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    className: "iw",
    d: "m39.1 121.3c0 0.9-1.2 1.6-2.8 1.6-1.6 0-2.8-0.7-2.8-1.6 0-0.9 1.2-1.7 2.8-1.7 1.6 0 2.8 0.8 2.8 1.7z"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    className: "ix",
    d: "m36.3 122.9c1.5 0 2.8-0.7 2.8-1.6q0 0 0 0c0 0.9-1.2 1.7-2.8 1.7-1.6 0-2.8-0.8-2.8-1.7q0 0 0 0c0 0.9 1.2 1.6 2.8 1.6z"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    className: "iy",
    d: "m36.4 122v1.7l-3.6-2.1v-1.7z"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    className: "iz",
    d: "m36.4 122v1.7l18.8-8.8v-3.9z"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    className: "iA",
    d: "m55.2 111l-18.8 11-3.6-2.1 18.8-11z"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    className: "iB",
    d: "m33.7 115.6h5.1v3.6c0 0.8-1.1 1.5-2.5 1.5-1.4 0-2.6-0.7-2.6-1.5z"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    className: "iC",
    d: "m38.8 115.7c0 0.8-1.1 1.4-2.5 1.4-1.4 0-2.6-0.6-2.6-1.4 0-0.9 1.2-1.5 2.6-1.5 1.4 0 2.5 0.6 2.5 1.5z"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    className: "iD",
    d: "m36.3 117.1c1.4 0 2.5-0.6 2.5-1.4q0 0 0 0c0 0.8-1.1 1.5-2.5 1.5-1.4 0-2.6-0.7-2.6-1.5q0 0 0 0c0.1 0.8 1.2 1.4 2.6 1.4z"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    className: "iE",
    d: "m34.9 113.5h2.8v1.9c0 0.5-0.7 0.8-1.4 0.8-0.8 0-1.4-0.3-1.4-0.8z"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    className: "iF",
    d: "m37.7 113.5c0 0.5-0.7 0.8-1.4 0.8-0.8 0-1.4-0.3-1.4-0.8 0-0.4 0.6-0.8 1.4-0.8 0.7 0 1.4 0.4 1.4 0.8z"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    className: "iG",
    d: "m36.3 114.3c0.7 0 1.3-0.3 1.4-0.8v0.1c0 0.4-0.7 0.8-1.4 0.8-0.8 0-1.4-0.4-1.4-0.8v-0.1c0 0.5 0.7 0.8 1.4 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m52.3 115.4c0-5.1-7.2-9.3-16-9.3-4.5 0-8.5 1.1-11.4 2.8l22.7 13.1c2.9-1.7 4.7-4 4.7-6.6z"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m20.3 115.4c0 5.2 7.2 9.3 16 9.3 4.4 0 8.4-1 11.3-2.7l-22.7-13.1c-2.8 1.7-4.6 4-4.6 6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m20.3 115.4c0-5.1 7.2-9.3 16-9.3 4.5 0 8.5 1.1 11.4 2.8l-22.7 13.1c-2.9-1.7-4.7-4-4.7-6.6z"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m52.3 115.4c0 5.2-7.2 9.3-16 9.3-4.4 0-8.4-1-11.3-2.7l22.7-13.1c2.8 1.7 4.6 4 4.6 6.5z"
  }))), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    className: "iH",
    d: "m90.7 86.4h-5.1v3.5 0.1c0 0.8 1.1 1.5 2.5 1.5 1.4 0 2.6-0.7 2.6-1.5v-0.1z"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    className: "iI",
    d: "m85.6 86.4c0 0.8 1.1 1.5 2.5 1.5 1.4 0 2.6-0.7 2.6-1.5 0-0.8-1.2-1.5-2.6-1.5-1.4 0-2.5 0.7-2.5 1.5z"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    className: "iJ",
    d: "m88.1 87.9c-1.4 0-2.5-0.7-2.5-1.5q0 0 0 0c0 0.9 1.1 1.5 2.5 1.5 1.4 0 2.6-0.6 2.6-1.4q0 0 0-0.1c0 0.8-1.2 1.5-2.6 1.5z"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    className: "iK",
    d: "m89.5 84.3h-2.7v1.9c0 0.4 0.6 0.8 1.3 0.8 0.8 0 1.4-0.4 1.4-0.8z"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    className: "iL",
    d: "m86.8 84.3c0 0.4 0.6 0.8 1.3 0.8 0.8 0 1.4-0.4 1.4-0.8 0-0.5-0.6-0.8-1.4-0.8-0.7 0-1.3 0.3-1.3 0.8z"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    className: "iM",
    d: "m88.1 85.1c-0.7 0-1.3-0.4-1.3-0.8 0 0.4 0.6 0.8 1.3 0.8 0.8 0 1.4-0.4 1.4-0.8 0 0.4-0.6 0.8-1.4 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m72.2 86.2c0-5.2 7.1-9.3 15.9-9.3 4.5 0 8.6 1.1 11.5 2.8l-22.8 13.1c-2.9-1.7-4.6-4.1-4.6-6.6z"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m104.1 86.2c0 5.1-7.2 9.3-16 9.3-4.4 0-8.4-1.1-11.3-2.7l22.8-13.1c2.8 1.7 4.5 4 4.5 6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m104.1 86.2c0-5.2-7.2-9.3-16-9.3-4.5 0-8.5 1.1-11.4 2.8l22.7 13.1c2.9-1.7 4.7-4.1 4.7-6.6z"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m72.2 86.2c0 5.1 7.1 9.3 15.9 9.3 4.4 0 8.4-1.1 11.3-2.7l-22.7-13.1c-2.8 1.7-4.5 4-4.5 6.5z"
  }))), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    className: "iN",
    d: "m33.7 86.4h5.1v3.5 0.1c0 0.8-1.1 1.5-2.5 1.5-1.4 0-2.6-0.7-2.6-1.5v-0.1z"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    className: "iO",
    d: "m38.8 86.4c0 0.8-1.1 1.5-2.5 1.5-1.4 0-2.6-0.7-2.6-1.5 0-0.8 1.2-1.5 2.6-1.5 1.4 0 2.5 0.7 2.5 1.5z"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    className: "iP",
    d: "m36.3 87.9c1.4 0 2.5-0.7 2.5-1.5q0 0 0 0c0 0.9-1.1 1.5-2.5 1.5-1.4 0-2.6-0.6-2.6-1.4q0 0 0-0.1c0.1 0.8 1.2 1.5 2.6 1.5z"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    className: "iQ",
    d: "m34.9 84.3h2.8v1.9c0 0.4-0.7 0.8-1.4 0.8-0.8 0-1.4-0.4-1.4-0.8z"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    className: "iR",
    d: "m37.7 84.3c0 0.4-0.7 0.8-1.4 0.8-0.8 0-1.4-0.4-1.4-0.8 0-0.5 0.6-0.8 1.4-0.8 0.7 0 1.4 0.3 1.4 0.8z"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    className: "iS",
    d: "m36.3 85.1c0.7 0 1.3-0.4 1.4-0.8 0 0.4-0.7 0.8-1.4 0.8-0.8 0-1.4-0.4-1.4-0.8 0 0.4 0.7 0.8 1.4 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m52.3 86.2c0-5.2-7.2-9.3-16-9.3-4.5 0-8.5 1.1-11.4 2.8l22.7 13.1c2.9-1.7 4.7-4.1 4.7-6.6z"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m20.3 86.2c0 5.1 7.2 9.3 16 9.3 4.4 0 8.4-1.1 11.3-2.7l-22.7-13.1c-2.8 1.7-4.6 4-4.6 6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    className: "it",
    d: "m20.3 86.2c0-5.2 7.2-9.3 16-9.3 4.5 0 8.5 1.1 11.4 2.8l-22.7 13.1c-2.9-1.7-4.7-4.1-4.7-6.6z"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    className: "iu",
    d: "m52.3 86.2c0 5.1-7.2 9.3-16 9.3-4.4 0-8.4-1.1-11.3-2.7l22.7-13.1c2.8 1.7 4.6 4 4.6 6.5z"
  }))), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    className: "iT",
    d: "m256.5 322.3c0 5.3-4.3 9.6-9.6 9.6-5.2 0-9.5-4.3-9.5-9.6 0-5.3 4.3-9.5 9.5-9.5 5.3 0 9.6 4.2 9.6 9.5z"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    className: "iU",
    d: "m319.8 391.1c0 5.2-4.3 9.5-9.6 9.5-5.2 0-9.5-4.3-9.5-9.5 0-5.3 4.3-9.6 9.5-9.6 5.3 0 9.6 4.3 9.6 9.6z"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    className: "iV",
    d: "m388.2 293c0 5.3-4.3 9.6-9.6 9.6-5.2 0-9.5-4.3-9.5-9.6 0-5.2 4.3-9.5 9.5-9.5 5.3 0 9.6 4.3 9.6 9.5z"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    className: "iW",
    d: "m451.8 261c0 5.3-4.3 9.6-9.6 9.6-5.2 0-9.5-4.3-9.5-9.6 0-5.3 4.3-9.5 9.5-9.5 5.3 0 9.6 4.2 9.6 9.5z"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    className: "iX",
    d: "m129.1 326.1c0 5.3-4.3 9.6-9.6 9.6-5.2 0-9.5-4.3-9.5-9.6 0-5.2 4.3-9.5 9.5-9.5 5.3 0 9.6 4.3 9.6 9.5z"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    className: "iY",
    d: "m157.5 261.7c0 5.3-4.3 9.6-9.6 9.6-5.3 0-9.5-4.3-9.5-9.6 0-5.2 4.2-9.5 9.5-9.5 5.3 0 9.6 4.3 9.6 9.5z"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    className: "iZ",
    d: "m123.6 207.2c0 5.2-4.2 9.5-9.5 9.5-5.3 0-9.6-4.3-9.6-9.5 0-5.3 4.3-9.6 9.6-9.6 5.3 0 9.5 4.3 9.5 9.6z"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    className: "j0",
    d: "m444.9 168.6c0 5.3-4.3 9.6-9.6 9.6-5.3 0-9.5-4.3-9.5-9.6 0-5.3 4.2-9.5 9.5-9.5 5.3 0 9.6 4.2 9.6 9.5z"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    className: "j1",
    d: "m158.9 119.5c0 5.3-4.3 9.5-9.5 9.5-5.3 0-9.6-4.2-9.6-9.5 0-5.3 4.3-9.6 9.6-9.6 5.2 0 9.5 4.3 9.5 9.6z"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    className: "j2",
    d: "m468.3 364.5c0 5.3-4.2 9.6-9.5 9.6-5.3 0-9.6-4.3-9.6-9.6 0-5.3 4.3-9.5 9.6-9.5 5.3 0 9.5 4.2 9.5 9.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.7e693eb8d468c5deb629d407929ad24b.svg";
export { ForwardRef as ReactComponent };